import { Extension, InputRule, Mark, Node as Node$1, callOrReturn, findChildren, findParentNode, findParentNodeClosestToPos, getExtensionField, getMarkAttributes, getMarkRange, getMarkType, getMarksBetween, getNodeType, getSchema, inputRulesPlugin, isList, isNodeSelection, markInputRule, markPasteRule, mergeAttributes, posToDOMRect, textblockTypeInputRule, wrappingInputRule } from "@tiptap/core";
import "@tiptap/extension-text-style";
import { NodeSelection, Plugin, PluginKey, TextSelection } from "@tiptap/pm/state";
import { Decoration, DecorationSet, __serializeForClipboard } from "@tiptap/pm/view";
import { Colored, ControlButton, ControlButtonText, DEFAULT_TEXT_COLOR, DropdownMenu, HIDDEN_CHAR_STYLES, HIGHLIGHT_COLORS, Icon, IconButton, Input, TEXT_COLORS, Text, ToggleGroup, Toolbar, Tooltip, colors, levels, resolveAvatarColourset } from "@vericus/cadmus-ui";
import crel from "crelt";
import ImageCompressor from "compressorjs";
import isSvg from "is-svg";
import { filetypeinfo } from "magic-bytes.js";
import { createMultipartUpload } from "@vericus/cadmus-media-upload";
import { v4, v7 } from "uuid";
import { Fragment, Node as Node$2, NodeRange, Slice } from "@tiptap/pm/model";
import { Parser, parseDocument } from "htmlparser2";
import { ChangeSet } from "@tiptap/pm/changeset";
import { opacify, transparentize } from "polished";
import { ReplaceAroundStep, Transform, canJoin, canSplit, liftTarget } from "@tiptap/pm/transform";
import { Code } from "@tiptap/extension-code";
import { css, keyframes, styled } from "styled-components";
import { CellSelection, TableMap, __clipCells, __insertCells, __pastedCells, addColumn, addRow, cellAround, isInTable, selectedRect, selectionCell, tableEditing } from "@tiptap/pm/tables";
import { history, redo, undo } from "@tiptap/pm/history";
import CodeMirror from "codemirror";
import "codemirror-mode-elixir";
import "codemirror/mode/clike/clike.js";
import "codemirror/mode/css/css.js";
import "codemirror/mode/go/go.js";
import "codemirror/mode/haskell/haskell.js";
import "codemirror/mode/htmlmixed/htmlmixed.js";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/markdown/markdown.js";
import "codemirror/mode/octave/octave.js";
import "codemirror/mode/python/python.js";
import "codemirror/mode/r/r.js";
import "codemirror/mode/shell/shell.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/mode/xml/xml.js";
import "codemirror/mode/yaml/yaml.js";
import { forwardRef, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer, mergeAttributes as mergeAttributes$1, useEditorState } from "@tiptap/react";
import { FloatingFocusManager, FloatingNode, FloatingPortal, FloatingTree, autoUpdate, flip, hide, offset, shift, useClick, useFloating, useFloatingNodeId, useFocus, useInteractions, useRole } from "@floating-ui/react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { collab, receiveTransaction } from "@tiptap/pm/collab";
import twemoji from "@twemoji/api";
import EMOJI_REGEX from "emojibase-regex";
import { ElementType } from "domelementtype";
import { getChildren, textContent } from "domutils";
import { Highlight, inputRegex, pasteRegex } from "@tiptap/extension-highlight";
import tinycolor from "tinycolor2";
import { convertLatexToMarkup } from "mathlive";
import { Subscript } from "@tiptap/extension-subscript";
import { Superscript } from "@tiptap/extension-superscript";
import { TableRow } from "@tiptap/extension-table-row";
import { Table } from "@tiptap/extension-table";
import useResizeObserver from "use-resize-observer/polyfilled.js";
import { Icon as Icon$1 } from "@vericus/cadmus-icons";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import { debounce } from "ts-debounce";
import "codemirror/addon/runmode/runmode-standalone.js";
//#region src/core/helpers/findSelectedNodeByType.ts
/**
* Get selected node, its `NodeSelection` and the start position of
* the node
*/
function findSelectedNodeByType(state, type) {
	const { selection } = state;
	const { $from, $to } = state.selection;
	let nodeSelection;
	let from;
	const predicate = (node) => node.type === state.schema.nodes[type];
	if (isNodeSelection(selection) && selection.node.type === state.schema.nodes[type]) {
		nodeSelection = selection;
		from = $from.start($from.depth + 1) - 1;
	}
	const parent = findParentNode(predicate)(selection);
	if ($from.node() === $to.node() && parent) {
		nodeSelection = NodeSelection.create(state.doc, parent.pos);
		from = parent.pos;
	}
	if (nodeSelection && from !== void 0) return {
		node: nodeSelection.node,
		selection: nodeSelection,
		from
	};
	return null;
}
//#endregion
//#region src/core/helpers/renderMediaHTML.ts
const svgAttrs = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: colors.icon,
	width: "24",
	height: "24",
	viewBox: "0 0 24 24",
	"aria-hidden": "true"
};
const OPEN_LINK_SVG = [
	"svg",
	svgAttrs,
	["path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.185 5.5H5.5V18.5H18.5V6.81502L12.315 13L11 11.685L17.185 5.5ZM20 14V20H4V4H10L11 5.5H15L14 4H20V10L18.5 9V13L20 14Z"
	}]
];
const VIDEO_SVG = [
	"svg",
	svgAttrs,
	["path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5001 9.4798L21.1918 6.1948C21.2593 6.14751 21.3384 6.11965 21.4206 6.11426C21.5028 6.10886 21.5849 6.12613 21.658 6.1642C21.7311 6.20226 21.7923 6.25966 21.835 6.33012C21.8777 6.40059 21.9002 6.48142 21.9001 6.5638V17.4358C21.9002 17.5182 21.8777 17.599 21.835 17.6695C21.7923 17.74 21.7311 17.7973 21.658 17.8354C21.5849 17.8735 21.5028 17.8908 21.4206 17.8854C21.3384 17.88 21.2593 17.8521 21.1918 17.8048L16.5001 14.5198V18.2998C16.5001 18.5385 16.4053 18.7674 16.2365 18.9362C16.0677 19.105 15.8388 19.1998 15.6001 19.1998H3.0001C2.7614 19.1998 2.53248 19.105 2.3637 18.9362C2.19492 18.7674 2.1001 18.5385 2.1001 18.2998V5.6998C2.1001 5.46111 2.19492 5.23219 2.3637 5.06341C2.53248 4.89463 2.7614 4.7998 3.0001 4.7998H15.6001C15.8388 4.7998 16.0677 4.89463 16.2365 5.06341C16.4053 5.23219 16.5001 5.46111 16.5001 5.6998V9.4798ZM5.7001 8.3998V10.1998H7.5001V8.3998H5.7001Z"
	}]
];
const AUDIO_SVG = [
	"svg",
	svgAttrs,
	["path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.5002 15.6002H3.0001C2.7614 15.6002 2.53248 15.5054 2.3637 15.3366C2.19492 15.1678 2.1001 14.9389 2.1001 14.7002V9.30021C2.1001 9.06152 2.19492 8.8326 2.3637 8.66382C2.53248 8.49504 2.7614 8.40021 3.0001 8.40021H6.5002L11.2648 4.50141C11.3307 4.44737 11.4106 4.41316 11.4953 4.40277C11.5799 4.39238 11.6657 4.40624 11.7427 4.44273C11.8198 4.47923 11.8849 4.53685 11.9304 4.6089C11.976 4.68095 12.0002 4.76447 12.0001 4.84971V19.1507C12.0002 19.236 11.976 19.3195 11.9304 19.3915C11.8849 19.4636 11.8198 19.5212 11.7427 19.5577C11.6657 19.5942 11.5799 19.608 11.4953 19.5977C11.4106 19.5873 11.3307 19.5531 11.2648 19.499L6.5011 15.6002H6.5002ZM18.6655 19.3208L17.3911 18.0464C18.2443 17.2873 18.9268 16.3559 19.3938 15.3137C19.8607 14.2716 20.1015 13.1422 20.1001 12.0002C20.1012 10.7997 19.8349 9.614 19.3206 8.52925C18.8062 7.4445 18.0567 6.48793 17.1265 5.72901L18.4045 4.45101C19.5011 5.37941 20.382 6.53585 20.9858 7.83969C21.5895 9.14353 21.9015 10.5634 21.9001 12.0002C21.9001 14.9009 20.6527 17.51 18.6655 19.3208ZM15.4768 16.1321L14.197 14.8523C14.6339 14.5163 14.9877 14.0844 15.231 13.5898C15.4743 13.0953 15.6006 12.5514 15.6001 12.0002C15.6001 10.7132 14.9251 9.58371 13.9081 8.94741L15.2032 7.65231C15.8849 8.15379 16.439 8.80868 16.8207 9.56402C17.2023 10.3194 17.4008 11.1539 17.4001 12.0002C17.4001 13.658 16.6531 15.1412 15.4768 16.1321Z"
	}]
];
function wrapSvg(tag, attrs, svg) {
	return [
		tag,
		{
			...attrs,
			style: [
				attrs.style || "",
				"display: flex",
				"justify-content: center",
				"align-items: center",
				"width: 40px",
				"height: 40px",
				`background-color: ${colors.white}`,
				"border-radius: 4px",
				"flex-shrink: 0"
			].filter(Boolean).join("; ")
		},
		svg
	];
}
/**
* Returns a TipTap / ProseMirror DOMOutputSpec array that renders the
* media card UI for use in `renderHTML`.
*/
function renderMediaHTML(mediaType, src, hasCaption) {
	const captionTextNode = [
		"span",
		{ style: [
			"text-overflow: ellipsis",
			"white-space: nowrap",
			"overflow: hidden",
			`color: ${colors.primary}`
		].join("; ") },
		hasCaption ? [
			"span",
			{ class: "media-caption" },
			0
		] : src
	];
	return [
		"figure",
		{
			[`data-${mediaType}`]: true,
			...src ? { "data-src": src } : {},
			style: [
				"display: flex",
				"align-items: center",
				"justify-content: space-between",
				"gap: 16px",
				`background-color: ${colors.bgrey400}`,
				"padding: 8px",
				"border-radius: 4px",
				"margin: 4px 45px"
			].join("; "),
			class: "media-card"
		},
		wrapSvg("span", {}, mediaType === "video" ? VIDEO_SVG : AUDIO_SVG),
		captionTextNode,
		wrapSvg("a", {
			...src ? { href: src } : {},
			target: "_blank",
			rel: "noreferrer noopener"
		}, OPEN_LINK_SVG)
	];
}
//#endregion
//#region src/core/helpers/media-floating-menu.ts
/**
* Creates the floating menu container with caption toggle and delete buttons.
*
* @param mediaType - The type of media (audio or video) to determine button icons.
* @param editor - The Tiptap editor instance for executing commands.
* @param getPos - A function that returns the current position of the node in the document.
* @returns An object containing the menu DOM element and a method to update caption state.
*/
function createMediaFloatingMenu(mediaType, editor, getPos) {
	const menu = document.createElement("div");
	menu.className = "media-floating-menu";
	menu.setAttribute("contenteditable", "false");
	menu.addEventListener("click", (e) => e.stopPropagation());
	menu.addEventListener("mousedown", (e) => {
		e.stopPropagation();
		e.preventDefault();
	});
	function handleToggleCaption() {
		if (!editor.isEditable) return;
		if (typeof getPos === "function") {
			const pos = getPos();
			if (pos !== void 0) editor.chain().focus().setNodeSelection(pos)[mediaType === "audio" ? "toggleAudioCaption" : "toggleVideoCaption"]().run();
		}
	}
	function handleDelete() {
		if (!editor.isEditable) return;
		if (typeof getPos === "function") {
			const pos = getPos();
			if (pos !== void 0) editor.chain().focus().setNodeSelection(pos)[mediaType === "audio" ? "deleteAudio" : "deleteVideo"]().run();
		}
	}
	const captionBtn = createMenuButton("Show caption", CAPTION_ICON_SVG, handleToggleCaption);
	const deleteBtn = createMenuButton("Delete", TRASH_ICON_SVG, handleDelete);
	menu.append(captionBtn, deleteBtn);
	return {
		dom: menu,
		setCaptionState(hasCaption) {
			const label = hasCaption ? "Hide caption" : "Show caption";
			captionBtn.title = label;
			captionBtn.setAttribute("aria-label", label);
			captionBtn.setAttribute("aria-pressed", String(hasCaption));
		}
	};
}
function createMenuButton(title, iconSvg, onClick) {
	const button = document.createElement("button");
	button.type = "button";
	button.title = title;
	button.setAttribute("aria-label", title);
	button.className = "media-floating-menu-btn";
	button.innerHTML = iconSvg;
	button.addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();
		onClick();
	});
	return button;
}
const CAPTION_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 21" width="16" height="16" fill="currentColor"><path d="M2.4866562,12.685112 C2.75458009,12.685112 2.97226499,12.6078181 3.13971743,12.4532279 C3.30716986,12.2986378 3.39424382,12.0931062 3.40094192,11.8366271 L4.76232339,11.8366271 C4.75897434,12.2231025 4.65850439,12.5770735 4.46091052,12.8985507 C4.26331665,13.220028 3.99288502,13.4694765 3.64960754,13.6469038 C3.30633005,13.8243311 2.92705597,13.9130435 2.51177394,13.9130435 C1.73479465,13.9130435 1.12192794,13.6539332 0.673155416,13.1357049 C0.224382895,12.6174765 0,11.9016295 0,10.9881423 L0,10.8880105 C0,10.0096574 0.222708396,9.30874219 0.668131868,8.78524374 C1.11355534,8.2617453 1.72474755,8 2.50172684,8 C3.18158372,8 3.72663322,8.20289652 4.13689168,8.60869565 C4.54715014,9.01449478 4.75562529,9.55467383 4.76232339,10.229249 L3.40094192,10.229249 C3.39424382,9.93412237 3.30716986,9.69433557 3.13971743,9.50988142 C2.97226499,9.32542727 2.7512311,9.23320158 2.47660911,9.23320158 C2.13835519,9.23320158 1.88299406,9.36231755 1.71051805,9.62055336 C1.53804205,9.87878917 1.45180534,10.2977573 1.45180534,10.8774704 L1.45180534,11.0355731 C1.45180534,11.622313 1.5372048,12.0439162 1.70800628,12.3003953 C1.87880776,12.5568744 2.13835514,12.685112 2.4866562,12.685112 Z M8.74097331,13.8076416 C8.67399234,13.6706186 8.62543186,13.5002206 8.59529042,13.2964427 C8.24364031,13.7075119 7.78650203,13.9130435 7.22386185,13.9130435 C6.69136311,13.9130435 6.25013257,13.7514289 5.90015699,13.428195 C5.5501814,13.1049611 5.37519623,12.6974113 5.37519623,12.2055336 C5.37519623,11.6012267 5.58869488,11.1374632 6.01569859,10.8142292 C6.44270229,10.4909953 7.05975525,10.3276241 7.86687598,10.3241107 L8.53500785,10.3241107 L8.53500785,9.99736495 C8.53500785,9.73385903 8.47053963,9.52305744 8.34160126,9.36495389 C8.21266288,9.20685033 8.00921123,9.12779974 7.73124019,9.12779974 C7.48675964,9.12779974 7.29502948,9.18928353 7.15604396,9.31225296 C7.01705844,9.4352224 6.94756672,9.60386366 6.94756672,9.81818182 L5.49576138,9.81818182 C5.49576138,9.48792105 5.59288234,9.18225876 5.78712716,8.90118577 C5.98137198,8.62011278 6.25598985,8.39964946 6.61098901,8.2397892 C6.96598817,8.07992893 7.36451898,8 7.80659341,8 C8.47640314,8 9.00805664,8.17654632 9.40156986,8.52964427 C9.79508308,8.88274221 9.99183673,9.37900427 9.99183673,10.0184453 L9.99183673,12.4901186 C9.99518578,13.0311841 10.0671892,13.4404905 10.2078493,13.7180501 L10.2078493,13.8076416 L8.74097331,13.8076416 Z M7.54034537,12.7483531 C7.75468448,12.7483531 7.95227539,12.6982877 8.13312402,12.5981555 C8.31397265,12.4980232 8.44793258,12.3636372 8.53500785,12.1949934 L8.53500785,11.2147563 L7.99246468,11.2147563 C7.26572112,11.2147563 6.8789118,11.4782582 6.83202512,12.0052701 L6.82700157,12.0948617 C6.82700157,12.2845859 6.89063254,12.4409304 7.01789639,12.5638999 C7.14516024,12.6868693 7.31930816,12.7483531 7.54034537,12.7483531 Z M16,11.0092227 C16,11.8875758 15.8099443,12.591126 15.4298273,13.1198946 C15.0497103,13.6486632 14.5364763,13.9130435 13.8901099,13.9130435 C13.3408659,13.9130435 12.8971236,13.712782 12.5588697,13.312253 L12.5588697,16 L11.1070644,16 L11.1070644,8.10540184 L12.4533752,8.10540184 L12.5036107,8.66403162 C12.8552608,8.22134166 13.3140736,8 13.8800628,8 C14.5498725,8 15.0706418,8.25998862 15.4423862,8.77997365 C15.8141306,9.29995868 16,10.0166841 16,10.9301713 L16,11.0092227 Z M14.5481947,10.8985507 C14.5481947,10.3680255 14.458609,9.95871905 14.2794349,9.67061924 C14.1002607,9.38251942 13.8398761,9.23847167 13.4982732,9.23847167 C13.0428025,9.23847167 12.7296712,9.42116638 12.5588697,9.78656126 L12.5588697,12.1212121 C12.7363693,12.4971472 13.0528496,12.685112 13.5083203,12.685112 C14.2015733,12.685112 14.5481947,12.0895975 14.5481947,10.8985507 Z" /></svg>`;
const TRASH_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 21" width="16" height="16" fill="currentColor"><path d="M5.03846154,5 L5.03846154,4 L10.9615385,4 L10.9615385,5 L14,5 L14,6.5 L2,6.5 L2,5 L5.03846154,5 Z M2.67986425,8 L13.5011312,8 L12.3427254,17 L3.63680821,17 L2.67986425,8 Z" /></svg>`;
//#endregion
//#region src/extensions/audio/audio-node-view.ts
var AudioNodeView = class {
	dom;
	contentDOM;
	node;
	editor;
	audio;
	menu;
	constructor(node, getPos, HTMLAttributes, editor) {
		this.node = node;
		this.editor = editor;
		const figcaption = document.createElement("figcaption");
		figcaption.style.textAlign = "center";
		const audio = document.createElement("audio");
		this.audio = audio;
		const baseStyle = "position: relative; width: 100%;";
		const attrStyle = typeof HTMLAttributes.style === "string" ? HTMLAttributes.style : "";
		audio.setAttribute("style", [baseStyle, attrStyle].filter(Boolean).join(" "));
		Object.entries(HTMLAttributes).forEach(([key, value]) => {
			if (value == null || key === "style") return;
			audio.setAttribute(key, String(value));
		});
		audio.setAttribute("contenteditable", "false");
		audio.setAttribute("controls", "true");
		audio.setAttribute("controlsList", "nodownload noplaybackrate");
		this.menu = createMediaFloatingMenu("audio", editor, getPos);
		const figure = document.createElement("figure");
		figure.setAttribute("data-audio", "true");
		figure.append(audio, this.menu.dom, figcaption);
		this.dom = figure;
		this.contentDOM = figcaption;
		this.update(node);
	}
	update(node) {
		if (node.type !== this.node.type) return false;
		this.node = node;
		if (node.attrs.src !== this.audio.getAttribute("src")) if (node.attrs.src) this.audio.setAttribute("src", String(node.attrs.src));
		else this.audio.removeAttribute("src");
		if (this.contentDOM) this.contentDOM.style.display = node.attrs.hasCaption ? "" : "none";
		if (this.dom) this.dom.contentEditable = this.editor.isEditable ? "true" : "false";
		this.menu.setCaptionState(!!node.attrs.hasCaption);
		return true;
	}
	ignoreMutation(mutation) {
		if (this.menu.dom.contains(mutation.target)) return true;
		return false;
	}
	stopEvent(event) {
		if (this.menu.dom.contains(event.target)) {
			if (event.type === "focus" || event.type === "blur") return false;
			return true;
		}
		return false;
	}
};
//#endregion
//#region src/core/helpers/files.ts
function isPastedFile(event) {
	const { clipboardData } = event;
	if (!clipboardData) return false;
	return clipboardData.types.indexOf("Files") !== -1;
}
function isDroppedFile(event) {
	const { dataTransfer } = event;
	if (!dataTransfer) return false;
	return Array.from(dataTransfer.types).indexOf("Files") !== -1;
}
function getDataTransferFiles(event) {
	let dataTransferItemsList = [];
	if (event.dataTransfer) {
		const dt = event.dataTransfer;
		if (dt.files && dt.files.length) dataTransferItemsList = dt.files;
		else if (dt.items && dt.items.length) dataTransferItemsList = dt.items;
	} else if (event.target && event.target.files) dataTransferItemsList = event.target.files;
	return Array.prototype.slice.call(dataTransferItemsList);
}
//#endregion
//#region src/extensions/media-uploader/media-error.png
var media_error_default = "data:image/png;base64,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";
//#endregion
//#region src/extensions/media-uploader/media-uploader-plugin.ts
const MediaUploaderPluginKey = new PluginKey("mediaUploader");
/**
* Create a Media upload management plugin.
*
* This plugin renders and manages placeholder widgets which track the process
* of uploading and inserting one or more media files in the document.
*
* It renders the following kinds of widgets/decorations acting as intermediate
* placeholders:
*
*   1. `AddMediaWidget` - a faded preview of the same size with a loader for
*        while the media is being uploaded
*   2. `ErrorWidget` - when there is an error in the upload process
*
* The placeholders widgets/decorations are managed through distinct action
* steps, these are represented via the variant `UploadPlaceholderAction`. These
* actions are:
*
*   1. `AddMediaPlaceholder` - action to add a new media placeholder
*   2. `AddErrorPlaceholder` - action to render a new error placeholder
*   3. `RemovePlaceholder` - action to remove any existing placeholder of both kinds.
*
* The above actions are read from the Transaction meta set for this plugin. It
* is expected that the Transaction meta is an Array of the above actions as
* multiple media uploads are supported. Therefore it is better to bulk manage
* the placeholders too.
*
* The placeholder widgets are stored in the plugin state using the standard
* `DecorationSet`. Each widget uses an `id` object reference (unique in
* comparison) to be easily referencible in the actions. This reference is
* stored in the widget specification object.
*/
const MediaUploaderPlugin = () => new Plugin({
	key: MediaUploaderPluginKey,
	state: {
		init() {
			return DecorationSet.empty;
		},
		apply(tr, decorations) {
			decorations = decorations.map(tr.mapping, tr.doc);
			tr.getMeta(MediaUploaderPluginKey)?.forEach((action) => {
				switch (action.type) {
					case "addMedia": {
						const deco = AddMediaWidget(action);
						decorations = decorations.add(tr.doc, [deco]);
						break;
					}
					case "addError": {
						const deco = ErrorWidget(action);
						decorations = decorations.add(tr.doc, [deco]);
						break;
					}
					case "removePlaceholder": {
						const { id } = action;
						const decos = decorations.find(void 0, void 0, (spec) => spec.id === id);
						decorations = decorations.remove(decos);
						break;
					}
				}
			});
			return decorations;
		}
	},
	props: { decorations(editorState) {
		return this.getState(editorState);
	} }
});
const ErrorWidget = (payload) => {
	const { id, pos, message, side } = payload;
	return Decoration.widget(pos, (view) => {
		const onCancel = () => {
			const meta = [{
				type: "removePlaceholder",
				id
			}];
			const tr = view.state.tr.setMeta(MediaUploaderPluginKey, meta);
			view.dispatch(tr);
		};
		return crel("figure", {
			class: "media-uploader-error",
			contenteditable: "false"
		}, [
			crel("img", {
				src: media_error_default,
				draggable: "false",
				contenteditable: "false"
			}),
			crel("p", { contenteditable: "false" }, message ? [message] : [
				`There was an error while uploading this media.`,
				crel("br"),
				`Please check your internet connection and try again.`
			]),
			crel("button", {
				class: "cui-LinkButton",
				onclick: onCancel
			}, [crel("span", ["Cancel"])])
		]);
	}, {
		id,
		side
	});
};
function getAddMediaElement(payload) {
	switch (payload.mediaType) {
		case "image": return crel("img", {
			src: payload.src,
			draggable: "false",
			style: payload.width ? `max-width: ${payload.width}px;` : void 0
		});
		case "audio": return crel("audio", {
			src: payload.src,
			controls: "true",
			draggable: "false",
			style: "pointer-events: none; opacity: 0.75; width: 100%;",
			controlsList: "nodownload noplaybackrate"
		});
		case "video": return crel("video", {
			src: payload.src,
			controls: "true",
			draggable: "false",
			style: "pointer-events: none; opacity: 0.75; width: 100%;",
			controlsList: "nodownload noplaybackrate"
		});
		default: throw new Error(`Unsupported media type: ${payload.mediaType}`);
	}
}
const AddMediaWidget = (payload) => {
	const { id, pos, src, width, side, mediaType } = payload;
	const figure = crel("figure", {
		"data-loading": "true",
		draggable: "false",
		contenteditable: "false"
	}, [getAddMediaElement(payload), crel("span", { "data-loading": "true" })]);
	return Decoration.widget(pos, () => figure, {
		id,
		src,
		width,
		side,
		mediaType
	});
};
function addErrorPlaceholder(attrs) {
	return {
		type: "addError",
		...attrs
	};
}
function addMediaPlaceholder(attrs) {
	return {
		type: "addMedia",
		...attrs
	};
}
function removePlaceholder(id) {
	return {
		type: "removePlaceholder",
		id
	};
}
/**
* Dispatch a new Transaction with the metadata for the `MediaUploaderPlugin` set.
*
* The metadata is an array of `UploadPlaceholderAction`s which dictate how the
* plugin will manipulate the existing state of placeholder widgets in the
* document.
*/
function setMediaUploaderTransactionMeta(editor, meta) {
	editor.commands.command(({ tr }) => {
		tr.setMeta(MediaUploaderPluginKey, meta);
		return true;
	});
}
/**
* Find a media upload placeholder with a specific `id` if it still exists in
* the body.
*
* @param state current EditorState to search in
* @param id some comparable reference to an existing placeholder instance
* @return position of the placeholder widget if found
*/
function findUploadPlaceholder(state, id) {
	const decos = MediaUploaderPluginKey.getState(state);
	if (!decos) return null;
	const found = decos.find(void 0, void 0, (spec) => spec.id === id);
	return found.length ? found[0].from : null;
}
/**
* Filter existing placeholder widgets which were placed at the given position.
*
* @param state current EditorState to look in
* @param pos document position the widgets were placed in
* @return the Decoration if found
*/
function findPlaceholdersAtPos(state, pos) {
	const decos = MediaUploaderPluginKey.getState(state);
	if (!decos) return null;
	return decos.find(void 0, void 0, () => true).filter((deco) => deco.from === pos);
}
//#endregion
//#region src/extensions/media-uploader/media-uploader.ts
const MediaUploader = Extension.create({
	name: "mediaUploader",
	addProseMirrorPlugins() {
		return [MediaUploaderPlugin()];
	},
	addKeyboardShortcuts() {
		const handleBackspace = () => this.editor.commands.command(({ tr, state }) => {
			const { selection } = state;
			const { from, to } = selection;
			const decos = MediaUploaderPluginKey.getState(state);
			if (!decos) return false;
			const actions = [];
			decos.find(void 0, void 0, () => true).forEach((deco) => {
				if (!deco.spec.src && deco.from >= from - 1 && deco.from <= to) actions.push(removePlaceholder(deco.spec.id));
			});
			if (actions.length) tr.setMeta(MediaUploaderPluginKey, actions);
			return false;
		});
		const handleDelete = () => this.editor.commands.command(({ tr, state }) => {
			const { selection } = state;
			const { from, to } = selection;
			const decos = MediaUploaderPluginKey.getState(state);
			if (!decos) return false;
			const actions = [];
			decos.find(void 0, void 0, () => true).forEach((deco) => {
				if (!deco.spec.src && deco.from >= from && deco.from <= to + 1) actions.push(removePlaceholder(deco.spec.id));
			});
			if (actions.length) tr.setMeta(MediaUploaderPluginKey, actions);
			return false;
		});
		return {
			Backspace: () => handleBackspace(),
			"Mod-Backspace": () => handleBackspace(),
			Delete: () => handleDelete(),
			"Mod-Delete": () => handleDelete()
		};
	}
});
//#endregion
//#region src/extensions/media-uploader/file-utils.ts
/** Allowed media mime types. */
const ALLOWED_MIME_TYPES = {
	image: [
		"image/jpeg",
		"image/png",
		"image/svg+xml",
		"image/tiff"
	],
	audio: [
		"audio/mpeg",
		"audio/wav",
		"audio/x-wav"
	],
	video: ["video/mp4", "video/quicktime"]
};
/**
* Compress a file or blob.
*
* This step is performed on the browser before uploading the file to the server.
*
* @param file image file to compress
* @return promise of a compressed blob
*/
async function compressImage(file) {
	return new Promise((resolve, reject) => {
		new ImageCompressor(file, {
			maxWidth: 2048,
			success: (blobOrFile) => {
				if (isBlob(blobOrFile)) return resolve(blobToFile(blobOrFile));
				return resolve(blobOrFile);
			},
			error: reject
		});
	});
}
function isBlob(file) {
	return file.name === void 0 && file.lastModified === void 0;
}
function blobToFile(blob, options) {
	return new File([blob], "someMedia", options);
}
/**
* Read a media blob and create a base64 encoded data URL string.
*
* @param file media file blob
* @return promise of the media data as a `data: URL` string.
*/
async function readMediaFile(file) {
	const reader = new FileReader();
	return new Promise((resolve, reject) => {
		reader.onload = () => resolve(reader.result);
		reader.onerror = () => reject(reader.error);
		reader.readAsDataURL(file);
	});
}
/**
* Check if media file's mime type is accepted.
*
* @param mime extension
* @param mediaType media type
* @return boolean
*/
function isAllowedMimeType(mime, mediaType) {
	return ALLOWED_MIME_TYPES[mediaType].includes(mime);
}
/**
* Get a media file's mime type.
*/
async function mediaMimes(file) {
	const reader = new FileReader();
	return new Promise((resolve, reject) => {
		reader.onloadend = () => {
			if (reader.result) {
				const buffer = new Uint8Array(reader.result);
				const filetypes = filetypeinfo(buffer);
				if (isSvg(new TextDecoder("utf-8").decode(buffer))) resolve(["image/svg+xml"]);
				else if (filetypes.length > 0) resolve(filetypes.map(({ mime }) => mime ?? ""));
				else resolve([]);
			} else resolve([]);
		};
		reader.onerror = () => {
			reject(/* @__PURE__ */ new Error("Error determining media mime type"));
		};
		reader.readAsArrayBuffer(file);
	});
}
const MAX_SIZE = 800;
const SIZE_STEP = 100;
async function getImageWidth(file) {
	return new Promise((resolve) => {
		const img = new Image();
		const url = URL.createObjectURL(file);
		img.onload = () => {
			let roundedWidth = Math.round(img.naturalWidth / SIZE_STEP) * SIZE_STEP;
			roundedWidth = roundedWidth > 0 ? roundedWidth : SIZE_STEP;
			resolve(roundedWidth > MAX_SIZE ? MAX_SIZE : roundedWidth);
		};
		img.src = url;
	});
}
//#endregion
//#region src/extensions/media-uploader/multipartUpload.ts
/**
* Build a {@link MultipartUploadApi} bound to the editor's media API. The
* endpoints are derived from `mediaAPIBase`. Only backends that expose the
* multipart endpoints (`/api/media`) opt into this path via
* `enableMultipartUpload`; the single-PUT-only `/api/work_media` backend never
* reaches it.
*
* `initMultipartUpload` forwards `workId`/`assessmentId` from the extension
* options so pantheon reserves the media under the right Work/Assessment, the
* same way the single-PUT `upload_url` call does.
*/
function createEditorMultipartApi(opts) {
	const { mediaAPIBase, tenant, userRole, userId, workId, assessmentId } = opts;
	const headers = {
		"x-cadmus-tenant": tenant ?? "",
		"x-cadmus-role": userRole ?? "",
		"x-cadmus-user": userId ?? ""
	};
	const jsonHeaders = {
		...headers,
		"Content-Type": "application/json",
		Accept: "application/json"
	};
	const acceptHeaders = {
		...headers,
		Accept: "application/json"
	};
	const credentials = "include";
	return {
		async initMultipartUpload({ filename, contentType }) {
			const res = await fetch(`${mediaAPIBase}/multipart`, {
				method: "POST",
				headers: jsonHeaders,
				credentials,
				body: JSON.stringify({
					filename,
					contentType,
					workId,
					assessmentId
				})
			});
			if (!res.ok) throw new Error(`Failed to start upload: ${res.status}`);
			return res.json();
		},
		async signPart({ mediaId, uploadId, partNumber, signal }) {
			const res = await fetch(`${mediaAPIBase}/${encodeURIComponent(mediaId)}/multipart/parts`, {
				method: "POST",
				headers: jsonHeaders,
				credentials,
				signal,
				body: JSON.stringify({
					uploadId,
					partNumber
				})
			});
			if (!res.ok) throw new Error(`Failed to sign part ${partNumber}: ${res.status}`);
			return res.json();
		},
		async listParts({ mediaId, uploadId, signal }) {
			const url = new URL(`${mediaAPIBase}/${encodeURIComponent(mediaId)}/multipart/parts`);
			url.searchParams.set("uploadId", uploadId);
			const res = await fetch(url.toString(), {
				method: "GET",
				headers: acceptHeaders,
				credentials,
				signal
			});
			if (!res.ok) throw new Error(`Failed to list parts: ${res.status}`);
			return res.json();
		},
		async completeMultipartUpload({ mediaId, uploadId, parts, signal }) {
			const res = await fetch(`${mediaAPIBase}/${encodeURIComponent(mediaId)}/multipart/complete`, {
				method: "POST",
				headers: jsonHeaders,
				credentials,
				signal,
				body: JSON.stringify({
					uploadId,
					parts
				})
			});
			if (!res.ok) throw new Error(`Failed to complete upload: ${res.status}`);
			return res.json();
		},
		async abortMultipartUpload({ mediaId, uploadId, signal }) {
			const url = new URL(`${mediaAPIBase}/${encodeURIComponent(mediaId)}/multipart`);
			url.searchParams.set("uploadId", uploadId);
			const res = await fetch(url.toString(), {
				method: "DELETE",
				headers: acceptHeaders,
				credentials,
				signal
			});
			if (!res.ok && res.status !== 204) throw new Error(`Failed to abort upload: ${res.status}`);
		}
	};
}
/**
* Upload a large media file via resumable S3 multipart, returning the media
* `src` URL (same contract as the single-PUT `uploadMediaToServer`). Chunking
* avoids the CloudFront 504 a single large-file PUT can hit.
*/
async function uploadMediaMultipart(opts, file) {
	const upload = createMultipartUpload({
		file,
		api: createEditorMultipartApi(opts)
	});
	try {
		return (await upload.start()).url;
	} catch (error) {
		try {
			upload.cancel();
		} catch (cancelError) {
			console.error("Failed to cancel multipart upload", cancelError);
		}
		throw error;
	}
}
//#endregion
//#region src/extensions/media-uploader/uploadMediaToServer.ts
/**
* Files larger than this upload via resumable S3 multipart; smaller files use a
* single PUT. 10 MiB.
*/
const MULTIPART_THRESHOLD_BYTES = 10 * 1024 * 1024;
/**
* Upload a media file to the Cadmus media API and return its `src` URL.
*
* Media over {@link MULTIPART_THRESHOLD_BYTES} uploads via resumable S3
* multipart where the backend supports it ({@link uploadMediaMultipart});
* everything else uses a single PUT ({@link uploadMediaSinglePut}).
*
* The returned URL points to an endpoint on the Cadmus API. Setting it as the
* media `src` makes the browser issue a `GET` that redirects to a presigned S3
* URL, so almost no file transfer passes through the Cadmus servers.
*
* The `editor` instance is used to read the `media-uploader` extension options,
* which carry the Cadmus API parameters the requests need. Please ensure that
* extension is configured on the passed `editor`.
*
* @param editor Editor instance containing the `media-uploader` extension
* @param file Media file to upload
* @return Promise of the uploaded media `src`
* @throws {Error} On network failures or missing extension options
*/
async function uploadMediaToServer(editor, file) {
	try {
		const opts = await getMediaUploaderOpts(editor);
		return opts.enableMultipartUpload === true && file.size > MULTIPART_THRESHOLD_BYTES ? await uploadMediaMultipart(opts, file) : await uploadMediaSinglePut(editor, file);
	} catch (error) {
		return Promise.reject(error);
	}
}
/**
* Upload media with a single presigned PUT, in three steps: reserve a DB entry
* under a `mediaId` and get a presigned URL, PUT the file to it, then confirm
* the upload and receive the final media `src` URL.
*/
async function uploadMediaSinglePut(editor, file) {
	const { endpoint, id } = await getMediaUploadEndpoint(editor, file);
	await uploadMediaToEndpoint(endpoint, file);
	return getUploadedMediaSrc(editor, id);
}
async function getMediaUploadEndpoint(editor, media) {
	const { workId, assessmentId, tenant, mediaAPIBase, userRole, userId } = await getMediaUploaderOpts(editor);
	const data = await (await request(buildData({
		filename: media.name,
		type: media.type,
		workId,
		assessmentId,
		userId
	}), `${mediaAPIBase}/upload_url`, "post", cadmusHeaders(tenant, userRole, userId))).json();
	if (data?.endpoint && data?.id) return data;
	return Promise.reject(/* @__PURE__ */ new Error("failed uploading media"));
}
async function uploadMediaToEndpoint(endpoint, file) {
	return statusOk(await fetch(endpoint, {
		method: "put",
		body: file,
		mode: "cors"
	}));
}
async function getUploadedMediaSrc(editor, mediaId) {
	const { tenant, mediaAPIBase, userRole, userId } = await getMediaUploaderOpts(editor);
	const data = await (await request(buildData({ mediaId }), `${mediaAPIBase}/upload`, "post", cadmusHeaders(tenant, userRole, userId))).json();
	if (data?.src) return data.src;
	return Promise.reject(/* @__PURE__ */ new Error("failed uploading media"));
}
async function getMediaUploaderOpts(editor) {
	const MediaUploaderExt = editor.extensionManager.extensions.find((ext) => ext.name === "mediaUploader");
	if (!MediaUploaderExt) return Promise.reject(/* @__PURE__ */ new Error("Media API is not set"));
	return MediaUploaderExt.options;
}
const cadmusHeaders = (tenant, userRole, userId) => ({
	"x-cadmus-tenant": tenant ?? "",
	"x-cadmus-role": userRole ?? "",
	"x-cadmus-user": userId ?? ""
});
async function statusOk(response) {
	if (response.ok) return Promise.resolve(response);
	return Promise.reject(/* @__PURE__ */ new Error("failed uploading media"));
}
async function request(body, endpoint, method, headers = {}) {
	return statusOk(await fetch(endpoint, {
		method,
		body,
		headers: {
			Accept: "application/json",
			...headers
		},
		credentials: "include"
	}));
}
function buildData(args) {
	const body = new FormData();
	Object.entries(args).forEach(([key, value]) => value && body.append(key, value));
	return body;
}
//#endregion
//#region src/extensions/media-uploader/insertMedia.ts
/**
* Insert one or more media files into the Editor.
*
* The media files are all compressed (client-side) and uploaded to the Cadmus server
* API. The media files are inserted in the current selection position by finding the
* correct location the media can be inserted.
*
* The function returns while the media uploading and insertion happens
* asynchronously.
*
* @param editor Editor to insert the media into
* @param files array of media files to upload and insert with its caption
* @param insertAt optional override position to insert the media.
*/
async function insertMedia(editor, files, mediaType, insertAt) {
	const { tr, doc } = editor.view.state;
	const $pos = insertAt ? doc.resolve(insertAt) : tr.selection.$from;
	const node = $pos.node($pos.depth);
	const isEmpty = node?.content.size === 0;
	let pos = $pos.pos;
	if (isEmpty) {
		const from = $pos.before($pos.depth);
		const to = from + node.nodeSize;
		tr.delete(from, to);
		pos = from;
	} else pos = $pos.after($pos.depth + 1);
	const length = files.length;
	const start = lowestDecoSide(findPlaceholdersAtPos(editor.view.state, pos)) - length;
	await Promise.all(files.map((file, index) => uploadMedia(editor, file, mediaType, pos, start + index)));
}
function lowestDecoSide(decos) {
	let lowest = 0;
	if (decos) decos.forEach((deco) => {
		if (deco.spec.side < lowest) lowest = deco.spec.side;
	});
	return lowest;
}
async function uploadMedia(editor, file, mediaType, pos, side) {
	const id = {};
	const isAllowed = !!(await mediaMimes(file[0])).find((mime) => isAllowedMimeType(mime, mediaType));
	const view = editor.view;
	if (!isAllowed) {
		setMediaUploaderTransactionMeta(editor, [{
			type: "addError",
			id,
			pos,
			message: "Media file type is not supported"
		}]);
		return;
	}
	try {
		const compressedFile = mediaType === "image" ? await compressImage(file[0]) : file[0];
		const src = await readMediaFile(compressedFile);
		const width = mediaType === "image" ? await getImageWidth(compressedFile) : void 0;
		setMediaUploaderTransactionMeta(editor, [addMediaPlaceholder({
			id,
			pos,
			src,
			width,
			side,
			mediaType
		})]);
		const mediaSrc = await uploadMediaToServer(editor, compressedFile);
		const placeholderPos = findUploadPlaceholder(view.state, id);
		if (placeholderPos === null) return;
		const placeholderText = file[1] ?? "";
		if (mediaType === "image") editor.commands.setImage({
			src: mediaSrc,
			width: width && width >= 800 ? "fitToText" : "original",
			position: placeholderPos,
			hasCaption: !!placeholderText,
			caption: placeholderText
		});
		else if (mediaType === "audio") editor.commands.setAudio({
			src: mediaSrc,
			position: placeholderPos,
			hasCaption: !!placeholderText,
			caption: placeholderText
		});
		else if (mediaType === "video") editor.commands.setVideo({
			src: mediaSrc,
			position: placeholderPos,
			hasCaption: !!placeholderText,
			caption: placeholderText
		});
		setMediaUploaderTransactionMeta(editor, repositionedPlaceholders(editor, placeholderPos, placeholderText.length, id));
	} catch (error) {
		console.error(error);
		const placeholderPos = findUploadPlaceholder(view.state, id);
		if (placeholderPos !== null) setMediaUploaderTransactionMeta(editor, [removePlaceholder(id), addErrorPlaceholder({
			id,
			pos: placeholderPos
		})]);
		else setMediaUploaderTransactionMeta(editor, [addErrorPlaceholder({
			id,
			pos
		})]);
	}
}
/**
* Helper function to repositioned upload placeholder widget(s).
* As the upload happens asynchronously, the insertion order of the media
* would be different to when it got uploaded and truly inserted to the
* editor state. Hence the need to move the placeholder widget around if media
* at the start or mid of the order ended up uploaded first, all the upload
* widget that is after the uploaded media widget need to be moved to after the
* inserted node to retain the order
*/
function repositionedPlaceholders(editor, placeholderPos, captionLength, deletedId) {
	const placeholders = findPlaceholdersAtPos(editor.view.state, placeholderPos);
	const uploadedSide = (placeholders?.find((deco) => deco.spec.id === deletedId))?.spec.side;
	const movedPlaceholders = placeholders?.filter((deco) => deco.spec.side > uploadedSide);
	const placeholderMetas = [removePlaceholder(deletedId)];
	if (movedPlaceholders) {
		placeholderMetas.push(...movedPlaceholders.map((deco) => removePlaceholder(deco.spec.id)));
		movedPlaceholders.forEach((deco) => {
			const { id, width, src, mediaType } = deco.spec;
			if (id && src && mediaType) placeholderMetas.push(addMediaPlaceholder({
				id,
				width,
				src,
				mediaType,
				pos: placeholderPos + captionLength + 2
			}));
		});
	}
	return placeholderMetas;
}
//#endregion
//#region src/extensions/media-uploader/patchMedia.ts
/**
* Patch media coming from paste by converting them to media
* upload widget if fetchable & supported mime type otherwise
* display a media upload error widget
*
* TODO: Currently only support image upload, other media type support will be added in the future
*/
function patchMedia(editor, tr) {
	const { mediaAPIBase } = editor.extensionManager.extensions.find((ext) => ext.name === "mediaUploader")?.options ?? {};
	const isInvalidMedia = (node) => {
		if (node.type.name === "image") return new URL(mediaAPIBase).hostname !== new URL(node.attrs.src).hostname;
		return false;
	};
	let invalidMedia;
	const queuedMedia = [];
	while ((invalidMedia = findChildren(tr.doc, isInvalidMedia)) && invalidMedia.length !== 0) {
		const { node, pos } = invalidMedia[0];
		const { src } = node.attrs;
		const { textContent } = node;
		if (src && !/^file/.test(src)) queuedMedia.push([
			src,
			pos,
			textContent
		]);
		tr.delete(pos, pos + node.nodeSize);
	}
	if (queuedMedia.length) setTimeout(() => {
		queuedMedia.forEach(([src, pos, textContent]) => {
			const canvas = document.createElement("canvas");
			const context = canvas.getContext("2d");
			const image = new Image();
			image.crossOrigin = "Anonymous";
			image.onload = () => {
				canvas.width = image.naturalWidth;
				canvas.height = image.naturalHeight;
				context?.drawImage(image, 0, 0);
				canvas.toBlob((blob) => {
					if (blob) insertMedia(editor, [[blobToFile(blob, { type: "image/png" }), textContent]], "image", pos);
					else setMediaUploaderTransactionMeta(editor, [addErrorPlaceholder({
						id: {},
						pos
					})]);
				});
			};
			image.onerror = () => {
				setMediaUploaderTransactionMeta(editor, [addErrorPlaceholder({
					id: {},
					pos
				})]);
			};
			image.src = src;
		});
	}, 0);
	return tr;
}
//#endregion
//#region src/extensions/audio/audio-plugin.ts
const AudioPlugin = (editor) => new Plugin({
	appendTransaction: (_transactions, _oldState, newState) => {
		const sel = findSelectedNodeByType(newState, "audio");
		if (!sel) return null;
		const { node, from } = sel;
		if (node.attrs.hasCaption === false) {
			const nodeSelection = NodeSelection.create(newState.doc, from);
			return newState.tr.setSelection(nodeSelection);
		}
		return null;
	},
	props: { handleDOMEvents: {
		paste(view, event) {
			if (!event.clipboardData || !isPastedFile(event)) return false;
			if (event.clipboardData?.getData("text/html")) return false;
			const files = Array.from(event.clipboardData.items).map((dt) => dt.getAsFile()).filter((file) => file !== null);
			if (files.length === 0) return false;
			const { tr } = view.state;
			if (!tr.selection.empty) tr.deleteSelection();
			const pos = tr.selection.from;
			const audios = files.filter((file) => /audio/i.test(file.type)).map((file) => [file, ""]);
			if (audios.length === 0) return false;
			insertMedia(editor, audios, "audio", pos);
			return true;
		},
		drop(view, event) {
			if (!isDroppedFile(event)) return false;
			if (event.dataTransfer?.getData("text/html")) return false;
			const audios = getDataTransferFiles(event).filter((file) => /audio/i.test(file.type)).map((file) => [file, ""]);
			if (audios.length === 0) return false;
			const result = view.posAtCoords({
				left: event.clientX,
				top: event.clientY
			});
			if (result) {
				event.preventDefault();
				insertMedia(editor, audios, "audio", result.pos);
				return true;
			}
			return false;
		}
	} }
});
//#endregion
//#region src/extensions/audio/audio.ts
const Audio = Node$1.create({
	name: "audio",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block",
	content: "inline*",
	selectable: true,
	draggable: true,
	defining: true,
	allowGapCursor: true,
	addNodeView() {
		return ({ node, getPos, editor, HTMLAttributes }) => new AudioNodeView(node, getPos, HTMLAttributes, editor);
	},
	addAttributes() {
		return {
			src: {
				default: null,
				parseHTML: (element) => element.getAttribute("data-src")
			},
			hasCaption: {
				default: false,
				parseHTML: (element) => {
					return !!element.querySelector(".media-caption");
				}
			}
		};
	},
	parseHTML() {
		return [{ tag: "figure[data-audio]" }];
	},
	renderHTML({ node }) {
		const { src, hasCaption } = node.attrs;
		return renderMediaHTML("audio", src, hasCaption);
	},
	addKeyboardShortcuts() {
		return { Enter: ({ editor }) => {
			const sel = editor.state.selection;
			const parentAudioNode = findParentNode((node) => {
				return node.type == editor.schema.nodes.audio;
			})(sel);
			if (!parentAudioNode) return false;
			const endPos = parentAudioNode.pos + parentAudioNode.node.nodeSize;
			editor.chain().insertContentAt(endPos, { type: "paragraph" }).run();
			return true;
		} };
	},
	addCommands() {
		return {
			setAudio: (options) => ({ tr, dispatch, state }) => {
				const { caption } = options;
				let node;
				if (caption?.length) node = this.type.create(options, state.schema.text(caption));
				else node = this.type.create(options);
				if (options.position !== void 0) {
					if (dispatch) tr.insert(options.position, node);
				} else {
					const { selection } = tr;
					if (dispatch) tr.replaceRangeWith(selection.from, selection.to, node);
				}
				return true;
			},
			setAudioSrc: (options) => ({ tr, dispatch }) => {
				const nodeType = this.type;
				if (tr.doc.nodeAt(options.position)?.type === nodeType) {
					if (dispatch) tr.setNodeAttribute(options.position, "src", options.src);
					return true;
				}
				return false;
			},
			toggleAudioCaption: () => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "audio");
				if (!sel) return false;
				const { node, from } = sel;
				const { hasCaption } = node.attrs;
				if (hasCaption === true) return chain().setNodeSelection(from).updateAttributes(this.name, { hasCaption: false }).deleteRange({
					from: from + 1,
					to: from + node.nodeSize
				}).run();
				if (hasCaption === false) return chain().setNodeSelection(from).updateAttributes(this.name, { hasCaption: true }).run();
				return true;
			},
			deleteAudio: () => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "audio");
				if (sel) {
					const { node, from } = sel;
					return chain().deleteRange({
						from,
						to: from + node.nodeSize
					}).run();
				}
				return false;
			}
		};
	},
	addProseMirrorPlugins() {
		return [new Plugin({ appendTransaction: (_, __, state) => {
			const { doc, tr, schema } = state;
			if (doc.nodeAt(0)?.type.name === "audio") {
				const type = schema.nodes["paragraph"];
				return tr.insert(0, type.create());
			}
			return null;
		} }), AudioPlugin(this.editor)];
	}
});
//#endregion
//#region src/core/helpers/rangeFromTransaction.ts
/**
* Calculates the affected document range based on the steps within a
* Prosemirror transaction.
*
* @param {Transaction} tr - The Prosemirror transaction to analyze.
* @returns {DocRange} An object containing the calculated start and end
* positions of the affected range:
*   * `from`: The starting position of the affected range.
*   * `to`: The ending position of the affected range.
*/
function rangeFromTransaction(tr) {
	let from, to;
	for (let i = 0; i < tr.steps.length; i++) {
		const step = tr.steps[i];
		const stepMapping = step.getMap();
		const stepFrom = stepMapping.map(step.from || step.pos, -1);
		const stepTo = stepMapping.map(step.to || step.pos, 1);
		if (from) from = Math.min(stepMapping.map(from, -1), stepFrom);
		else from = stepFrom;
		if (to) to = Math.max(stepMapping.map(to, 1), stepTo);
		else to = stepTo;
	}
	return {
		from,
		to
	};
}
//#endregion
//#region src/core/text/regex.ts
const WORD_REGEX = /[\p{P}\p{L}\p{N}\p{M}-]+|[a-zA-Z0-9_\-–—'’\u0392-\u03c9\u0400-\u04FF\u0027\u00C0-\u017F]+|[\u4E00-\u9FFF\u3400-\u4dbf\uf900-\ufaff\u3040-\u309f\uac00-\ud7af\u0400-\u04FF]+|[\u00E4\u00C4\u00E5\u00C5\u00F6\u00D6]+|[\u0531-\u0556\u0561-\u0586\u0559\u055A\u055B]+|w+/gu;
/**
* Extend a `basseRegex` with prefix, postfix, and flags, creating a new RegExp.
*/
function buildRegex(baseRegex, prefix = "", postfix = "", flags) {
	return new RegExp(`${prefix}${baseRegex.source}${postfix}`, flags ?? baseRegex.flags);
}
/**
* Combine 2 regexps with a boolean OR.
*
* e.g.
* const a = /regexa/
* const b = /regexb/
* const c = combineRegex(a, b) === /((regexa)|(regexb))/
*/
function combineRegex(firstRegex, secondRegex, flags) {
	return new RegExp(`((${firstRegex.source})|(${secondRegex.source}))`, flags);
}
/**
* RegExp for well formed URLs.
* Taken from https://gist.github.com/dperini/729294
*/
const BASE_URL_REGEX = /* @__PURE__ */ new RegExp("(?:(?:(?:https?):)?\\/\\/)?(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z0-9\\u00a1-\\uffff][a-z0-9\\u00a1-\\uffff_-]{0,62})?[a-z0-9\\u00a1-\\uffff]\\.)+(?:[a-z\\u00a1-\\uffff]{2,}\\.?))(?::\\d{2,5})?(?:[/?#]\\S*)?", "i");
buildRegex(BASE_URL_REGEX, "^", "$", "gui");
const URL_REGEX_EXACT = buildRegex(BASE_URL_REGEX, "^", "$", "ui");
const URL_OR_WORD_REGEX = combineRegex(BASE_URL_REGEX, WORD_REGEX, "gu");
/** RegEx for parsing Markdown style `CodeBlock`*/
const MARKDOWN_CODEBLOCK_REGEX = /* @__PURE__ */ new RegExp(/```([a-z]*)\n([\s\S]*?)\n```/, "ui");
/** RegEx to parse markdown style input for `CodeBlock` along with the language   */
const CODEBLOCK_MARKDOWN_INPUT_REGEX = /^```([a-z]+)?[\s\n]$/;
//#endregion
//#region src/core/text/url.ts
function isValidURL(url) {
	return URL_REGEX_EXACT.test(url);
}
//#endregion
//#region src/core/text/tokeniser.ts
/**
* Create a set of unique words and the total word count for the given range in
* a Node (and its decendants).
*/
function tokeniseUniqueWords(doc, from, to) {
	const words = /* @__PURE__ */ new Set();
	let wordCount = 0;
	const matches = wordRegexMatchAll(textBetween(doc, " ", from, to));
	for (const match of matches) {
		words.add(match[0]);
		wordCount++;
	}
	return [words, wordCount];
}
/**
* Process chunks of tokenisable plain text under node `topNode` in the given range.
*
* A chunk of text is considered tokenisable if it contains "word" tokens. The
* end boundary of such a chunk might contain additional leftover text which was
* not considered tokenisable and should be considered as one opaque word token.
*
* This condition to decide what's an opaque leftover can be customised by
* passing a custom `ignoreNode` predicate. The default heuristic is to check
* for text nodes which should behave as 1 single word (like link nodes with a
* valid URL).
*
* @param topNode start node whose descendants are iterated over
* @param from start position inside the `topNode`
* @param to end position inside the `topNode`
* @param onProcessChunk callback receiving the tokenisable plain text, the start position of this text, and extra
*   single token leftover if any.
* @param ignoreNode optional predicate to provide the condition where a text
*   node should be ignored or not considered tokenisable, and instead included in
*   the leftover chunk. As mentioned, this node becomes the cutoff point for the
*   current chunk.
*/
function processTextBetween(topNode, from, to, onProcessChunk, ignoreNode = isOneWordNode) {
	let textFrom = from;
	let text = "";
	let startConcat = false;
	topNode.nodesBetween(from, to, (node, pos) => {
		if (node.isText) {
			if (startConcat) textFrom = pos;
			if (ignoreNode(node)) {
				onProcessChunk(text, textFrom, node.text ?? null);
				startConcat = true;
				text = "";
			} else {
				text += node.text;
				startConcat = false;
			}
		} else if (node.isBlock) {
			if (ignoreNode(node)) return false;
			onProcessChunk(text, textFrom, null);
			startConcat = true;
			text = "";
		} else if (node.type.name === "hardBreak") {
			text += "\n";
			startConcat = false;
		} else if (node.isInline) if (ignoreNode(node)) {
			onProcessChunk(text, textFrom, null);
			startConcat = true;
			text = "";
			return false;
		} else {
			text += node.text;
			startConcat = false;
		}
	});
	if (text !== "") onProcessChunk(text, textFrom, null);
}
function isOneWordNode(node) {
	if (node.marks.some((mark) => mark.type.name === "link")) return isValidURL(node.text ?? "");
	return false;
}
/** Run a Regexp `match` on a given string using a well-defined `WORD_REGEX`. */
function wordRegexMatch(text) {
	return text.match(URL_OR_WORD_REGEX);
}
/**  Run a Regexp `matchAll` on a given string using a well-defined `WORD_REGEX`. */
function wordRegexMatchAll(text) {
	return text.matchAll(URL_OR_WORD_REGEX);
}
/**
* Characters allowed inside a spellable word: apostrophes (straight, backtick,
* and the curly variants word processors substitute) and the ASCII hyphen for
* compounds. Everything else, including em/en dashes and quotes, separates
* words. A token is also trimmed of any of these that dangle at either end.
*
* This deliberately mirrors the server's tokeniser (see suggestion-rs
* `is_word_char`/`word_parser`) so that the phrases we decorate match the
* phrases the server flags. The shared `WORD_REGEX` cannot be used here because
* it greedily absorbs all punctuation (e.g. "porposal.." stays one token),
* which never matches the server's normalised "porposal".
*/
const SPELLABLE_CONNECTORS = "'`‘’-";
const SPELLABLE_WORD_REGEX = new RegExp(`[\\p{L}${SPELLABLE_CONNECTORS}]+`, "gu");
const LEADING_CONNECTORS = new RegExp(`^[${SPELLABLE_CONNECTORS}]+`, "u");
const DANGLING_CONNECTORS = new RegExp(`^[${SPELLABLE_CONNECTORS}]+|[${SPELLABLE_CONNECTORS}]+$`, "gu");
const HAS_LETTER = /\p{L}/u;
/**
* Tokenise a chunk of plain text into spellable words for spelling suggestions,
* matching the server's tokenisation so looked-up phrases align with flagged
* ones. Yields each word together with its offset within `text`.
*/
function* spellableWordsMatchAll(text) {
	for (const match of text.matchAll(SPELLABLE_WORD_REGEX)) {
		const raw = match[0];
		const matchIndex = match.index;
		if (!raw || matchIndex === void 0) continue;
		const leadingTrim = LEADING_CONNECTORS.exec(raw)?.[0].length ?? 0;
		const word = raw.replace(DANGLING_CONNECTORS, "");
		if (!HAS_LETTER.test(word)) continue;
		yield {
			word,
			index: matchIndex + leadingTrim
		};
	}
}
//#endregion
//#region src/core/text/word-count.ts
/**
* Get total word count across all text nodes in the given document.
*/
function nodeWordCount(topNode) {
	return textWordCount(textBetween(topNode, " "));
}
/**
* Get text inside node/fragment separated by "blockSeparator" excluding
* nodes which have attrs.hideText
* @param {PMNode | Fragment} node [top most node or fragment]
* @param {string} blockSeparator [separator used for in between blocks]
* @param {number} from [start position of the node]
* @param {number} to [end position of the node]
*/
function textBetween(node, blockSeparator, from, to) {
	const nodeSize = node instanceof Node$2 ? node.content.size : node.size;
	const topBoundary = to ?? nodeSize;
	const bottomBoundary = from ?? 0;
	let text = "", separated = true;
	const leafText = " ";
	node.nodesBetween(bottomBoundary, topBoundary, (node, pos) => {
		if (node.attrs.hideText) return false;
		if (node.isText) {
			text += node?.text?.slice(Math.max(bottomBoundary, pos) - pos, topBoundary - pos) ?? "";
			separated = !blockSeparator;
		} else if (node.isLeaf && leafText) {
			text += leafText;
			separated = !blockSeparator;
		} else if (!separated && node.isBlock) {
			text += blockSeparator;
			separated = true;
		}
		return true;
	}, 0);
	return text;
}
/**
* Get word count for currently selected text nodes in the given `state`.
*/
function selectionWordCount(state) {
	const { doc, selection } = state;
	if (selection) {
		const { from, to } = selection;
		return textWordCount(textBetween(doc, " ", from, to));
	}
	return 0;
}
/** Plain text word count. */
function textWordCount(text) {
	const match = wordRegexMatch(text.trim());
	return match ? match.length : 0;
}
/**
* Get word count from HTML string.
*/
function getHTMLWordCount(html) {
	let text = "";
	const parser = new Parser({ ontext(data) {
		text += data + " ";
	} }, { decodeEntities: true });
	parser.write(html);
	parser.end();
	return textWordCount(text.trim());
}
//#endregion
//#region src/core/text/plain-text.ts
/**
* Get document concatenated text separated by `\n.
*/
function getText(doc, extensions) {
	const schema = getSchema(extensions);
	return nodeText(Node$2.fromJSON(schema, doc));
}
/**
* Get node concatenated text separated by `\n.
*/
function nodeText(node) {
	return textBetween(node, "\n");
}
//#endregion
//#region src/core/text/word-count-changes.ts
/**
* Get the word count changes from a transaction.
* @param transaction - The transaction to get the word count changes from.
* @returns The word count changes.
*/
function wordCountChanges(transaction) {
	const { before: oldDoc, doc } = transaction;
	let changeset = ChangeSet.create(oldDoc);
	let deletedWords = 0;
	let addedWords = 0;
	changeset = changeset.addSteps(doc, transaction.mapping.maps, void 0);
	changeset.changes.forEach((change) => {
		const { deleted, fromA, toA, fromB, toB, inserted } = change;
		if (deleted) deletedWords += wordRegexMatch(oldDoc.textBetween(fromA, toA, "\n"))?.length ?? 0;
		if (inserted) addedWords += wordRegexMatch(doc.textBetween(fromB, toB, "\n"))?.length ?? 0;
	});
	return {
		addedWords,
		deletedWords
	};
}
//#endregion
//#region src/extensions/code-block/types.ts
const LANGUAGE_CONFIG = {
	["c"]: {
		label: "C",
		mode: "text/x-csrc",
		markdown: ["c"]
	},
	["c++"]: {
		label: "C++",
		mode: "text/x-c++src",
		markdown: [
			"c++",
			"cpp",
			"cplusplus"
		]
	},
	["c#"]: {
		label: "C#",
		mode: "text/x-csharp",
		markdown: ["cs", "csharp"]
	},
	["java"]: {
		label: "Java",
		mode: "text/x-java",
		markdown: ["java"]
	},
	["scala"]: {
		label: "Scala",
		mode: "text/x-scala",
		markdown: ["scala"]
	},
	["kotlin"]: {
		label: "Kotlin",
		mode: "text/x-kotlin",
		markdown: ["kotlin", "kt"]
	},
	["objective-c"]: {
		label: "Objective C",
		mode: "text/x-objectivec",
		markdown: ["objc", "objectivec"]
	},
	["javascript"]: {
		label: "JavaScript",
		mode: "javascript",
		markdown: [
			"coffeescript",
			"ecmascript",
			"javascript",
			"js",
			"node"
		]
	},
	["typescript"]: {
		label: "TypeScript",
		mode: "text/typescript",
		markdown: ["ts", "typescript"]
	},
	["json"]: {
		label: "JSON",
		mode: "application/json",
		markdown: ["json"]
	},
	["html"]: {
		label: "HTML",
		mode: "text/html",
		markdown: [
			"html",
			"xhtml",
			"xml"
		]
	},
	["css"]: {
		label: "CSS",
		mode: "text/css",
		markdown: [
			"css",
			"less",
			"sass",
			"scss",
			"styl",
			"stylus"
		]
	},
	["r"]: {
		label: "R",
		mode: "r",
		markdown: ["r"]
	},
	["python"]: {
		label: "Python",
		mode: "python",
		markdown: ["py", "python"]
	},
	["yaml"]: {
		label: "YAML",
		mode: "yaml",
		markdown: ["yaml", "yml"]
	},
	["markdown"]: {
		label: "Markdown",
		mode: "markdown",
		markdown: ["markdown"]
	},
	["go"]: {
		label: "Go",
		mode: "go",
		markdown: ["go"]
	},
	["shell"]: {
		label: "Shell",
		mode: "text/x-sh",
		markdown: [
			"bash",
			"sh",
			"shell",
			"zsh"
		]
	},
	["matlab"]: {
		label: "Matlab",
		mode: "text/x-octave",
		markdown: ["matlab", "Matlab"]
	},
	["sql"]: {
		label: "SQL",
		mode: "text/x-sql",
		markdown: ["sql", "SQL"]
	},
	["elixir"]: {
		label: "Elixir",
		mode: "elixir",
		markdown: [
			"elixir",
			"ex",
			"exs"
		]
	},
	["haskell"]: {
		label: "Haskell",
		mode: "haskell",
		markdown: ["haskell", "hs"]
	},
	["plain"]: {
		label: "Plain Text",
		mode: "plain",
		markdown: [""]
	}
};
//#endregion
//#region src/extensions/code-block/utils.ts
/** Get the display name for the given `CodeBlockLanguage` */
const getLanguageDisplay = (language) => {
	return LANGUAGE_CONFIG[language]["label"];
};
/**
* Get the `CodeMirror` language mode for a given `CodeBlockLanguage` to create
* a mapping from language options to `CodeMirror` modes
*/
const getLanguageMode = (language) => {
	return LANGUAGE_CONFIG[language]["mode"];
};
/**
* Finds the parent `codeBlock` node from a given selection, if the selection is
* in a `codeBlock`
*/
const findCodeBlockSelection = (selection) => findParentNode((node) => node.type.name == "codeBlock")(selection);
/** Parses a language name written in markdown syntax to a `CodeBlockLanguage` */
const parseMarkdownLanguage = (lang) => {
	for (const [key, value] of Object.entries(LANGUAGE_CONFIG)) if (value.markdown.includes(lang)) return key;
	return "plain";
};
//#endregion
//#region src/extensions/code-block/plugins/code-block-delete-indicator-plugin.ts
/** `PluginKey` for `CodeBlockDeleteIndicator` */
const CodeBlockDeleteIndicatorPluginKey = new PluginKey("CodeBlockDeleteIndicator");
/**
* Plugin to style a `CodeBlock` to indicate that it is being deleted by adding a class to the
* `CodeBlock`'s `NodeView`
*/
const CodeBlockDeleteIndicatorPlugin = () => new Plugin({
	key: CodeBlockDeleteIndicatorPluginKey,
	state: {
		init() {
			return { highlight: false };
		},
		apply(tr, currentState) {
			const payload = tr.getMeta(CodeBlockDeleteIndicatorPluginKey);
			if (payload) return payload;
			return currentState;
		}
	},
	props: { decorations(editorState) {
		if (this.getState(editorState)?.highlight) {
			const codeBlock = findCodeBlockSelection(editorState.selection);
			const decorations = [];
			if (codeBlock) decorations.push(Decoration.node(codeBlock.pos, codeBlock.pos + codeBlock.node.nodeSize, { class: "code-block-pre-delete" }));
			return DecorationSet.create(editorState.doc, decorations);
		}
		return DecorationSet.empty;
	} }
});
//#endregion
//#region src/extensions/code-block/plugins/code-block-paste-plugin.ts
const CodeBlockPastePluginKey = new PluginKey("codeBlockPastePlugin");
/**
* Plugin that is used to track paste metadata relating to codeblock
* whether its source is from `vscode` or `markdown` or `undefined`
* when deduction can't be made on where it's coming from or even a
* code block at all. In addition to that, it is also try to parse
* the codeblock's language if the source is from `vscode` or `markdown`.
* This plugin is also used to track whether selection is inside a codeblock
* or not when the paste happen as if it is inside `codeBlock` then text only
* paste is probably desired rather than a prosemirror's slice that comes from
* most likely parsing `html` if the paste event have html clipboard.
*/
const CodeBlockPastePlugin = () => {
	return new Plugin({ key: CodeBlockPastePluginKey });
};
//#endregion
//#region src/extensions/table/constants.ts
/**
* Default applied color when alternate table color is selected
*/
const defaultTableColor = transparentize(.94, colors.blue500);
/**
* A list of possible colors that can be applied to table / cells
*/
const tableColors = [
	{
		button: opacify(.19, colors.grey50),
		actual: colors.grey50
	},
	{
		button: transparentize(.75, colors.blue500),
		actual: defaultTableColor
	},
	{
		button: transparentize(.75, colors.green500),
		actual: transparentize(.94, colors.green500)
	},
	{
		button: transparentize(.75, colors.yellow500),
		actual: transparentize(.94, colors.yellow500)
	},
	{
		button: transparentize(.75, colors.red500),
		actual: transparentize(.94, colors.red500)
	},
	{
		button: transparentize(.75, colors.indigo500),
		actual: transparentize(.94, colors.indigo500)
	}
];
//#endregion
//#region src/extensions/paste/cleaner/clipboard-cleaner.ts
/**  General fallback handler for HTML Paste */
var ClipboardCleaner = class {
	outHTML;
	doc;
	dom;
	constructor(doc) {
		this.doc = doc;
	}
	getOutput() {
		this.dom = this.doc.getElementsByTagName("body")[0];
		this.iterateNode(this.dom);
		this._patchDocument();
		this.cleanDOM();
		this.outHTML = this.dom.innerHTML;
		return this.outHTML;
	}
	_patchDocument() {
		this.patchDocument();
	}
	patchDocument() {
		(this.dom?.querySelectorAll("img"))?.forEach((img) => {
			const parent = img.parentElement;
			if (parent && parent.tagName.toLowerCase() !== "figure") {
				const figure = document.createElement("figure");
				figure.appendChild(img);
				if (parent.nextSibling && parent.parentNode) parent.parentNode.insertBefore(figure, parent.nextSibling);
				else this.dom?.appendChild(figure);
			}
		});
		(this.dom?.querySelectorAll("table"))?.forEach((table) => {
			table.querySelectorAll("tr")?.forEach((tr) => {
				const cols = tr.querySelectorAll("td,th");
				if (cols) {
					const colNum = Array.from(cols).reduce((acc, col) => {
						const colSpan = col.getAttribute("colSpan") ?? "1";
						return acc + parseInt(colSpan, 10);
					}, 0) ?? 1;
					cols.forEach((col) => {
						const colSpan = col.getAttribute("colSpan") ?? "1";
						const colWidth = 800 / colNum * parseInt(colSpan, 10);
						col.setAttribute("colwidth", `${colWidth}`);
					});
				}
			});
		});
	}
	iterateNode(node) {
		if (node.tagName === "P" && !node.firstChild) {
			node.parentNode?.removeChild(node);
			return;
		} else if (node.nodeType === Node.COMMENT_NODE) {
			node.parentNode?.removeChild(node);
			return;
		} else if (node.nodeType === Node.ELEMENT_NODE) {
			let childNode = node.firstChild;
			while (childNode) {
				const nextChildNode = childNode.nextSibling;
				this.iterateNode(childNode);
				childNode = nextChildNode;
			}
			node = this.convertNode(node);
		}
	}
	cleanDOM() {}
	convertNode(node) {
		if (node.tagName === "THREAD") {
			const newNode = document.createElement("span");
			newNode.innerHTML = node.innerHTML;
			node.parentNode?.replaceChild(newNode, node);
			return newNode;
		}
		return node;
	}
};
//#endregion
//#region src/extensions/paste/cleaner/google-docs-clipboard-cleaner.ts
var GoogleDocsClipboardCleaner = class extends ClipboardCleaner {
	convertNode(node) {
		super.convertNode(node);
		const element = node;
		if (element.tagName === "B" && element.style.fontWeight === "normal") return this.neutralizeInlineNode(node);
		return node;
	}
	neutralizeInlineNode(node) {
		const newNode = document.createElement("span");
		while (node.firstChild) newNode.appendChild(node.firstChild);
		node.parentNode?.replaceChild(newNode, node);
		return newNode;
	}
};
//#endregion
//#region src/extensions/paste/cleaner/microsoft-word-clipboard-cleaner.ts
var MicrosoftWordClipboardCleaner = class extends ClipboardCleaner {
	cleanDOM() {
		(this.dom?.querySelectorAll("div[style*=\"mso-element:footnote-list\"]"))?.forEach((el) => el?.parentNode?.removeChild(el));
	}
	iterateNode(node) {
		const element = node;
		if (element.tagName === "P" && !element.firstChild) {
			node.parentNode?.removeChild(node);
			return true;
		} else if (node.nodeType === Node.COMMENT_NODE) if (node.textContent === "EndFragment") {
			while (node) {
				const nextSibling = node.nextSibling;
				node.parentNode?.removeChild(node);
				node = nextSibling;
			}
			return false;
		} else {
			node.parentNode?.removeChild(node);
			return true;
		}
		if (node.nodeType === Node.ELEMENT_NODE) {
			let childNode = node.firstChild;
			while (childNode) {
				const nextChildNode = childNode.nextSibling;
				if (this.iterateNode(childNode)) childNode = nextChildNode;
				else childNode = false;
			}
			node = this.convertNode(node);
		}
		return true;
	}
};
//#endregion
//#region src/extensions/paste/cleaner/parseHTMLString.ts
function parseHTMLString(html) {
	return new DOMParser().parseFromString(html, "text/html");
}
//#endregion
//#region src/extensions/paste/cleaner/paste-origin.ts
function htmlPasteOrigin(doc) {
	const body = doc.getElementsByTagName("body")[0];
	const html = doc.getElementsByTagName("html")[0];
	const firstB = body.querySelector("b");
	const firstElement = body.firstElementChild;
	if (html.hasAttribute("xmlns:w")) return "Microsoft Word";
	else if (firstB?.id?.startsWith("docs-internal-guid")) return "Google Docs";
	else if (firstElement?.hasAttribute("data-pm-slice")) return "prosemirror";
	else return "Unknown";
}
//#endregion
//#region src/extensions/paste/cleaner/cleanPastedHTML.ts
function cleanPastedHTML(htmlString) {
	const doc = parseHTMLString(htmlString);
	return getCleaner(htmlPasteOrigin(doc), doc).getOutput();
}
function getCleaner(origin, doc) {
	switch (origin) {
		case "Google Docs": return new GoogleDocsClipboardCleaner(doc);
		case "Microsoft Word": return new MicrosoftWordClipboardCleaner(doc);
		default: return new ClipboardCleaner(doc);
	}
}
//#endregion
//#region src/extensions/paste/global-clipboard.ts
/**
* Global Cadmus Editor library specific shared clipboard.
*/
let __CADMUS_EDITOR_CLIPBOARD = null;
function getLastClipboard() {
	return __CADMUS_EDITOR_CLIPBOARD;
}
function saveToClipboard(clipboard) {
	__CADMUS_EDITOR_CLIPBOARD = clipboard;
}
//#endregion
//#region src/extensions/paste/paste-plugin.ts
const PastePluginKey = new PluginKey("paste");
/**
* Create a paste handling plugin which cleans, records, and annotates external
* pastes with the paste chip.
*
* ## Schema
*
* The plugin needs the `pasteChip` and `paragraph` nodes to be present in the
* schema.
*
* ## HTML Cleaning
*
* The plugin cleans the incoming HTML strings before its parsed by ProseMirror
* by providing a function to the `transformPastedHTML` editor prop. The HTML
* cleaning has specific cases for Google Docs and Microsoft Word to perform
* some form of HTML normalisation to make it easier for ProseMirror to parse.
*
* ## Copy handling
*
* To differenciate between internal and external pastes we need to maintain a
* global clipboard. On a copy event, the plugin will serialise the copied
* fragment and store it globally. Paste handlers can use this later. The global
* clipboard stores HTML strings.
*
* ## Paste and Drop handling
*
* On paste events, the plugin will count the number of words in the parsed
* slice and determine whether to append an educative paste chip node at the end
* of the pasted slice. The paste chip is shown for word counts greater than 30
* and the paste being of external origin.
*
* The origin of the paste can be found by the paste event type (drop events) or
* by comparing the content with the global clipboard.
*
* @param props initialisation options
* @return ProseMirror plugin binding copy, paste and drop events.
*/
function PastePlugin(editor, props) {
	const { editorId } = props;
	const handleCopyEvents = copyEventHandler(editorId);
	return new Plugin({
		key: PastePluginKey,
		appendTransaction(transactions, _oldState, newState) {
			const pasteTransaction = transactions.find((tr) => tr.getMeta(PastePluginKey));
			if (pasteTransaction) {
				const pasteMeta = pasteTransaction.getMeta(PastePluginKey);
				let newTr;
				if (!pasteMeta.internal) {
					newTr = newTr ?? newState.tr;
					newTr = patchMedia(editor, newTr);
				}
				if (newTr) return newTr;
			}
		},
		props: {
			handleDrop: (_view, event, slice, moved) => {
				const html = event.dataTransfer?.getData("text/html");
				const text = event.dataTransfer?.getData("text/plain");
				editor.chain().command(({ commands }) => {
					if (!moved) commands.setDropSelection(event);
					return true;
				}).handlePaste(event, moved, slice, html, text).command(({ tr, dispatch }) => {
					dispatch?.(tr.setMeta("uiEvent", "drop"));
					return true;
				}).run();
				if (moved) return false;
				return true;
			},
			handlePaste(_view, event, slice) {
				const html = event.clipboardData?.getData("text/html");
				let text = event.clipboardData?.getData("text/plain");
				let pasteSlice = slice;
				const uriList = event.clipboardData?.getData("text/uri-list");
				if (uriList && !text && !html) {
					text = uriList;
					pasteSlice = new Slice(Fragment.from(editor.schema.text(text)), 1, 1);
				}
				editor.chain().handlePaste(event, false, pasteSlice, html, text).command(({ tr, dispatch }) => {
					dispatch?.(tr.setMeta("uiEvent", "paste"));
					return true;
				}).run();
				return true;
			},
			handleDOMEvents: {
				dragstart: handleCopyEvents,
				copy: handleCopyEvents,
				cut: handleCopyEvents
			}
		}
	});
}
function copyEventHandler(editorId) {
	return (view, _event) => {
		const { selection } = view.state;
		if (selection.empty) return false;
		const { dom, text } = __serializeForClipboard(view, selection.content());
		if (dom?.innerHTML && saveToClipboard) saveToClipboard({
			origin: editorId,
			content: dom.innerHTML
		});
		else if (text && saveToClipboard) saveToClipboard({
			origin: editorId,
			content: text
		});
		return false;
	};
}
//#endregion
//#region src/extensions/paste/paste.ts
/** Paste extension wrapping the ProseMirror Paste plugin. */
const Paste = Extension.create({
	name: "cadmus-paste",
	addOptions() {
		return {
			editorId: "body",
			annotatePaste: true
		};
	},
	addStorage() {
		return { editorId: this.options.editorId };
	},
	addCommands() {
		return {
			deletePasteChip: (mouseEvent) => ({ commands, view }) => {
				if (!this.editor?.isEditable) return false;
				const eventPos = view.posAtCoords({
					left: mouseEvent.clientX,
					top: mouseEvent.clientY
				});
				if (eventPos) commands.deleteRange({
					from: eventPos.inside,
					to: eventPos.inside + 1
				});
				return true;
			},
			setDropSelection: (mouseEvent) => ({ view, state, tr, dispatch }) => {
				let $mouse;
				const eventPos = view.posAtCoords({
					left: mouseEvent.clientX,
					top: mouseEvent.clientY
				});
				if (eventPos) $mouse = state.doc.resolve(eventPos.pos);
				if ($mouse) {
					tr.setSelection(new TextSelection($mouse));
					dispatch?.(tr);
				}
				return true;
			},
			handlePaste: (event, moved, slice, html, text) => ({ chain }) => {
				return chain().handlePasteMetadata(event, moved, slice, html, text).command(({ commands }) => {
					return commands.first([
						() => commands.handleVSCodePaste(text),
						() => commands.handleMarkdownPaste(text),
						() => commands.handleTablePaste(slice),
						() => commands.handlePasteFallback(moved, slice)
					]);
				}).command(({ tr, dispatch }) => {
					const replaceSelection = wordCountChanges(tr);
					const pasteMeta = tr.getMeta(PastePluginKey);
					tr.setMeta(PastePluginKey, {
						...pasteMeta,
						wordsAdded: replaceSelection.addedWords,
						wordsDeleted: replaceSelection.deletedWords
					});
					dispatch?.(tr);
					return true;
				}).addPasteChip().run();
			},
			handlePasteFallback: (moved, slice) => ({ chain }) => {
				if (moved) return true;
				return chain().command(({ tr, commands, dispatch, view }) => {
					const meta = tr.getMeta(PastePluginKey);
					if (tr.getMeta(CodeBlockPastePluginKey)?.insideCodeBlock && meta?.text) {
						const newSlice = new Slice(Fragment.from(view.state.schema.text(meta.text.replace(/\r\n?/g, "\n"))), 0, 0);
						dispatch?.(tr.replaceSelection(newSlice));
						return true;
					}
					if (meta && meta.html) {
						const html = cleanPastedHTML(meta.html);
						const preserveWhitespace = meta.internal || meta.origin === "prosemirror" ? "full" : false;
						commands.insertContent(html, { parseOptions: { preserveWhitespace } });
					} else dispatch?.(tr.replaceSelection(slice));
					return true;
				}).command(({ tr, dispatch }) => {
					dispatch?.(tr.scrollIntoView());
					return true;
				}).run();
			},
			handlePasteMetadata: (event, moved, slice, html, text) => ({ chain }) => {
				const timestamp = this.options.getTime?.() ?? (/* @__PURE__ */ new Date()).toISOString();
				const editorEventId = v7();
				return chain().handleVSCodePasteMetadata(event, moved, slice, html, text).handleMarkdownPasteMetadata(event, moved, slice, html, text).handleCodeBlockPasteMetadata(event, moved, slice, html, text).command(({ tr, dispatch, editor }) => {
					const { annotatePaste } = this.options;
					let internal = moved;
					let pasteType = "allowed";
					let wordCount = nodeWordCount(slice.content);
					let origin = "Unknown";
					if (!moved) {
						const clipboard = getLastClipboard();
						const codeBlockPasteMeta = tr.getMeta(CodeBlockPastePluginKey);
						const insideCodeBlock = codeBlockPasteMeta?.insideCodeBlock && text;
						if (insideCodeBlock) wordCount = textWordCount(text);
						if ((text && !html || !clipboard) && !internal) internal = false;
						if (codeBlockPasteMeta?.source === "vscode") origin = "Visual Studio Code";
						let clipboardText;
						if (clipboard?.content) clipboardText = parseHTMLString(clipboard?.content).body.innerText;
						if (html && !insideCodeBlock) {
							const htmlEl = parseHTMLString(html);
							const htmlBody = htmlEl.getElementsByTagName("body")[0];
							if (clipboard) {
								const clipboardBody = parseHTMLString(clipboard.content).getElementsByTagName("body")[0];
								if (htmlBody.innerHTML.replace(/<!--.*?-->/gi, "").trim() === clipboardBody.innerHTML.replace(/<!--.*?-->/gi, "").trim()) {
									internal = true;
									origin = clipboard.origin;
								} else origin = htmlPasteOrigin(htmlEl);
							} else origin = htmlPasteOrigin(htmlEl);
						} else if (text && clipboard?.content === text) {
							internal = true;
							origin = clipboard.origin;
						} else if (text && clipboardText && clipboardText === text && clipboard?.origin) {
							internal = true;
							origin = clipboard.origin;
						}
					} else origin = editor.storage["cadmus-paste"].editorId;
					if (internal || !annotatePaste) pasteType = "allowed";
					else if (wordCount >= 90) pasteType = "locked";
					else if (wordCount >= 30) pasteType = "highlighted";
					const pasteMeta = {
						origin,
						pasteType,
						wordCount,
						internal,
						html,
						text,
						timestamp,
						editorEventId
					};
					tr.setMeta(PastePluginKey, pasteMeta);
					tr.setMeta("paste", true);
					dispatch?.(tr);
					return true;
				}).run();
			},
			addPasteChip: () => ({ commands }) => {
				const { annotatePaste } = this.options;
				if (!annotatePaste) return true;
				return commands.first([
					() => commands.addTablePasteChip(),
					() => commands.addCodeBlockPasteChip(),
					() => commands.command(({ tr, state, dispatch }) => {
						const { pasteType, wordCount } = tr.getMeta(PastePluginKey);
						if (pasteType !== "allowed") {
							const { selection } = state;
							const { $to } = selection;
							const pasteNode = state.schema.nodes.pasteChip.create({ pasted: wordCount });
							if ($to.parent?.isTextblock) tr.insert($to.pos, pasteNode);
							else {
								const paragraphNode = state.schema.nodes.paragraph.create(void 0, [pasteNode]);
								tr.insert($to.after($to.depth), paragraphNode);
							}
						}
						dispatch?.(tr);
						return true;
					})
				]);
			},
			addPasteChipAfterPredicate: (selectionPredicate) => ({ tr, dispatch, state }) => {
				const pasteMeta = tr.getMeta(PastePluginKey);
				if (pasteMeta.pasteType === "allowed") return false;
				const contentNodePos = selectionPredicate(state.selection);
				if (!contentNodePos) return false;
				const { pos, node } = contentNodePos;
				const $pos = state.doc.resolve(pos + node.nodeSize);
				const pasteNode = state.schema.nodes.pasteChip.create({ pasted: pasteMeta.wordCount });
				tr.insert($pos.start($pos.depth + 1), pasteNode);
				dispatch?.(tr);
				return true;
			}
		};
	},
	addProseMirrorPlugins() {
		return [PastePlugin(this.editor, this.options)];
	}
});
//#endregion
//#region src/extensions/blank/blank.ts
/**
* The Blank extension creates a readonly fillable "Blank" node type, as a
* placeholder indicating where an input can be made.
*/
const Blank = Node$1.create({
	name: "blanks",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "inline",
	inline: true,
	draggable: false,
	atom: true,
	allowGapCursor: true,
	addAttributes() {
		return {
			blanks: {
				default: 0,
				parseHTML: (element) => parseInt(element.getAttribute("data-cadmus-blank") ?? "0") || 0,
				renderHTML: (attributes) => {
					return { "data-cadmus-blank": attributes.blanks || 0 };
				}
			},
			id: {
				default: null,
				parseHTML: (element) => element.getAttribute("id"),
				renderHTML: (attributes) => attributes.id ? { id: attributes.id } : {}
			}
		};
	},
	parseHTML() {
		return [{ tag: "span[data-cadmus-blank]" }];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"span",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			"____________"
		];
	},
	addProseMirrorPlugins() {
		return [new Plugin({ appendTransaction: (transactions, oldState, newState) => {
			const pasteTransaction = transactions.find((tr) => tr.getMeta(PastePluginKey) && tr.getMeta("uiEvent") == "paste");
			if (!pasteTransaction) return;
			const tr = newState.tr;
			const existingBlankIds = listExistingBlanks(oldState);
			const { from = 0, to = 0 } = rangeFromTransaction(pasteTransaction);
			pasteTransaction.doc.nodesBetween(from, to, (node, pos) => {
				if (node.type.name === "blanks") {
					let newId = node.attrs.id;
					if (existingBlankIds.includes(newId)) newId = v4();
					tr.setNodeMarkup(pos, void 0, {
						...node.attrs,
						id: newId
					});
				}
			});
			return tr;
		} })];
	},
	addCommands() {
		return {
			insertBlank: () => ({ commands, editor }) => {
				if (!editor.isEditable) return false;
				return commands.insertContent({
					type: "blanks",
					attrs: { id: v4() }
				});
			},
			deleteBlank: (id) => ({ tr, commands, editor }) => {
				if (!editor.isEditable) return false;
				const item = findChildren(tr.doc, (node) => {
					return node.type.name === "blanks" && id === node.attrs.id;
				})?.[0];
				if (!item) return true;
				return commands.deleteRange({
					from: item.pos,
					to: item.pos + item.node.nodeSize
				});
			}
		};
	}
});
/**
* List IDs of blank nodes in the state in order of appearance.
*
* @param editorState - The current state of the editor
* @returns array of blank IDs.
*/
function listExistingBlanks(editorState) {
	return findChildren(editorState.doc, (node) => node.type.name === "blanks").map((blank) => blank.node.attrs.id) || [];
}
//#endregion
//#region src/extensions/block-background/block-background.ts
const BlockBackground = Extension.create({
	name: "BlockBackground",
	addOptions() {
		return { types: [] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { backgroundColor: {
				default: null,
				parseHTML: (element) => element.style.backgroundColor || element.getAttribute("data-cadmus-background-color"),
				renderHTML: (attributes) => {
					if (attributes.backgroundColor) return {
						style: `--background-color: ${attributes.backgroundColor};`,
						"data-cadmus-background-color": attributes.backgroundColor
					};
					return {};
				}
			} }
		}];
	}
});
//#endregion
//#region src/extensions/block-text-visibility/block-text-visibility.ts
/**
* Editor Extension to hide Block(s) without deleting the Block(s)
* Mainly used for Caption like node such as tableCaption
*/
const BlockTextVisibility = Extension.create({
	name: "blockTextVisibility",
	addOptions() {
		return { types: [] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { hideText: {
				default: null,
				parseHTML: (element) => element.style.display === "none" || element.getAttribute("data-cadmus-hidden") === "true",
				renderHTML: (attributes) => {
					if (attributes.hideText) return {
						style: `display: none;`,
						"data-cadmus-hidden": true,
						contenteditable: false
					};
					return {};
				}
			} }
		}];
	},
	addCommands() {
		return {
			hideText: (parentNodePos, blockType) => ({ tr, state }) => {
				const { doc } = state;
				const parentNode = doc.nodeAt(parentNodePos);
				const nodeType = getNodeType(blockType, state.schema);
				if (parentNode && nodeType) {
					const nodePos = findChildren(parentNode, (node) => node.type === nodeType)[0];
					if (nodePos) {
						tr.setNodeMarkup(parentNodePos + nodePos.pos + 1, void 0, Object.assign({}, nodePos.node.attrs, { hideText: true }));
						if (nodePos.node.attrs.hideText) return false;
						return true;
					}
				}
				return false;
			},
			showText: (parentNodePos, blockType) => ({ tr, state }) => {
				const { doc } = state;
				const parentNode = doc.nodeAt(parentNodePos);
				const nodeType = getNodeType(blockType, state.schema);
				if (parentNode && nodeType) {
					const nodePos = findChildren(parentNode, (node) => node.type === nodeType)[0];
					if (nodePos) {
						tr.setNodeMarkup(parentNodePos + nodePos.pos + 1, void 0, Object.assign({}, nodePos.node.attrs, { hideText: false }));
						return true;
					}
				}
				return false;
			},
			toggleShowText: (parentNodePos, blockType) => ({ tr, state }) => {
				const { doc } = state;
				const parentNode = doc.nodeAt(parentNodePos);
				const nodeType = getNodeType(blockType, state.schema);
				if (parentNode && nodeType) {
					const nodePos = findChildren(parentNode, (node) => node.type === nodeType)[0];
					if (nodePos) {
						tr.setNodeMarkup(parentNodePos + nodePos.pos + 1, void 0, Object.assign({}, nodePos.node.attrs, { hideText: !nodePos.node.attrs.hideText }));
						return true;
					}
				}
				return false;
			}
		};
	}
});
//#endregion
//#region src/extensions/blockquote/blockquote.ts
const inputRegex$4 = /^\s*>\s$/gm;
/**
* Make non nestable blockquote as oposed to tiptap's blockquote
* that can have any kind of blocks inside it
*/
const Blockquote = Node$1.create({
	name: "blockquote",
	content: "inline*",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block",
	defining: true,
	parseHTML() {
		return [{ tag: "blockquote" }];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"blockquote",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			["p", 0]
		];
	},
	addCommands() {
		return { toggleBlockquote: () => ({ commands }) => {
			return commands.toggleNode("blockquote", "paragraph");
		} };
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-b": () => this.editor.commands.toggleBlockquote() };
	},
	addInputRules() {
		return [textblockTypeInputRule({
			find: inputRegex$4,
			type: this.type
		})];
	}
});
//#endregion
//#region src/extensions/list/helpers/calculateItemRange.ts
/**
* Returns a range that include all selected list items.
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
*/
function calculateItemRange(editor, selection) {
	const { $from, $to } = selection;
	const isListNode = (node) => isList(node.type.name, editor.extensionManager.extensions);
	return $from.blockRange($to, isListNode);
}
//#endregion
//#region src/extensions/list/helpers/isListItem.ts
/**
* Helper function to check if a node with type name is of type list item
*/
function isListItem(name, extensions) {
	const extension = extensions.filter((extension) => extension.type === "node").find((item) => item.name === name);
	if (!extension) return false;
	const group = callOrReturn(getExtensionField(extension, "group", {
		name: extension.name,
		options: extension.options,
		storage: extension.storage
	}));
	if (typeof group !== "string") return false;
	return group.split(" ").includes("listItemGroup");
}
//#endregion
//#region src/extensions/list/helpers/findParentItem.ts
/**
* Find parent list and list item of node inside nodeRange if exist
* otherwise return false
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-command-dedent.ts
*/
function findParentItem(editor, $from, range) {
	const parentItem = $from.node(range.depth - 1);
	const parentList = $from.node(range.depth - 2);
	if (!isListItem(parentItem.type.name, editor.extensionManager.extensions) || !isList(parentList.type.name, editor.extensionManager.extensions)) return false;
	return {
		parentItem,
		parentList
	};
}
//#endregion
//#region src/extensions/list/helpers/findPreviousItem.ts
/**
* Try to find the previous item. Indent can only works if we can find this item.
*
* It may be the previous list item in the same list (in this case, `previousItem`
* will be equal to `selectedList`), or it may be the last list item in the
* previous list.
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-command-indent.ts
*/
function findPreviousItem(editor, selectedList, $from, range) {
	let previousItem;
	let previousList;
	let previousItemStart;
	let previousListStart;
	const { doc } = $from;
	if (range.startIndex >= 1) {
		previousItem = selectedList.child(range.startIndex - 1);
		previousList = selectedList;
		previousListStart = doc.resolve(range.start).start(range.depth);
		previousItemStart = previousListStart + 1;
		for (let i = 0; i < range.startIndex - 1; i++) previousItemStart += previousList.child(i).nodeSize;
	} else {
		const listIndex = $from.index(range.depth - 1);
		if (listIndex >= 1) {
			const listParent = $from.node(range.depth - 1);
			const listParentStart = $from.start(range.depth - 1);
			previousList = listParent.child(listIndex - 1);
			if (!previousItem || !isList(previousItem.type.name, editor.extensionManager.extensions)) return false;
			previousListStart = listParentStart + 1;
			for (let i = 0; i < listIndex - 1; i++) previousListStart += listParent.child(i).nodeSize;
			previousItem = previousList.child(previousList.childCount - 1);
			previousItemStart = previousListStart + previousList.nodeSize - previousItem.nodeSize - 1;
			if (!isListItem(previousItem.type.name, editor.extensionManager.extensions)) return false;
		} else return false;
	}
	return {
		previousItem,
		previousList,
		previousItemStart,
		previousListStart
	};
}
//#endregion
//#region src/extensions/list/helpers/sliceSelectedItems.ts
/**
* Separate selected list item into two slices: `selectedSlice` and `unselectedSlice`.
*
* If `unselectedSlice` exists, we don't want to change its indentation.
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-command-indent.ts
*/
function sliceSelectedItems(doc, $to, range) {
	let selectedSlice;
	let unselectedSlice;
	const start = range.start;
	const mid = $to.depth >= range.depth + 2 ? $to.end(range.depth + 2) : range.end - 1;
	const end = range.end;
	if (mid + 1 >= end) {
		selectedSlice = doc.slice(start, end);
		unselectedSlice = null;
	} else {
		selectedSlice = doc.slice(start, mid);
		unselectedSlice = doc.slice(mid + 1, end - 1);
	}
	return {
		selectedSlice,
		unselectedSlice
	};
}
//#endregion
//#region src/extensions/list/commands/indentList.ts
/**
* A helper function to indent selected list items.
*
* @beta
* ported from https://github.com/remirror/remirror/blob/9014d98411459968cf5aaac8ec9cf01e8bcd1c85/packages/remirror__extension-list/src/list-command-indent.ts
*/
function indentList(editor, tr) {
	const { selection, doc } = tr;
	const { $from, $to } = selection;
	const range = calculateItemRange(editor, selection);
	if (!range) return false;
	const selectedList = doc.resolve(range.start).node();
	if (!isList(selectedList.type.name, editor.extensionManager.extensions)) return false;
	const findPreviousItemResult = findPreviousItem(editor, selectedList, $from, range);
	if (!findPreviousItemResult) return false;
	const { previousItem, previousList, previousItemStart } = findPreviousItemResult;
	const { selectedSlice, unselectedSlice } = sliceSelectedItems(doc, $to, range);
	const newPreviousItemContent = previousItem.content.append(Fragment.fromArray([selectedList.copy(selectedSlice.content)])).append(unselectedSlice ? unselectedSlice.content : Fragment.empty);
	tr.deleteRange(range.start, range.end);
	const previousItemEnd = previousItemStart + previousItem.nodeSize - 2;
	const newPreviousItem = previousItem.copy(newPreviousItemContent);
	newPreviousItem.check();
	tr.replaceRangeWith(previousItemStart - 1, previousItemEnd + 1, newPreviousItem);
	tr.setSelection(previousList === selectedList ? TextSelection.create(tr.doc, $from.pos, $to.pos) : TextSelection.create(tr.doc, $from.pos - 2, $to.pos - 2));
	return true;
}
//#endregion
//#region src/extensions/list/commands/liftListItemOutOfList.ts
/**
* Build a command to lift the content inside a list item around the selection
* out of list
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
*/
function liftListItemOutOfList(itemType) {
	return ({ tr, dispatch, state }) => {
		const { selection } = tr;
		const { $from, $to } = selection;
		const range = $from.blockRange($to, (node) => node.firstChild?.type === itemType);
		if (!range) return false;
		if (!dispatch) return true;
		return liftOutOfList(state, dispatch, range);
	};
}
function liftOutOfList(state, dispatch, range) {
	const tr = state.tr, list = range.parent;
	const originMappingLength = tr.mapping.maps.length;
	for (let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
		pos -= list.child(i).nodeSize;
		tr.delete(pos - 1, pos + 1);
	}
	const $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
	if (!item) return false;
	if (tr.mapping.slice(originMappingLength).map(range.end) !== range.start + item.nodeSize) return false;
	const atStart = range.startIndex === 0, atEnd = range.endIndex === list.childCount;
	const parent = $start.node(-1), indexBefore = $start.index(-1);
	if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? Fragment.empty : Fragment.from(list)))) return false;
	const start = $start.pos, end = start + item.nodeSize;
	tr.step(new ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new Slice((atStart ? Fragment.empty : Fragment.from(list.copy(Fragment.empty))).append(atEnd ? Fragment.empty : Fragment.from(list.copy(Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
	dispatch(tr.scrollIntoView());
	return true;
}
//#endregion
//#region src/extensions/list/commands/wrapSelectedItems.ts
/**
* Wraps list items in `range` to a list.
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
*/
function wrapItems({ listType, itemType, tr, range }) {
	const oldList = range.parent;
	const slice = tr.doc.slice(range.start, range.end);
	if (oldList.type === listType && slice.content.firstChild?.type === itemType) return false;
	const newItems = [];
	for (let i = 0; i < slice.content.childCount; i++) {
		const oldItem = slice.content.child(i);
		if (!itemType.validContent(oldItem.content)) return false;
		const newItem = itemType.createChecked(null, oldItem.content);
		newItems.push(newItem);
	}
	const newList = listType.createChecked(null, newItems);
	tr.replaceRange(range.start, range.end, new Slice(Fragment.from(newList), 0, 0));
	return true;
}
/**
* Wraps existed list items to a new type of list, which only containes these list items.
*
* @remarks
*
* @example
*
* Here is some pseudo-code to show the purpose of this function:
*
* before:
*
* ```html
*  <ul>
*    <li>item A</li>
*    <li>item B<!-- cursor_start --></li>
*    <li>item C<!-- cursor_end --></li>
*    <li>item D</li>
*  </ul>
* ```
*
* after:
*
* ```html
*  <ul>
*    <li>item A</li>
*  </ul>
*  <ol>
*    <li>item B<!-- cursor_start --></li>
*    <li>item C<!-- cursor_end --></li>
*  </ol>
*  <ul>
*    <li>item D</li>
*  </ul>
* ```
*
* @alpha
*
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
*/
function wrapSelectedItems({ editor, listType, itemType, tr }) {
	const range = calculateItemRange(editor, tr.selection);
	if (!range) return false;
	const atStart = range.startIndex === 0;
	const { from, to } = tr.selection;
	if (!wrapItems({
		listType,
		itemType,
		tr,
		range
	})) return false;
	tr.setSelection(new TextSelection(tr.doc.resolve(atStart ? from : from + 2), tr.doc.resolve(atStart ? to : to + 2)));
	tr.scrollIntoView();
	return true;
}
//#endregion
//#region src/extensions/list/commands/wrapListBackward.ts
/**
* Wraps selected list items to fit the list type and list item type in the
* previous list.
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
*/
function wrapListBackward(editor, tr) {
	const $cursor = tr.selection.$from;
	const range = $cursor.blockRange();
	if (!range || !isListItem(range.parent.type.name, editor.extensionManager.extensions) || range.startIndex !== 0) return false;
	const root = $cursor.node(range.depth - 2);
	const itemIndex = $cursor.index(range.depth);
	const listIndex = $cursor.index(range.depth - 1);
	const rootIndex = $cursor.index(range.depth - 2);
	const previousList = root.maybeChild(rootIndex - 1);
	const previousListItem = previousList?.lastChild;
	if (itemIndex !== 0 || listIndex !== 0) return false;
	if (previousList && isList(previousList.type.name, editor.extensionManager.extensions) && previousListItem && isListItem(previousListItem.type.name, editor.extensionManager.extensions)) return wrapSelectedItems({
		editor,
		listType: previousList.type,
		itemType: previousListItem.type,
		tr
	});
	if (isListItem(root.type.name, editor.extensionManager.extensions)) {
		const parentListItem = root;
		const parentList = $cursor.node(range.depth - 3);
		if (isList(parentList.type.name, editor.extensionManager.extensions)) return wrapSelectedItems({
			editor,
			listType: parentList.type,
			itemType: parentListItem.type,
			tr
		});
	}
	return false;
}
//#endregion
//#region src/extensions/list/commands/listBackspace.ts
/**
* Command to handle backspace keymap
* it does list wrapping, joining previous list or lifting list item
* to parent list
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
*/
function listBackspace(editor) {
	return ({ chain }) => {
		return chain().command(({ view }) => {
			if (!view) return false;
			return true;
		}).command(({ state }) => {
			const $cursor = state.selection.$cursor;
			if (!$cursor || $cursor.parentOffset > 0) return false;
			const range = $cursor.blockRange();
			if (!range || !isListItem(range.parent.type.name, editor.extensionManager.extensions) || range.startIndex !== 0) return false;
			return true;
		}).command(({ tr }) => {
			if (!tr.steps.length) return false;
			wrapListBackward(editor, tr);
			return true;
		}).command(({ tr, state, commands }) => {
			if (!tr.steps.length) return false;
			const $cursor = state.selection.$cursor;
			if (!$cursor || $cursor.parentOffset > 0) return false;
			const range = $cursor.blockRange();
			if (!range || !isListItem(range.parent.type.name, editor.extensionManager.extensions) || range.startIndex !== 0) return false;
			const itemIndex = $cursor.index(range.depth);
			const listIndex = $cursor.index(range.depth - 1);
			const rootIndex = $cursor.index(range.depth - 2);
			if (itemIndex === 0 && listIndex === 0 && rootIndex <= 1) commands.liftListItem(range.parent.type);
			return true;
		}).command(({ commands, tr }) => {
			if (!tr.steps.length) return false;
			return commands.joinBackward();
		}).run();
	};
}
//#endregion
//#region src/extensions/list/commands/maybeJoinList.ts
/**
* go through list/list item nodes before and after current selection
* or given ResolvedPos $pos and see if it can be joined with list/list
* item on that position
*/
function maybeJoinList(editor, tr, $pos) {
	const $from = $pos || tr.selection.$from;
	let joinable = [];
	let index;
	let parent;
	let before;
	let after;
	for (let depth = $from.depth; depth >= 0; depth--) {
		parent = $from.node(depth);
		index = $from.index(depth);
		before = parent.maybeChild(index - 1);
		after = parent.maybeChild(index);
		if (before && after && before.type.name === after.type.name && isList(before.type.name, editor.extensionManager.extensions)) {
			const pos = $from.before(depth + 1);
			joinable.push(pos);
		}
		index = $from.indexAfter(depth);
		before = parent.maybeChild(index - 1);
		after = parent.maybeChild(index);
		if (before && after && before.type.name === after.type.name && isList(before.type.name, editor.extensionManager.extensions)) {
			const pos = $from.after(depth + 1);
			joinable.push(pos);
		}
	}
	joinable = [...new Set(joinable)].sort((a, b) => b - a);
	let updated = false;
	for (const pos of joinable) if (canJoin(tr.doc, pos)) {
		tr.join(pos);
		updated = true;
	}
	return updated;
}
//#endregion
//#region src/extensions/list/commands/changeItemsType.ts
/**
* Change list items type
* ported from https://github.com/remirror/remirror/blob/9014d98411459968cf5aaac8ec9cf01e8bcd1c85/packages/remirror__extension-list/src/list-command-dedent.ts
*/
function changeItemsType(editor, tr, range, parentList, parentItem) {
	if (wrapSelectedItems({
		editor,
		listType: parentList.type,
		itemType: parentItem.type,
		tr
	})) return new NodeRange(tr.selection.$from, tr.selection.$to, range.depth);
	return range;
}
//#endregion
//#region src/extensions/list/commands/indentSiblingsOfItems.ts
/**
* indent Sibling of list to become a sublist when a list item is
* outdented
* ported from https://github.com/remirror/remirror/blob/9014d98411459968cf5aaac8ec9cf01e8bcd1c85/packages/remirror__extension-list/src/list-command-dedent.ts
*/
function indentSiblingsOfItems(tr, range) {
	const selectedList = range.parent;
	const lastSelectedItem = range.parent.child(range.endIndex - 1);
	const endOfRange = range.end;
	const endOfSelectedList = range.$to.end(range.depth);
	if (endOfRange < endOfSelectedList) {
		tr.step(new ReplaceAroundStep(endOfRange - 1, endOfSelectedList, endOfRange, endOfSelectedList, new Slice(Fragment.from(lastSelectedItem.type.create(null, selectedList.copy())), 1, 0), 1, true));
		return new NodeRange(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfSelectedList), range.depth);
	}
	return range;
}
//#endregion
//#region src/extensions/list/commands/indentSiblingsOfList.ts
/**
* indent Sibling of list to become a sublist when a list item is
* outdented
* ported from https://github.com/remirror/remirror/blob/9014d98411459968cf5aaac8ec9cf01e8bcd1c85/packages/remirror__extension-list/src/list-command-dedent.ts
*/
function indentSiblingsOfList(tr, range) {
	const selectedList = range.parent;
	const lastSelectedItem = range.parent.child(range.endIndex - 1);
	const endOfSelectedList = range.end;
	const endOfParentListItem = range.$to.end(range.depth - 1);
	if (endOfSelectedList + 1 < endOfParentListItem) {
		tr.step(new ReplaceAroundStep(endOfSelectedList - 1, endOfParentListItem, endOfSelectedList + 1, endOfParentListItem, new Slice(Fragment.from(selectedList.type.create(null, lastSelectedItem.type.create(null))), 2, 0), 0, true));
		return new NodeRange(tr.selection.$from, tr.selection.$to, range.depth);
	}
	return range;
}
//#endregion
//#region src/extensions/list/commands/outdentList.ts
/**
* A helper function to outdent selected list items.
*
* @beta
*
* ported from dedentList function from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-command-dedent.ts
*/
function outdentList(editor, tr) {
	let range = calculateItemRange(editor, tr.selection);
	if (!range) return false;
	const findParentItemResult = findParentItem(editor, tr.selection.$from, range);
	if (!findParentItemResult) return false;
	const { parentItem, parentList } = findParentItemResult;
	range = indentSiblingsOfItems(tr, range);
	range = indentSiblingsOfList(tr, range);
	range = changeItemsType(editor, tr, range, parentList, parentItem);
	const target = liftTarget(range);
	if (typeof target !== "number") return true;
	tr.lift(range, target);
	range = calculateItemRange(editor, tr.selection);
	if (range) maybeJoinList(editor, tr, tr.doc.resolve(range.end - 2));
	return true;
}
//#endregion
//#region src/extensions/list/commands/splitListItem.ts
/**
* Build a command that splits a non-empty textblock at the top level
* of a list item by also splitting that list item.
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
*/
function splitListItem(listItemTypeOrName, ignoreAttrs = ["checked"]) {
	return ({ tr, dispatch, state }) => {
		const listItemType = getNodeType(listItemTypeOrName, state.schema);
		const { $from, $to } = tr.selection;
		if (isNodeSelection(tr.selection) && tr.selection.node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
		const grandParent = $from.node(-1);
		if (grandParent.type !== listItemType) return false;
		if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
			if ($from.depth === 2 || $from.node(-3).type !== listItemType || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
			if (dispatch) {
				const keepItem = $from.index(-1) > 0;
				let wrap = Fragment.empty;
				for (let depth = $from.depth - (keepItem ? 1 : 2); depth >= $from.depth - 3; depth--) wrap = Fragment.from($from.node(depth).copy(wrap));
				const content = listItemType.contentMatch.defaultType?.createAndFill() || void 0;
				wrap = wrap.append(Fragment.from(listItemType.createAndFill(null, content) || void 0));
				tr.replace($from.before(keepItem ? void 0 : -1), $from.after(-3), new Slice(wrap, keepItem ? 3 : 2, 2));
				tr.setSelection(tr.selection.constructor.near(tr.doc.resolve($from.pos + (keepItem ? 3 : 2))));
				dispatch(tr.scrollIntoView());
			}
			return true;
		}
		const listItemAttributes = Object.fromEntries(Object.entries(grandParent.attrs).filter(([attr]) => !ignoreAttrs.includes(attr)));
		const contentType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
		const contentAttributes = { ...$from.node().attrs };
		tr.delete($from.pos, $to.pos);
		const types = contentType ? [{
			type: listItemType,
			attrs: listItemAttributes
		}, {
			type: contentType,
			attrs: contentAttributes
		}] : [{
			type: listItemType,
			attrs: listItemAttributes
		}];
		if (!canSplit(tr.doc, $from.pos, 2)) return false;
		if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
		return true;
	};
}
//#endregion
//#region src/extensions/list/commands/deepChangeListType.ts
/**
* Change a bullet list into a task list or vice versa. These lists use different type of list items,
* so you need to use this function to not only change the list type but also change the list item type.
* ported from https://github.com/remirror/remirror/blob/9014d98411/packages/remirror__extension-list/src/list-commands.ts
**/
function deepChangeListType(tr, foundList, listType, itemType) {
	const oldList = foundList.node;
	const $start = tr.doc.resolve(foundList.start);
	const listParent = $start.node(-1);
	const indexBefore = $start.index(-1);
	if (!listParent) return false;
	if (!listParent.canReplace(indexBefore, indexBefore + 1, Fragment.from(listType.create()))) return false;
	const newItems = [];
	for (let index = 0; index < oldList.childCount; index++) {
		const oldItem = oldList.child(index);
		if (!itemType.validContent(oldItem.content)) return false;
		const newItem = itemType.createChecked(null, oldItem.content);
		newItems.push(newItem);
	}
	const newList = listType.createChecked(null, newItems);
	const start = foundList.pos;
	const end = start + oldList.nodeSize;
	const from = tr.selection.from;
	tr.replaceRangeWith(start, end, newList);
	tr.setSelection(tr.selection.constructor.near(tr.doc.resolve(from)));
	return true;
}
//#endregion
//#region src/extensions/list/commands/toggleList.ts
/**
* Toggles a list.
*
* @remarks
*
* When the provided list wrapper is inactive (e.g. ul) then wrap the list with
* this type. When it is active then remove the selected line from the list.
*
* @param listType - the list node type
* @param itemType - the list item node type
* ported from https://github.com/remirror/remirror/blob/main/packages/remirror__extension-list/src/list-commands.ts
**/
function toggleList(editor, listType, itemType) {
	return (props) => {
		const { tr, dispatch, commands } = props;
		const { selection } = tr;
		const { $from, $to } = selection;
		const range = $from.blockRange($to);
		if (!range) return false;
		const parentList = findParentNode((node) => isList(node.type.name, editor.extensionManager.extensions))(selection);
		if (parentList && range.depth - parentList.depth <= 1 && range.startIndex === 0) {
			if (parentList.node.type === listType) return commands.liftListItemOutOfList(itemType);
			if (isList(parentList.node.type.name, editor.extensionManager.extensions)) {
				if (listType.validContent(parentList.node.content)) {
					dispatch?.(tr.setNodeMarkup(parentList.pos, listType));
					return true;
				}
				if (deepChangeListType(tr, parentList, listType, itemType)) {
					dispatch?.(tr.scrollIntoView());
					return true;
				}
				return false;
			}
		}
		commands.wrapInList(listType);
		return true;
	};
}
//#endregion
//#region src/extensions/list/list.ts
const List = Extension.create({
	name: "list",
	addCommands() {
		return {
			cadmusSplitListItem: (listItemTypeOrName) => splitListItem(listItemTypeOrName),
			indentList: () => ({ tr, dispatch }) => {
				if (indentList(this.editor, tr)) {
					dispatch?.(tr.scrollIntoView());
					return true;
				}
				return false;
			},
			outdentList: () => ({ tr, dispatch, commands }) => {
				if (outdentList(this.editor, tr)) {
					dispatch?.(tr.scrollIntoView());
					return true;
				} else {
					const parentListItem = findParentNode((node) => isListItem(node.type.name, this.editor.extensionManager.extensions))(tr.selection);
					if (parentListItem) {
						commands.liftListItemOutOfList(parentListItem.node.type);
						return true;
					}
				}
				return false;
			},
			toggleCadmusList: (listType, listItemType) => toggleList(this.editor, listType, listItemType),
			liftListItemOutOfList: (listItemType) => liftListItemOutOfList(listItemType),
			listBackspace: () => listBackspace(this.editor)
		};
	},
	addKeyboardShortcuts() {
		return {
			Tab: () => this.editor.commands.indentList(),
			"Shift-Tab": () => this.editor.commands.outdentList(),
			Backspace: () => this.editor.commands.listBackspace(),
			"Mod-Backspace": () => this.editor.commands.listBackspace(),
			"ctrl-h": () => this.editor.commands.listBackspace()
		};
	},
	addProseMirrorPlugins() {
		return [new Plugin({ appendTransaction: (_transaction, _oldState, newState) => {
			const { tr } = newState;
			return maybeJoinList(this.editor, tr) ? tr : null;
		} })];
	}
});
//#endregion
//#region src/extensions/bullet-list/bullet-list.ts
const inputRegex$3 = /^\s*([-+*])\s$/;
const BulletList = Node$1.create({
	name: "bulletList",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block list",
	content: "listItem+",
	parseHTML() {
		return [{ tag: "ul" }];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"ul",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	addCommands() {
		return { toggleBulletList: () => ({ commands }) => {
			return commands.toggleCadmusList(this.type, getNodeType("listItem", this.editor.schema));
		} };
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-8": () => this.editor.commands.toggleBulletList() };
	},
	addProseMirrorPlugins() {
		return [inputRulesPlugin({
			editor: this.editor,
			rules: [wrappingInputRule({
				find: inputRegex$3,
				type: this.type
			}), new InputRule({
				find: inputRegex$3,
				handler: ({ state, range }) => {
					const { tr } = state;
					tr.deleteRange(range.from, range.to);
					if (!wrapSelectedItems({
						listType: this.type,
						itemType: getNodeType("listItem", this.editor.schema),
						tr,
						editor: this.editor
					})) {
						const $cursor = tr.doc.resolve(range.from);
						if ($cursor.depth > 2) {
							if (!isListItem($cursor.node($cursor.depth - 1).type.name, this.editor.extensionManager.extensions)) return null;
						} else return null;
					}
				}
			})]
		})];
	}
});
//#endregion
//#region src/extensions/code/code.ts
/**
* `Code` extension to handle the inline code mark for the editor.
*
* The extension extends TipTap's `Code` extension and adds left and right
* arrow key handlers to assist with exiting the mark
*/
const Code$1 = Code.extend({
	priority: 101,
	addKeyboardShortcuts() {
		return {
			ArrowLeft: () => {
				const state = this.editor.state;
				const { from, to } = state.selection;
				if (from >= 1 && from === to) {
					const codeOnRight = isCodeMarkPresent(state, from + 1, to + 1, this.type);
					const noCodeUnderCursor = !isCodeMarkPresent(state, from, to, this.type);
					let nothingOnLeft = true;
					state.doc.nodesBetween(from - 1, to - 1, (node) => {
						if (node) nothingOnLeft = false;
					});
					if (codeOnRight && noCodeUnderCursor && nothingOnLeft) return this.editor.chain().unsetCode().insertContent(" ").setTextSelection(from - 1).run();
				}
				return false;
			},
			ArrowRight: () => {
				const state = this.editor.state;
				const { from, to } = state.selection;
				if (from > 1 && from === to) {
					const codeOnLeft = isCodeMarkPresent(state, from - 1, to - 1, this.type);
					const noCodeUnderCursor = !isCodeMarkPresent(state, from, to, this.type);
					let nothingOnRight = true;
					state.doc.nodesBetween(from + 1, to + 1, (node) => {
						if (node) nothingOnRight = false;
					});
					if (codeOnLeft && noCodeUnderCursor && nothingOnRight) return this.editor.chain().unsetCode().insertContent(" ").run();
				}
				return false;
			}
		};
	}
});
/** Checks if a code mark is present on the given range */
const isCodeMarkPresent = (state, from, to, type) => {
	let flag = false;
	state.doc.nodesBetween(from, to, (node) => {
		if (node.marks.find((markItem) => markItem.type === type)) flag = true;
	});
	return flag;
};
//#endregion
//#region src/editor-typography.ts
const fontFamilySans = `acumin-pro, -apple-system, BlinkMacSystemFont,
Helvetica, Arial, "Noto Sans", "Noto Sans CJK", "Noto Sans JP", "Noto Sans KR",
"Noto Sans HK", "Noto Sans SC", "Noto Sans TC", "Twemoji Mozilla",
"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji",
"EmojiOne Color", "Android Emoji", sans-serif`;
const editorTypography = {
	displayOne: {
		fontFamily: "utopia-std-display",
		fontWeight: 600,
		fontSize: "3.8125rem",
		paddingTop: "9px",
		paddingBottom: "9px",
		lineHeight: "1.18",
		letterSpacing: "0px",
		textTransform: "none",
		element: "h1"
	},
	displayTwo: {
		fontFamily: "utopia-std-display",
		fontWeight: 600,
		fontSize: "3.05rem",
		paddingTop: "9px",
		paddingBottom: "9px",
		lineHeight: "1.29",
		letterSpacing: "0px",
		textTransform: "none",
		element: "h1"
	},
	displayThree: {
		fontFamily: "utopia-std-display",
		fontWeight: 400,
		fontSize: "2.25rem",
		paddingTop: "9px",
		paddingBottom: "9px",
		lineHeight: "1.33",
		letterSpacing: "0px",
		textTransform: "none",
		element: "h1"
	},
	headingOne: {
		fontFamily: "acumin-pro",
		fontWeight: 600,
		fontSize: "2.4375rem",
		paddingTop: "9px",
		paddingBottom: "9px",
		lineHeight: "1.384",
		letterSpacing: "0px",
		textTransform: "none",
		element: "h1"
	},
	headingTwo: {
		fontFamily: "acumin-pro",
		fontWeight: 600,
		fontSize: "1.953rem",
		paddingTop: "6px",
		paddingBottom: "6px",
		lineHeight: "1.44",
		letterSpacing: "0px",
		textTransform: "none",
		element: "h2"
	},
	headingThree: {
		fontFamily: "acumin-pro",
		fontWeight: 600,
		fontSize: "1.5625rem",
		paddingTop: "6px",
		paddingBottom: "6px",
		lineHeight: "1.44",
		letterSpacing: "0px",
		textTransform: "none",
		element: "h3"
	},
	headingFour: {
		fontFamily: "acumin-pro",
		fontWeight: 600,
		fontSize: "1.25rem",
		paddingTop: "6px",
		paddingBottom: "6px",
		lineHeight: "1.35",
		letterSpacing: "0px",
		textTransform: "none",
		element: "h4"
	},
	headingFive: {
		fontFamily: "acumin-pro",
		fontWeight: 600,
		fontSize: "1.0625rem",
		paddingTop: "6px",
		paddingBottom: "6px",
		lineHeight: "1.412",
		letterSpacing: "0.1px",
		textTransform: "none",
		element: "h5"
	},
	headingSix: {
		fontFamily: "acumin-pro",
		fontWeight: 600,
		fontSize: "0.875rem",
		paddingTop: "3px",
		paddingBottom: "3px",
		lineHeight: "1.5",
		letterSpacing: "0.2px",
		textTransform: "none",
		element: "h6"
	},
	blockquote: {
		fontFamily: "adobe-text-pro, times, serif",
		fontWeight: 400,
		fontSize: "1rem",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.5",
		letterSpacing: "0.2px",
		textTransform: "none",
		element: "p"
	},
	lead: {
		fontFamily: "acumin-pro",
		fontWeight: 400,
		fontSize: "1.25rem",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.35",
		letterSpacing: "0.4px",
		textTransform: "none",
		element: "p"
	},
	bodyLg: {
		fontFamily: "acumin-pro",
		fontWeight: 400,
		fontSize: "1.125rem",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.5",
		letterSpacing: "0.2px",
		textTransform: "none",
		element: "p"
	},
	bodyMd: {
		fontFamily: "acumin-pro",
		fontWeight: 400,
		fontSize: "1rem",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.5",
		letterSpacing: "0.2px",
		textTransform: "none",
		element: "p"
	},
	bodySm: {
		fontFamily: "acumin-pro",
		fontWeight: 400,
		fontSize: "14px",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.5",
		letterSpacing: "0.2px",
		textTransform: "none",
		element: "p"
	},
	bodyLine: {
		fontFamily: "Open Sauce Two",
		fontWeight: 400,
		fontSize: "1rem",
		lineHeight: "150%",
		letterSpacing: "0px",
		paddingBottom: "0px",
		paddingTop: "0px",
		textTransform: "none",
		element: "span"
	},
	systemMd: {
		fontFamily: "acumin-pro",
		fontWeight: 400,
		fontSize: "0.8125rem",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.5",
		letterSpacing: "0.3px",
		textTransform: "none",
		element: "p"
	},
	systemSm: {
		fontFamily: "acumin-pro",
		fontWeight: 400,
		fontSize: "0.75rem",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.5",
		letterSpacing: "0.4px",
		textTransform: "none",
		element: "p"
	},
	label: {
		fontFamily: "acumin-pro-semi-condensed",
		fontWeight: 600,
		fontSize: "0.75rem",
		paddingTop: "0px",
		paddingBottom: "0px",
		lineHeight: "1.5",
		letterSpacing: "1.5px",
		textTransform: "uppercase",
		element: "p"
	},
	ctaLg: {
		fontFamily: "Open Sauce Two",
		fontWeight: 700,
		fontSize: "1rem",
		lineHeight: "125%",
		letterSpacing: "0.8px",
		paddingTop: "0px",
		paddingBottom: "0px",
		textTransform: "uppercase",
		element: "span"
	},
	ctaMd: {
		fontFamily: "Open Sauce Two",
		fontWeight: 700,
		fontSize: "0.75rem",
		lineHeight: "150%",
		letterSpacing: "0.6px",
		paddingTop: "0px",
		paddingBottom: "0px",
		textTransform: "uppercase",
		element: "span"
	}
};
//#endregion
//#region src/extensions/code/styles.ts
const codeStyles = css`
  code {
    font-family: ibm-plex-mono, ui-monospace, monospace;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    border: 1px solid ${colors.grey50};
    line-height: 24px;
    color: ${colors.indigo800};
    background: #eff2f6;
    border-radius: 3px;
    padding: 1px 4px 1.5px 4px;
  }

  h1 > code {
    font-size: calc(${editorTypography.headingOne.fontSize} - 1px);
    font-weight: 600;
  }

  h2 > code {
    font-size: calc(${editorTypography.headingTwo.fontSize} - 1px);
    font-weight: 600;
  }

  h3 > code {
    font-size: calc(${editorTypography.headingThree.fontSize} - 1px);
    font-weight: 600;
  }

  h4 > code {
    font-size: calc(${editorTypography.headingFour.fontSize} - 1px);
    font-weight: 600;
  }

  h5 > code {
    font-size: calc(${editorTypography.headingFive.fontSize} - 1px);
    font-weight: 600;
  }

  h6 > code {
    font-size: calc(${editorTypography.headingSix.fontSize} - 1px);
    font-weight: 600;
  }
`;
//#endregion
//#region src/extensions/table/utils/controlDimension.ts
/**
* Get DOM heights of each rows of table Element to be used for positioning
* Row insert button and row selection handle
*/
const getRowHeights = (tableRef) => {
	const heights = [];
	if (tableRef.lastChild?.lastChild) {
		const rows = tableRef.lastChild?.lastChild?.childNodes;
		if (!rows) return heights;
		for (let i = 0, count = rows.length; i < count; i++) {
			const row = rows[i];
			if (i === 0 || i === rows.length - 1) heights[i] = row.getBoundingClientRect().height + 1;
			else heights[i] = row.getBoundingClientRect().height;
		}
	}
	return heights;
};
/**
* Get DOM width of each collumn of table Element to be used for positioning
* Column insert button and column selection handle
*/
const getColWidths = (tableRef, tableNode) => {
	const widths = [];
	if (tableNode && tableRef.lastChild?.lastChild?.childNodes) {
		const map = TableMap.get(tableNode);
		const rows = tableRef.lastChild.lastChild.childNodes;
		if (!rows) return widths;
		for (let i = 0; i < map.width; i++) {
			const cell = map.cellsInRect({
				left: i,
				right: i + 1,
				top: 0,
				bottom: map.height
			}).find((cellPos) => {
				const cellRect = map.findCell(cellPos);
				if (cellRect) return cellRect.right - cellRect.left === 1;
			});
			if (cell) {
				const rowIndex = map.findCell(cell)?.top;
				const row = rows[rowIndex];
				if (!row) continue;
				const colIndex = map.cellsInRect({
					left: 0,
					right: map.width,
					top: rowIndex,
					bottom: rowIndex + 1
				}).findIndex((cellPos) => cellPos === cell);
				const column = row.childNodes[colIndex];
				if (!column) continue;
				if (i === 0) widths[i] = column.getBoundingClientRect().width + 1;
				else widths[i] = column.getBoundingClientRect().width;
			}
		}
	}
	return widths;
};
//#endregion
//#region src/extensions/table/utils/createCell.ts
/**
* Create Cell with a type(header or normal cell) with attrs & content
*/
function createCell(cellType, cellAttrs, cellContent) {
	if (cellContent) return cellType.createChecked(cellAttrs, cellContent);
	return cellType.createAndFill(cellAttrs);
}
//#endregion
//#region src/extensions/table/utils/getTableNodeTypes.ts
/**
* Get all node types related to table with a `tableRole` from a schema
*/
function getTableNodeTypes(schema) {
	if (schema.cached.tableNodeTypes) return schema.cached.tableNodeTypes;
	const roles = {};
	Object.keys(schema.nodes).forEach((type) => {
		const nodeType = schema.nodes[type];
		if (nodeType.spec.tableRole) roles[nodeType.spec.tableRole] = nodeType;
	});
	schema.cached.tableNodeTypes = roles;
	return roles;
}
//#endregion
//#region src/extensions/table/utils/createTable.ts
/**
* Create table node with the tableGroup wrapper with caption and footer
*/
function createTable(schema, rowsCount, colsCount, withHeaderRow, cellContent) {
	const types = getTableNodeTypes(schema);
	const headerCells = [];
	const cells = [];
	const tableGroups = [];
	for (let index = 0; index < colsCount; index += 1) {
		const cell = createCell(types.cell, { colwidth: [710 / colsCount] }, cellContent);
		if (cell) cells.push(cell);
		if (withHeaderRow) {
			const headerCell = createCell(types.header_cell, { colwidth: [710 / colsCount] }, cellContent);
			if (headerCell) headerCells.push(headerCell);
		}
	}
	const rows = [];
	for (let index = 0; index < rowsCount; index += 1) rows.push(types.row.createChecked(null, withHeaderRow && index === 0 ? headerCells : cells));
	const table = types.table.createChecked(null, rows);
	const caption = types.table_caption.createAndFill();
	const tableFootnote = types.table_footnote.createAndFill({ hideText: true });
	if (caption) tableGroups.push(caption);
	if (table) tableGroups.push(table);
	if (tableFootnote) tableGroups.push(tableFootnote);
	return types.table_group.createChecked(null, tableGroups);
}
//#endregion
//#region src/extensions/table/utils/find.ts
/**
* Iterates over parent nodes, returning the closest table node.
*/
const findTable = (selection) => findParentNode((node) => node.type.spec.tableRole && node.type.spec.tableRole === "table")(selection);
/**
* Iterates over parent nodes, returning the closest table group node.
*/
const findTableGroup = (selection) => findParentNode((node) => node.type.spec.tableRole && node.type.spec.tableRole === "table_group")(selection);
/**
* Iterates over parent nodes, returning the closest table caption node.
*/
const findTableCaption = (selection) => findParentNode((node) => node.type.spec.tableRole && node.type.spec.tableRole === "table_caption")(selection);
/**
* Iterates over parent nodes, returning the closest table footnote node.
*/
const findTableFootnote = (selection) => findParentNode((node) => node.type.spec.tableRole && node.type.spec.tableRole === "table_footnote")(selection);
/**
* Iterates over parent nodes, returning a table cell or a table header node closest to a given `$pos`.
*/
const findCellClosestToPos = ($pos) => {
	const predicate = (node) => node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
	return findParentNodeClosestToPos($pos, predicate);
};
//#endregion
//#region src/extensions/table/utils/isSelectionType.ts
function isSelectionType(selection, type) {
	if (!selection) return false;
	return selection.toJSON().type === type;
}
//#endregion
//#region src/extensions/table/utils/getCells.ts
/**
* Get node and the doc level position based on its relative position to table node
*/
const getContentNodePos = (table, nodePos) => {
	const node = table.node.nodeAt(nodePos);
	const pos = nodePos + table.start;
	return {
		pos,
		start: pos + 1,
		node,
		depth: table.depth + 2
	};
};
/**
* Returns Cells Rect if there are selected cell(s)
*/
const getCellsRect = (map, selection) => {
	if (!isSelectionType(selection, "cell")) return;
	const start = selection.$anchorCell.start(-1);
	return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};
/**
* Returns `TableMap`, selected `Rect` with its width and height and individual cells node
* and its position. This is useful when changing cells' border
*/
const getCellsMap = (schema, selection) => {
	const table = findTable(selection);
	if (!table) return;
	const map = TableMap.get(table.node);
	if (!isSelectionType(selection, "cell")) {
		const tableNodeTypes = getTableNodeTypes(schema);
		const cellType = tableNodeTypes.cell;
		const headerCellType = tableNodeTypes.header_cell;
		const cell = findParentNode((node) => node.type === cellType || node.type === headerCellType)(selection);
		if (!cell) return;
		return {
			width: 1,
			height: 1,
			map,
			cells: [{
				pos: cell.pos,
				start: cell.pos + 1,
				node: cell.node,
				depth: table.depth + 2
			}]
		};
	}
	const rect = getCellsRect(map, selection);
	if (!rect) return;
	const cells = map.cellsInRect(rect);
	return {
		width: rect.right - rect.left,
		height: rect.bottom - rect.top,
		rect,
		map,
		cells: cells.map((nodePos) => getContentNodePos(table, nodePos))
	};
};
//#endregion
//#region src/extensions/table/utils/headers.ts
/**
* Check if Table have a header row
*/
function hasHeaderRow(state) {
	const table = findTable(state.selection);
	if (!table) return false;
	const map = TableMap.get(table.node);
	for (let i = 0; i < map.width; i++) {
		const cell = table.node.nodeAt(map.map[i]);
		if (cell && cell.type !== state.schema.nodes.tableHeader) return false;
	}
	return true;
}
/**
* Check if Table have a header column
*/
function hasHeaderColumn(state) {
	const table = findTable(state.selection);
	if (!table) return false;
	const map = TableMap.get(table.node);
	const cellPositions = map.cellsInRect({
		left: 0,
		top: 0,
		right: 1,
		bottom: map.height
	});
	for (let i = 0; i < cellPositions.length; i++) try {
		const cell = table.node.nodeAt(cellPositions[i]);
		if (cell && cell.type !== state.schema.nodes.tableHeader) return false;
	} catch (_e) {
		return false;
	}
	return true;
}
//#endregion
//#region src/extensions/table/utils/isSelected.ts
/** Checks if a given CellSelection `rect` is selected */
const isRectSelected = (rect) => (selection) => {
	if (!isSelectionType(selection, "cell")) return false;
	const map = TableMap.get(selection.$anchorCell.node(-1));
	const start = selection.$anchorCell.start(-1);
	const cells = map.cellsInRect(rect);
	const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
	for (let i = 0, count = cells.length; i < count; i++) if (selectedCells.indexOf(cells[i]) === -1) return false;
	return true;
};
/** Checks if entire column at index `columnIndex` is selected. */
const isColumnSelected = (columnIndex) => (selection) => {
	if (isSelectionType(selection, "cell")) {
		const map = TableMap.get(selection.$anchorCell.node(-1));
		return isRectSelected({
			left: columnIndex,
			right: columnIndex + 1,
			top: 0,
			bottom: map.height
		})(selection);
	}
	return false;
};
/** Checks if entire row at index `rowIndex` is selected. */
const isRowSelected = (rowIndex) => (selection) => {
	if (isSelectionType(selection, "cell")) return isRectSelected({
		left: 0,
		right: TableMap.get(selection.$anchorCell.node(-1)).width,
		top: rowIndex,
		bottom: rowIndex + 1
	})(selection);
	return false;
};
/** Checks if entire table is selected */
const isTableSelected = (selection) => {
	if (isSelectionType(selection, "cell")) {
		const map = TableMap.get(selection.$anchorCell.node(-1));
		return isRectSelected({
			left: 0,
			right: map.width,
			top: 0,
			bottom: map.height
		})(selection);
	}
	return false;
};
/** Check if selection inside table group and select the whole table */
const isSelectionIncludeTable = (state) => {
	if (isTableSelected(state.selection)) return true;
	const tableGroup = findTableGroup(state.selection);
	if (!tableGroup?.node) return false;
	const tableType = getTableNodeTypes(state.schema).table;
	const table = findChildren(tableGroup.node, (node) => node.type === tableType)[0];
	if (!table?.node) return false;
	const { from, to } = state.selection;
	const tableStart = tableGroup.start + table.pos;
	const tableEnd = tableStart + table.node.nodeSize;
	return from <= tableStart && to >= tableEnd;
};
/** Check if selection is inside table wrapper node */
const isSelectionInsideTableGroup = (selection) => {
	if (isSelectionType(selection, "cell")) return true;
	else if (isSelectionType(selection, "text") || isSelectionType(selection, "node")) return !!findTableGroup(selection);
	return false;
};
/** Check if selection is inside table node */
const isSelectionInsideTable = (selection) => {
	if (isSelectionType(selection, "cell")) return true;
	else if (isSelectionType(selection, "text") || isSelectionType(selection, "node")) return !!findTable(selection);
	return false;
};
//#endregion
//#region src/extensions/table/utils/selectNodes.ts
/**
* Select helpers to select row/column at given index
*/
const select = (type) => (index, expand) => (tr) => {
	const table = findTable(tr.selection);
	const isRowSelection = type === "row";
	if (table) {
		const map = TableMap.get(table.node);
		if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
			let left = isRowSelection ? 0 : index;
			let top = isRowSelection ? index : 0;
			let right = isRowSelection ? map.width : index + 1;
			let bottom = isRowSelection ? index + 1 : map.height;
			if (expand) {
				const cell = findCellClosestToPos(tr.selection.$from);
				if (!cell) return tr;
				const selRect = map.findCell(cell.pos - table.start);
				if (isRowSelection) {
					top = Math.min(top, selRect.top);
					bottom = Math.max(bottom, selRect.bottom);
				} else {
					left = Math.min(left, selRect.left);
					right = Math.max(right, selRect.right);
				}
			}
			const cellsInFirstRow = map.cellsInRect({
				left,
				top,
				right: isRowSelection ? right : left + 1,
				bottom: isRowSelection ? top + 1 : bottom
			});
			const cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
				left: isRowSelection ? left : right - 1,
				top: isRowSelection ? bottom - 1 : top,
				right,
				bottom
			});
			const head = table.start + cellsInFirstRow[0];
			const anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
			const $head = tr.doc.resolve(head);
			const $anchor = tr.doc.resolve(anchor);
			return tr.setSelection(new CellSelection($anchor, $head));
		}
	}
	return tr;
};
/**
* Returns a new transaction that selects a column at index `columnIndex`.
* Use the optional `expand` param to extend from current selection.
*/
const selectColumn = select("column");
/**
* Returns a new transaction that selects a row at index `rowIndex`.
* Use the optional `expand` param to extend from current selection.
*/
const selectRow = select("row");
/** Returns a new transaction that selects a table. */
const selectTable = (tr) => {
	const table = findTable(tr.selection);
	if (table) {
		const { map } = TableMap.get(table.node);
		if (map && map.length) {
			const head = table.start + map[0];
			const anchor = table.start + map[map.length - 1];
			const $head = tr.doc.resolve(head);
			const $anchor = tr.doc.resolve(anchor);
			return tr.setSelection(new CellSelection($anchor, $head));
		}
	}
	return tr;
};
//#endregion
//#region src/extensions/table/utils/tableBorders.ts
/**
* Check if selected cells have border on given side
*/
const haveTableBorderStyle = (state, side) => {
	const table = findTable(state.selection);
	const cellsMap = getCellsMap(state.schema, state.selection);
	if (table && cellsMap) {
		const { cells, rect, height, map } = cellsMap;
		if (side === "top") return cells.every((cell) => {
			if (!isTopCell(cell, table, map, rect)) return true;
			return cellHasBorder(cell, table, map, "top");
		});
		else if (side === "bottom") return cells.every((cell) => {
			if (!isBottomCell(cell, table, map, rect)) return true;
			return cellHasBorder(cell, table, map, "bottom");
		});
		else if (side === "insideHorizontal") {
			if (height <= 1) return false;
			return cells.every((cell) => {
				if (!isBottomCell(cell, table, map, rect)) return cellHasBorder(cell, table, map, "bottom");
				return cellHasBorder(cell, table, map, "top");
			});
		} else if (side === "all") return cells.every((cell) => cellHasBorder(cell, table, map, "bottom") && cellHasBorder(cell, table, map, "top") && cellHasBorder(cell, table, map, "right") && cellHasBorder(cell, table, map, "left"));
		else return false;
	}
	return false;
};
/**
* Check if cell is at the top row of selected rect
*/
const isTopCell = (cell, table, map, rect) => {
	return !rect || rect.top === map.findCell(cell.pos - table.start).top;
};
/**
* Check if cell is at the bottom row of selected rect
*/
const isBottomCell = (cell, table, map, rect) => {
	return !rect || rect.bottom === map.findCell(cell.pos - table.start).bottom;
};
/**
* Check if a given cell have border on given side by checking
* cell's border and it's neighbouring cell that intersect at border side
*/
const cellHasBorder = (cell, table, map, side) => {
	let neighbourCellPos;
	if (side === "left") {
		neighbourCellPos = map.nextCell(cell.pos - table.start, "horiz", -1);
		if (neighbourCellPos !== null) {
			const neighbourCell = table.node.nodeAt(neighbourCellPos);
			return cell.node.attrs.border.left || neighbourCell.attrs.border.right;
		}
		return cell.node.attrs.border.left;
	} else if (side === "top") {
		neighbourCellPos = map.nextCell(cell.pos - table.start, "vert", -1);
		if (neighbourCellPos !== null) {
			const neighbourCell = table.node.nodeAt(neighbourCellPos);
			return cell.node.attrs.border.top || neighbourCell.attrs.border.bottom;
		}
		return cell.node.attrs.border.top;
	} else if (side === "right") {
		neighbourCellPos = map.nextCell(cell.pos - table.start, "horiz", 1);
		if (neighbourCellPos !== null) {
			const neighbourCell = table.node.nodeAt(neighbourCellPos);
			return cell.node.attrs.border.right || neighbourCell.attrs.border.left;
		}
		return cell.node.attrs.border.right;
	} else {
		neighbourCellPos = map.nextCell(cell.pos - table.start, "vert", 1);
		if (neighbourCellPos !== null) {
			const neighbourCell = table.node.nodeAt(neighbourCellPos);
			return cell.node.attrs.border.bottom || neighbourCell.attrs.border.top;
		}
		return cell.node.attrs.border.bottom;
	}
};
//#endregion
//#region src/extensions/table/utils/setCellAttrs.ts
/**
* Set cell's attributes merged with current cell's attributes
*/
const setCellAttrs = (cell, attrs) => (tr) => {
	if (cell) tr.setNodeMarkup(cell.pos, void 0, Object.assign({}, cell.node.attrs, attrs));
	return tr;
};
const setNeighbourCellsBorder = (map, cellPos, side, border) => (tr) => {
	const table = findTable(tr.selection);
	if (!table) return tr;
	let newTr = tr;
	let neighbourCellPos;
	const relativePos = cellPos - table.start;
	if (side === "left") neighbourCellPos = map.nextCell(relativePos, "horiz", -1);
	else if (side === "right") neighbourCellPos = map.nextCell(relativePos, "horiz", 1);
	else if (side === "bottom") neighbourCellPos = map.nextCell(relativePos, "vert", 1);
	else neighbourCellPos = map.nextCell(relativePos, "vert", -1);
	if (neighbourCellPos !== null) {
		const node = table.node.nodeAt(neighbourCellPos);
		const pos = table.start + neighbourCellPos;
		let newBorder;
		if (side === "left") newBorder = { right: border };
		else if (side === "right") newBorder = { left: border };
		else if (side === "bottom") newBorder = { top: border };
		else newBorder = { bottom: border };
		const newAttrs = {
			...node.attrs,
			border: {
				...node.attrs.border,
				...newBorder
			}
		};
		newTr = setCellAttrs({
			node,
			pos
		}, newAttrs)(newTr);
	}
	return newTr;
};
/**
* Set table's cell on `index` of the cellsMap's border on the specified `side` to be on/off
*/
const setCellBorder = (cellsMap, index, side, border) => (tr) => {
	const table = findTable(tr.selection);
	if (!table) return tr;
	let newTr = tr;
	const { cells, map, rect } = cellsMap;
	const cell = cells[index];
	const { node, pos } = cell;
	let newBorder;
	if (side === "all") newBorder = {
		left: border,
		right: border,
		top: border,
		bottom: border
	};
	else if (side === "top") {
		if (isTopCell(cell, table, map, rect)) newBorder = { top: border };
	} else if (side === "bottom") {
		if (isBottomCell(cell, table, map, rect)) newBorder = { bottom: border };
	} else if (side === "insideHorizontal" && rect) if (isBottomCell(cell, table, map, rect)) newBorder = { top: border };
	else newBorder = { bottom: border };
	if (newBorder) {
		const newAttrs = {
			...node.attrs,
			border: {
				...node.attrs.border,
				...newBorder
			}
		};
		newTr = setCellAttrs({
			node,
			pos
		}, newAttrs)(newTr);
		if (side === "all") {
			newTr = setNeighbourCellsBorder(map, pos, "top", border)(newTr);
			newTr = setNeighbourCellsBorder(map, pos, "bottom", border)(newTr);
			newTr = setNeighbourCellsBorder(map, pos, "left", border)(newTr);
			newTr = setNeighbourCellsBorder(map, pos, "right", border)(newTr);
		} else if (side === "bottom") newTr = setNeighbourCellsBorder(map, pos, "bottom", border)(newTr);
		else if (side === "top") newTr = setNeighbourCellsBorder(map, pos, "top", border)(newTr);
	}
	return newTr;
};
/**
* Set selected cells background to `color`
*/
const setCellsBackground = (color) => (state, dispatch) => {
	if (!isInTable(state)) return false;
	let tr = state.tr;
	const rect = selectedRect(state);
	if (!rect) return false;
	const { map } = rect;
	for (let row = rect.top; row < rect.bottom; row++) for (let col = rect.left; col < rect.right; col++) {
		const cellPos = map.map[row * map.width + col];
		const cell = rect.table.nodeAt(cellPos);
		if (cell) tr = setCellAttrs({
			pos: cellPos + rect.tableStart,
			node: cell
		}, { backgroundColor: color })(tr);
	}
	dispatch?.(tr);
	return true;
};
//#endregion
//#region src/extensions/table/utils/tableStyles.ts
/**
* Check if table inside selection has an alternate background
*/
const hasAlternateColor = (state) => {
	const table = findTable(state.selection);
	if (table) return !!table.node.attrs.alternateBackground;
	return false;
};
/**
* Check selected table's table level background color
*/
const tableColor = (state) => {
	const table = findTable(state.selection);
	if (table) return table.node.attrs.backgroundColor;
};
/**
* Check selected table's cells level background color
*/
const cellsColor = (state) => {
	const table = findTable(state.selection);
	let color;
	if (table) {
		const rect = selectedRect(state);
		if (!rect) return color;
		const { map, table } = rect;
		map.cellsInRect(rect).some((cellPos, index) => {
			const cell = table.nodeAt(cellPos);
			if (cell) {
				if (!color && index === 0) color = cell.attrs.backgroundColor;
				if (color !== cell.attrs.backgroundColor && index !== 0) {
					color = void 0;
					return true;
				}
			}
		});
	}
	return color;
};
//#endregion
//#region src/extensions/floating-menu/floating-menu-plugin.ts
/**
* Prosemirror Plugin that watches the view using a `PluginView` to update the
* open state for the menu.
*/
const FloatingMenuOpenStatePlugin = (options) => new Plugin({
	key: typeof options.pluginKey === "string" ? new PluginKey(options.pluginKey) : options.pluginKey,
	view: () => ({
		update: (view, oldState) => {
			const { isAsync, shouldShow, editor, setOpen } = options;
			const { state, composing } = view;
			const { doc, selection } = state;
			const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
			if (!isAsync && (composing || isSame)) return;
			setOpen(getOpenState(editor, oldState, shouldShow));
		},
		destroy: () => {
			options.setOpen(false);
		}
	})
});
const getOpenState = (editor, oldState, shouldShow) => {
	const { view, state } = editor;
	const { selection } = state;
	const { ranges } = selection;
	return shouldShow({
		editor,
		view,
		state,
		oldState,
		from: Math.min(...ranges.map((range) => range.$from.pos)),
		to: Math.max(...ranges.map((range) => range.$to.pos))
	});
};
//#endregion
//#region src/extensions/floating-menu/useFloatingMenuOpenState.ts
/**
* React hook tracking FloatingMenu open state.
*
* The hook uses a render effect to register a Prosemirror `PluginView` plugin
* with an `Editor`, which updates the open state along with the view updates.
* Each view update applies `options.shouldShow` to keep the menu open state in
* sync.
*
* @returns React `useState<boolean>()` return type.
*/
function useFloatingMenuOpenState(props) {
	const { pluginKey, editor, shouldShow, isAsync, onOpenChange, onClose } = props;
	const [open, setOpen] = useState(false);
	const openRef = useRef(open);
	useEffect(() => {
		if (!editor.isDestroyed) {
			editor.registerPlugin(FloatingMenuOpenStatePlugin({
				editor,
				pluginKey,
				setOpen,
				shouldShow,
				isAsync
			}));
			const nextShow = getOpenState(editor, editor.state, shouldShow);
			setTimeout(() => setOpen(nextShow), 0);
		}
		return () => {
			editor.unregisterPlugin(pluginKey);
		};
	}, [
		editor,
		pluginKey,
		shouldShow,
		isAsync,
		setOpen
	]);
	useEffect(() => {
		if (openRef.current !== open && !open) onClose?.(editor);
		if (openRef.current !== open) onOpenChange?.(open);
		openRef.current = open;
	}, [
		open,
		onOpenChange,
		onClose,
		editor
	]);
	return [open, setOpen];
}
//#endregion
//#region src/extensions/floating-menu/floating-menu-component.tsx
/**
* React component to display floating contents on a target position in the DOM.
*/
function FloatingMenuComponent(props) {
	const { editor, getBoundingClientRect, portalId, mainAxisOffset = 8, placement = "bottom", modal = false, ...rest } = props;
	const [open, setOpen] = useFloatingMenuOpenState(props);
	const nodeId = useFloatingNodeId();
	const { x, y, refs, strategy, context } = useFloating({
		whileElementsMounted: (referenceEl, floatingEl, update) => autoUpdate(referenceEl, floatingEl, update, { animationFrame: true }),
		open,
		onOpenChange: setOpen,
		nodeId,
		middleware: [
			offset(mainAxisOffset),
			shift(),
			flip(),
			hide()
		],
		placement,
		...rest
	});
	const { getFloatingProps } = useInteractions([
		useFocus(context),
		useRole(context, { role: "menu" }),
		useClick(context)
	]);
	const defaultGetBoundingClientRect = useCallback(() => {
		const { state, view } = editor;
		const { selection } = state;
		const { ranges } = selection;
		const from = Math.min(...ranges.map((range) => range.$from.pos));
		const to = Math.max(...ranges.map((range) => range.$to.pos));
		if (isNodeSelection(selection)) {
			const node = view.nodeDOM(from);
			if (node) return node.getBoundingClientRect();
		}
		return posToDOMRect(view, from, to);
	}, [editor]);
	useLayoutEffect(() => {
		refs.setReference({ getBoundingClientRect: getBoundingClientRect ?? defaultGetBoundingClientRect });
	}, [
		refs,
		editor,
		getBoundingClientRect,
		defaultGetBoundingClientRect
	]);
	return /* @__PURE__ */ jsx(FloatingTree, { children: /* @__PURE__ */ jsx(FloatingNode, {
		id: nodeId,
		children: open && /* @__PURE__ */ jsx(FloatingPortal, {
			id: portalId,
			children: /* @__PURE__ */ jsx(FloatingFocusManager, {
				context,
				disabled: !modal,
				children: /* @__PURE__ */ jsx("div", {
					style: {
						position: strategy,
						top: y ?? 0,
						left: x ?? 0,
						zIndex: 1e3
					},
					ref: refs.setFloating,
					...getFloatingProps(),
					children: props.children
				})
			})
		})
	}) });
}
//#endregion
//#region src/extensions/floating-menu/floating-menu-extension.ts
/**
* Tiptap extension that exposes command to dismiss floating menus
* like equation & hyperlink.
*/
const FloatingMenuExtension = Extension.create({
	name: "floatingMenu",
	addCommands() {
		return { dismissMenu: () => ({ chain, editor }) => {
			const enabledExtensions = editor.extensionManager.extensions.map(({ name }) => name);
			return chain().command(({ commands }) => {
				if (enabledExtensions.includes("math")) return commands.setEquationMenuTarget();
				return true;
			}).command(({ commands }) => {
				if (enabledExtensions.includes("link")) return commands.setHyperlinkMenuTarget();
				return true;
			}).run();
		} };
	}
});
//#endregion
//#region src/extensions/collab/caret-plugin.ts
/** Plugin key for the collaborative caret plugin. */
const caretPluginKey = new PluginKey("collabCaret");
/**
* Plugin creator for a collaborative carets plugin that displays carets of
* other user clients (other than the user's own `clientId`).
*
* @param myClientId - User's current client ID.
* @param presence - Dynamic state of connected user clients.
* @returns A ProseMirror Plugin that displays other user's carets.
*/
function caretPlugin(myClientId, presence) {
	return new Plugin({
		key: caretPluginKey,
		state: {
			init: (_state, _editorState) => DecorationSet.empty,
			apply: (tr, decoSet, _oldEditorState, newEditorState) => {
				const meta = tr.getMeta(caretPluginKey);
				if (meta?.updateCarets) {
					const carets = meta.updateCarets;
					const decorations = createDecorationWidgets(newEditorState, myClientId, carets, presence);
					return DecorationSet.create(newEditorState.doc, decorations);
				}
				if (tr.docChanged) return decoSet.map(tr.mapping, tr.doc);
				return decoSet;
			}
		},
		props: { decorations: (state) => {
			return caretPluginKey.getState(state);
		} }
	});
}
function createDecorationWidgets(state, myClientId, carets, presence) {
	const decorations = [];
	const clients = presence.clients();
	if (clients.length === 0 || carets.length === 0) return decorations;
	for (const client of clients) {
		if (client.clientId === myClientId) continue;
		const caret = carets.find((caret) => caret.clientId === client.clientId);
		if (caret && caret.head >= 0 && caret.head <= state.doc.content.size) {
			if (state.doc.resolve(caret.head).parent.isTextblock) decorations.push(Decoration.widget(caret.head, () => caretBuilder(client), {
				side: 10,
				key: caret.clientId
			}));
		}
	}
	return decorations;
}
function caretBuilder(user) {
	const colourset = resolveAvatarColourset(user.colourset);
	const caret = document.createElement("span");
	caret.classList.add("ProseMirror-collab-caret");
	caret.setAttribute("style", `--caret-color: ${colourset.caret};`);
	const userDiv = document.createElement("div");
	userDiv.insertBefore(document.createTextNode(user.name.slice(0, 2)), null);
	const nonbreakingSpace1 = document.createTextNode("⁠");
	const nonbreakingSpace2 = document.createTextNode("⁠");
	caret.insertBefore(nonbreakingSpace1, null);
	caret.insertBefore(userDiv, null);
	caret.insertBefore(nonbreakingSpace2, null);
	return caret;
}
//#endregion
//#region src/extensions/collab/collab.ts
/**
* Wraps ProseMirror collab plugin as a TipTap extension.
*/
const Collab = Extension.create({
	name: "Collab",
	addCommands() {
		return {
			receiveSteps: (steps, clientIds, onComplete) => ({ state }) => {
				const tr = receiveTransaction(state, steps, clientIds, { mapSelectionBackward: true });
				const newState = state.apply(tr);
				onComplete?.(newState);
				return true;
			},
			updateCarets: (carets) => ({ tr }) => {
				const meta = { updateCarets: carets };
				tr.setMeta(caretPluginKey, meta);
				return true;
			}
		};
	},
	addProseMirrorPlugins() {
		const clientID = this.options.clientId || Math.floor(Math.random() * 4294967295).toString();
		const plugins = [collab({
			version: this.options.version,
			clientID
		})];
		if (this.options.presence) plugins.push(caretPlugin(clientID, this.options.presence));
		return plugins;
	}
});
//#endregion
//#region src/extensions/history/history.ts
const HistoryPluginKey = new PluginKey("history");
/**
* TipTap extension wrapper on the prosemirror-history plugin that emits Cadmus
* Editor history events via Transaction metadata.
*
* These events will be collected by the `telemetry` Extension.
*/
const History = Extension.create({
	name: "history",
	addOptions() {
		return {
			depth: 100,
			newGroupDelay: 500
		};
	},
	addCommands() {
		return {
			undo: () => ({ state, dispatch }) => {
				const timestamp = this.options.getTime?.() ?? (/* @__PURE__ */ new Date()).toISOString();
				const editorEventId = v7();
				return undo(state, (tr) => {
					const { addedWords, deletedWords } = wordCountChanges(tr);
					const meta = {
						type: "undo",
						wordsAdded: addedWords,
						wordsDeleted: deletedWords,
						timestamp,
						editorEventId
					};
					tr.setMeta(HistoryPluginKey, meta);
					dispatch?.(tr);
				});
			},
			redo: () => ({ state, dispatch }) => {
				const timestamp = this.options.getTime?.() ?? (/* @__PURE__ */ new Date()).toISOString();
				const editorEventId = v7();
				return redo(state, (tr) => {
					const { addedWords, deletedWords } = wordCountChanges(tr);
					const meta = {
						type: "redo",
						wordsAdded: addedWords,
						wordsDeleted: deletedWords,
						timestamp,
						editorEventId
					};
					tr.setMeta(HistoryPluginKey, meta);
					dispatch?.(tr);
				});
			}
		};
	},
	addProseMirrorPlugins() {
		return [history(this.options)];
	},
	addKeyboardShortcuts() {
		return {
			"Mod-z": () => this.editor.commands.undo(),
			"Mod-y": () => this.editor.commands.redo(),
			"Shift-Mod-z": () => this.editor.commands.redo()
		};
	}
});
//#endregion
//#region src/extensions/collab/sendable-word-count-change.ts
function sendableWordCountChange(sendable) {
	const sendableMeta = {
		pastes: [],
		histories: []
	};
	if (!sendable || !sendable.origins) return sendableMeta;
	return [...new Set(sendable.origins)].reduce((acc, origin) => {
		const pasteMeta = origin.getMeta(PastePluginKey);
		if (pasteMeta) acc.pastes.push({
			origin: pasteMeta.origin,
			count: pasteMeta.wordCount ?? 0,
			added: pasteMeta.wordsAdded ?? 0,
			deleted: pasteMeta.wordsDeleted ?? 0,
			internal: pasteMeta.internal,
			timestamp: pasteMeta.timestamp,
			editorEventId: pasteMeta.editorEventId
		});
		const historyMeta = origin.getMeta(HistoryPluginKey);
		if (historyMeta) acc.histories.push({
			added: historyMeta.wordsAdded ?? 0,
			deleted: historyMeta.wordsDeleted ?? 0,
			timestamp: historyMeta.timestamp,
			type: historyMeta.type,
			editorEventId: historyMeta.editorEventId
		});
		return acc;
	}, sendableMeta);
}
//#endregion
//#region src/extensions/document/document.ts
/**
* A document that allows multiple types of block nodes as children.
*/
const Document = Node$1.create({
	name: "doc",
	topNode: true,
	content: "(block | tableBlock | codeBlock | mathBlock)+"
});
/**
* A document that only allows simple block nodes as children.
*/
const SlimDocument = Node$1.create({
	name: "doc",
	topNode: true,
	content: "block+"
});
/**
* A document that only allows a single block node as a child.
*/
const SingleBlockDocument = Node$1.create({
	name: "doc",
	topNode: true,
	content: "block"
});
//#endregion
//#region src/paste-rules/nodePasteRule.ts
/**
* Go through each node inside fragment and apply paste node transformation
* (Adding mark or node) if the parent node allow the transformed node as its
* content
*/
function NodePasteRule(regexp, transformFn) {
	const handler = (fragment) => {
		const nodes = [];
		fragment.forEach((child) => {
			if (child.isText && child.text) {
				const pos = Array.from(child.text.matchAll(regexp)).reduce((pos, match) => {
					const start = match.index ?? 0;
					const end = start + match[0].length;
					if (start > 0) nodes.push(child.cut(pos, start));
					const transformedNode = transformFn(child.cut(start, end), match);
					nodes.push(transformedNode ?? child.cut(start, end));
					return end;
				}, 0);
				if (pos < child.text.length) nodes.push(child.cut(pos));
			} else {
				const transformedNode = handler(child.content);
				if (child.type.validContent(Fragment.from(transformedNode))) nodes.push(child.copy(transformedNode));
				else nodes.push(child);
			}
		});
		return Fragment.fromArray(nodes);
	};
	return new Plugin({
		key: new PluginKey("nodePasteRule"),
		props: { transformPasted: (slice) => {
			return new Slice(handler(slice.content), slice.openStart, slice.openEnd);
		} }
	});
}
//#endregion
//#region src/extensions/emoji/emoji.ts
const Emoji = Node$1.create({
	name: "emoji",
	inline: true,
	group: "inline",
	selectable: false,
	atom: true,
	addAttributes() {
		return { text: {
			default: "",
			renderHTML: (attributes) => ({ "data-emoji-text": attributes.text })
		} };
	},
	parseHTML() {
		return [
			{
				tag: "span[data-emoji-text]",
				getAttrs: (domNode) => {
					if (domNode instanceof Element) {
						const text = domNode.getAttribute("data-emoji-text");
						if (text) return { text };
					}
					return false;
				}
			},
			{
				tag: "img[data-emoji-ch]",
				getAttrs: (domNode) => {
					if (domNode instanceof Element) {
						const text = domNode.getAttribute("data-emoji-ch");
						if (text) return { text };
					}
					return false;
				}
			},
			{
				tag: "img",
				getAttrs: (domNode) => {
					const { src } = domNode;
					const maybeEmoji = src.match(/https:\/\/paper.dropboxstatic.com\/static\/img\/ace\/emoji\/(.*).png/);
					if (maybeEmoji?.length !== 2) return false;
					const emojiCode = maybeEmoji[1];
					let emojiChar = "";
					try {
						emojiChar = String.fromCodePoint(parseInt(`0x${emojiCode}`, 16));
					} catch (_ex) {
						return false;
					}
					return { text: emojiChar };
				}
			}
		];
	},
	renderHTML({ node, HTMLAttributes }) {
		const { text } = node.attrs;
		const attrs = mergeAttributes(HTMLAttributes, { contentEditable: "false" });
		const div = document.createElement("div");
		div.textContent = text;
		twemoji.parse(div);
		const img = div.querySelector("img");
		if (!img) return [
			"span",
			attrs,
			text
		];
		return [
			"span",
			attrs,
			["img", {
				src: img.getAttribute("src"),
				alt: img.getAttribute("alt"),
				class: "emoji"
			}]
		];
	},
	addProseMirrorPlugins() {
		return [NodePasteRule(new RegExp(EMOJI_REGEX, "g"), (_node, match) => {
			const emojiText = match[0];
			return this.type.create({ text: emojiText });
		})];
	},
	addInputRules() {
		return [new InputRule({
			find: EMOJI_REGEX,
			handler: ({ state, match, range }) => {
				const { tr, doc } = state;
				const { from, to } = range;
				const emojiText = match[0];
				const start = doc.resolve(from).start() + (match.index ?? 0);
				tr.replaceWith(start, to, this.type.create({ text: emojiText }));
			}
		})];
	}
});
//#endregion
//#region src/extensions/empty-media-node/empty-media-node.ts
const emptyMediaNodeKey = new PluginKey("emptyMediaNode");
function getMediaTypes(schema, nodeNames) {
	return nodeNames.filter((name) => !!schema.nodes[name]).map((name) => getNodeType(name, schema));
}
function isEmptyMediaNode(node, mediaTypes) {
	return mediaTypes.includes(node.type) && node.textContent === "";
}
const EmptyMediaNode = Extension.create({
	name: "emptyMediaNode",
	addOptions() {
		return { nodeNames: [
			"image",
			"audio",
			"video"
		] };
	},
	addProseMirrorPlugins() {
		return [new Plugin({
			key: emptyMediaNodeKey,
			state: {
				init: (_, state) => {
					const { doc, schema } = state;
					const decorations = [];
					const mediaTypes = getMediaTypes(schema, this.options.nodeNames);
					doc.descendants((node, pos) => {
						if (isEmptyMediaNode(node, mediaTypes)) {
							const decoration = Decoration.node(pos, pos + node.nodeSize, { "data-empty-node": "true" });
							decorations.push(decoration);
						}
					});
					return DecorationSet.create(doc, decorations);
				},
				apply: (tr, decoSet, _, newState) => {
					if (tr.docChanged) {
						let updatedDecoSet = decoSet.map(tr.mapping, tr.doc);
						const { doc, schema } = newState;
						const mediaTypes = getMediaTypes(schema, this.options.nodeNames);
						const newDecorations = [];
						updatedDecoSet = updatedDecoSet.remove(updatedDecoSet.find().filter((deco) => {
							const node = doc.nodeAt(deco.from);
							return !node || !isEmptyMediaNode(node, mediaTypes);
						}));
						let from;
						let to;
						for (let i = 0; i < tr.steps.length; i++) {
							const step = tr.steps[i];
							const stepMapping = step.getMap();
							const stepFrom = stepMapping.map(step.from || step.pos, -1);
							const stepTo = stepMapping.map(step.to || step.pos, 1);
							if (from !== void 0) from = Math.min(stepMapping.map(from, -1), stepFrom);
							else from = stepFrom;
							if (to !== void 0) to = Math.max(stepMapping.map(to, 1), stepTo);
							else to = stepTo;
						}
						if (from !== void 0 && to !== void 0) doc.nodesBetween(from, to, (node, pos) => {
							if (isEmptyMediaNode(node, mediaTypes)) {
								const decoration = Decoration.node(pos, pos + node.nodeSize, { "data-empty-node": "true" });
								newDecorations.push(decoration);
							}
						});
						return updatedDecoSet.add(doc, newDecorations);
					}
					return decoSet;
				}
			},
			props: { decorations: (state) => emptyMediaNodeKey.getState(state) }
		})];
	}
});
//#endregion
//#region src/extensions/task-list/task-list.ts
const TaskList = Node$1.create({
	name: "taskList",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block list",
	content: "taskItem+",
	parseHTML() {
		return [{
			tag: "ul[data-type=\"taskList\"]",
			priority: 51
		}, {
			tag: "ul",
			priority: 51,
			getAttrs: (node) => {
				if (typeof node === "string") return false;
				if (!node.className.split(" ").some((className) => /(checkList|list-task)/i.test(className))) return false;
				return {};
			}
		}];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"ul",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { "data-type": "taskList" }),
			0
		];
	},
	addCommands() {
		return { toggleTaskList: () => ({ commands }) => {
			return commands.toggleCadmusList(this.type, getNodeType("taskItem", this.editor.schema));
		} };
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-9": () => this.editor.commands.toggleTaskList() };
	}
});
/** Check if selection is inside Task List */
const isSelectionInsideTaskList = (selection) => {
	if (isSelectionType(selection, "text")) return !!findTaskList(selection);
	return false;
};
const findTaskList = (selection) => findParentNode((node) => node.type.name === "taskList")(selection);
//#endregion
//#region src/extensions/footnote/utils.ts
/**
* List of Footnotes within a proseMirror node in order of appearance.
*
* Takes a proseMirror node and finds all the footnote nodes under it.
*
* @param topNode - a proseMirror node
* @returns FootnoteInfo[] - ID, content and wordCount of the footnotes
* in the editor
*/
function listFootnotes(topNode) {
	return findChildren(topNode, (node) => node.type.name === "footnote").map((footnote) => ({
		id: footnote.node.attrs.id,
		content: footnote.node.attrs.content,
		wordCount: getHTMLWordCount(footnote.node.attrs.content)
	}));
}
/**
* Finds a footnote node by its ID by going through the children of the given
* node.
*
* @param node The node to search for the footnote in
* @param footnoteId The ID of the footnote to find
* @returns The footnote node if found, undefined otherwise
*/
function findFootnoteNode(node, footnoteId) {
	if (!footnoteId) return void 0;
	return findChildren(node, (node) => node.type.name === "footnote" && footnoteId === node.attrs.id)?.[0];
}
/**
* Calls the plugin state to get the active footnote ID.
*
* @param state current editor state
* @returns active footnote ID or null if no footnote is active
*/
function currentActiveFootnoteId(state) {
	return FootnoteActiveStatusPluginKey.getState(state)?.activeFootnoteId ?? null;
}
//#endregion
//#region src/extensions/footnote/footnote-active-status-plugin.ts
const FootnoteActiveStatusPluginKey = new PluginKey("FootnoteActiveStatus");
/**
* Plugin for tracking active footnote in the editor.
*
* The main purpose is to track and keep active footnote ID in its own state.
*
* In addition, handles click and double click on the footnote node, and adds a
* decoration to the active footnote node.
*/
function FootnoteActiveStatusPlugin(props) {
	return new Plugin({
		key: FootnoteActiveStatusPluginKey,
		state: {
			init() {
				return { activeFootnoteId: null };
			},
			apply(tr, value) {
				const focusedFtntId = tr.getMeta("activeFootnoteId");
				if (focusedFtntId !== void 0) return { activeFootnoteId: focusedFtntId };
				return value;
			}
		},
		/**
		* Adds a decoration to the active footnote node in the editor
		*/
		props: {
			decorations(editorState) {
				if (!props.editor.isEditable) return void 0;
				const footnoteId = this.getState(editorState)?.activeFootnoteId;
				const footnoteNode = footnoteId ? findFootnoteNode(editorState.doc, footnoteId) : void 0;
				if (!footnoteNode) return DecorationSet.empty;
				const { pos, node } = footnoteNode;
				const decoration = Decoration.node(pos, pos + node.nodeSize, { class: "footnote-active" });
				return DecorationSet.create(editorState.doc, [decoration]);
			},
			/**
			* Handles click on the footnote superscript in the main editor
			*/
			handleClickOn(view, _pos, node) {
				if (!props.editor.isEditable) return false;
				if (node.type.name === "footnote") {
					const footnoteId = node.attrs.id;
					if (footnoteId !== this.getState(view.state)?.activeFootnoteId) view.dispatch(view.state.tr.setMeta("activeFootnoteId", footnoteId));
					return true;
				}
				return false;
			},
			/**
			* If the footnote node is double clicked, bring focus to the main editor,
			* and select the footnote node (so it can be copied, deleted, etc.)
			*/
			handleDoubleClickOn(view, _pos, node, nodePos) {
				if (!props.editor.isEditable) return false;
				if (node.type.name === "footnote") {
					const selection = new NodeSelection(view.state.doc.resolve(nodePos));
					if (selection) {
						view.focus();
						view.dispatch(view.state.tr.setSelection(selection));
					}
					return true;
				}
				return false;
			}
		}
	});
}
//#endregion
//#region src/extensions/footnote/footnote-list-plugin.ts
const FootnoteListPluginKey = new PluginKey("FootnoteList");
function FootnoteListPlugin() {
	return new Plugin({
		key: FootnoteListPluginKey,
		state: {
			init(_, state) {
				return listFootnotes(state.doc);
			},
			apply(tr, currentList, _oldEditorState, newEditorState) {
				if (!tr.docChanged) return currentList;
				return listFootnotes(newEditorState.doc);
			}
		}
	});
}
//#endregion
//#region src/extensions/footnote/footnote.ts
const Footnote = Node$1.create({
	name: "footnote",
	group: "inline",
	content: "inline*",
	inline: true,
	atom: true,
	selectable: true,
	gapCursor: true,
	addOptions() {
		return { HTMLAttributes: {} };
	},
	addAttributes() {
		return {
			id: {
				default: null,
				parseHTML: (element) => element.getAttribute("data-footnote-id"),
				renderHTML: (attributes) => attributes.id ? { "data-footnote-id": attributes.id } : {}
			},
			content: {
				default: "",
				parseHTML: (element) => element.getAttribute("data-footnote-content") || "",
				renderHTML: (attributes) => ({ "data-footnote-content": attributes.content })
			}
		};
	},
	parseHTML() {
		return [{
			tag: "footnote",
			priority: 51,
			context: "table//|taskList//",
			ignore: true,
			skip: true
		}, {
			tag: "footnote",
			priority: 51
		}];
	},
	renderHTML(attrs) {
		return [
			"footnote",
			mergeAttributes(this.options.HTMLAttributes, attrs.HTMLAttributes),
			""
		];
	},
	addCommands() {
		return {
			insertFootnote: () => ({ tr, editor }) => {
				if (isSelectionInsideTable(tr.selection) || isSelectionInsideTableGroup(tr.selection) || isSelectionInsideTaskList(tr.selection)) return false;
				const sel = tr.selection;
				const newId = v4();
				const pasteNode = editor.schema.nodes.footnote.create({ id: newId });
				tr.insert(sel.to, pasteNode).setMeta("activeFootnoteId", newId);
				return true;
			},
			deleteFootnote: (id) => ({ tr, commands }) => {
				const item = findFootnoteNode(tr.doc, id);
				if (!item) return false;
				return commands.deleteRange({
					from: item.pos,
					to: item.pos + item.node.nodeSize
				});
			},
			updateFootnote: (id, content) => ({ tr }) => {
				const item = findFootnoteNode(tr.doc, id);
				if (item) {
					tr.setNodeMarkup(item.pos, void 0, {
						...item.node.attrs,
						content
					});
					return true;
				}
				return false;
			},
			focusFootnote: (id) => ({ tr }) => {
				const item = findFootnoteNode(tr.doc, id);
				if (item) {
					const newSelection = TextSelection.create(tr.doc, item.pos + item.node.nodeSize);
					tr.setSelection(newSelection);
				}
				tr.setMeta("activeFootnoteId", item ? id : null);
				return true;
			}
		};
	},
	addKeyboardShortcuts() {
		return { "Alt-Mod-f": ({ editor }) => editor.commands.insertFootnote() };
	},
	addProseMirrorPlugins() {
		return [
			new Plugin({ appendTransaction: (transactions, oldState, newState) => {
				const pasteTransaction = transactions.find((tr) => tr.getMeta(PastePluginKey) && tr.getMeta("uiEvent") == "paste");
				if (!pasteTransaction) return;
				const tr = newState.tr;
				const existingFootnoteIds = listFootnotes(oldState.doc).map((footnote) => footnote.id);
				const { from = 0, to = 0 } = rangeFromTransaction(pasteTransaction);
				pasteTransaction.doc.nodesBetween(from, to, (node, pos) => {
					if (node.type.name === "footnote") {
						let newId = node.attrs.id;
						if (existingFootnoteIds.includes(newId)) newId = v4();
						tr.setNodeMarkup(pos, void 0, {
							...node.attrs,
							id: newId
						});
					}
				});
				return tr;
			} }),
			FootnoteActiveStatusPlugin({ editor: this.editor }),
			FootnoteListPlugin()
		];
	}
});
//#endregion
//#region src/core/utilities/htmlToProsemirror/domParserConverter.ts
function namedNodeMapToRecord(attributes) {
	const output = {};
	for (let i = 0; i < attributes.length; i++) {
		const attribute = attributes[i];
		output[attribute.name] = attribute.value;
	}
	return output;
}
const convert$1 = (nodes) => {
	const output = [];
	if (nodes.length === 0) return output;
	for (let i = 0; i < nodes.length; i++) {
		const node = nodes[i];
		node.normalize();
		if (node.nodeType === Node.TEXT_NODE && node.textContent) output.push(node.textContent);
		else if (node.nodeType === Node.ELEMENT_NODE) {
			const attributes = node.attributes;
			output.push([
				node.nodeName.toLowerCase(),
				namedNodeMapToRecord(attributes),
				...convert$1(node.childNodes)
			]);
		}
	}
	return output;
};
const domParserConverter = (html) => {
	return convert$1(new DOMParser().parseFromString(html, "text/html").querySelectorAll("body")[0].childNodes);
};
//#endregion
//#region src/core/utilities/htmlToProsemirror/htmlparserConverter.ts
const convert = (nodes) => {
	const output = [];
	if (nodes.length === 0) return output;
	for (let i = 0; i < nodes.length; i++) {
		const node = nodes[i];
		if (node.type === ElementType.Text) output.push(textContent(node));
		else if (node.type === ElementType.Tag) {
			const attributes = node.attribs;
			output.push([
				node.name.toLowerCase(),
				attributes,
				...convert(getChildren(node))
			]);
		}
	}
	return output;
};
const htmlparserConverter = (html) => convert(getChildren(parseDocument(html)));
//#endregion
//#region src/core/utilities/htmlToProsemirror/htmlToProsemirror.ts
const defaultSpec = [
	"p",
	{},
	""
];
/**
* Convert an HTML string into ProseMirror's DOMOutputSpec,
* but always wrap result in an Array for destructuring.
*/
function htmlToDOMOutputSpec(html, parser = domParserConverter) {
	if (html == null || html === "") return [defaultSpec];
	return parser(html);
}
//#endregion
//#region src/extensions/footnote/footnote-static.ts
/**
* Extension for displaying read-only footnote at the bottom of the page.
* Used in CadmusKitServer for rendering paginated PDFs.
*/
const FootnoteStatic = Node$1.create({
	name: "footnote",
	group: "inline",
	content: "inline*",
	inline: true,
	atom: true,
	selectable: true,
	gapCursor: true,
	addOptions() {
		return { HTMLAttributes: {} };
	},
	addAttributes() {
		return {
			id: {
				default: null,
				parseHTML: (element) => element.getAttribute("data-footnote-id"),
				renderHTML: (attributes) => attributes.id ? { "data-footnote-id": attributes.id } : {}
			},
			content: {
				default: "",
				parseHTML: (element) => element.getAttribute("data-footnote-content") || "",
				renderHTML: (attributes) => ({ "data-footnote-content": attributes.content })
			}
		};
	},
	parseHTML() {
		return [{
			tag: "footnote",
			priority: 51
		}];
	},
	renderHTML({ HTMLAttributes, node }) {
		const { id, content } = node.attrs;
		const cleanedContent = removeParagraphTag(content);
		const insertedContent = cleanedContent === "" ? [""] : htmlToDOMOutputSpec(cleanedContent).map((item) => [
			"span",
			mergeAttributes({ class: "footnote-content" }),
			item
		]);
		return [
			"footnote",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, id ? { id: `footnote-${id}` } : {}),
			...insertedContent
		];
	}
});
/**
* Utility function to remove the <p> tag from the HTML string.
*
* Needed here because footnote content comes from SlimEditor which stores its
* content inside <p></p> tags - but footnote itself needs to be inline element
* to be displayed correctly.
*
* @param {string} html - The HTML string to process.
* @returns {string} - The inner HTML of the <p> tag or the original string.
*/
function removeParagraphTag(html) {
	const p = new DOMParser().parseFromString(html, "text/html").querySelector("p");
	return p ? p.innerHTML : html;
}
//#endregion
//#region src/extensions/footnote/use-footnote-list.ts
function useFootnoteList(editor) {
	return useEditorState({
		editor,
		selector: (ctx) => ({
			footnotes: FootnoteListPluginKey.getState(ctx.editor.state),
			activeFootnoteId: currentActiveFootnoteId(ctx.editor.state)
		})
	});
}
//#endregion
//#region src/extensions/highlight/highlight.ts
const Highlight$1 = Highlight.extend({
	addOptions() {
		return {
			...this.parent?.(),
			multicolor: true,
			HTMLAttributes: {},
			defaultHighlightColor: HIGHLIGHT_COLORS[2],
			highlightColors: HIGHLIGHT_COLORS
		};
	},
	addAttributes() {
		if (!this.options.multicolor) return {};
		const highlightColors = this.options.highlightColors.map((c) => tinycolor(c).toHexString());
		const defaultHighlightColor = tinycolor(this.options.defaultHighlightColor).toHexString();
		const getColor = (color) => {
			return color && highlightColors.includes(tinycolor(color).toHexString()) ? color : defaultHighlightColor;
		};
		return { color: {
			default: null,
			parseHTML: (element) => {
				const color = element.getAttribute("data-color") || element.style.backgroundColor;
				if (color || element.tagName.toLowerCase() === "mark") return getColor(color);
				return false;
			},
			renderHTML: (attributes) => {
				if (!attributes.color) return {};
				return {
					"data-color": getColor(attributes.color),
					style: `background-color: ${tinycolor(getColor(attributes.color)).setAlpha(.54).toHex8String()}`
				};
			}
		} };
	},
	parseHTML() {
		return [{ tag: "mark" }, {
			tag: "span",
			priority: 51,
			getAttrs: (element) => {
				if (!element.hasAttribute("style")) return false;
				const color = element.style.backgroundColor;
				if (!color) return false;
				return this.options.highlightColors.map((c) => tinycolor(c).toHexString()).includes(tinycolor(color).toHexString()) ? {} : false;
			}
		}];
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-h": () => this.editor.commands.toggleHighlight({ color: this.options.defaultHighlightColor }) };
	},
	addInputRules() {
		return [markInputRule({
			find: inputRegex,
			type: this.type,
			getAttributes: () => ({ color: this.options.defaultHighlightColor })
		})];
	},
	addPasteRules() {
		return [markPasteRule({
			find: pasteRegex,
			type: this.type,
			getAttributes: () => ({ color: this.options.defaultHighlightColor })
		})];
	}
});
//#endregion
//#region src/extensions/hyperlink/helpers.ts
/** Open a hyperlink in a new tab. */
function openLink(href) {
	const link = /https?/iu.test(href) ? href : `//${href}`;
	try {
		window.open(link, "_blank");
	} catch (e) {
		if (e instanceof SyntaxError) return;
		throw e;
	}
}
/**
* Recursively strip down part of URL string that is
* not URI decodable
* # Examples
* ## Decodable URI:
* - https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9312452/#:~:text=The%20study%20authors%20concluded%2C%20%E2%80%9C
* ## Undecodable URI:
* - https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9312452/#:~:text=The%20study%20authors%20concluded%2C%20%E2%80
* which gonna be stripped down to https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9312452/#:~:text=The%20study%20authors%20concluded%2C%20
**/
function getValidURL(href) {
	const undecodableURLRegex = /^(.*)(%.*)$/;
	if (isURLDecodable(href)) return href;
	else if (!undecodableURLRegex.test(href)) return "";
	else return getValidURL(href.replace(undecodableURLRegex, "$1"));
}
function isURLDecodable(href) {
	return true;
}
//#endregion
//#region src/extensions/hyperlink/hyperlink-menu-plugin.ts
/** Plugin key for `HyperlinkMenuPlugin` */
const HyperlinkMenuPluginKey = new PluginKey("hyperlinkMenu");
const mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : false;
/**
* Plugin to render a floating menu for hyperlink creation and edit on hyperlink marks.
*
* This plugin store the state of the clicked hyperlink mark which HyperlinkMenu used
* to control whether it needs to be opened or closed through the Transaction metadata
* actions under the `HyperlinkMenuPluginKey`:
*
*   - `TriggerMenuAction` will decorate the provided range with a `.selected-link`
*     class and open the menu with the given `href` as the input contents.
*
*   - `DismissMenuAction` will unset the plugin state removing any menu.
*/
const HyperlinkMenuPlugin = (props) => {
	return new Plugin({
		key: HyperlinkMenuPluginKey,
		state: {
			init() {
				return null;
			},
			apply(tr, state) {
				const payload = tr.getMeta(HyperlinkMenuPluginKey);
				switch (payload?.type) {
					case "triggerMenu": return payload.target;
					case "dismissMenu": return null;
					default: return state;
				}
			}
		},
		props: {
			handleClick(view, pos, event) {
				const { state } = view;
				const { schema, doc } = state;
				const pluginState = this.getState(state);
				const markType = getMarkType("link", schema);
				const range = getMarkRange(doc.resolve(pos), markType);
				const { href } = (range ? getMarksBetween(range.from, range.to, doc) : []).find(({ mark }) => mark.type === markType)?.mark?.attrs ?? {};
				const validLinkClicked = event.target?.closest("a") && href !== void 0;
				if (validLinkClicked && (mac && event.metaKey || !mac && event.ctrlKey)) {
					props.onOpenLink(href);
					return true;
				}
				if (validLinkClicked && range) {
					const { from, to } = range;
					const target = {
						href,
						from,
						to
					};
					props.editor.chain().focus().dismissMenu().setTextSelection({
						from,
						to
					}).setHyperlinkMenuTarget(target).run();
				} else if (pluginState) props.editor.commands.setHyperlinkMenuTarget();
				return false;
			},
			decorations(editorState) {
				const menuState = this.getState(editorState);
				if (menuState) {
					const { from, to } = menuState;
					return DecorationSet.create(editorState.doc, [Decoration.inline(from, to, { class: "selected-link" }, {
						inclusiveStart: true,
						inclusiveEnd: true
					})]);
				}
				return DecorationSet.empty;
			}
		}
	});
};
//#endregion
//#region src/extensions/hyperlink/hyperlink.ts
/**
* Cadmus Hyperlink extension for `link` marks and their management.
*
* The `link` marks are rendered as HTML `a` tags with `href`.
*
* New hyperlinks can be created on a text selection using the `toggleLink`
* command. When creating new links a bubble menu with input and action buttons
* would open on the selection range. If a valid URL is entered and confirmed,
* the range becomes a link mark.
*
* The extension also adds extra input rules and paste rules in the form of:
*
*   - Markdown style link input & paste rule.
*   - URL input and paste rule
*   - Keyboard shortcut to mark text as link. e.g. `CMD-k`
*/
const Hyperlink = Mark.create({
	name: "link",
	priority: 1e3,
	inclusive: false,
	excludes: "_",
	addOptions() {
		return {
			HTMLAttributes: {
				target: "_blank",
				rel: "noopener noreferrer nofollow",
				["data-cadmus-link"]: "true",
				"aria-label": "Press Option + m to open the link menu"
			},
			onOpenLink: openLink,
			role: "menu"
		};
	},
	addAttributes() {
		return {
			href: { default: null },
			target: { default: this.options.HTMLAttributes.target }
		};
	},
	parseHTML() {
		return [{ tag: "a[href]:not([href *= 'javascript:' i])" }];
	},
	renderHTML({ HTMLAttributes }) {
		const href = HTMLAttributes.href;
		const attrs = HTMLAttributes;
		attrs.href = getValidURL(href);
		return [
			"a",
			mergeAttributes(this.options.HTMLAttributes, attrs),
			0
		];
	},
	addCommands() {
		return {
			setLink: (href) => ({ commands }) => {
				return commands.setMark(this.name, { href });
			},
			unsetLink: () => ({ commands }) => {
				return commands.unsetMark(this.name, { extendEmptyMarkRange: true });
			},
			toggleLink: () => ({ commands, state }) => {
				const { selection, doc } = state;
				const { from, to } = selection;
				const text = doc.textBetween(from, to);
				const href = isValidURL(text) ? text : "";
				if (getMarkAttributes(state, this.name).href === void 0) {
					if (selection.empty) return false;
					return commands.setHyperlinkMenuTarget({
						href,
						from,
						to
					});
				}
				return commands.toggleMark(this.name, { href }, { extendEmptyMarkRange: true });
			},
			updateLink: (href) => ({ state, dispatch, commands, chain }) => {
				if (dispatch) {
					const attrs = getMarkAttributes(state, this.name);
					const isValid = isValidURL(href);
					href = /^https?/.test(href) ? href : `https://${href}`;
					if (attrs.href !== void 0) if (isValid) return chain().extendMarkRange(this.name, attrs).updateAttributes(this.name, { href }).run();
					else return chain().extendMarkRange(this.name, attrs).unsetLink().run();
					if (isValid) return commands.setLink(href);
				}
				return true;
			},
			setHyperlinkMenuTarget: (target) => ({ tr, dispatch }) => {
				const payload = target ? {
					type: "triggerMenu",
					target
				} : { type: "dismissMenu" };
				dispatch?.(tr.setMeta(HyperlinkMenuPluginKey, payload));
				return true;
			}
		};
	},
	addInputRules() {
		return [new InputRule({
			find: buildRegex(BASE_URL_REGEX, "\\[(.*)\\]\\((", ")\\)$", "ui"),
			handler: ({ state, match, range }) => {
				const { from, to } = range;
				const { tr } = state;
				const text = match[1];
				const href = /^https?/.test(match[2]) ? match[2] : `https://${match[2]}`;
				const mark = this.type.create({ href });
				tr.replaceWith(from, to, this.editor.schema.text(text, [mark]));
			}
		}), new InputRule({
			find: buildRegex(BASE_URL_REGEX, "", "$", "ui"),
			handler: ({ state, match, range }) => {
				const { tr } = state;
				const { from, to } = range;
				const href = /^https?/.test(match[0]) ? match[0] : `https://${match[0]}`;
				const mark = this.type.create({ href });
				tr.replaceWith(from, to, this.editor.schema.text(match[0], [mark]));
			}
		})];
	},
	addProseMirrorPlugins() {
		return [
			NodePasteRule(buildRegex(BASE_URL_REGEX, "\\[(.*)\\]\\((", ")\\)", "gui"), (_node, match) => {
				const text = match[1];
				const href = /^https?/.test(match[2]) ? match[2] : `https://${match[2]}`;
				const mark = this.type.create({ href });
				return this.editor.schema.text(text, [mark]);
			}),
			NodePasteRule(buildRegex(BASE_URL_REGEX, "", "", "gui"), (_node, match) => {
				const href = /^https?/.test(match[0]) ? match[0] : `https://${match[0]}`;
				const mark = this.type.create({ href });
				return this.editor.schema.text(match[0], [mark]);
			}),
			HyperlinkMenuPlugin({
				onOpenLink: this.options.onOpenLink,
				editor: this.editor
			})
		];
	},
	addKeyboardShortcuts() {
		return {
			"Mod-k": () => this.editor.commands.toggleLink(),
			"Alt-m": () => {
				const { schema, doc } = this.editor.state;
				const markType = getMarkType("link", schema);
				const pos = this.editor.state.selection.anchor;
				const range = getMarkRange(doc.resolve(pos), markType);
				const { href } = (range ? getMarksBetween(range.from, range.to, doc) : []).find(({ mark }) => mark.type === markType)?.mark?.attrs ?? {};
				if (href && range) {
					const { from, to } = range;
					const target = {
						href,
						from,
						to
					};
					this.editor.chain().focus().dismissMenu().setTextSelection({
						from,
						to
					}).setHyperlinkMenuTarget(target).run();
					return true;
				}
				return false;
			}
		};
	}
});
//#endregion
//#region src/extensions/hyperlink/hyperlink-menu-component.tsx
/**
* React component for the Hyperlink floating menu.
*
* There will be only one such menu rendered at a time, and its display and
* position will be controlled using a `BubbleMenu` plugin instance.
*/
function HyperlinkMenuComponent(props) {
	const { editor, portalId } = props;
	const isLinkEnabled = useMemo(() => editor.extensionManager.extensions.findIndex(({ name }) => name === "link") !== -1, [editor.extensionManager.extensions]);
	return /* @__PURE__ */ jsx(FloatingMenuComponent, {
		pluginKey: "hyperlinkFloatingMenu",
		portalId,
		editor,
		shouldShow: useCallback(({ state }) => {
			return !!HyperlinkMenuPluginKey.getState(state) && isLinkEnabled;
		}, [isLinkEnabled]),
		getBoundingClientRect: useCallback(() => {
			const { state, view } = editor;
			const hyperlink = HyperlinkMenuPluginKey.getState(state);
			const { selection } = state;
			let { from, to } = selection;
			if (hyperlink) {
				from = hyperlink.from;
				to = hyperlink.to;
			}
			return posToDOMRect(view, from, to);
		}, [editor]),
		isAsync: true,
		modal: true,
		children: /* @__PURE__ */ jsx(HyperlinkMenu, { editor })
	});
}
const HyperlinkMenu = ({ editor }) => {
	const [inputHref, setInputHref] = useState("");
	const { hyperlink } = useEditorState({
		editor,
		selector: (ctx) => ({ hyperlink: HyperlinkMenuPluginKey.getState(ctx.editor.state) })
	});
	const inputRef = useRef(null);
	useEffect(() => {
		const href = hyperlink?.href ?? "";
		inputRef.current?.focus({ preventScroll: true });
		setInputHref(href);
	}, [setInputHref, hyperlink]);
	const onConfirm = useCallback((href) => {
		editor.chain().updateLink(href).command(({ tr }) => {
			tr.setMeta(HyperlinkMenuPluginKey, { type: "dismissMenu" });
			return true;
		}).focus().run();
	}, [editor]);
	const onTrash = useCallback(() => {
		editor.chain().unsetLink().command(({ tr }) => {
			tr.setMeta(HyperlinkMenuPluginKey, { type: "dismissMenu" });
			return true;
		}).focus().run();
	}, [editor]);
	const onExit = useCallback(() => {
		editor.commands.setHyperlinkMenuTarget();
		editor.commands.focus();
	}, [editor]);
	return /* @__PURE__ */ jsxs(Container, {
		onKeyDown: (e) => {
			if (e.code === "Escape") onExit();
		},
		children: [
			/* @__PURE__ */ jsx(Input, {
				"aria-label": "link url",
				placeholder: "Paste web address",
				type: "url",
				fullWidth: true,
				value: inputHref,
				onChange: (event) => setInputHref(event.target.value),
				onKeyDown: (event) => {
					if (event.code === "Enter") onConfirm(inputHref);
				},
				ref: inputRef
			}),
			/* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "confirm url change",
				onClick: () => onConfirm(inputHref),
				iconName: "Tick"
			}),
			/* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "open in new tab",
				disabled: !isValidURL(inputHref),
				onClick: () => openLink?.(inputHref),
				iconName: "Open"
			}),
			/* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "remove link",
				onClick: onTrash,
				iconName: "Trash"
			})
		]
	});
};
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(3, min-content);
  grid-gap: 4px;
  padding: 6px;
  box-shadow: ${levels.two};
  background: white;
  border-radius: 4px;
  width: 450px;
  box-sizing: border-box;
  align-items: center;
`;
//#endregion
//#region src/extensions/image/image-resize-handles.ts
/** Adds resize handles (corner point divs) to the given img element that have event listeners to
* resize the imgWrapperDiv according to mouse movement.
*/
var ImageResizeHandles = class {
	imgWrapperDiv;
	resizePointsParent;
	originalWidth;
	newWidth;
	editor;
	mouseXPos = 0;
	activeResizeDirection = void 0;
	constructor(imgWrapperDiv, editor) {
		this.imgWrapperDiv = imgWrapperDiv;
		this.editor = editor;
		const ne = crel("div", { class: "resize-point resize-point--ne" });
		const nw = crel("div", { class: "resize-point resize-point--nw" });
		const se = crel("div", { class: "resize-point resize-point--se" });
		const sw = crel("div", { class: "resize-point resize-point--sw" });
		this.addMouseDownListeners(se, "se");
		this.addMouseDownListeners(sw, "sw");
		this.addMouseDownListeners(ne, "ne");
		this.addMouseDownListeners(nw, "nw");
		this.resizePointsParent = crel("div", { class: "resize-points" }, [
			ne,
			nw,
			se,
			sw
		]);
		crel(this.imgWrapperDiv, this.resizePointsParent);
		this.setVisible(false);
	}
	/**
	* Sets the visibility of the resize points by changing display property
	*/
	setVisible(flag) {
		if (flag) this.resizePointsParent.style.removeProperty("display");
		else this.resizePointsParent.style.display = "none";
	}
	/**
	* Adds the mouse down listener to a given `resizePoint`.
	*/
	addMouseDownListeners(resizePoint, resizeDirection) {
		resizePoint.addEventListener("mousedown", (e) => {
			e.preventDefault();
			this.activeResizeDirection = resizeDirection;
			this.originalWidth = this.imgWrapperDiv.getBoundingClientRect().width;
			this.newWidth = this.originalWidth;
			this.mouseXPos = e.pageX;
			window.addEventListener("mousemove", this.handleMoouseMoveResize);
			window.addEventListener("mouseup", this.handleMouseUp);
		});
	}
	/**
	* Handle the mousemove event to resize the imgDivWrapper element
	* @param e
	*/
	handleMoouseMoveResize = (e) => {
		e.preventDefault();
		const resizingSmoothnessFactor = 1.5;
		let width;
		if (this.originalWidth) switch (this.activeResizeDirection) {
			case "ne":
				width = this.originalWidth - resizingSmoothnessFactor * (e.pageX - this.mouseXPos);
				break;
			case "nw":
				width = this.originalWidth + resizingSmoothnessFactor * (e.pageX - this.mouseXPos);
				break;
			case "sw":
				width = this.originalWidth - resizingSmoothnessFactor * (e.pageX - this.mouseXPos);
				break;
			case "se":
				width = this.originalWidth + resizingSmoothnessFactor * (e.pageX - this.mouseXPos);
				break;
			default: width = this.originalWidth;
		}
		else width = 710;
		if (width < 160) this.newWidth = 160;
		else this.newWidth = width;
		this.imgWrapperDiv.style.width = `${this.newWidth}px`;
	};
	/**
	* Handle the `mouseup` event after resizing is done to dispatch the size update
	* command to the editor and remove the event listeners from the window.
	*/
	handleMouseUp = () => {
		if (!this.newWidth || this.newWidth >= 710) this.editor.chain().focus().updateImageWidth("fitToText").run();
		else this.editor.chain().focus().updateCustomWidth(this.newWidth).run();
		window.removeEventListener("mousemove", this.handleMoouseMoveResize);
		window.removeEventListener("mouseup", this.handleMouseUp);
	};
};
//#endregion
//#region src/extensions/image/image-node-view.ts
/**
* Custom Image node view with caption, custom width and resize handles, and
* alignment.
*
* ## Structure
*
*     <figure>
*       <div class="img-wrapper">
*         <img />
*         <div class="resize-points" />
*       </div>
*    </figure>
*
* The `img` element has 100% width and is resized by adjusting the width of the
* `.img-wrapper` according to the attributes of `image` node.
*/
var ImageNodeView = class {
	/** Top level `<figure />` element. */
	dom;
	/** Editable `<figcaption />` element. */
	contentDOM;
	/** Prosemirror `image` node */
	node;
	/** Tiptap editor reference */
	editor;
	/** Wrapping div `.img-wrapper` on the img. */
	imgWrapperDiv;
	/** Resize handles on the wrapper. */
	imageResizeHandles;
	constructor(node, getPos, HTMLAttributes, editor) {
		this.node = node;
		this.editor = editor;
		const figcaption = crel("figcaption", { class: node.attrs.hasCaption ? "" : "no-caption" });
		figcaption.style.textAlign = node.attrs.textAlign;
		const img = crel("img", {
			...HTMLAttributes,
			contentEditable: false
		});
		img.addEventListener("click", () => {
			if (typeof getPos === "function" && this.editor.isEditable) {
				if (getPos()) this.editor.commands.setNodeSelection(getPos());
			}
		});
		const wrapper = crel("div", {
			"data-image-width": node.attrs.width,
			"data-image-align": node.attrs.imageAlign,
			class: "img-wrapper"
		}, [img]);
		this.imgWrapperDiv = wrapper;
		this.updateWrapperWidth(img);
		const resizeHandles = new ImageResizeHandles(wrapper, editor);
		this.imageResizeHandles = resizeHandles;
		const figure = crel("figure", {
			draggable: "true",
			contentEditable: this.editor.isEditable,
			"data-image-width": node.attrs.width
		}, [wrapper, figcaption]);
		this.dom = figure;
		this.contentDOM = figcaption;
	}
	/**
	* Updates the wrapper width based on the value of the `width` and
	* `customWidth` attributes of the image node.
	*
	* @param imgElement wrapped `<img />` element
	*/
	updateWrapperWidth(imgElement) {
		if (this.node.attrs.width == "custom") this.imgWrapperDiv.style.width = `${this.node.attrs.customWidth}px`;
		else if (this.node.attrs.width == "original") {
			this.imgWrapperDiv.style.width = `${imgElement.naturalWidth}px`;
			imgElement.addEventListener("load", () => {
				this.imgWrapperDiv.style.width = `${imgElement.naturalWidth}px`;
			}, { once: true });
		} else this.imgWrapperDiv.style.removeProperty("width");
	}
	update(node) {
		if (node.type !== this.node.type) return false;
		this.node = node;
		if (this.dom) {
			if (this.editor.isEditable) this.dom.contentEditable = "true";
			else this.dom.contentEditable = "false";
			crel(this.dom, { "data-image-width": node.attrs.width });
		}
		const imgs = this.dom.getElementsByTagName("img");
		const img = imgs && imgs[0];
		if (img) crel(img, {
			src: node.attrs.src,
			alt: node.textContent
		});
		if (this.imgWrapperDiv) {
			crel(this.imgWrapperDiv, {
				"data-image-width": node.attrs.width,
				"data-image-align": node.attrs.imageAlign
			});
			if (img) this.updateWrapperWidth(img);
		}
		if (this.dom && this.contentDOM) if (!node.attrs.hasCaption) this.contentDOM.classList.add("no-caption");
		else {
			this.contentDOM.classList.remove("no-caption");
			this.contentDOM.style.textAlign = node.attrs.textAlign;
		}
		return true;
	}
	selectNode() {
		if (!this.editor.isEditable) return;
		this.dom.classList.add("ProseMirror-selectednode");
		this.imageResizeHandles.setVisible(true);
	}
	deselectNode() {
		this.dom.classList.remove("ProseMirror-selectednode");
		this.imageResizeHandles.setVisible(false);
	}
	/**
	* Ignores mutation to the imgWrapperDiv Dom element in order to prevent
	* re-rendering when drag reszing changes its width property.
	*/
	ignoreMutation = (mutation) => {
		let returnFlag = false;
		mutation.target.childNodes.forEach((childNode) => {
			if (childNode.nodeName === "IMG") returnFlag = true;
		});
		return returnFlag;
	};
};
//#endregion
//#region src/extensions/image/image-plugin.ts
const ImagePlugin = (editor) => new Plugin({
	appendTransaction: (_transactions, _oldState, newState) => {
		const sel = findSelectedNodeByType(newState, "image");
		if (!sel) return null;
		const { node, from } = sel;
		if (node.attrs.hasCaption === false) {
			const nodeSelection = NodeSelection.create(newState.doc, from);
			return newState.tr.setSelection(nodeSelection);
		}
		return null;
	},
	props: { handleDOMEvents: {
		paste(view, event) {
			if (!event.clipboardData || !isPastedFile(event)) return false;
			if (event.clipboardData?.getData("text/html")) return false;
			const files = Array.from(event.clipboardData.items).map((dt) => dt.getAsFile()).filter((file) => file !== null);
			if (files.length === 0) return false;
			const { tr } = view.state;
			if (!tr.selection.empty) tr.deleteSelection();
			const pos = tr.selection.from;
			const images = files.filter((file) => /image/i.test(file.type)).map((file) => [file, ""]);
			if (images.length === 0) return false;
			insertMedia(editor, images, "image", pos);
			return true;
		},
		drop(view, event) {
			if (!isDroppedFile(event)) return false;
			if (event.dataTransfer?.getData("text/html")) return false;
			const images = getDataTransferFiles(event).filter((file) => /image/i.test(file.type)).map((file) => [file, ""]);
			if (images.length === 0) return false;
			const result = view.posAtCoords({
				left: event.clientX,
				top: event.clientY
			});
			if (result) {
				event.preventDefault();
				insertMedia(editor, images, "image", result.pos);
				return true;
			}
			return false;
		}
	} }
});
//#endregion
//#region src/extensions/image/image.ts
const Image$1 = Node$1.create({
	name: "image",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block",
	content: "inline*",
	selectable: true,
	draggable: true,
	defining: true,
	allowGapCursor: true,
	addAttributes() {
		return {
			src: {
				default: null,
				parseHTML: (element) => element.getAttribute("src")
			},
			width: {
				default: "fitToText",
				parseHTML: (element) => {
					const width = element.getAttribute("data-image-width");
					switch (width) {
						case "fitToText":
						case "full":
						case "original":
						case "custom": return width;
						default: return null;
					}
				},
				renderHTML: (attributes) => ({ "data-image-width": attributes.width })
			},
			customWidth: {
				default: 710,
				parseHTML: (element) => {
					const customWidth = element.getAttribute("data-image-custom-width");
					if (!customWidth) return null;
					try {
						return parseInt(customWidth);
					} catch (_e) {
						return null;
					}
				},
				renderHTML: (attributes) => ({ "data-image-custom-width": attributes.customWidth })
			},
			imageAlign: {
				default: "center",
				parseHTML: (element) => {
					const alignment = element.getAttribute("data-image-align");
					switch (alignment) {
						case "right":
						case "center":
						case "left": return alignment;
						default: return null;
					}
				},
				renderHTML: (attributes) => ({ "data-image-align": attributes.imageAlign })
			},
			textAlign: {
				default: "center",
				parseHTML: (element) => {
					const alignment = element.style.textAlign;
					switch (alignment) {
						case "center":
						case "left":
						case "right": return alignment;
						default: return "center";
					}
				}
			},
			hasCaption: {
				default: false,
				parseHTML: (element) => {
					const captionNode = element.parentElement?.querySelector("figcaption") || element.parentElement?.parentElement?.parentElement?.querySelector("figcaption");
					return element.hasAttribute("alt") || !!captionNode;
				}
			}
		};
	},
	parseHTML() {
		return [{
			tag: "figcaption",
			ignore: true
		}, {
			tag: "img[src]",
			getContent: (element, schema) => {
				let figureNode = element.parentElement;
				if (figureNode && figureNode.tagName.toLowerCase() === "div") figureNode = element.parentElement?.parentElement?.parentElement ?? null;
				if (figureNode && figureNode.tagName.toLowerCase() === "figure") {
					const captionNode = figureNode.querySelector("figcaption");
					if (captionNode?.textContent) {
						const text = schema.text(captionNode.textContent);
						return Fragment.from(text);
					}
				}
				const alt = element.getAttribute("alt") ?? "";
				if (alt) {
					const text = schema.text(alt);
					return Fragment.from(text);
				}
				return Fragment.empty;
			}
		}];
	},
	renderHTML({ node, HTMLAttributes }) {
		const { hasCaption } = node.attrs;
		let customWidthAttributes = {};
		switch (node.attrs.width) {
			case "custom":
				customWidthAttributes = { style: `width:${node.attrs.customWidth}px` };
				break;
			case "original":
				customWidthAttributes = { style: `width:auto` };
				break;
			case "fitToText":
				customWidthAttributes = { style: `width:710px` };
				break;
			default: customWidthAttributes = {};
		}
		let imageAlignAttributes = {};
		switch (node.attrs.imageAlign) {
			case "left":
				imageAlignAttributes = { style: "margin: 0px auto 0px 45px;" };
				break;
			case "right":
				imageAlignAttributes = { style: "margin: 0px 45px 0px auto;" };
				break;
			default: imageAlignAttributes = { style: "margin: 0px auto;" };
		}
		const captionAttribs = { style: `text-align: ${node.attrs.textAlign}` };
		return [
			"figure",
			{},
			["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				contentEditable: "false",
				style: "max-width: 100%; position: relative"
			}, customWidthAttributes, imageAlignAttributes)],
			hasCaption ? [
				"figcaption",
				captionAttribs,
				0
			] : ""
		];
	},
	addKeyboardShortcuts() {
		return { Enter: ({ editor }) => {
			const sel = editor.state.selection;
			const parentImageNode = findParentNode((node) => {
				return node.type == editor.schema.nodes.image;
			})(sel);
			if (!parentImageNode) return false;
			const endPos = parentImageNode.pos + parentImageNode.node.nodeSize;
			editor.chain().insertContentAt(endPos, { type: "paragraph" }).run();
			return true;
		} };
	},
	addCommands() {
		return {
			setImage: (options) => ({ tr, dispatch, state }) => {
				const { caption } = options;
				let node;
				if (caption?.length) node = this.type.create(options, state.schema.text(caption));
				else node = this.type.create(options);
				if (options.position !== void 0) {
					if (dispatch) tr.insert(options.position, node);
				} else {
					const { selection } = tr;
					if (dispatch) tr.replaceRangeWith(selection.from, selection.to, node);
				}
				return true;
			},
			setImageSrc: (options) => ({ tr, dispatch }) => {
				const nodeType = this.type;
				if (tr.doc.nodeAt(options.position)?.type === nodeType) {
					if (dispatch) tr.setNodeAttribute(options.position, "src", options.src);
					return true;
				}
				return false;
			},
			updateImageWidth: (width) => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "image");
				if (!sel) return false;
				const { from } = sel;
				return chain().updateAttributes(this.name, { width }).setNodeSelection(from).run();
			},
			updateCustomWidth: (customWidth) => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "image");
				if (!sel) return false;
				const { from } = sel;
				return chain().updateAttributes(this.name, {
					customWidth,
					width: "custom"
				}).setNodeSelection(from).run();
			},
			updateImageAlignment: (alignment) => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "image");
				if (!sel) return false;
				const { from } = sel;
				return chain().updateAttributes(this.name, {
					imageAlign: alignment,
					textAlign: alignment
				}).setNodeSelection(from).run();
			},
			toggleImageCaption: () => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "image");
				if (!sel) return false;
				const { node, from } = sel;
				const { hasCaption } = node.attrs;
				if (hasCaption === true) return chain().setNodeSelection(from).updateAttributes(this.name, { hasCaption: false }).deleteRange({
					from: from + 1,
					to: from + node.nodeSize
				}).run();
				if (hasCaption === false) return chain().setNodeSelection(from).updateAttributes(this.name, { hasCaption: true }).run();
				return true;
			},
			deleteImage: () => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "image");
				if (sel) {
					const { node, from } = sel;
					return chain().deleteRange({
						from,
						to: from + node.nodeSize
					}).run();
				}
				return false;
			}
		};
	},
	addNodeView() {
		return ({ editor, node, getPos, HTMLAttributes }) => {
			return new ImageNodeView(node, getPos, HTMLAttributes, editor);
		};
	},
	addProseMirrorPlugins() {
		return [new Plugin({ appendTransaction: (_, __, state) => {
			const { doc, tr, schema } = state;
			if (doc.nodeAt(0)?.type.name === "image") {
				const type = schema.nodes["paragraph"];
				return tr.insert(0, type.create());
			}
			return null;
		} }), ImagePlugin(this.editor)];
	}
});
//#endregion
//#region src/extensions/image/image-menu-component.tsx
/**
* Bubble menu component for single image management.
*/
function ImageMenuComponent(props) {
	const { editor, portalId } = props;
	const isImageEnabled = useMemo(() => editor.extensionManager.extensions.findIndex(({ name }) => name === "image") !== -1, [editor.extensionManager.extensions]);
	return /* @__PURE__ */ jsx(FloatingMenuComponent, {
		pluginKey: "imageFloatingMenu",
		editor,
		shouldShow: useCallback(({ state }) => {
			const { selection } = state;
			const { empty, $anchor } = selection;
			if (!isImageEnabled || empty || !$anchor.parent) return false;
			if (isNodeSelection(selection) && selection.node.type == state.schema.nodes.image) return true;
			return false;
		}, [isImageEnabled]),
		portalId,
		children: /* @__PURE__ */ jsx(ImageMenuItems, { editor })
	});
}
function ImageMenuItems({ editor }) {
	const ref = useRef(null);
	const onImageAlignmentChange = (value) => {
		switch (value) {
			case "left":
				editor.chain().updateImageAlignment("left").run();
				break;
			case "center":
				editor.chain().updateImageAlignment("center").run();
				break;
			case "right":
				editor.chain().updateImageAlignment("right").run();
				break;
		}
	};
	const onImageSizeChange = (value) => {
		switch (value) {
			case "fitText":
				editor.chain().updateImageWidth("fitToText").run();
				break;
			case "fullWidth":
				editor.chain().updateImageWidth("full").updateImageAlignment("center").run();
				break;
			case "original":
				editor.chain().updateImageWidth("original").run();
				break;
		}
	};
	const onCaptionClick = () => editor.chain().focus().toggleImageCaption().run();
	const onDeleteImage = () => editor.chain().focus().deleteImage().run();
	const { isCenterAlign, isLeftAlign, isRightAlign, isFitToText, isFullWidth, isOriginalWidth, hasCaption } = useEditorState({
		editor,
		selector: (ctx) => ({
			isCenterAlign: ctx.editor.isActive("image", { imageAlign: "center" }),
			isLeftAlign: ctx.editor.isActive("image", { imageAlign: "left" }),
			isRightAlign: ctx.editor.isActive("image", { imageAlign: "right" }),
			isFitToText: ctx.editor.isActive("image", { width: "fitToText" }),
			isFullWidth: ctx.editor.isActive("image", { width: "full" }),
			isOriginalWidth: ctx.editor.isActive("image", { width: "original" }),
			hasCaption: ctx.editor.isActive("image", { hasCaption: true })
		})
	});
	const imageAlignment = useMemo(() => {
		if (isLeftAlign) return "left";
		else if (isRightAlign) return "right";
		return "center";
	}, [isLeftAlign, isRightAlign]);
	const imageSize = useMemo(() => {
		if (isOriginalWidth) return "original";
		if (isFullWidth) return "fullWidth";
		return "fitText";
	}, [isFullWidth, isOriginalWidth]);
	useEffect(() => {
		ref.current?.focus();
	}, []);
	return /* @__PURE__ */ jsxs(ButtonGroups$1, {
		onKeyDown: (e) => {
			if (e.code === "Escape") editor.commands.focus();
		},
		children: [
			/* @__PURE__ */ jsxs(StyledToggleGroupRoot, {
				type: "single",
				ref: (r) => ref.current = r,
				"aria-label": "Image alignment",
				onValueChange: onImageAlignmentChange,
				value: imageAlignment,
				loop: true,
				children: [
					/* @__PURE__ */ jsx(ToggleGroupItem, {
						value: "left",
						disabled: isFullWidth,
						"aria-disabled": isFullWidth,
						"aria-label": "Left Align Image",
						selected: isLeftAlign,
						children: /* @__PURE__ */ jsx(Icon, { iconName: "ImageAlignLeft" })
					}),
					/* @__PURE__ */ jsx(ToggleGroupItem, {
						value: "center",
						"aria-label": "Center Align Image",
						selected: isCenterAlign,
						children: /* @__PURE__ */ jsx(Icon, { iconName: "ImageAlignCenter" })
					}),
					/* @__PURE__ */ jsx(ToggleGroupItem, {
						value: "right",
						"aria-label": "Right Align Image",
						disabled: isFullWidth,
						selected: isRightAlign,
						"aria-disabled": isFullWidth,
						children: /* @__PURE__ */ jsx(Icon, { iconName: "ImageAlignRight" })
					})
				]
			}),
			/* @__PURE__ */ jsx(GroupDivider$1, {}),
			/* @__PURE__ */ jsxs(StyledToggleGroupRoot, {
				type: "single",
				"aria-label": "Image size",
				value: imageSize,
				onValueChange: onImageSizeChange,
				loop: true,
				children: [
					/* @__PURE__ */ jsx(ToggleGroupItem, {
						value: "fitText",
						selected: isFitToText,
						"aria-label": "Fit To Text",
						children: /* @__PURE__ */ jsx(Icon, { iconName: "ImageFit" })
					}),
					/* @__PURE__ */ jsx(ToggleGroupItem, {
						value: "fullWidth",
						selected: isFullWidth,
						"aria-label": "Banner Size",
						children: /* @__PURE__ */ jsx(Icon, { iconName: "ImageCover" })
					}),
					/* @__PURE__ */ jsx(ToggleGroupItem, {
						value: "original",
						selected: isOriginalWidth,
						"aria-label": "Original Image Size",
						children: /* @__PURE__ */ jsx(Icon, { iconName: "ImageOriginal" })
					})
				]
			}),
			/* @__PURE__ */ jsx(GroupDivider$1, {}),
			/* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "Toggle Image Caption",
				selected: hasCaption,
				onClick: onCaptionClick,
				iconName: "Caption"
			}),
			/* @__PURE__ */ jsx(GroupDivider$1, {}),
			/* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "Delete Image",
				onClick: onDeleteImage,
				iconName: "Trash"
			})
		]
	});
}
const ToggleGroupItem = (props) => /* @__PURE__ */ jsx(Tooltip, {
	size: "sm",
	width: "auto",
	side: "bottom",
	content: /* @__PURE__ */ jsx(Text, {
		kind: "systemSm",
		children: props["aria-label"]
	}),
	children: /* @__PURE__ */ jsx(StyledRadixToggleGroupItem, {
		value: props.value,
		disabled: props.disabled,
		"aria-disabled": props["aria-disabled"],
		"aria-label": props["aria-label"],
		selected: props.selected,
		children: props.children
	})
});
const ButtonGroups$1 = styled.div`
  background: white;
  box-shadow: ${levels.two};
`;
const GroupDivider$1 = styled.div`
  display: inline-flex;
  width: 1px;
  height: 20px;
  background: rgba(89, 115, 166, 0.15);
  margin: 7px 2px;
`;
const StyledRadixToggleGroupItem = styled(ToggleGroup.Item)`
  --size: 36px;
  min-width: var(--size);
  height: var(--size);
  padding: 4px;

  border-radius: 6px;
  border: none;
  outline: 0;
  position: relative;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  background-clip: content-box;
  background-color: ${(p) => p.selected && !p.disabled ? p.theme.background.action1 : "transparent"};
  fill: ${(p) => p.selected && !p.disabled ? p.theme.text.accent : p.theme.text.shade1};
  color: ${(p) => p.selected && !p.disabled ? p.theme.text.accent : p.theme.text.main};
  transition:
    background 0.1s ease-out,
    fill 0.1s ease-out;

  &:not([aria-disabled="true"]) {
    &:focus {
      background-color: ${(p) => p.theme.colors.grey50};
    }

    &:focus-visible {
      ${(p) => p.theme.focus};
      outline: 0;
    }

    &:hover {
      background-color: ${(p) => p.theme.colors.grey50};
    }

    &:active,
    &[aria-expanded="true"] {
      background-color: ${(p) => p.theme.colors.grey100};
    }
  }

  &[aria-disabled="true"] {
    opacity: 0.36;
    cursor: not-allowed;
  }
`;
const StyledToggleGroupRoot = styled(ToggleGroup.Root)`
  display: inline-block;
`;
//#endregion
//#region src/extensions/indentation/commands/decreaseIndent.ts
/**
* Create a `Command` to decrease level indentation of blocks in current selection until 0.
*
* @param intentableNodes node names which are capabale of level indentation
*/
function decreaseIndent(indentableNodes) {
	return ({ tr, dispatch, state }) => {
		let can = false;
		tr.selection.ranges.forEach((range) => {
			const from = range.$from.pos;
			const to = range.$to.pos;
			state.doc.nodesBetween(from, to, (node, pos, parent) => {
				const $pos = state.doc.resolve(pos);
				if (parent === state.doc && indentableNodes.includes(node.type.name) && node.attrs.indentLevel > 0 && $pos.depth <= 1) {
					can = true;
					tr.setNodeMarkup(pos, void 0, {
						...node.attrs,
						indentLevel: node.attrs.indentLevel - 1
					});
				}
			});
		});
		if (can) dispatch?.(tr);
		return can;
	};
}
//#endregion
//#region src/extensions/indentation/commands/increaseIndent.ts
/**
* Create a `Command` to increase level indentation of blocks in current selection.
*
* @param intentableNodes node names which are capabale of level indentation
* @param maxIndent maximum level of indentation, starting from 0
*/
function increaseIndent(indentableNodes, maxIndent) {
	return ({ tr, dispatch, state }) => {
		let can = false;
		tr.selection.ranges.forEach((range) => {
			const from = range.$from.pos;
			const to = range.$to.pos;
			state.doc.nodesBetween(from, to, (node, pos, parent) => {
				const $pos = state.doc.resolve(pos);
				if (parent === state.doc && indentableNodes.includes(node.type.name) && node.attrs.indentLevel < maxIndent - 1 && $pos.depth <= 1) {
					can = true;
					tr.setNodeMarkup(pos, void 0, {
						...node.attrs,
						indentLevel: node.attrs.indentLevel + 1
					});
				}
			});
		});
		if (can) dispatch?.(tr);
		return can;
	};
}
//#endregion
//#region src/extensions/indentation/commands/setIndentStyle.ts
/**
* Create a `Command` to set the Special indentation style for blocks in current
* selection.
*
* @param enabledStyles allowed Special Indentation styles
* @param styleableNodes Node names which can have Special Indentation
* @param style Special Indentation style to set
* @param direction direction of the Tab key which determines whether to toggle
*   forward or backwards through the available Special Indentation styles.
*/
function setIndentStyle(enabledStyles, stylableNodes, style, direction) {
	return ({ tr, dispatch, state }) => {
		if (!enabledStyles.includes(style)) return false;
		let can = false;
		tr.selection.ranges.forEach((range) => {
			const from = range.$from.pos;
			const to = range.$to.pos;
			state.doc.nodesBetween(from, to, (node, pos, parent) => {
				const $pos = state.doc.resolve(pos);
				if (parent === state.doc && canSetIndentStyle(stylableNodes, node, style, direction) && $pos.depth <= 1) {
					can = true;
					tr.setNodeMarkup(pos, void 0, {
						...node.attrs,
						indentSpecial: style
					});
				}
			});
		});
		if (can) dispatch?.(tr);
		return can;
	};
}
function indentationOrder(style) {
	switch (style) {
		case "hanging": return 0;
		case "normal": return 1;
		case "firstLine": return 2;
	}
}
function canSetIndentStyle(stylableNodes, node, style, direction) {
	if (!stylableNodes.includes(node.type.name)) return false;
	if (direction === 0) return node.attrs["indentSpecial"] !== style;
	if (direction === 1) return indentationOrder(node.attrs["indentSpecial"]) + 1 === indentationOrder(style);
	return indentationOrder(node.attrs["indentSpecial"]) - 1 === indentationOrder(style);
}
//#endregion
//#region src/extensions/indentation/commands/toggleIndentStyle.ts
function toggleIndentStyle(enabledSytles, defaultIndentation, stylableNodes, style) {
	return ({ tr, dispatch, state }) => {
		if (!enabledSytles.includes(style)) return false;
		let can = false;
		tr.selection.ranges.forEach((range) => {
			const from = range.$from.pos;
			const to = range.$to.pos;
			state.doc.nodesBetween(from, to, (node, pos, parent) => {
				const $pos = state.doc.resolve(pos);
				if (parent === state.doc && $pos.depth <= 1 && canToggleIndentStyle(enabledSytles, stylableNodes, node, style)) {
					can = true;
					const newAttrs = {
						...node.attrs,
						indentSpecial: node.attrs["indentSpecial"] === style ? defaultIndentation : style
					};
					tr.setNodeMarkup(pos, void 0, newAttrs);
				}
			});
		});
		if (can) dispatch?.(tr);
		return can;
	};
}
function canToggleIndentStyle(enabledSytles, stylableNodes, node, style) {
	if (!stylableNodes.includes(node.type.name)) return false;
	if (!(enabledSytles.includes(node.attrs["indentSpecial"]) || enabledSytles.includes(style))) return false;
	return true;
}
//#endregion
//#region src/extensions/indentation/commands/unsetIndentStyle.ts
/**
* Create a `Command` to reset any Special Indentation style on the current blocks.
*
* @param styleableNodes Node names which can have Special Indentation
* @param defaultStyle the style that is reset to
*/
function unsetIndentStyle(stylableNodes, defaultStyle) {
	return ({ tr, dispatch, state }) => {
		let can = false;
		tr.selection.ranges.forEach((range) => {
			const from = range.$from.pos;
			const to = range.$to.pos;
			state.doc.nodesBetween(from, to, (node, pos, parent) => {
				if (parent === state.doc && stylableNodes.includes(node.type.name)) {
					can = true;
					tr.setNodeMarkup(pos, void 0, {
						...node.attrs,
						indentSpecial: defaultStyle
					});
				}
			});
		});
		if (can) dispatch?.(tr);
		return can;
	};
}
//#endregion
//#region src/extensions/indentation/helpers/parseLevelIndent.ts
/**
* Curried function to parseLevelIndent an element given a max level
* of indentation styles and a default indentation style
*/
function parseLevelIndent(maxIndent, indentStyle = "normal") {
	return (element) => {
		const { marginLeft, textIndent } = element.style;
		let indent = 0;
		(element.className && typeof element.className === "string" && element.className.split(" ") || []).forEach((classname) => {
			const result = classname.match(/(.*)(indentation|indent|level)([^0-9]*)(\d+)(.*)$/);
			const indentation = result && result[4] && parseInt(result[4], 10);
			if (indentation && indentation > 1) if (indentation - 1 <= maxIndent) indent = indentation - 1;
			else indent = maxIndent;
		});
		if (!indent) {
			const indentData = element.getAttribute("data-indent");
			indent = indentData ? parseInt(indentData, 10) : 0;
		}
		if (marginLeft && !indent) {
			let indentOffset = 0;
			if (indentStyle !== "normal" && textIndent) indentOffset = parseFloat(textIndent);
			const indentation = Math.floor((parseFloat(marginLeft) - indentOffset) / 27);
			if (indentation) if (indentation <= maxIndent) indent = indentation;
			else indent = maxIndent;
		}
		return indent;
	};
}
//#endregion
//#region src/extensions/indentation/helpers/parseSpecialIndent.ts
function coalesceIndentStyle$1(enabledStyles, defaultStyle) {
	return (style) => enabledStyles.find((enabledStyle) => enabledStyle === style) ? style : defaultStyle;
}
/**
* Curried function to parseSpecialIndent from an element given a list
* of enabled indentation styles and a default indentation style
*/
function parseSpecialIndent(enabledStyles, defaultStyle) {
	const getIndentStyle = coalesceIndentStyle$1(enabledStyles, defaultStyle);
	return (element) => {
		const { textIndent } = element.style;
		if (!textIndent) {
			const indentData = element.getAttribute("data-indent-special");
			return indentData ? getIndentStyle(indentData) : getIndentStyle(defaultStyle);
		}
		const indentSize = parseFloat(textIndent);
		if (indentSize > 0) return getIndentStyle("firstLine");
		else if (indentSize < 0) return getIndentStyle("hanging");
		return defaultStyle;
	};
}
//#endregion
//#region src/extensions/indentation/helpers/renderLevelIndent.ts
/**
* Render data-indent attribute based on the `indentLevel` node attrs
* and given `maxIndentation`.
*/
function renderLevelIndent(maxIndentation) {
	return (attributes) => {
		const level = attributes.indentLevel ?? 0;
		return { "data-indent": level < maxIndentation ? level : maxIndentation - 1 };
	};
}
//#endregion
//#region src/extensions/indentation/helpers/renderSpecialIndent.ts
function coalesceIndentStyle(enabledStyles, defaultStyle) {
	return (style) => style && enabledStyles.includes(style) ? style : defaultStyle;
}
/**
* Render data-indent-special attribute based on the indent-style node attrs
*/
function renderSpecialIndent(enabledStyles, defaultStyle) {
	const getIndentStyle = coalesceIndentStyle(enabledStyles, defaultStyle);
	return (attributes) => {
		return { "data-indent-special": getIndentStyle(attributes.indentSpecial) };
	};
}
//#endregion
//#region src/extensions/indentation/level-indentation.ts
/**
* Extension to setup indentation attributes for blocks that can have multiple
* levels of indentation.
*/
const LevelIndentation = Extension.create({
	name: "levelIndentation",
	addGlobalAttributes() {
		if (this.options.types.length) return [{
			types: this.options.types,
			attributes: { indentLevel: {
				default: 0,
				renderHTML: (attributes) => renderLevelIndent(this.options.maxIndentation)(attributes),
				parseHTML: (element) => parseLevelIndent(this.options.maxIndentation)(element)
			} }
		}];
		return [];
	}
});
//#endregion
//#region src/extensions/indentation/mix-indentation.ts
/**
* Extension for block(s) that can have a mix of the level & special indentation
*/
const MixIndentation = Extension.create({
	name: "mixIndentation",
	addOptions() {
		return {
			types: ["paragraph"],
			indentationStyles: [
				"normal",
				"firstLine",
				"hanging"
			],
			defaultIndentation: "normal",
			maxIndentation: 8
		};
	},
	addGlobalAttributes() {
		if (this.options.types.length) return [{
			types: this.options.types,
			attributes: {
				indentSpecial: {
					default: this.options.defaultIndentation,
					renderHTML: (attributes) => renderSpecialIndent(this.options.indentationStyles, this.options.defaultIndentation)(attributes),
					parseHTML: parseSpecialIndent(this.options.indentationStyles, this.options.defaultIndentation)
				},
				indentLevel: {
					default: 0,
					renderHTML: (attributes) => renderLevelIndent(this.options.maxIndentation)(attributes),
					parseHTML: (element) => parseLevelIndent(this.options.maxIndentation, this.options.defaultIndentation)(element)
				}
			}
		}];
		return [];
	}
});
//#endregion
//#region src/extensions/indentation/special-indentation.ts
/**
* Extension to setup indentation attributes for blocks that can have special
* indentation like hanging indent and/or first line indentation
*/
const SpecialIndentation = Extension.create({
	name: "specialIndentation",
	addOptions() {
		return {
			types: ["paragraph"],
			indentationStyles: ["normal", "firstLine"],
			defaultIndentation: "normal"
		};
	},
	addStorage() {
		return { enabledStyles: this.options.indentationStyles };
	},
	addKeyboardShortcuts() {
		const shortcuts = {};
		if (this.options.indentationStyles.includes("hanging")) shortcuts["Mod-Alt-6"] = ({ editor }) => editor.commands.toggleIndentStyle("hanging");
		return shortcuts;
	},
	addGlobalAttributes() {
		if (this.options.types.length) return [{
			types: this.options.types,
			attributes: { indentSpecial: {
				default: this.options.defaultIndentation,
				renderHTML: (attributes) => renderSpecialIndent(this.options.indentationStyles, this.options.defaultIndentation)(attributes),
				parseHTML: parseSpecialIndent(this.options.indentationStyles, this.options.defaultIndentation)
			} }
		}];
		return [];
	}
});
//#endregion
//#region src/extensions/indentation/indentation.ts
/**
* Extension providing various indentation styles for blocks in the editor.
*
* ## Types Of Indentations
*
* ### Level Indentation
*
* The simplest form of indentation where the entire block has some multiple of
* left margin value. The amount of left-margin to add on the block is
* determined by the node attribute `indentLevel` (HTML attribute
* `data-indent-level`), which is a `number` between 0 and a configured MAXIMUM
* value.
*
* ### Special Indentation
*
* A form of textual indetation with preset styles. The supported styles are:
*
*   - `firstLine` where only the first line has a TAB indentation
*   - `hanging` where all the lines following the first line have a TAB indentation.
*
* The current applied type for a text block is determined by the node attribute
* `indentSpecial` (HTML attribute `data-indent-special`) with a style name.
*
* ### Mixed Indentation
*
* This type is a combination of the **Level** and **Special** indentation
* styles. Blocks with mixed indentation will use both the `indentLevel` and
* `indentSpecial` attributes. The `Tab` indent shortcut will first apply the
* `indentSpecial` style and then start indenting the level of the block.
* Similarly when moving backwards with `Shift-Tab`, any `indentationSpecial`
* will first be removed before unindenting through the levels until 0.
*/
const Indentation = Extension.create({
	name: "indentation",
	addOptions() {
		return {
			specialTypes: ["paragraph"],
			levelTypes: [
				"paragraph",
				"heading",
				"blockquote"
			],
			indentationStyles: [
				"normal",
				"firstLine",
				"hanging"
			],
			defaultIndentation: "normal",
			maxIndentation: 8
		};
	},
	addExtensions() {
		const mixTypes = this.options.specialTypes.filter((t) => this.options.levelTypes.includes(t));
		const specialTypes = this.options.specialTypes.filter((t) => !this.options.levelTypes.includes(t));
		const levelTypes = this.options.levelTypes.filter((t) => !this.options.specialTypes.includes(t));
		return [
			SpecialIndentation.configure({
				types: specialTypes,
				indentationStyles: this.options.indentationStyles,
				defaultIndentation: this.options.defaultIndentation
			}),
			MixIndentation.configure({
				types: mixTypes,
				maxIndentation: this.options.maxIndentation,
				indentationStyles: this.options.indentationStyles,
				defaultIndentation: this.options.defaultIndentation
			}),
			LevelIndentation.configure({
				types: levelTypes,
				maxIndentation: this.options.maxIndentation,
				defaultIndentation: this.options.defaultIndentation
			})
		];
	},
	addCommands() {
		const { specialTypes, levelTypes, maxIndentation, defaultIndentation, indentationStyles } = this.options;
		return {
			increaseIndent: () => increaseIndent(levelTypes, maxIndentation),
			decreaseIndent: () => decreaseIndent(levelTypes),
			setIndentStyle: (style, direction = 0) => setIndentStyle(indentationStyles, specialTypes, style, direction),
			unsetIndentStyle: () => unsetIndentStyle(specialTypes, defaultIndentation),
			toggleIndentStyle: (style) => toggleIndentStyle(indentationStyles, defaultIndentation, specialTypes, style)
		};
	},
	addKeyboardShortcuts() {
		return {
			Tab: ({ editor }) => {
				const { selection } = editor.state;
				if (selection.empty && selection.$anchor.parentOffset === 0 && selection.$anchor.depth === 1) return editor.commands.first(({ commands }) => [() => commands.setIndentStyle("firstLine", 1), () => commands.increaseIndent()]);
				else return editor.commands.increaseIndent();
			},
			"Shift-Tab": ({ editor }) => {
				const { selection } = editor.state;
				if (selection.empty && selection.$anchor.parentOffset === 0 && selection.$anchor.depth === 1) return editor.commands.first(({ commands }) => [() => commands.setIndentStyle("normal", -1), () => commands.decreaseIndent()]);
				else return editor.commands.decreaseIndent();
			},
			Backspace: ({ editor }) => {
				const { selection } = editor.state;
				if (selection.empty && selection.$anchor.parentOffset === 0 && selection.$anchor.depth === 1) return editor.commands.first(({ commands }) => [() => commands.setIndentStyle("normal", -1), () => commands.decreaseIndent()]);
				else return editor.commands.decreaseIndent();
			}
		};
	}
});
//#endregion
//#region src/extensions/list-item/list-item.ts
const ListItem = Node$1.create({
	name: "listItem",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "paragraph block*",
	defining: true,
	group: "listItemGroup",
	parseHTML() {
		return [{ tag: "li" }];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"li",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	addKeyboardShortcuts() {
		return { Enter: () => this.editor.commands.cadmusSplitListItem("listItem") };
	}
});
//#endregion
//#region src/extensions/math/nodes/block-math-base.ts
/**
* Base Block level atomic math nodes to display equation
*/
const BlockMathBase = Node$1.create({
	name: "blockMath",
	atom: true,
	selectable: true,
	draggable: true,
	group: "math_block",
	mathRole: "block",
	addOptions() {
		return {
			HTMLAttributes: { class: `node-${this.name}` },
			convertLatexToMarkup: (latex) => `<code>${latex}</code>`
		};
	},
	addAttributes() {
		return {
			equation: {
				default: "",
				parseHTML: (element) => {
					if (element.hasAttribute("data-math-latex")) return element.getAttribute("data-math-latex");
					if (element.hasAttribute("data-equation-content")) return element.getAttribute("data-equation-content");
					return element.textContent;
				},
				renderHTML: ({ equation }) => ({ "data-math-latex": equation })
			},
			caption: {
				default: "",
				parseHTML: (element) => element.getAttribute("data-math-caption"),
				renderHTML: ({ caption }) => ({
					"data-math-caption": caption,
					style: `--math-caption: "${caption}";`
				})
			}
		};
	},
	renderText({ node }) {
		return `$$${node.attrs.equation}$$\n`;
	},
	parseHTML() {
		return [
			{
				tag: "div",
				getAttrs(node) {
					if (typeof node === "string") return false;
					const element = node;
					if (element.hasAttribute("data-math-latex")) return {
						equation: element.getAttribute("data-math-latex"),
						caption: element.getAttribute("data-math-caption")
					};
					return false;
				}
			},
			{
				tag: "img",
				context: "mathFigure/",
				getAttrs(node) {
					if (typeof node === "string") return false;
					const element = node;
					if (element.hasAttribute("data-equation-content")) return { equation: element.getAttribute("data-equation-content") };
					return false;
				}
			},
			{
				tag: "math-field",
				context: "mathFigure/"
			}
		];
	}
});
//#endregion
//#region src/extensions/math/nodes/inline-math-base.ts
/**
* Inline level atomic math nodes to display equation
*/
const InlineMathBase = Node$1.create({
	name: "inlineMath",
	inline: true,
	atom: true,
	selectable: true,
	draggable: true,
	group: "inline",
	mathRole: "inline",
	addOptions() {
		return {
			HTMLAttributes: { class: `node-${this.name}` },
			convertLatexToMarkup: (latex) => `<code>${latex}</code>`
		};
	},
	addAttributes() {
		return { equation: {
			default: "",
			parseHTML: (element) => {
				if (element.hasAttribute("data-math-latex")) return element.getAttribute("data-math-latex");
				if (element.hasAttribute("data-equation-content")) return element.getAttribute("data-equation-content");
				return element.textContent;
			},
			renderHTML: ({ equation }) => ({ "data-math-latex": equation })
		} };
	},
	renderText({ node }) {
		return `$${node.attrs.equation}$`;
	},
	parseHTML() {
		return [
			{ tag: "math-field" },
			{
				tag: "span",
				getAttrs(node) {
					if (typeof node === "string") return false;
					const element = node;
					if (element.hasAttribute("data-math-latex")) return { equation: element.getAttribute("data-math-latex") };
					return false;
				}
			},
			{
				tag: "img",
				getAttrs(node) {
					if (typeof node === "string") return false;
					const element = node;
					if (element.hasAttribute("data-equation-content")) return { equation: element.getAttribute("data-equation-content") };
					return false;
				}
			}
		];
	}
});
//#endregion
//#region src/extensions/math/nodes/math-figure.ts
/**
* Figure element that wraps blockMath
*/
const MathFigure = Node$1.create({
	name: "mathFigure",
	content: "blockMath",
	group: "mathBlock",
	mathRole: "figure",
	defining: true,
	addOptions() {
		return { HTMLAttributes: { "data-math-group": true } };
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"figure",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	parseHTML() {
		return [{
			tag: "figure",
			getAttrs(node) {
				if (typeof node === "string") return false;
				const dom = node;
				if (dom.getAttribute("data-math-group") === "true") return {};
				if (dom.querySelectorAll("[data-equation-content]").length) return {};
				return false;
			}
		}];
	}
});
//#endregion
//#region src/extensions/math/nodes/block-math-server.ts
/**
* Server side Block level atomic math nodes to display equation
*/
const BlockMathServer = BlockMathBase.extend({
	addOptions() {
		return {
			HTMLAttributes: { class: `node-${this.name}` },
			convertLatexToMarkup: (latex) => latex
		};
	},
	renderHTML({ HTMLAttributes, node }) {
		return [
			"div",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: "math-block-wrapper math-node" }),
			...htmlToDOMOutputSpec(this.options.convertLatexToMarkup(node.attrs.equation), htmlparserConverter),
			["div", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: "math-block-caption" })]
		];
	}
});
//#endregion
//#region src/extensions/math/nodes/inline-math-server.ts
/**
* Server side inline level atomic math nodes to display equation
*/
const InlineMathServer = InlineMathBase.extend({ renderHTML({ HTMLAttributes, node }) {
	return [
		"span",
		mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: "inline-math-node" }),
		...htmlToDOMOutputSpec(this.options.convertLatexToMarkup(node.attrs.equation), htmlparserConverter)
	];
} });
//#endregion
//#region src/extensions/math/math-server-extension.ts
const MathServerExtension = Extension.create({
	name: "math",
	addExtensions: () => [
		MathFigure,
		BlockMathServer.configure({ convertLatexToMarkup: (latex) => {
			return convertLatexToMarkup(latex, { mathstyle: "displaystyle" });
		} }),
		InlineMathServer.configure({ convertLatexToMarkup: (latex) => {
			return convertLatexToMarkup(latex, { mathstyle: "textstyle" });
		} })
	]
});
//#endregion
//#region src/extensions/math/styles.ts
const mathStyles = css`
  figure[data-math-group] {
    width: 90%;
    max-width: 710px;
    box-sizing: border-box;
  }

  .empty-math-node [data-node-view-wrapper]::after {
    content: " ";
    display: inline-block;
    pointer-events: none;
    width: 100%;
    background-position: center;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-repeat: no-repeat;
  }

  .node-inlineMath.empty-math-node [data-node-view-wrapper]::after {
    background-image: url("data:image/svg+xml, %3Csvg%20width=%22191%22%20height=%2232%22%20viewBox=%220%200%20191%2032%22%20fill=%22none%22%20xmlns=%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20x=%220.0965576%22%20width=%22190%22%20height=%2232%22%20rx=%223%22%20fill=%22%23F4F5F8%22%20fill-opacity=%220.5%22%2F%3E%0A%3Cpath%20d=%22M31.5686%209.864V21H33.0406V9.864H31.5686ZM35.6466%2021H37.0546V16.712C37.0546%2015.08%2037.6626%2013.912%2039.1986%2013.912C40.4306%2013.912%2040.9106%2014.728%2040.9106%2015.96V21H42.3186V15.784C42.3186%2013.624%2041.1346%2012.696%2039.5986%2012.696C38.0306%2012.696%2037.3746%2013.528%2037.0546%2014.216C37.0546%2013.976%2037.0386%2013.128%2036.9906%2012.888H35.6306C35.6466%2013.512%2035.6466%2014.232%2035.6466%2014.936V21ZM44.0109%2018.68C44.2189%2020.136%2045.2589%2021.192%2047.3549%2021.192C49.3709%2021.192%2050.5069%2020.152%2050.5069%2018.728C50.5069%2017.528%2050.0109%2016.712%2047.5469%2016.12C46.0589%2015.768%2045.7229%2015.464%2045.7229%2014.856C45.7229%2014.328%2046.0749%2013.784%2047.2109%2013.784C48.4429%2013.784%2048.8429%2014.52%2048.9709%2015.032H50.3149C50.2189%2013.912%2049.3549%2012.696%2047.2589%2012.696C45.1789%2012.696%2044.3309%2013.832%2044.3309%2014.968C44.3309%2016.072%2044.8109%2016.792%2047.1309%2017.352C48.6829%2017.72%2049.0509%2018.072%2049.0509%2018.84C49.0509%2019.576%2048.5869%2020.088%2047.4029%2020.088C46.2989%2020.088%2045.6429%2019.56%2045.4189%2018.68H44.0109ZM59.0003%2017.192C59.0163%2016.984%2059.0163%2016.776%2059.0163%2016.52C59.0163%2014.792%2058.1683%2012.696%2055.5443%2012.696C53.0803%2012.696%2051.8643%2014.616%2051.8643%2017.032C51.8643%2019.112%2052.9043%2021.192%2055.4483%2021.192C57.6723%2021.192%2058.5523%2019.8%2058.8723%2018.76H57.4483C57.1923%2019.352%2056.7763%2020.024%2055.4963%2020.024C54.1203%2020.024%2053.2883%2018.84%2053.2723%2017.192H59.0003ZM53.3203%2016.216C53.4643%2014.792%2054.0883%2013.8%2055.5283%2013.8C56.9043%2013.8%2057.5763%2014.872%2057.5923%2016.216H53.3203ZM60.9153%2021H62.3233V17.064C62.3233%2015.016%2063.3793%2014.136%2065.0433%2014.088V12.696C63.6993%2012.728%2062.7393%2013.448%2062.3233%2014.536C62.3233%2013.752%2062.2913%2013.112%2062.2753%2012.888H60.8993C60.8993%2013.32%2060.9153%2013.96%2060.9153%2015.096V21ZM66.0378%2014.024H67.4458V19.112C67.4458%2020.456%2067.9898%2021.112%2069.2538%2021.112C69.6538%2021.112%2070.1338%2021.096%2070.4698%2020.968V19.912C70.2458%2019.96%2069.9578%2019.976%2069.7658%2019.976C69.0298%2019.976%2068.8378%2019.576%2068.8378%2018.776V14.024H70.6298V12.888H68.8378V10.488H67.4458V12.888H66.0378V14.024ZM76.4341%2021H77.8421V12.888H76.4341V21ZM77.8421%2011V9.256H76.4341V11H77.8421ZM80.3309%2021H81.7389V16.712C81.7389%2015.08%2082.3469%2013.912%2083.8829%2013.912C85.1149%2013.912%2085.5949%2014.728%2085.5949%2015.96V21H87.0029V15.784C87.0029%2013.624%2085.8189%2012.696%2084.2829%2012.696C82.7149%2012.696%2082.0589%2013.528%2081.7389%2014.216C81.7389%2013.976%2081.7229%2013.128%2081.6749%2012.888H80.3149C80.3309%2013.512%2080.3309%2014.232%2080.3309%2014.936V21ZM90.9014%2021V9.256H89.4934V21H90.9014ZM93.3903%2021H94.7983V12.888H93.3903V21ZM94.7983%2011V9.256H93.3903V11H94.7983ZM97.2872%2021H98.6952V16.712C98.6952%2015.08%2099.3032%2013.912%20100.839%2013.912C102.071%2013.912%20102.551%2014.728%20102.551%2015.96V21H103.959V15.784C103.959%2013.624%20102.775%2012.696%20101.239%2012.696C99.6712%2012.696%2099.0152%2013.528%2098.6952%2014.216C98.6952%2013.976%2098.6792%2013.128%2098.6312%2012.888H97.2712C97.2872%2013.512%2097.2872%2014.232%2097.2872%2014.936V21ZM113.01%2017.192C113.026%2016.984%20113.026%2016.776%20113.026%2016.52C113.026%2014.792%20112.178%2012.696%20109.554%2012.696C107.09%2012.696%20105.874%2014.616%20105.874%2017.032C105.874%2019.112%20106.914%2021.192%20109.458%2021.192C111.682%2021.192%20112.562%2019.8%20112.882%2018.76H111.458C111.202%2019.352%20110.786%2020.024%20109.506%2020.024C108.13%2020.024%20107.298%2018.84%20107.282%2017.192H113.01ZM107.33%2016.216C107.474%2014.792%20108.098%2013.8%20109.538%2013.8C110.914%2013.8%20111.586%2014.872%20111.602%2016.216H107.33ZM125.632%2017.192C125.648%2016.984%20125.648%2016.776%20125.648%2016.52C125.648%2014.792%20124.8%2012.696%20122.176%2012.696C119.712%2012.696%20118.496%2014.616%20118.496%2017.032C118.496%2019.112%20119.536%2021.192%20122.08%2021.192C124.304%2021.192%20125.184%2019.8%20125.504%2018.76H124.08C123.824%2019.352%20123.408%2020.024%20122.128%2020.024C120.752%2020.024%20119.92%2018.84%20119.904%2017.192H125.632ZM119.952%2016.216C120.096%2014.792%20120.72%2013.8%20122.16%2013.8C123.536%2013.8%20124.208%2014.872%20124.224%2016.216H119.952ZM133%2024.184H134.36V15.128C134.36%2014.392%20134.36%2013.736%20134.376%2012.888H133.048C133.016%2013.224%20132.984%2013.624%20133%2013.912C132.808%2013.384%20132.136%2012.696%20130.632%2012.696C128.68%2012.696%20127.064%2014.312%20127.064%2017.032C127.064%2019.736%20128.584%2021.192%20130.424%2021.192C131.832%2021.192%20132.584%2020.68%20133%2019.832V24.184ZM128.52%2016.968C128.52%2015.176%20129.304%2013.896%20130.824%2013.896C132.568%2013.896%20133.032%2015%20133.032%2016.904C133.032%2018.792%20132.52%2020.008%20130.76%2020.008C129.224%2020.008%20128.52%2018.616%20128.52%2016.968ZM143.377%2012.888H141.969V17.112C141.969%2019.144%20141.393%2019.976%20139.905%2019.976C138.561%2019.976%20138.225%2018.984%20138.225%2017.928V12.888H136.833V18.216C136.833%2020.504%20138.145%2021.192%20139.521%2021.192C140.801%2021.192%20141.569%2020.68%20141.969%2019.784C141.985%2020.296%20142.001%2020.792%20142.033%2021H143.393C143.393%2020.52%20143.377%2019.432%20143.377%2018.632V12.888ZM151.92%2015.352C151.92%2013.512%20150.816%2012.696%20148.832%2012.696C146.496%2012.696%20145.808%2013.976%20145.696%2015.096H147.056C147.2%2014.472%20147.44%2013.8%20148.784%2013.8C150.304%2013.8%20150.528%2014.664%20150.528%2015.384V16.072H149.152C146.736%2016.072%20145.312%2016.904%20145.312%2018.712C145.312%2019.944%20146.128%2021.192%20148.048%2021.192C149.616%2021.192%20150.272%2020.472%20150.56%2019.944C150.576%2020.44%20150.624%2020.824%20150.688%2021H152.032C151.984%2020.76%20151.92%2019.976%20151.92%2019.224V15.352ZM150.544%2017.304C150.544%2018.776%20150.288%2020.088%20148.336%2020.088C147.328%2020.088%20146.752%2019.48%20146.752%2018.632C146.752%2017.496%20147.616%2017.048%20149.232%2017.048H150.544V17.304ZM153.291%2014.024H154.699V19.112C154.699%2020.456%20155.243%2021.112%20156.507%2021.112C156.907%2021.112%20157.387%2021.096%20157.723%2020.968V19.912C157.499%2019.96%20157.211%2019.976%20157.019%2019.976C156.283%2019.976%20156.091%2019.576%20156.091%2018.776V14.024H157.883V12.888H156.091V10.488H154.699V12.888H153.291V14.024ZM159.478%2021H160.886V12.888H159.478V21ZM160.886%2011V9.256H159.478V11H160.886ZM166.623%2012.696C164.175%2012.696%20162.799%2014.552%20162.799%2016.952C162.799%2019.4%20164.207%2021.192%20166.527%2021.192C169.007%2021.192%20170.351%2019.272%20170.351%2016.92C170.351%2014.376%20168.879%2012.696%20166.623%2012.696ZM166.559%2013.864C168.079%2013.864%20168.911%2015.128%20168.911%2016.952C168.911%2018.792%20168.063%2020.024%20166.591%2020.024C165.135%2020.024%20164.239%2018.728%20164.239%2016.936C164.239%2015.096%20165.039%2013.864%20166.559%2013.864ZM172.272%2021H173.68V16.712C173.68%2015.08%20174.288%2013.912%20175.824%2013.912C177.056%2013.912%20177.536%2014.728%20177.536%2015.96V21H178.944V15.784C178.944%2013.624%20177.76%2012.696%20176.224%2012.696C174.656%2012.696%20174%2013.528%20173.68%2014.216C173.68%2013.976%20173.664%2013.128%20173.616%2012.888H172.256C172.272%2013.512%20172.272%2014.232%20172.272%2014.936V21Z%22%20fill=%22%235B6F98%22%2F%3E%0A%3Cpath%20d=%22M12.7011%2021.0403C12.4676%2021.0403%2012.2925%2020.9694%2012.1758%2020.8277C12.0591%2020.686%2011.9424%2020.3441%2011.8257%2019.8022L11.5755%2018.6392L10.6876%2019.8898C10.4292%2020.2566%2010.1874%2020.5359%209.96229%2020.7277C9.74552%2020.9111%209.49958%2021.0028%209.22445%2021.0028C9.05771%2021.0028%208.92431%2020.9569%208.82426%2020.8652C8.72422%2020.7652%208.67419%2020.6318%208.67419%2020.465C8.67419%2020.315%208.72422%2020.1899%208.82426%2020.0899C8.91597%2019.9898%209.03269%2019.9398%209.17443%2019.9398C9.29115%2019.9398%209.39536%2019.969%209.48707%2020.0273C9.59545%2020.094%209.69967%2020.1274%209.79972%2020.1274C9.96646%2020.1274%2010.1582%2019.9815%2010.375%2019.6897L11.488%2018.139L11.1128%2016.3256C11.0545%2016.0588%2010.9669%2015.8671%2010.8502%2015.7503C10.7418%2015.6336%2010.5751%2015.5753%2010.35%2015.5753C10.2416%2015.5753%2010.1374%2015.5794%2010.0373%2015.5878C9.94562%2015.5961%209.85808%2015.6086%209.7747%2015.6253L9.81222%2015.3877C10.3041%2015.3293%2010.7001%2015.2459%2011.0003%2015.1376C11.142%2015.0875%2011.2629%2015.0542%2011.3629%2015.0375C11.4713%2015.0125%2011.5547%2015%2011.6131%2015C11.7631%2015%2011.8632%2015.1209%2011.9132%2015.3627L12.2634%2017.051C12.6135%2016.5424%2012.9012%2016.1422%2013.1263%2015.8504C13.3514%2015.5503%2013.5098%2015.3585%2013.6015%2015.2751C13.6932%2015.1834%2013.7932%2015.1209%2013.9016%2015.0875C14.0183%2015.0459%2014.1392%2015.025%2014.2643%2015.025C14.6561%2015.025%2014.8521%2015.1918%2014.8521%2015.5252C14.8521%2015.6753%2014.8062%2015.7962%2014.7145%2015.8879C14.6228%2015.9796%2014.5061%2016.0255%2014.3643%2016.0255C14.2393%2016.0255%2014.1267%2015.9963%2014.0267%2015.9379C13.9683%2015.9046%2013.9183%2015.8837%2013.8766%2015.8754C13.8433%2015.8671%2013.8057%2015.8629%2013.7641%2015.8629C13.6807%2015.8629%2013.589%2015.9046%2013.4889%2015.988C13.4139%2016.0547%2013.0345%2016.5674%2012.3509%2017.5262L12.7261%2019.2645C12.7678%2019.4229%2012.8053%2019.5646%2012.8386%2019.6897C12.872%2019.8064%2012.9053%2019.9064%2012.9387%2019.9898C13.0137%2020.1566%2013.1221%2020.2399%2013.2638%2020.2399C13.4973%2020.2399%2013.8308%2019.9231%2014.2643%2019.2895L14.4394%2019.4896C13.7557%2020.5234%2013.1763%2021.0403%2012.7011%2021.0403Z%22%20fill=%22%235B6F98%22%20stroke=%22%235B6F98%22%20stroke-width=%220.6%22%2F%3E%0A%3Cpath%20d=%22M18.0431%2021.8063H17.0832C16.9508%2021.8063%2016.8433%2021.6993%2016.8433%2021.5674C16.8433%2021.4355%2016.9508%2021.3285%2017.0832%2021.3285H18.0431C18.1756%2021.3285%2018.2831%2021.2214%2018.2831%2021.0895V11.0546C18.283%2010.9226%2018.1755%2010.8156%2018.0431%2010.8156H17.0832C16.9508%2010.8156%2016.8433%2010.7086%2016.8433%2010.5767C16.8433%2010.4448%2016.9508%2010.3378%2017.0832%2010.3378H18.0431C18.44%2010.3378%2018.763%2010.6594%2018.763%2011.0546V21.0895C18.763%2021.4847%2018.44%2021.8063%2018.0431%2021.8063Z%22%20fill=%22%235B6F98%22%20stroke=%22%235B6F98%22%20stroke-width=%220.65%22%2F%3E%0A%3Cpath%20d=%22M19.9178%2021.8063H18.958C18.5611%2021.8063%2018.2381%2021.4847%2018.2381%2021.0895V11.0546C18.2381%2010.6594%2018.5611%2010.3378%2018.958%2010.3378H19.9178C20.0503%2010.3378%2020.1578%2010.4448%2020.1578%2010.5767C20.1578%2010.7086%2020.0503%2010.8156%2019.9178%2010.8156H18.958C18.8255%2010.8156%2018.718%2010.9226%2018.718%2011.0546V21.0895C18.718%2021.2214%2018.8255%2021.3285%2018.958%2021.3285H19.9178C20.0503%2021.3285%2020.1578%2021.4355%2020.1578%2021.5674C20.1578%2021.6993%2020.0503%2021.8063%2019.9178%2021.8063Z%22%20fill=%22%235B6F98%22%20stroke=%22%235B6F98%22%20stroke-width=%220.65%22%2F%3E%0A%3Cpath%20d=%22M17.7517%2016.072H19.2517%22%20stroke=%22%235B6F98%22%20stroke-width=%220.75%22%20stroke-linecap=%22round%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  }

  .node-inlineMath.empty-math-node math-field {
    min-width: 190px;
  }

  .node-blockMath.empty-math-node [data-node-view-wrapper]::after {
    background-image: url("data:image/svg+xml, %3Csvg%20width=%22175%22%20height=%2226%22%20viewBox=%220%200%20175%2026%22%20fill=%22none%22%20xmlns=%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d=%22M12.7966%2019.0403C12.5632%2019.0403%2012.3881%2018.9694%2012.2714%2018.8277C12.1547%2018.686%2012.038%2018.3441%2011.9212%2017.8022L11.6711%2016.6392L10.7832%2017.8898C10.5248%2018.2566%2010.283%2018.5359%2010.0579%2018.7277C9.84111%2018.9111%209.59516%2019.0028%209.32003%2019.0028C9.15329%2019.0028%209.01989%2018.9569%208.91984%2018.8652C8.8198%2018.7652%208.76978%2018.6318%208.76978%2018.465C8.76978%2018.315%208.8198%2018.1899%208.91984%2018.0899C9.01155%2017.9898%209.12827%2017.9398%209.27001%2017.9398C9.38673%2017.9398%209.49094%2017.969%209.58265%2018.0273C9.69104%2018.094%209.79525%2018.1274%209.8953%2018.1274C10.062%2018.1274%2010.2538%2017.9815%2010.4706%2017.6897L11.5836%2016.139L11.2084%2014.3256C11.15%2014.0588%2011.0625%2013.8671%2010.9458%2013.7503C10.8374%2013.6336%2010.6707%2013.5753%2010.4456%2013.5753C10.3372%2013.5753%2010.233%2013.5794%2010.1329%2013.5878C10.0412%2013.5961%209.95366%2013.6086%209.87029%2013.6253L9.9078%2013.3877C10.3997%2013.3293%2010.7957%2013.2459%2011.0959%2013.1376C11.2376%2013.0875%2011.3585%2013.0542%2011.4585%2013.0375C11.5669%2013.0125%2011.6503%2013%2011.7086%2013C11.8587%2013%2011.9588%2013.1209%2012.0088%2013.3627L12.3589%2015.051C12.7091%2014.5424%2012.9967%2014.1422%2013.2218%2013.8504C13.4469%2013.5503%2013.6053%2013.3585%2013.6971%2013.2751C13.7888%2013.1834%2013.8888%2013.1209%2013.9972%2013.0875C14.1139%2013.0459%2014.2348%2013.025%2014.3599%2013.025C14.7517%2013.025%2014.9476%2013.1918%2014.9476%2013.5252C14.9476%2013.6753%2014.9018%2013.7962%2014.8101%2013.8879C14.7184%2013.9796%2014.6016%2014.0255%2014.4599%2014.0255C14.3349%2014.0255%2014.2223%2013.9963%2014.1223%2013.9379C14.0639%2013.9046%2014.0139%2013.8837%2013.9722%2013.8754C13.9388%2013.8671%2013.9013%2013.8629%2013.8596%2013.8629C13.7763%2013.8629%2013.6846%2013.9046%2013.5845%2013.988C13.5095%2014.0547%2013.1301%2014.5674%2012.4465%2015.5262L12.8217%2017.2645C12.8633%2017.4229%2012.9009%2017.5646%2012.9342%2017.6897C12.9676%2017.8064%2013.0009%2017.9064%2013.0343%2017.9898C13.1093%2018.1566%2013.2177%2018.2399%2013.3594%2018.2399C13.5928%2018.2399%2013.9263%2017.9231%2014.3599%2017.2895L14.5349%2017.4896C13.8513%2018.5234%2013.2719%2019.0403%2012.7966%2019.0403Z%22%20fill=%22%235B6F98%22%20stroke=%22%235B6F98%22%20stroke-width=%220.6%22%2F%3E%0A%3Cpath%20fill-rule=%22evenodd%22%20clip-rule=%22evenodd%22%20d=%22M9.50803%208.7435H14.8501V7.37574L8.54773%207.24897L8.27615%207.23468L4.89584%2016.8778L3.55365%2012.97H0.943359V14.6541H2.28346L4.18143%2019.9965H5.59112L9.50803%208.7435Z%22%20fill=%22%235B6F98%22%2F%3E%0A%3Cpath%20d=%22M25.9486%205.864V17H27.4206V5.864H25.9486ZM30.0266%2017H31.4346V12.712C31.4346%2011.08%2032.0426%209.912%2033.5786%209.912C34.8106%209.912%2035.2906%2010.728%2035.2906%2011.96V17H36.6986V11.784C36.6986%209.624%2035.5146%208.696%2033.9786%208.696C32.4106%208.696%2031.7546%209.528%2031.4346%2010.216C31.4346%209.976%2031.4186%209.128%2031.3706%208.888H30.0106C30.0266%209.512%2030.0266%2010.232%2030.0266%2010.936V17ZM38.3909%2014.68C38.5989%2016.136%2039.6389%2017.192%2041.7349%2017.192C43.7509%2017.192%2044.8869%2016.152%2044.8869%2014.728C44.8869%2013.528%2044.3909%2012.712%2041.9269%2012.12C40.4389%2011.768%2040.1029%2011.464%2040.1029%2010.856C40.1029%2010.328%2040.4549%209.784%2041.5909%209.784C42.8229%209.784%2043.2229%2010.52%2043.3509%2011.032H44.6949C44.5989%209.912%2043.7349%208.696%2041.6389%208.696C39.5589%208.696%2038.7109%209.832%2038.7109%2010.968C38.7109%2012.072%2039.1909%2012.792%2041.5109%2013.352C43.0629%2013.72%2043.4309%2014.072%2043.4309%2014.84C43.4309%2015.576%2042.9669%2016.088%2041.7829%2016.088C40.6789%2016.088%2040.0229%2015.56%2039.7989%2014.68H38.3909ZM53.3803%2013.192C53.3963%2012.984%2053.3963%2012.776%2053.3963%2012.52C53.3963%2010.792%2052.5483%208.696%2049.9243%208.696C47.4603%208.696%2046.2443%2010.616%2046.2443%2013.032C46.2443%2015.112%2047.2843%2017.192%2049.8283%2017.192C52.0523%2017.192%2052.9323%2015.8%2053.2523%2014.76H51.8283C51.5723%2015.352%2051.1563%2016.024%2049.8763%2016.024C48.5003%2016.024%2047.6683%2014.84%2047.6523%2013.192H53.3803ZM47.7003%2012.216C47.8443%2010.792%2048.4683%209.8%2049.9083%209.8C51.2843%209.8%2051.9563%2010.872%2051.9723%2012.216H47.7003ZM55.2953%2017H56.7033V13.064C56.7033%2011.016%2057.7593%2010.136%2059.4233%2010.088V8.696C58.0793%208.728%2057.1193%209.448%2056.7033%2010.536C56.7033%209.752%2056.6713%209.112%2056.6553%208.888H55.2793C55.2793%209.32%2055.2953%209.96%2055.2953%2011.096V17ZM60.4178%2010.024H61.8258V15.112C61.8258%2016.456%2062.3698%2017.112%2063.6338%2017.112C64.0338%2017.112%2064.5138%2017.096%2064.8498%2016.968V15.912C64.6258%2015.96%2064.3378%2015.976%2064.1458%2015.976C63.4098%2015.976%2063.2178%2015.576%2063.2178%2014.776V10.024H65.0098V8.888H63.2178V6.488H61.8258V8.888H60.4178V10.024ZM70.8141%2014.28C70.8141%2015.176%2070.8141%2016.088%2070.7981%2017H72.1421C72.1741%2016.776%2072.2061%2016.344%2072.2061%2015.928C72.6061%2016.712%2073.2941%2017.192%2074.5901%2017.192C76.8781%2017.192%2078.1261%2015.24%2078.1261%2012.776C78.1261%2010.376%2076.8461%208.696%2074.7981%208.696C73.3261%208.696%2072.5741%209.352%2072.2221%2010.04V5.256H70.8141V14.28ZM76.6861%2012.808C76.6861%2014.776%2075.8381%2016.008%2074.3981%2016.008C72.6861%2016.008%2072.1421%2014.664%2072.1421%2012.968C72.1421%2011.032%2072.7501%209.88%2074.4781%209.88C75.8861%209.88%2076.6861%2011.048%2076.6861%2012.808ZM81.4627%2017V5.256H80.0547V17H81.4627ZM87.1996%208.696C84.7516%208.696%2083.3756%2010.552%2083.3756%2012.952C83.3756%2015.4%2084.7836%2017.192%2087.1036%2017.192C89.5836%2017.192%2090.9276%2015.272%2090.9276%2012.92C90.9276%2010.376%2089.4556%208.696%2087.1996%208.696ZM87.1356%209.864C88.6556%209.864%2089.4876%2011.128%2089.4876%2012.952C89.4876%2014.792%2088.6396%2016.024%2087.1676%2016.024C85.7116%2016.024%2084.8156%2014.728%2084.8156%2012.936C84.8156%2011.096%2085.6156%209.864%2087.1356%209.864ZM97.9502%2014.52C97.6142%2015.48%2097.0222%2016.024%2096.0142%2016.024C94.6062%2016.024%2093.8222%2014.792%2093.8222%2012.936C93.8222%2011.096%2094.6382%209.864%2096.0622%209.864C97.2462%209.864%2097.7582%2010.584%2097.9502%2011.4H99.3422C99.2462%2010.36%2098.4302%208.696%2096.0942%208.696C93.6782%208.696%2092.3822%2010.696%2092.3822%2012.984C92.3822%2015.592%2093.7582%2017.192%2095.9982%2017.192C98.0622%2017.192%2099.0062%2015.912%2099.3422%2014.52H97.9502ZM102.544%205.256H101.136V17H102.544V14.12L103.76%2012.952L106.48%2017H108.128L104.72%2012.04L107.776%208.888H106.096C105.008%2010.088%20103.216%2011.96%20102.544%2012.76V5.256ZM120.021%2013.192C120.037%2012.984%20120.037%2012.776%20120.037%2012.52C120.037%2010.792%20119.189%208.696%20116.565%208.696C114.101%208.696%20112.885%2010.616%20112.885%2013.032C112.885%2015.112%20113.925%2017.192%20116.469%2017.192C118.693%2017.192%20119.573%2015.8%20119.893%2014.76H118.469C118.213%2015.352%20117.797%2016.024%20116.517%2016.024C115.141%2016.024%20114.309%2014.84%20114.293%2013.192H120.021ZM114.341%2012.216C114.485%2010.792%20115.109%209.8%20116.549%209.8C117.925%209.8%20118.597%2010.872%20118.613%2012.216H114.341ZM127.39%2020.184H128.75V11.128C128.75%2010.392%20128.75%209.736%20128.766%208.888H127.438C127.406%209.224%20127.374%209.624%20127.39%209.912C127.198%209.384%20126.526%208.696%20125.022%208.696C123.07%208.696%20121.454%2010.312%20121.454%2013.032C121.454%2015.736%20122.974%2017.192%20124.814%2017.192C126.222%2017.192%20126.974%2016.68%20127.39%2015.832V20.184ZM122.91%2012.968C122.91%2011.176%20123.694%209.896%20125.214%209.896C126.958%209.896%20127.422%2011%20127.422%2012.904C127.422%2014.792%20126.91%2016.008%20125.15%2016.008C123.614%2016.008%20122.91%2014.616%20122.91%2012.968ZM137.767%208.888H136.359V13.112C136.359%2015.144%20135.783%2015.976%20134.295%2015.976C132.951%2015.976%20132.615%2014.984%20132.615%2013.928V8.888H131.223V14.216C131.223%2016.504%20132.535%2017.192%20133.911%2017.192C135.191%2017.192%20135.959%2016.68%20136.359%2015.784C136.375%2016.296%20136.391%2016.792%20136.423%2017H137.783C137.783%2016.52%20137.767%2015.432%20137.767%2014.632V8.888ZM146.309%2011.352C146.309%209.512%20145.205%208.696%20143.221%208.696C140.885%208.696%20140.197%209.976%20140.085%2011.096H141.445C141.589%2010.472%20141.829%209.8%20143.173%209.8C144.693%209.8%20144.917%2010.664%20144.917%2011.384V12.072H143.541C141.125%2012.072%20139.701%2012.904%20139.701%2014.712C139.701%2015.944%20140.517%2017.192%20142.437%2017.192C144.005%2017.192%20144.661%2016.472%20144.949%2015.944C144.965%2016.44%20145.013%2016.824%20145.077%2017H146.421C146.373%2016.76%20146.309%2015.976%20146.309%2015.224V11.352ZM144.933%2013.304C144.933%2014.776%20144.677%2016.088%20142.725%2016.088C141.717%2016.088%20141.141%2015.48%20141.141%2014.632C141.141%2013.496%20142.005%2013.048%20143.621%2013.048H144.933V13.304ZM147.68%2010.024H149.088V15.112C149.088%2016.456%20149.632%2017.112%20150.896%2017.112C151.296%2017.112%20151.776%2017.096%20152.112%2016.968V15.912C151.888%2015.96%20151.6%2015.976%20151.408%2015.976C150.672%2015.976%20150.48%2015.576%20150.48%2014.776V10.024H152.272V8.888H150.48V6.488H149.088V8.888H147.68V10.024ZM153.867%2017H155.275V8.888H153.867V17ZM155.275%207V5.256H153.867V7H155.275ZM161.012%208.696C158.564%208.696%20157.188%2010.552%20157.188%2012.952C157.188%2015.4%20158.596%2017.192%20160.916%2017.192C163.396%2017.192%20164.74%2015.272%20164.74%2012.92C164.74%2010.376%20163.268%208.696%20161.012%208.696ZM160.948%209.864C162.468%209.864%20163.3%2011.128%20163.3%2012.952C163.3%2014.792%20162.452%2016.024%20160.98%2016.024C159.524%2016.024%20158.628%2014.728%20158.628%2012.936C158.628%2011.096%20159.428%209.864%20160.948%209.864ZM166.661%2017H168.069V12.712C168.069%2011.08%20168.677%209.912%20170.213%209.912C171.445%209.912%20171.925%2010.728%20171.925%2011.96V17H173.333V11.784C173.333%209.624%20172.149%208.696%20170.613%208.696C169.045%208.696%20168.389%209.528%20168.069%2010.216C168.069%209.976%20168.053%209.128%20168.005%208.888H166.645C166.661%209.512%20166.661%2010.232%20166.661%2010.936V17Z%22%20fill=%22%235B6F98%22%2F%3E%0A%3C%2Fsvg%3E%0A");
  }

  .node-inlineMath,
  .node-blockMath {
    &.ProseMirror-selectednode [data-node-view-wrapper] {
      background: rgba(244, 245, 248, 0.5);
    }
  }

  .math-predelete {
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      box-shadow: 0 0 0 1px ${colors.red500};
      background: #d9264408;
    }
  }
  .node-inlineMath {
    position: relative;
  }

  .node-blockMath {
    position: relative;
    display: flex;
    *[data-node-view-wrapper] {
      flex-grow: 1;
      width: 100%;
    }
  }

  .math-block-wrapper {
    position: relative;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    padding: 24px 0px;
    margin: auto;
    &::after {
      position: absolute;
      right: 8px;
      top: 0;
      display: inline-flex;
      height: 100%;
      align-items: center;
      z-index: 400;
      font-size: 14px;
      line-height: 21px;
      content: var(--math-caption, "");
    }
  }

  .math-node[data-math-latex=""] {
    display: none;
  }
`;
//#endregion
//#region src/extensions/ordered-list/ordered-list.ts
const inputRegex$2 = /^(\d+)\.\s$/;
const OrderedList = Node$1.create({
	name: "orderedList",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block list",
	content: "listItem+",
	addAttributes() {
		return { start: {
			default: 1,
			parseHTML: (element) => {
				return element.hasAttribute("start") ? parseInt(element.getAttribute("start") || "", 10) : 1;
			},
			keepOnSplit: false
		} };
	},
	parseHTML() {
		return [{ tag: "ol" }];
	},
	renderHTML({ HTMLAttributes }) {
		const { start, ...attributesWithoutStart } = HTMLAttributes;
		return start === 1 ? [
			"ol",
			mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart),
			0
		] : [
			"ol",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	addCommands() {
		return { toggleOrderedList: () => ({ commands }) => {
			return commands.toggleCadmusList(this.type, getNodeType("listItem", this.editor.schema));
		} };
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-7": () => this.editor.commands.toggleOrderedList() };
	},
	addProseMirrorPlugins() {
		return [inputRulesPlugin({
			editor: this.editor,
			rules: [new InputRule({
				find: inputRegex$2,
				handler: ({ state, match, range }) => {
					const { tr } = state;
					tr.deleteRange(range.from, range.to);
					const listType = this.type;
					const canUpdate = wrapSelectedItems({
						listType,
						itemType: getNodeType("listItem", this.editor.schema),
						tr,
						editor: this.editor
					});
					const start = +match[1] > 1 ? +match[1] : 1;
					if (!canUpdate) {
						const $cursor = tr.doc.resolve(range.from);
						if ($cursor.depth > 2) {
							if (!isListItem($cursor.node($cursor.depth - 1).type.name, this.editor.extensionManager.extensions)) return null;
						} else return null;
					}
					const found = findParentNode((node) => node.type === this.type)(tr.selection);
					if (found) if (start !== 1) tr.setNodeMarkup(found.pos, void 0, { start });
					else tr.setNodeMarkup(found.pos, void 0, {});
				}
			}), wrappingInputRule({
				find: inputRegex$2,
				type: this.type,
				getAttributes: (match) => {
					if (+match[1] > 1) return { start: +match[1] };
				},
				joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1]
			})]
		})];
	}
});
//#endregion
//#region src/extensions/paste-chip/paste-chip.ts
/** Inline atom Node for displaying the paste chip */
const PasteChip = Node$1.create({
	name: "pasteChip",
	addOptions() {
		return {
			HTMLAttributes: {},
			enableManual: false
		};
	},
	group: "inline",
	inline: true,
	draggable: false,
	atom: true,
	allowGapCursor: true,
	addAttributes() {
		return { pasted: {
			default: 0,
			parseHTML: (element) => parseInt(element.getAttribute("data-cadmus-pasted") ?? "0") || 0,
			renderHTML: (attributes) => {
				return { "data-cadmus-pasted": attributes.pasted || 0 };
			}
		} };
	},
	parseHTML() {
		return [{ tag: "span[data-cadmus-pasted]" }];
	},
	renderHTML({ HTMLAttributes }) {
		return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
	},
	addNodeView() {
		return ({ node, editor }) => {
			const { pasted } = node.attrs;
			let paraphrasingLink = crel("span", "paraphrasing");
			if (this.options.enableManual) paraphrasingLink = crel("button", {
				tabindex: "-1",
				class: "cui-LinkButton",
				onclick: () => editor.commands.setMeta("openManualPreset", "paraphrasing")
			}, paraphrasingLink);
			let quotingLink = crel("span", "quoting");
			if (this.options.enableManual) quotingLink = crel("button", {
				tabindex: "-1",
				class: "cui-LinkButton",
				onclick: () => editor.commands.setMeta("openManualPreset", "quoting")
			}, quotingLink);
			const closeButton = crel("button", {
				tabindex: "-1",
				onclick: (event) => editor.commands.deletePasteChip(event),
				class: "icon-button",
				"aria-label": "close"
			}, createCloseIcon());
			return { dom: crel("span", { "data-cadmus-pasted": `${pasted}` }, `${pasted} words pasted. Consider `, paraphrasingLink, " or ", quotingLink, closeButton) };
		};
	}
});
function createCloseIcon() {
	const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	svg.setAttributeNS(null, "viewBox", "0 0 16 21");
	svg.setAttributeNS(null, "width", "1em");
	svg.setAttributeNS(null, "height", "100%");
	const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
	path.setAttributeNS(null, "d", "M8,9.57142857 L10.8643218,6.70710678 C11.2548461,6.31658249 11.8880111,6.31658249 12.2785354,6.70710678 L12.2928932,6.72146465 C12.6834175,7.11198894 12.6834175,7.74515392 12.2928932,8.13567821 L9.42857143,11 L9.42857143,11 L12.2928932,13.8643218 C12.6834175,14.2548461 12.6834175,14.8880111 12.2928932,15.2785354 L12.2785354,15.2928932 C11.8880111,15.6834175 11.2548461,15.6834175 10.8643218,15.2928932 L8,12.4285714 L8,12.4285714 L5.13567821,15.2928932 C4.74515392,15.6834175 4.11198894,15.6834175 3.72146465,15.2928932 L3.70710678,15.2785354 C3.31658249,14.8880111 3.31658249,14.2548461 3.70710678,13.8643218 L6.57142857,11 L6.57142857,11 L3.70710678,8.13567821 C3.31658249,7.74515392 3.31658249,7.11198894 3.70710678,6.72146465 L3.72146465,6.70710678 C4.11198894,6.31658249 4.74515392,6.31658249 5.13567821,6.70710678 L8,9.57142857 L8,9.57142857 Z");
	svg.appendChild(path);
	return svg;
}
//#endregion
//#region src/extensions/subscript/subscript.ts
const Subscript$1 = Subscript.extend({ addKeyboardShortcuts() {
	return { "Mod-'": () => this.editor.commands.toggleSubscript() };
} });
//#endregion
//#region src/extensions/suggestion/helpers.ts
/**
* Disable all forms of Cadmus and Browser spell check. This is useful Grammarly
* should be the sole spell checker.
*/
function disableSpellCheck(editor) {
	return editor.commands.setSpellCheckSource(null);
}
/**
* Switch to using Cadmus suggestions in the editor.
*/
function enableCadmusSpellCheck(editor) {
	return editor.commands.setSpellCheckSource("cadmus");
}
/**
* Check if Cadmus spellcheck suggestions are enabled on the Editor attributes.
*/
function canSpellCheckWithCadmus(editor) {
	return !!editor.view.someProp("attributes", (attributes) => {
		return (typeof attributes === "object" ? attributes : attributes(editor.state))["data-cadmus-spellcheck"] === "true";
	});
}
/**
* Create the Editor element HTML attributes which control spellchecking
* behaviours.
*/
function spellCheckAttrs(source) {
	let browser = "false";
	let cadmus = "false";
	if (source === "cadmus") {
		cadmus = "true";
		browser = "false";
	}
	if (source === "browser") {
		cadmus = "false";
		browser = "true";
	}
	return {
		spellcheck: browser,
		"data-cadmus-spellcheck": cadmus
	};
}
/**
* Get the start position of the Block prior to the from selection as start and
* the end position of the Block where the to selection is as end
*/
function getNodeBoundaries(doc, from, to) {
	const docSize = doc.content.size;
	const nodeBeforeFrom = doc.childBefore(from && docSize > from ? from : 0);
	const nodeBeforeTo = doc.childBefore(to && docSize > to ? to : docSize);
	return {
		start: nodeBeforeFrom.offset,
		end: nodeBeforeTo.node?.nodeSize ? nodeBeforeTo.offset + nodeBeforeTo.node?.nodeSize : docSize
	};
}
//#endregion
//#region src/extensions/suggestion/suggestion-decoration-plugin.ts
/** Reference key for the `SuggestionDecorationPlugin`. */
const SuggestionDecorationPluginKey = new PluginKey("suggestionDecoration");
/**
* Create a new `SuggestionDecorationPlugin` to manage suggestion decorations in
* a document.
*
* A suggestion decoration is an inline decoration which marks a word as a
* misspelling with the replacement candidates stored in the decoration `spec`
* object. See the type `SuggestionDecorationSpec`.
*
* On every transaction, any updated text nodes are re-processed (tokenised and
* looked up using the `SuggestionClient`) to update the decoration positions or
* add new decorations.
*
* It is expected that some other out-of-bound process is reading the entire
* document and sending it to the server for spelling suggestions.
*
* ## Transaction Meta Actions
*
* The plugin watches out for the following transaction meta actions payloads:
*
*   - `IgnoreWordAction` filters out any existing decorations for a given
*     `word`.
*   - `RefreshSuggestionsAction` triggers a full document refresh of suggestion
*     decorations.
*
*/
const SuggestionDecorationPlugin = (props) => new Plugin({
	key: SuggestionDecorationPluginKey,
	state: {
		init() {
			return DecorationSet.empty;
		},
		apply(tr, decoSet) {
			const payload = tr.getMeta(SuggestionDecorationPluginKey);
			switch (payload?.type) {
				case "ignoreWord": return handleIgnoreWordAction(decoSet, payload.word);
				case "refreshSuggestions": return handleRefreshSuggestionsAction(tr, decoSet, props.client);
				default: return processUpdatedNodes(tr, decoSet, props.client);
			}
		}
	},
	props: { decorations(state) {
		return canSpellCheckWithCadmus(props.editor) ? this.getState(state) : void 0;
	} }
});
/**
* Suggestion Decoration which add suggestion class and also phrase and candidates
* as the decoration specification data.
*/
function SuggestionDecoration(from, to, phrase, candidates) {
	return Decoration.inline(from, to, {
		class: "suggestion",
		["aria-label"]: "Press Option + m to open the suggestion menu",
		id: "suggestion-menu-button",
		["aria-controls"]: "suggestion-menu",
		["aria-haspopup"]: "true"
	}, {
		phrase,
		candidates
	});
}
/**
* Go through updated textNode on a transaction and re-decorate them with
* suggestions if words on those blocks require suggestion
*/
function processUpdatedNodes(tr, decoSet, client) {
	if (tr.docChanged) {
		decoSet = decoSet.map(tr.mapping, tr.doc);
		const { to, from = 0 } = rangeFromTransaction(tr);
		const { start, end } = getNodeBoundaries(tr.doc, from, to);
		const outdatedDecos = decoSet.find(start, end);
		decoSet = decoSet.remove(outdatedDecos);
		const newDecos = getSuggestionDecorations(tr.doc, start, end, decoSet, client);
		return decoSet.add(tr.doc, newDecos);
	}
	return decoSet;
}
/**
* Handle transaction meta action event `ignoreWord`. Any existing decorations
* for the ignored word will be removed from the given set.
*/
function handleIgnoreWordAction(decoSet, word) {
	const invalidDeco = decoSet.find(void 0, void 0, (spec) => spec.phrase === word);
	return decoSet.remove(invalidDeco);
}
/**
* Handle transaction metadata event for `refreshSuggestions`. The entire
* document will be considered for decorating misspelled words when this event
* exists on the transaction metadata.
*/
function handleRefreshSuggestionsAction(tr, decoSet, client) {
	const newDecos = getSuggestionDecorations(tr.doc, 0, tr.doc.content.size, decoSet, client);
	return decoSet.add(tr.doc, newDecos);
}
/**
* Create new decorations for mispelled words in a `doc` node between the given
* range.
*
* The `doc` node is tokenised as word chunks, finding misspelled words using
* the `client` lookup. If a word is misspelled and is currently not decorated,
* a new `Decoration` will be created for the word on its position.
*
* @param doc node to start iterating over
* @param from start position
* @param to end position
* @param existing existing suggestion decorations in the document
* @param client Suggestions Client to use to lookup spelling.
*/
function getSuggestionDecorations(doc, from, to, existing, client) {
	const decorations = [];
	processTextBetween(doc, from, to, (text, textFrom) => {
		applySuggestionDecorations(text, textFrom, existing, client, decorations);
	}, ignoreNodeForSuggestions);
	return decorations;
}
function applySuggestionDecorations(text, start, existing, client, collection) {
	for (const { word, index } of spellableWordsMatchAll(text ?? "")) {
		const from = start + index;
		const to = from + word.length;
		const candidates = client.lookup(word);
		if (candidates?.length) {
			if (existing.find(from, to, ({ phrase }) => phrase === word).length === 0) collection.push(SuggestionDecoration(from, to, word, candidates));
		}
	}
}
const MARKS_TO_IGNORE_FOR_SUGGESTION = [
	"link",
	"superscript",
	"subscript",
	"code"
];
const NODES_TO_IGNORE_FOR_SUGGESTION = [
	"inlineMath",
	"pasteChip",
	"blockMath",
	"codeBlock",
	"footnote"
];
function ignoreNodeForSuggestions(node) {
	return node.marks.some((mark) => MARKS_TO_IGNORE_FOR_SUGGESTION.includes(mark.type.name)) || NODES_TO_IGNORE_FOR_SUGGESTION.includes(node.type.name);
}
//#endregion
//#region src/extensions/suggestion/suggestion-menu-plugin.ts
/** Reference plugin key for `SuggestionMenuPlugin`. */
const SuggestionMenuPluginKey = new PluginKey("suggestionMenu");
/**
* Initialise the SuggestionMenuPlugin which manages state and DOM events for
* the right-click context menu providing spelling suggestions for any
* right-clicked word (if its decorated with suggestions).
*
* ## Plugin State
*
* The plugin state will contain the information on any suggestion decorated
* word under the cursor. If the word is not decorated or the selection is not
* viable, the state will be `null`.
*
* The state information will contain the positions of the decoration and the
* suggestion candidates. This data is pulled from the decoration spec data set
* in the `SuggestionDecorationPlugin`.
*
* ## Transaction Meta
*
* The state updates are triggered using the transaction metadata payloads for
* this plugin. These meta payloads are attached using the DOM event handlers
* mentioned below. The following meta payloads are handled:
*
* - `TriggerMenuAction` to trigger the menu on a valid suggestion decorated
*     word. The payload will contain all the position and spelling candidates
*     for the menu to render.

* - `DismissMenuAction` to dismiss the menu by re-setting the state to `null`.
*
*/
const SuggestionMenuPlugin = (props) => {
	return new Plugin({
		key: SuggestionMenuPluginKey,
		state: {
			init() {
				return null;
			},
			apply(tr, state) {
				const payload = tr.getMeta(SuggestionMenuPluginKey);
				switch (payload?.type) {
					case "triggerMenu": return payload.target;
					case "dismissMenu": return null;
					default: return state;
				}
			}
		},
		props: {
			handleClick(view, _, event) {
				const state = this.getState(view.state);
				if (event.button !== 2) {
					if (state) view.dispatch(view.state.tr.setMeta(this, { type: "dismissMenu" }));
				}
				return false;
			},
			handleDOMEvents: { contextmenu(view, event) {
				if (!canSpellCheckWithCadmus(props.editor)) return true;
				const pos = view.posAtCoords({
					left: event.clientX,
					top: event.clientY
				});
				if (!pos) return true;
				const from = pos.pos;
				const deco = SuggestionDecorationPluginKey.getState(view.state)?.find(from, from).pop();
				if (deco) {
					const spec = deco.spec;
					if (textBetween(view.state.doc, "\n", deco.from, deco.to).toLowerCase() === spec.phrase.toLowerCase()) {
						view.dispatch(view.state.tr.setMeta(this, {
							type: "triggerMenu",
							target: {
								...spec,
								from: deco.from,
								to: deco.to
							}
						}));
						event.preventDefault();
						event.stopPropagation();
						return true;
					}
				}
				view.dispatch(view.state.tr.setMeta(this, { type: "dismissMenu" }));
				return true;
			} }
		}
	});
};
//#endregion
//#region src/extensions/suggestion/suggestion.ts
/**
* Cadmus spelling suggestions extension.
*
* It uses a `SuggestionClient` instance to request server spelling suggestions
* on the editor contents and adds decorations on misspelled words. The
* decorations contains state (via decoration spec object) which is used to
* render a right-click context menu (via `SuggestionMenuPlugin`) for selecting
* the correct replacement candidate via user action.
*
* See `SuggestionDecorationPlugin` for more details on the decoration
* management and state.
*
* Both `SuggestionDecorationPlugin` and `SuggestionMenuPlugin` listen for
* Transaction metadata actions to update their state.
*
* This extension triggers the event when the whole document is tokenised and
* sent to server for spelling suggestions. This request is further optimised by
* the `SuggestionClient` which doesn't re-process previously known words. This
* processing is triggered on:
*
*   1. Editor creation.
*   2. Every transaction in a debounced fashion.
*
*/
const Suggestion = Extension.create({
	name: "suggestion",
	onBeforeCreate() {
		this.editor.setOptions({ editorProps: {
			...this.editor.options.editorProps,
			attributes: {
				...this.editor.options.editorProps.attributes,
				...spellCheckAttrs(this.options.spellCheckSource)
			}
		} });
	},
	/**
	* Upon creation of the editor instance, initialised word count &
	* suggestion without debouncing it.
	*/
	onCreate() {
		const onNewSuggestions = () => this.editor.commands.refreshSuggestions();
		this.options.client.on("newSuggestions", onNewSuggestions);
		this.editor.on("destroy", () => {
			this.options.client.off("newSuggestions", onNewSuggestions);
		});
	},
	addKeyboardShortcuts() {
		return { "Alt-m": () => {
			if (!canSpellCheckWithCadmus(this.editor)) return false;
			const pos = this.editor.state.selection.anchor;
			const deco = SuggestionDecorationPluginKey.getState(this.editor.state)?.find(pos, pos).pop();
			if (deco) {
				const spec = deco.spec;
				if (textBetween(this.editor.state.doc, "\n", deco.from, deco.to).toLowerCase() === spec.phrase.toLowerCase()) {
					this.editor.view.dispatch(this.editor.view.state.tr.setMeta(SuggestionMenuPluginKey, {
						type: "triggerMenu",
						target: {
							...spec,
							from: deco.from,
							to: deco.to
						}
					}));
					return true;
				}
			}
			this.editor.view.dispatch(this.editor.view.state.tr.setMeta(SuggestionMenuPluginKey, { type: "dismissMenu" }));
			return true;
		} };
	},
	addCommands() {
		return {
			ignoreSuggestion: (word) => ({ tr, dispatch }) => {
				if (dispatch) {
					tr.setMeta(SuggestionDecorationPluginKey, {
						type: "ignoreWord",
						word
					});
					tr.setMeta(SuggestionMenuPluginKey, { type: "dismissMenu" });
					this.options.client.ignoreWord(word);
				}
				return true;
			},
			refreshSuggestions: () => ({ tr, dispatch }) => {
				if (dispatch) tr.setMeta(SuggestionDecorationPluginKey, { type: "refreshSuggestions" });
				return true;
			},
			acceptSuggestion: (from, to, candidate) => ({ tr, dispatch }) => {
				if (dispatch) {
					tr.insertText(candidate, from, to);
					tr.setMeta(SuggestionMenuPluginKey, { type: "dismissMenu" });
				}
				return true;
			},
			setSpellCheckSource: (source) => ({ view }) => {
				const attributes = {
					...view.props.attributes,
					...spellCheckAttrs(source)
				};
				view.setProps({ attributes });
				return true;
			}
		};
	},
	addProseMirrorPlugins() {
		return [SuggestionDecorationPlugin({
			client: this.options.client,
			editor: this.editor
		}), SuggestionMenuPlugin({ editor: this.editor })];
	}
});
//#endregion
//#region src/extensions/suggestion/suggestion-menu-component.tsx
/**
* React component rendering the right-click suggestion menu for a misspelled
* word, managed by the `SuggestionMenuPlugin`.
*
* The menu is dynamically positioned on the page using TippyJS. The
* `SuggestionMenuPlugin` manages all of that. The plugin is initialised and
* registered into the given `Editor` using a mount effect.
*
* The state of the menu is pulled directly from the plugin state of
* `SuggestionMenuPlugin` which will contain information on the currently
* clicked misspelled word (if any).
*/
function SuggestionMenuComponent(props) {
	const { editor, portalId } = props;
	const [menuOpened, setMenuOpened] = useState(false);
	return /* @__PURE__ */ jsx(FloatingMenuComponent, {
		pluginKey: "suggestionFloatingMenu",
		editor,
		shouldShow: useCallback(({ state }) => {
			return !!SuggestionMenuPluginKey.getState(state);
		}, []),
		getBoundingClientRect: useCallback(() => {
			const { state, view } = editor;
			const suggestion = SuggestionMenuPluginKey.getState(state);
			const { selection } = state;
			const { ranges } = selection;
			let from = Math.min(...ranges.map((range) => range.$from.pos));
			let to = Math.max(...ranges.map((range) => range.$to.pos));
			if (suggestion) {
				from = suggestion.from;
				to = suggestion.to;
			}
			return posToDOMRect(view, from, to);
		}, [editor]),
		portalId,
		isAsync: true,
		onOpenChange: (open) => setMenuOpened(open),
		children: /* @__PURE__ */ jsx(SuggestionContextMenu, {
			editor: props.editor,
			open: menuOpened
		})
	});
}
const SuggestionContextMenu = ({ editor, open }) => {
	const { suggestion } = useEditorState({
		editor,
		selector: (ctx) => ({ suggestion: SuggestionMenuPluginKey.getState(ctx.editor.state) })
	});
	const onSelectedCandidate = (candidate) => {
		if (suggestion) {
			const { from, to } = suggestion;
			editor.chain().acceptSuggestion(from, to, candidate).focus().run();
		}
	};
	const onIgnore = () => {
		if (suggestion) editor.chain().ignoreSuggestion(suggestion.phrase).focus().run();
	};
	return /* @__PURE__ */ jsxs(DropdownMenu.Root, {
		open,
		modal: false,
		children: [/* @__PURE__ */ jsx(StyledTrigger, { disabled: true }), /* @__PURE__ */ jsxs(DropdownMenu.Content, {
			id: "suggestion-menu",
			"aria-labelledby": "suggestion-menu-button",
			align: "center",
			sideOffset: -20,
			onEscapeKeyDown: () => {
				editor.view.dispatch(editor.state.tr.setMeta(SuggestionMenuPluginKey, { type: "dismissMenu" }));
				editor.commands.focus();
			},
			children: [
				/* @__PURE__ */ jsx(DropdownMenu.Label, { children: "Suggestions" }),
				suggestion?.candidates?.map((candidate) => /* @__PURE__ */ jsx(DropdownMenu.Item, {
					onClick: () => onSelectedCandidate(candidate),
					children: candidate
				}, candidate)),
				/* @__PURE__ */ jsx(DropdownMenu.Separator, {}),
				/* @__PURE__ */ jsx(DropdownMenu.Item, {
					onClick: onIgnore,
					asChild: true,
					children: /* @__PURE__ */ jsx(Colored, {
						color: "red500",
						children: "Ignore phrase"
					})
				})
			]
		})]
	});
};
const StyledTrigger = styled(DropdownMenu.Trigger)`
  visibility: hidden;
  z-index: -1;
`;
//#endregion
//#region src/extensions/superscript/superscript.ts
const Superscript$1 = Superscript.extend({ addKeyboardShortcuts() {
	return { "Mod-;": ({ editor }) => editor.commands.toggleSuperscript() };
} });
//#endregion
//#region src/extensions/table/plugins/table-column-resizing-plugin.ts
function pointsAtCell($pos) {
	return $pos.parent.type.spec.tableRole == "row" && $pos.nodeAfter;
}
function setAttr(attrs, name, value) {
	const result = {};
	for (const prop in attrs) result[prop] = attrs[prop];
	result[name] = value;
	return result;
}
const columnResizingPluginKey = new PluginKey("tableColumnResizing");
function columnResizing({ editor, handleWidth = 5, cellMinWidth = 25, lastColumnResizable = true } = {}) {
	return new Plugin({
		key: columnResizingPluginKey,
		state: {
			init() {
				return new ResizeState(-1, false);
			},
			apply(tr, prev) {
				return prev.apply(tr);
			}
		},
		props: {
			attributes(state) {
				return columnResizingPluginKey.getState(state).activeHandle > -1 ? { class: "resize-cursor" } : { class: "" };
			},
			handleDOMEvents: {
				mousemove(view, event) {
					if (editor?.isEditable) handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable);
					return false;
				},
				mouseleave(view) {
					if (editor?.isEditable) handleMouseLeave(view);
					return false;
				},
				mousedown(view, event) {
					if (editor?.isEditable) handleMouseDown(view, event, cellMinWidth);
					return false;
				}
			},
			decorations(state) {
				const pluginState = columnResizingPluginKey.getState(state);
				if (pluginState.activeHandle > -1) return handleDecorations(state, pluginState.activeHandle);
			},
			nodeViews: {}
		}
	});
}
var ResizeState = class ResizeState {
	activeHandle;
	dragging;
	constructor(activeHandle, dragging) {
		this.activeHandle = activeHandle;
		this.dragging = dragging;
	}
	apply(tr) {
		let state = this;
		const action = tr.getMeta(columnResizingPluginKey);
		if (action && action.setHandle != null) return new ResizeState(action.setHandle, null);
		if (action && action.setDragging !== void 0) return new ResizeState(state.activeHandle, action.setDragging);
		if (state.activeHandle && state.activeHandle > -1 && tr.docChanged) {
			let handle = tr.mapping.map(state.activeHandle, -1);
			if (handle !== null && !pointsAtCell(tr.doc.resolve(handle))) handle = -1;
			state = new ResizeState(handle, state.dragging);
		}
		return state;
	}
};
function handleMouseMove(view, event, handleWidth, _cellMinWidth, lastColumnResizable) {
	const pluginState = columnResizingPluginKey.getState(view.state);
	if (!pluginState) return;
	if (!pluginState.dragging) {
		const target = domCellAround(event.target);
		let cell = -1;
		if (target) {
			const { left, right } = target.getBoundingClientRect();
			if (event.clientX - left <= handleWidth) cell = edgeCell(view, event, "left", handleWidth);
			else if (right - event.clientX <= handleWidth) cell = edgeCell(view, event, "right", handleWidth);
		}
		if (cell != pluginState.activeHandle) {
			if (!lastColumnResizable && cell !== -1) {
				const $cell = view.state.doc.resolve(cell);
				const table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
				if (map.colCount($cell.pos - start) + $cell?.nodeAfter?.attrs.colspan - 1 == map.width - 1) return;
			}
			updateHandle(view, cell);
		}
	}
}
function handleMouseLeave(view) {
	const pluginState = columnResizingPluginKey.getState(view.state);
	if (pluginState.activeHandle > -1 && !pluginState.dragging) updateHandle(view, -1);
}
function handleMouseDown(view, event, cellMinWidth) {
	const win = view.dom.ownerDocument.defaultView ?? window;
	const pluginState = columnResizingPluginKey.getState(view.state);
	if (!pluginState || pluginState.activeHandle == -1 || pluginState.dragging) return false;
	const cell = view.state.doc.nodeAt(pluginState.activeHandle);
	if (cell) {
		const width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
		view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, { setDragging: {
			startX: event.clientX,
			startWidth: width
		} }));
	}
	function finish(event) {
		win.removeEventListener("mouseup", finish);
		win.removeEventListener("mousemove", move);
		const pluginState = columnResizingPluginKey.getState(view.state);
		if (pluginState?.dragging) {
			updateColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, event, cellMinWidth));
			view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, { setDragging: null }));
		}
	}
	function move(event) {
		if (!event.which) return finish(event);
		const pluginState = columnResizingPluginKey.getState(view.state);
		if (!pluginState) return;
		const dragged = draggedWidth(pluginState.dragging, event, cellMinWidth);
		displayColumnWidth(view, pluginState.activeHandle, dragged, cellMinWidth);
	}
	win.addEventListener("mouseup", finish);
	win.addEventListener("mousemove", move);
	event.preventDefault();
	return true;
}
function currentColWidth(view, cellPos, { colspan, colwidth }) {
	const width = colwidth && colwidth[colwidth.length - 1];
	if (width) return width;
	const dom = view.domAtPos(cellPos);
	let domWidth = dom.node.childNodes[dom.offset].offsetWidth, parts = colspan;
	if (colwidth) {
		for (let i = 0; i < colspan; i++) if (colwidth[i]) {
			domWidth -= colwidth[i];
			parts--;
		}
	}
	return domWidth / parts;
}
function domCellAround(target) {
	while (target && target.nodeName != "TD" && target.nodeName != "TH") target = target.classList.contains("ProseMirror") ? null : target.parentNode;
	return target;
}
function edgeCell(view, event, side, handleWidth) {
	const offset = side == "right" ? -handleWidth : handleWidth;
	const found = view.posAtCoords({
		left: event.clientX + offset,
		top: event.clientY
	});
	if (!found) return -1;
	const { pos } = found;
	const $cell = cellAround(view.state.doc.resolve(pos));
	if (!$cell) return -1;
	if (side == "right") return $cell.pos;
	const map = TableMap.get($cell.node(-1)), start = $cell.start(-1);
	const index = map.map.indexOf($cell.pos - start);
	return index % map.width == 0 ? -1 : start + map.map[index - 1];
}
function draggedWidth(dragging, event, cellMinWidth) {
	const offset = event.clientX - dragging.startX;
	return Math.max(cellMinWidth, dragging.startWidth + offset);
}
function updateHandle(view, value) {
	view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, { setHandle: value }));
}
function updateColumnWidth(view, cell, width) {
	const $cell = view.state.doc.resolve(cell);
	if (!$cell) return;
	const table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
	const col = map.colCount($cell.pos - start) + $cell.nodeAfter?.attrs.colspan - 1;
	const tr = view.state.tr;
	for (let row = 0; row < map.height; row++) {
		const mapIndex = row * map.width + col;
		if (row && map.map[mapIndex] == map.map[mapIndex - map.width]) continue;
		const pos = map.map[mapIndex];
		const cell = table.nodeAt(pos);
		if (!cell) continue;
		const { attrs } = cell;
		const index = attrs.colspan == 1 ? 0 : col - map.colCount(pos);
		if (attrs.colwidth && attrs.colwidth[index] == width) continue;
		const colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
		colwidth[index] = width;
		tr.setNodeMarkup(start + pos, null, setAttr(attrs, "colwidth", colwidth));
	}
	if (tr.docChanged) view.dispatch(tr);
}
function displayColumnWidth(view, cell, width, cellMinWidth) {
	const $cell = view.state.doc.resolve(cell);
	const table = $cell.node(-1), start = $cell.start(-1);
	const col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter?.attrs.colspan - 1;
	let dom = view.domAtPos($cell.start(-1)).node;
	while (dom?.nodeName != "TABLE") dom = dom.parentNode;
	if (!dom) return;
	updateColumns(table, dom.firstChild, dom, cellMinWidth, col, width);
}
function zeroes(n) {
	return new Array(n).fill(0);
}
function handleDecorations(state, cell) {
	const decorations = [];
	const $cell = state.doc.resolve(cell);
	const table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
	const col = map.colCount($cell.pos - start) + $cell.nodeAfter?.attrs.colspan - 1;
	for (let row = 0; row < map.height; row++) {
		const index = col + row * map.width;
		if ((col == map.width || map.map[index] != map.map[index + 1]) && (row == 0 || map.map[index] != map.map[index - map.width])) {
			const cellPos = map.map[index];
			const cell = table.nodeAt(cellPos);
			if (cell) {
				const pos = start + cellPos + cell.nodeSize - 1;
				const dom = document.createElement("div");
				dom.className = "column-resize-handle";
				decorations.push(Decoration.widget(pos, dom));
			}
		}
	}
	return DecorationSet.create(state.doc, decorations);
}
function updateColumns(node, colgroup, table, cellMinWidth, overrideCol, overrideValue) {
	let totalWidth = 0;
	let fixedWidth = true;
	let nextDOM = colgroup.firstChild;
	const row = node.firstChild;
	if (!row) return;
	for (let i = 0, col = 0; i < row.childCount; i += 1) {
		const { colspan, colwidth } = row.child(i).attrs;
		for (let j = 0; j < colspan; j += 1, col += 1) {
			const hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth[j];
			const cssWidth = hasWidth ? `${hasWidth}px` : "";
			totalWidth += hasWidth || cellMinWidth;
			if (!hasWidth) fixedWidth = false;
			if (!nextDOM) colgroup.appendChild(document.createElement("col")).style.width = cssWidth;
			else {
				if (nextDOM.style.width !== cssWidth) nextDOM.style.width = cssWidth;
				nextDOM = nextDOM.nextSibling;
			}
		}
	}
	while (nextDOM) {
		const after = nextDOM.nextSibling;
		nextDOM.parentNode?.removeChild(nextDOM);
		nextDOM = after;
	}
	if (fixedWidth) {
		table.style.width = `${totalWidth > 800 ? 800 : totalWidth}px`;
		table.style.minWidth = "";
	} else {
		table.style.width = "";
		table.style.minWidth = `${totalWidth > 800 ? 800 : totalWidth}px`;
	}
}
//#endregion
//#region src/extensions/table/plugins/table-control-plugin.ts
const TableControlPluginKey = new PluginKey("tableControl");
/**
* Plugin that shows control to select table and also visual indicator
* on row/column insertion
*/
const TableControlPlugin = (opts) => new Plugin({
	key: TableControlPluginKey,
	state: {
		init() {
			return {
				row: null,
				col: null
			};
		},
		apply(tr, oldState) {
			const payload = tr.getMeta(TableControlPluginKey);
			if (payload) return payload;
			return oldState;
		}
	},
	props: { decorations: (state) => {
		if (!opts.editor.isEditable) return DecorationSet.empty;
		const { doc, selection } = state;
		const decorations = [];
		const table = findTable(selection);
		const isResizing = !!columnResizingPluginKey.getState(state)?.dragging;
		const pluginState = TableControlPluginKey.getState(state);
		if (table && !isResizing) {
			const map = TableMap.get(table.node);
			if (pluginState.row !== null && pluginState.row !== map.height) map.cellsInRect({
				left: 0,
				right: map.width,
				top: pluginState.row,
				bottom: pluginState.row + 1
			}).map((cellPos) => {
				decorations.push(Decoration.widget(table.start + cellPos + 1, crel("div", { class: "row-insert-handle" })));
			});
			if (pluginState.col !== null && pluginState.col !== map.width) map.cellsInRect({
				left: pluginState.col,
				right: pluginState.col + 1,
				top: 0,
				bottom: map.height
			}).map((cellPos) => {
				decorations.push(Decoration.widget(table.start + cellPos + 1, crel("div", { class: "col-insert-handle" })));
			});
		}
		return DecorationSet.create(doc, decorations);
	} }
});
//#endregion
//#region src/extensions/table/plugins/table-delete-indicator-plugin.ts
const TableDeleteIndicatorPluginKey = new PluginKey("TableDeleteIndicator");
/**
* Plugin that shows visual indicator of cells that will get deleted
* when user click on delete button
*/
const TableDeleteIndicatorPlugin = () => new Plugin({
	key: TableDeleteIndicatorPluginKey,
	state: {
		init() {
			return { highlight: false };
		},
		apply(tr, currentState) {
			const payload = tr.getMeta(TableDeleteIndicatorPluginKey);
			if (payload) return payload;
			return currentState;
		}
	},
	props: { decorations(editorState) {
		if (this.getState(editorState)?.highlight) {
			const table = findTable(editorState.selection);
			const decorations = [];
			if (table) {
				getCellsMap(editorState.schema, editorState.selection)?.cells?.forEach((cell) => {
					decorations.push(Decoration.node(cell.pos, cell.pos + cell.node.nodeSize, { class: "cell-predelete" }));
				});
				return DecorationSet.create(editorState.doc, decorations);
			}
		}
		return DecorationSet.empty;
	} }
});
//#endregion
//#region src/extensions/table/plugins/table-ensure-group-plugin.ts
/**
* Plugin to ensure that table is wrapped inside table group
* when it got pasted over without it which also includes the
* insertion of table caption and footnote
*/
const TableEnsureGroupPlugin = () => new Plugin({
	key: new PluginKey("tableEnsureGroup"),
	appendTransaction: (_tr, oldState, editorState) => {
		if (oldState.doc === editorState.doc) return;
		const { doc, schema, tr } = editorState;
		const tableNodeTypes = getTableNodeTypes(schema);
		const tables = findChildren(doc, (node) => {
			return node.type === getTableNodeTypes(schema).table;
		});
		let fixing = false;
		tables.sort((a, b) => {
			if (a.pos > b.pos) return -1;
			else if (a.pos < b.pos) return 1;
			return 0;
		}).map(({ node, pos }) => {
			const tableGroup = findParentNodeClosestToPos(doc.resolve(pos), (node) => node.type === tableNodeTypes.table_group);
			if (!tableGroup) {
				const emptyCaption = tableNodeTypes.table_caption.createAndFill();
				const emptyFootnote = tableNodeTypes.table_footnote.createAndFill();
				if (emptyCaption && emptyFootnote) {
					const newNode = tableNodeTypes.table_group.createChecked(void 0, [
						emptyCaption,
						node,
						emptyFootnote
					]);
					tr.replaceWith(pos, pos + node.nodeSize, newNode);
					fixing = true;
				}
			} else if (findChildren(tableGroup.node, (node) => node.type === tableNodeTypes.cell).length === 0) {
				tr.delete(tableGroup.pos, tableGroup.pos + tableGroup.node.nodeSize);
				fixing = true;
			}
		});
		if (fixing) return tr;
	}
});
//#endregion
//#region src/extensions/table/components/useTableControl.ts
const useComponentBoundingRect = (target) => {
	const [boundingRect, setBoundingRect] = useState(null);
	useLayoutEffect(() => {
		if (target.current) setBoundingRect(target.current.getBoundingClientRect());
	}, [target]);
	useResizeObserver({
		ref: target.current,
		onResize: () => target.current && setBoundingRect(target.current?.getBoundingClientRect())
	});
	return boundingRect;
};
/**
* React hooks to position, show/hide, highlight table controls
* for insert/delete row(s)/column(s) and row(s)/column(s)
* selection handle
*/
const useTableControl = (props) => {
	const { editor, node, tableRef, colNum, getPos } = props;
	const [colWidths, setColWidths] = useState([]);
	const [rowHeights, setRowHeights] = useState();
	const [isResizing, setIsResizing] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [selectedRows, setSelectedRows] = useState([]);
	const [selectedColumns, setSelectedColumns] = useState([]);
	const [isSelected, setIsSelected] = useState(false);
	const [predelete, setPredelete] = useState(false);
	const tableRect = useComponentBoundingRect(tableRef);
	useEffect(() => {
		if (tableRef.current) {
			setRowHeights(getRowHeights(tableRef.current));
			setColWidths(getColWidths(tableRef.current, node));
		}
	}, [
		tableRef,
		node,
		tableRect,
		colNum,
		isResizing
	]);
	useEffect(() => {
		const handleResize = ({ transaction }) => {
			const pos = getPos();
			const { selection } = transaction;
			if (transaction.getMeta(columnResizingPluginKey)) setIsResizing(!!columnResizingPluginKey.getState(editor.state)?.dragging);
			const predeleteMeta = transaction.getMeta(TableDeleteIndicatorPluginKey);
			if (predeleteMeta) setPredelete(!!predeleteMeta.highlight);
			const table = findTable(transaction.selection);
			if (table?.pos === pos && table?.node) {
				setIsEditing(true);
				const map = TableMap.get(table.node);
				const newSelectedRows = [];
				const newSelectedColumns = [];
				for (let row = 0; row < map.height; row++) if (isRowSelected(row)(selection)) newSelectedRows.push(row);
				for (let col = 0; col < map.width; col++) if (isColumnSelected(col)(selection)) newSelectedColumns.push(col);
				setSelectedRows(newSelectedRows);
				setSelectedColumns(newSelectedColumns);
				setIsSelected(isTableSelected(selection));
			} else {
				setIsEditing(false);
				setSelectedRows([]);
				setSelectedColumns([]);
				setIsSelected(false);
			}
		};
		editor.on("transaction", handleResize);
		return () => {
			editor?.off("transaction", handleResize);
		};
	}, [
		editor,
		node,
		tableRef,
		getPos
	]);
	return {
		colWidths,
		rowHeights,
		tableRect,
		isResizing,
		isEditing,
		isSelected,
		selectedColumns,
		selectedRows,
		predelete
	};
};
//#endregion
//#region src/extensions/table/components/TableControl.tsx
/**
* Table control component for selecting & inserting column/rows
*/
function TableControl(props) {
	const { editor, tableRef, node } = props;
	const columnControlRef = useRef(null);
	const rowControlRef = useRef(null);
	const expandTableControlRef = useRef(null);
	const handleKeyboardShortcut = useCallback((e) => {
		if (e.altKey && e.code === "KeyC") columnControlRef.current?.focus();
		else if (e.altKey && e.code === "KeyR") rowControlRef.current?.focus();
		else if (e.altKey && e.code === "KeyA") expandTableControlRef.current?.focus();
	}, []);
	const { colWidths, rowHeights, tableRect, isEditing, isResizing, isSelected, predelete, selectedColumns, selectedRows } = useTableControl(props);
	useEffect(() => {
		if (isEditing && editor.isFocused) {
			document.addEventListener("keydown", handleKeyboardShortcut);
			return () => document.removeEventListener("keydown", handleKeyboardShortcut);
		}
	}, [
		isEditing,
		editor.isFocused,
		handleKeyboardShortcut
	]);
	if (!tableRef.current || !tableRect || isResizing || !isEditing) return null;
	const { marginTop } = getComputedStyle(tableRef.current);
	return /* @__PURE__ */ jsxs(TableControlWrapper, {
		contentEditable: false,
		style: {
			"--tableTop": `${tableRect.top}px`,
			"--tableWidth": `${tableRect.width}px`,
			"--tableHeight": `${tableRect.height}px`,
			"--tableMarginTop": `${marginTop}`
		},
		onKeyDown: (e) => {
			if (e.key === "Escape") editor.commands.focus();
			if (e.code === "KeyM" && e.altKey) document.getElementById("editor-table-menu")?.focus();
		},
		children: [
			/* @__PURE__ */ jsx(TableSelectAll, {
				"aria-keyshortcuts": "Alt+T",
				"aria-label": "Select the whole table",
				selected: isSelected,
				predelete,
				onClick: (e) => {
					e.preventDefault();
					e.nativeEvent.stopImmediatePropagation();
					editor.commands.selectTable();
				}
			}),
			/* @__PURE__ */ jsx(TableColumnControlGroup, {
				ref: columnControlRef,
				selectedColumns,
				predelete,
				colWidths,
				editor
			}),
			/* @__PURE__ */ jsx(TableRowControlGroup, {
				ref: rowControlRef,
				selectedRows,
				predelete,
				rowHeights,
				editor
			}),
			/* @__PURE__ */ jsxs(Toolbar.Root, {
				ref: expandTableControlRef,
				"aria-label": "Expand table",
				"aria-keyshortcuts": "Alt+A",
				orientation: "vertical",
				children: [/* @__PURE__ */ jsx(Toolbar.Button, {
					asChild: true,
					children: /* @__PURE__ */ jsx(TableInsertRowAfter, {
						"aria-label": "Add new row",
						onClick: (e) => {
							e.preventDefault();
							e.nativeEvent.stopImmediatePropagation();
							const map = TableMap.get(node);
							editor.commands.addRowAt(map.height);
						},
						onFocus: () => {
							const map = TableMap.get(node);
							editor.commands.preinsertRow(map.height);
						},
						onBlur: () => {
							editor.commands.preinsertRow();
						},
						onMouseEnter: () => {
							const map = TableMap.get(node);
							editor.commands.preinsertRow(map.height);
						},
						onMouseLeave: () => {
							editor.commands.preinsertRow();
						}
					})
				}), /* @__PURE__ */ jsx(Toolbar.Button, {
					asChild: true,
					children: /* @__PURE__ */ jsx(TableInsertColumnAfter, {
						"aria-label": "Add new column",
						onClick: (e) => {
							e.preventDefault();
							e.nativeEvent.stopImmediatePropagation();
							const map = TableMap.get(node);
							editor.commands.addColumnAt(map.width);
						},
						onFocus: () => {
							const map = TableMap.get(node);
							editor.commands.preinsertCol(map.width);
						},
						onBlur: () => {
							editor.commands.preinsertCol();
						},
						onMouseEnter: () => {
							const map = TableMap.get(node);
							editor.commands.preinsertCol(map.width);
						},
						onMouseLeave: () => {
							editor.commands.preinsertCol();
						}
					})
				})]
			})
		]
	});
}
const controlFocus = css`
  &:focus {
    &::after {
      ${(p) => p.theme.focus}
      z-index: 1;
    }
  }
`;
const TableControlWrapper = styled.div`
  position: absolute;
  width: calc(var(--tableWidth) + 36px);
  height: calc(var(--tableHeight) + 36px);
  top: calc(var(--tableMarginTop) - 18px);
  left: -18px;
`;
const TableSelectAll = styled.button`
  position: absolute;
  padding: 0;
  border: none;
  left: 21px;
  top: 21px;
  &::after {
    content: "";
    cursor: pointer;
    width: 10px;
    height: 10px;
    border: 1px solid #c3cddf;
    box-sizing: border-box;
    border-radius: 2px;
    position: absolute;
    top: -13px;
    left: -13px;
    background: ${(p) => getHandleColor(p)};
  }

  ${controlFocus}

  &:hover::after {
    background: ${colors.grey200};
  }
`;
const TableInsertColumnAfter = styled.button`
  position: absolute;
  top: 8px;
  width: 16px;
  font-size: 12px;
  left: calc(var(--tableWidth) + 20px);
  height: calc(var(--tableHeight) + 28px);
  padding: 0;
  border: none;

  &:focus {
    outline: none;
  }

  &::after {
    content: "+";
    cursor: pointer;
    position: relative;
    color: ${colors.grey500};
    font-weight: 900;
    background: #f4f5f8;
    border: 1px solid #f4f5f8;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0px 2px 2px 0px;
    width: 100%;
    height: 100%;
  }

  ${controlFocus}

  &:hover::after {
    background: ${colors.indigo500};
    border: 1px solid ${colors.indigo500};
    color: white;
  }
`;
const TableInsertRowAfter = styled.button`
  position: absolute;
  height: 16px;
  font-size: 12px;
  left: 8px;
  padding: 0;
  border: none;
  top: calc(var(--tableHeight) + 20px);
  width: calc(var(--tableWidth) + 10px);
  &::after {
    content: "+";
    cursor: pointer;
    position: relative;
    color: ${colors.grey500};
    font-weight: 900;
    background: #f4f5f8;
    border: 1px solid #f4f5f8;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 0px 0px 0px 2px;
    width: 100%;
    height: 100%;
  }

  &:focus {
    outline: none;
  }

  ${controlFocus}

  &:hover::after {
    background: ${colors.indigo500};
    border: 1px solid ${colors.indigo500};
    color: white;
  }
`;
function getHandleColor(props) {
	const { predelete, selected } = props;
	if (predelete && selected) return colors.red500;
	if (selected) return colors.indigo500;
	return "#f4f5f8";
}
/**
* Table Column selection, insert Column before handle
*/
const TableColumnControlGroup = forwardRef(function(props, ref) {
	const { editor, colWidths, selectedColumns, predelete, ...rest } = props;
	if (!colWidths) return null;
	return /* @__PURE__ */ jsx(TableColumnControlGroupWrapper, {
		ref,
		orientation: "horizontal",
		"aria-label": "Column menu",
		"aria-keyshortcuts": "Alt+C",
		...rest,
		children: colWidths.map((width, index) => /* @__PURE__ */ jsxs(TableColumnControl, {
			style: { width },
			children: [/* @__PURE__ */ jsx(Toolbar.Button, {
				asChild: true,
				children: /* @__PURE__ */ jsx(TableColumnInsertBeforeControl, {
					"aria-label": `Insert new column as column ${index + 1}`,
					onClick: (e) => {
						e.preventDefault();
						e.nativeEvent.stopImmediatePropagation();
						editor.commands.addColumnAt(index);
					},
					onFocus: () => {
						editor.commands.preinsertCol(index);
					},
					onBlur: () => {
						editor.commands.preinsertCol();
					},
					onMouseEnter: () => {
						editor.commands.preinsertCol(index);
					},
					onMouseLeave: () => {
						editor.commands.preinsertCol();
					}
				})
			}), /* @__PURE__ */ jsx(Toolbar.Button, {
				asChild: true,
				children: /* @__PURE__ */ jsx(TableColumnGripControl, {
					"aria-label": `Select column ${index + 1}`,
					onClick: (e) => {
						e.preventDefault();
						e.nativeEvent.stopImmediatePropagation();
						editor.commands.selectColumn(index);
					},
					predelete,
					selected: selectedColumns.includes(index),
					first: index === 0,
					last: index === colWidths.length - 1
				})
			})]
		}, index))
	});
});
const TableColumnControlGroupWrapper = styled(Toolbar.Root)`
  display: flex;
  flex-direction: row;
  height: 18px;
  position: absolute;
  border-collapse: collapse;
  left: 18px;
`;
const TableColumnControl = styled.div`
  position: relative;
`;
const TableColumnGripControl = styled.button`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-grow: 1;
  padding: 0;
  border: none;

  &::after {
    content: "${(p) => p.selected || p.predelete ? "⋯" : " "}";
    color: ${(p) => p.selected || p.predelete ? "white" : "inherit"};
    cursor: pointer;
    width: calc(100% - ${(p) => p.first ? "3" : "2"}px);
    height: 8px;
    background: ${(p) => getHandleColor(p)};
    border-top: 1px solid ${(p) => getHandleColor(p)};
    border-bottom: 1px solid ${(p) => getHandleColor(p)};
    border-left: ${(p) => p.first ? "2px" : "1px"} solid
      ${(p) => getHandleColor(p)};
    border-right: ${(p) => p.last ? "2px" : "1px"} solid
      ${(p) => getHandleColor(p)};
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    font-size: 18px;
    line-height: 8px;
    position: absolute;
    top: -10px;
    border-radius: 2px 2px 0px 0px;
  }

  ${controlFocus}

  ${(p) => !p.selected && css`
      &:hover::after,
      &:focus::after {
        content: "⋯";
        background: ${colors.grey200};
        border-color: transparent;
        color: ${colors.grey500};
      }
    `}
`;
const TableColumnInsertBeforeControl = styled.button`
  padding: 0;
  border: none;

  &::after {
    content: " ";
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    width: 4px;
    height: 4px;
    background: ${colors.grey500};
    font-weight: 900;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    line-height: 16px;
    color: white;
    position: absolute;
    left: -2px;
    bottom: 15px;
  }

  ${controlFocus}

  &:hover::after {
    content: "+";
    background: ${colors.indigo500};
    width: 16px;
    height: 16px;
    left: -8px;
    top: -9px;
  }
`;
/**
* Table Row selection, insert Row before handle
*/
const TableRowControlGroup = forwardRef(function(props, ref) {
	const { editor, rowHeights, selectedRows, predelete, ...rest } = props;
	if (!rowHeights) return null;
	return /* @__PURE__ */ jsx(TableRowControlGroupWrapper, {
		ref,
		orientation: "vertical",
		"aria-label": "Row menu",
		"aria-keyshortcuts": "Alt+R",
		...rest,
		children: rowHeights.map((height, index) => /* @__PURE__ */ jsxs(TableRowControl, {
			style: { height },
			children: [/* @__PURE__ */ jsx(Toolbar.Button, {
				asChild: true,
				children: /* @__PURE__ */ jsx(TableRowInsertBeforeControl, {
					"aria-label": `Insert new row as row ${index + 1}`,
					onClick: (e) => {
						e.preventDefault();
						e.nativeEvent.stopImmediatePropagation();
						editor.commands.addRowAt(index);
					},
					onFocus: () => {
						editor.commands.preinsertRow(index);
					},
					onBlur: () => {
						editor.commands.preinsertRow();
					},
					onMouseEnter: () => {
						editor.commands.preinsertRow(index);
					},
					onMouseLeave: () => {
						editor.commands.preinsertRow();
					}
				})
			}), /* @__PURE__ */ jsx(StyledToolbarButton, {
				asChild: true,
				children: /* @__PURE__ */ jsx(TableRowGripControl, {
					"aria-label": `Select row ${index + 1}`,
					onClick: (e) => {
						e.preventDefault();
						e.nativeEvent.stopImmediatePropagation();
						editor.commands.selectRow(index);
					},
					predelete,
					selected: selectedRows.includes(index),
					first: index === 0,
					last: index === rowHeights.length - 1
				})
			})]
		}, index))
	});
});
const TableRowControlGroupWrapper = styled(Toolbar.Root)`
  display: flex;
  flex-direction: column;
  width: 18px;
  position: absolute;
  top: 18px;
  border-collapse: collapse;
`;
const StyledToolbarButton = styled(Toolbar.Button)`
  outline: none;
`;
const TableRowControl = styled.div`
  position: relative;
`;
const TableRowGripControl = styled.button`
  position: absolute;
  right: 0;
  height: 100%;
  display: flex;
  flex-grow: 1;
  padding: 0;
  top: 0;
  border: none;

  &::after {
    right: 0;
    position: absolute;
    content: "${(p) => p.selected || p.predelete ? "⋯" : " "}";
    color: ${(p) => p.selected || p.predelete ? "white" : "inherit"};
    cursor: pointer;
    width: 8px;
    background: ${(p) => getHandleColor(p)};
    border-top: ${(p) => p.first ? "2px" : "1px"} solid
      ${(p) => getHandleColor(p)};
    border-bottom: ${(p) => p.last ? "2px" : "1px"} solid
      ${(p) => getHandleColor(p)};
    border-left: 1px solid ${(p) => getHandleColor(p)};
    border-right: 1px solid ${(p) => getHandleColor(p)};
    writing-mode: vertical-rl;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    align-self: center;
    font-size: 18px;
    height: calc(100% - ${(p) => p.first || p.last ? "3" : "2"}px);
    border-radius: 2px 0px 0px 2px;
  }

  ${controlFocus}

  ${(p) => !p.selected && css`
      &:hover::after,
      &:focus::after {
        content: "⋯";
        background: ${colors.grey200};
        border-color: transparent;
        color: ${colors.grey500};
        writing-mode: vertical-rl;
      }
    `}
`;
const TableRowInsertBeforeControl = styled.button`
  padding: 0;
  border: none;

  &::after {
    content: " ";
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    width: 4px;
    height: 4px;
    background: ${colors.grey500};
    font-weight: 900;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    top: -2px;
    line-height: 16px;
    color: white;
  }

  ${controlFocus}

  &:hover::after {
    content: "+";
    background: ${colors.indigo500};
    width: 16px;
    height: 16px;
    left: -9px;
    top: -6px;
  }
`;
//#endregion
//#region src/extensions/table/components/TableComponent.tsx
/**
* Table React Nodeview component.
*/
function TableComponent(props) {
	const { node, editor, getPos } = props;
	const [colWidths, setColWidths] = useState([]);
	const [totalWidth, setTotalWidth] = useState(0);
	const tableRef = useRef(null);
	useEffect(() => {
		const row = node.firstChild;
		if (row) {
			const newColWidths = [];
			let newTotalWidths = 0;
			for (let i = 0, col = 0; i < row.childCount; i += 1) {
				const { colspan, colwidth } = row.child(i).attrs;
				for (let j = 0; j < colspan; j += 1, col += 1) {
					const colWidth = (colwidth && colwidth[j]) ?? 50;
					newTotalWidths += colWidth;
					newColWidths.push(colWidth);
				}
			}
			setColWidths(newColWidths);
			if (newTotalWidths < 800) setTotalWidth(newTotalWidths);
			else setTotalWidth(800);
		}
	}, [node]);
	return /* @__PURE__ */ jsx(NodeViewWrapper, { children: /* @__PURE__ */ jsx(Root, { children: /* @__PURE__ */ jsx(ScollableWrapper, { children: /* @__PURE__ */ jsxs(Component, { children: [editor.isEditable && /* @__PURE__ */ jsx(TableControl, {
		editor,
		tableRef,
		node,
		colNum: colWidths.length,
		getPos
	}), /* @__PURE__ */ jsxs("table", {
		ref: tableRef,
		"data-table-alternate-background": props.node.attrs.alternateBackground,
		"data-cadmus-background-color": props.node.attrs.backgroundColor,
		style: {
			display: "inline-block",
			width: totalWidth,
			maxWidth: 756,
			"--background-color": props.node.attrs.backgroundColor
		},
		children: [/* @__PURE__ */ jsx("colgroup", { children: colWidths.map((colWidth, index) => /* @__PURE__ */ jsx("col", { style: { width: colWidth } }, index)) }), /* @__PURE__ */ jsx(NodeViewContent, { as: "tbody" })]
	})] }) }) }) });
}
const Root = styled.div`
  display: flex;
  justify-content: center;
`;
const ScollableWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
  padding: 0px ${44 / 2}px;
`;
const Component = styled.div`
  position: relative;
  display: inline-block;
  margin-top: 20px;
`;
//#endregion
//#region src/extensions/table/components/styles.tsx
const ButtonGroups = styled(Toolbar.Root)`
  background: white;
  box-shadow: ${levels.two};
  display: inline-flex;
  align-items: center;
`;
const GroupDivider = styled(Toolbar.Separator)`
  &:not(:last-child) {
    display: inline-flex;
    width: 1px;
    height: 20px;
    background: rgba(89, 115, 166, 0.15);
    margin: 7px 2px;
  }
`;
//#endregion
//#region src/extensions/table/components/BlockMenu.tsx
/**
* Table's Footnote and Caption toggle Menu Items
*/
function BlockMenu(props) {
	const { editor } = props;
	const { canHideCaption, canHideFootnote } = useEditorState({
		editor,
		selector: (ctx) => ({
			canHideCaption: ctx.editor.can().hideTableCaption(),
			canHideFootnote: ctx.editor.can().hideTableFootnote()
		})
	});
	if (!isSelectionType(editor.state.selection, "text")) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(Toolbar.Button, {
			asChild: true,
			children: /* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "Toggle Table Caption",
				iconName: "Caption",
				selected: canHideCaption,
				onClick: () => editor.chain().toggleTableCaption().focus().run()
			})
		}),
		/* @__PURE__ */ jsx(Toolbar.Button, {
			asChild: true,
			children: /* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "Toggle Table Footnotes ",
				iconName: "Footer",
				selected: canHideFootnote,
				onClick: () => editor.chain().toggleTableFootnote().focus().run()
			})
		}),
		/* @__PURE__ */ jsx(GroupDivider, {})
	] });
}
//#endregion
//#region src/extensions/table/components/BorderMenu.tsx
/**
* Table Border Menu's dropdown
*/
function BorderMenu(props) {
	const { editor } = props;
	const { shouldShow } = useEditorState({
		editor,
		selector: (ctx) => ({ shouldShow: isSelectionInsideTable(ctx.editor.state.selection) })
	});
	if (!shouldShow) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs(DropdownMenu.Root, { children: [/* @__PURE__ */ jsx(Toolbar.Button, {
		asChild: true,
		children: /* @__PURE__ */ jsx(DropdownMenu.Trigger, {
			asChild: true,
			children: /* @__PURE__ */ jsx(ControlButton, {
				iconName: "BorderBottom",
				"aria-label": "Borders"
			})
		})
	}), /* @__PURE__ */ jsx(DropdownMenu.Content, { children: /* @__PURE__ */ jsx(BorderDropDownContent, { editor }) })] }), /* @__PURE__ */ jsx(GroupDivider, {})] });
}
/**
* Table Border Menu's dropdown menu items
*/
function BorderDropDownContent(props) {
	const { editor } = props;
	const { haveTop, haveBottom, haveAll } = useEditorState({
		editor,
		selector: (ctx) => ({
			haveTop: haveTableBorderStyle(ctx.editor.state, "top"),
			haveBottom: haveTableBorderStyle(ctx.editor.state, "bottom"),
			haveAll: haveTableBorderStyle(ctx.editor.state, "all")
		})
	});
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(BorderItem, {
			onClick: () => editor.commands.setTableCellBorder("all", true),
			active: haveAll,
			ariaLabel: "Apply border to all sides",
			iconName: "BorderAll",
			text: "All borders"
		}),
		/* @__PURE__ */ jsx(DropdownMenu.Separator, {}),
		/* @__PURE__ */ jsx(DropdownMenu.Label, { children: /* @__PURE__ */ jsx(Text, {
			kind: "bodySm",
			color: "grey500",
			style: { fontWeight: 400 },
			children: "APA Style"
		}) }),
		/* @__PURE__ */ jsx(BorderItem, {
			onClick: () => editor.commands.setTableCellBorder("all", false),
			ariaLabel: "Remove borders",
			iconName: "BorderNone",
			text: "Remove borders"
		}),
		/* @__PURE__ */ jsx(BorderItem, {
			onClick: () => editor.commands.setTableCellBorder("top", !haveTop),
			active: haveTop,
			ariaLabel: "Toggle border top",
			iconName: "BorderTop",
			text: "Top Border"
		}),
		/* @__PURE__ */ jsx(BorderItem, {
			onClick: () => editor.commands.setTableCellBorder("bottom", !haveBottom),
			active: haveBottom,
			ariaLabel: "Toggle border bottom",
			iconName: "BorderBottom",
			text: "Bottom Border"
		}),
		/* @__PURE__ */ jsx(BorderInsideHorizontalMenu, { editor })
	] });
}
/**
* Table Border Menu's dropdown menu item for inside horizontal
* border toggle. only shows when selection allows to set an
* insideHorizontal border
*/
function BorderInsideHorizontalMenu(props) {
	const { editor } = props;
	if (!editor.can().setTableCellBorder("insideHorizontal", true) && !editor.can().setTableCellBorder("insideHorizontal", false)) return null;
	const isActive = haveTableBorderStyle(editor.state, "insideHorizontal");
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(DropdownMenu.Separator, {}), /* @__PURE__ */ jsx(BorderItem, {
		onClick: () => isActive ? editor.commands.setTableCellBorder("insideHorizontal", false) : editor.commands.setTableCellBorder("insideHorizontal", true),
		active: isActive,
		ariaLabel: "Toggle horizontal inside borders",
		iconName: "BorderInsideHorizontal",
		text: "Horizontal Inside Border"
	})] });
}
function BorderItem(props) {
	const { iconName, active, text, onClick, ariaLabel } = props;
	return /* @__PURE__ */ jsx(DropdownMenu.CheckboxItem, {
		onSelect: (e) => {
			e.preventDefault();
			onClick();
		},
		checked: active,
		tickable: true,
		iconName,
		"aria-label": ariaLabel,
		children: /* @__PURE__ */ jsx(Text, {
			kind: "bodySm",
			color: active ? "lilac500" : void 0,
			bold: active,
			children: text
		})
	});
}
//#endregion
//#region src/extensions/table/components/FormatRowColor.tsx
/**
* Shared Table menu item for cell/table color
*/
function FormatRowColor(props) {
	const { editor, isCell, activeColor } = props;
	return /* @__PURE__ */ jsxs(ItemsContainer, {
		"aria-label": "Set Color",
		value: activeColor ?? "unset",
		children: [/* @__PURE__ */ jsx(ColorButtonGroups, { children: tableColors.map(({ button, actual }, index) => {
			return /* @__PURE__ */ jsx(StyledRadioItem, {
				value: actual,
				"aria-label": actual,
				asChild: true,
				children: /* @__PURE__ */ jsx(ColorButton, {
					color: button,
					selected: activeColor === actual,
					onClick: (e) => {
						e.preventDefault();
						e.nativeEvent.stopImmediatePropagation();
						return isCell ? editor.chain().setCellsBackground(actual).focus().run() : editor.chain().setTableColor(actual).focus().run();
					}
				})
			}, index);
		}) }), /* @__PURE__ */ jsxs(FormatMenuButton, { children: [/* @__PURE__ */ jsx(GroupDivider, {}), /* @__PURE__ */ jsx(StyledRadioItem, {
			value: "unset",
			"aria-label": "without color",
			asChild: true,
			children: /* @__PURE__ */ jsx(UnsetButton, {
				"aria-label": "Remove alternate table background",
				onMouseDown: (e) => {
					e.preventDefault();
					e.nativeEvent.stopImmediatePropagation();
					if (isCell) editor.chain().setCellsBackground().focus().run();
					else editor.chain().toggleTableAlternateColor().focus().run();
				},
				children: /* @__PURE__ */ jsx(Icon$1, { iconName: "Unset" })
			})
		})] })]
	});
}
const UnsetButton = styled(IconButton)`
  width: 28px;
  height: 28px;
`;
const FormatMenuButton = styled.div`
  height: 100%;
  display: inline-flex;
  align-items: center;
`;
const ItemsContainer = styled(DropdownMenu.RadioGroup)`
  display: flex;
  height: 32px;
  flex-grow: 1;
  align-items: center;
  gap: 4px;
  margin: 0 8px;
  align-items: center;
`;
const ColorButtonGroups = styled(ButtonGroups)`
  box-shadow: none;
  padding: 0px 4px;
  gap: 8px;
`;
const StyledRadioItem = styled(DropdownMenu.RadioItem)`
  outline: none;
`;
const ColorButton = styled.button`
  display: inline-flex;
  width: 16px;
  height: 16px;
  padding: 0px;

  border-radius: 50%;
  border: 4px solid transparent;
  background: ${(p) => p.color};
  position: relative;

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: -7px;
    left: -7px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid
      ${(p) => p.selected ? p.theme.text.accent : "transparent"};
  }

  &:disabled {
    opacity: 0.36;
  }

  &:focus {
    ${(p) => p.theme.focus}
    z-index: 1;
  }

  &:hover {
    cursor: pointer;
  }
`;
//#endregion
//#region src/extensions/table/components/CellColorMenu.tsx
/**
* Table Menu component for applying background color to selected cell(s)
*/
function CellColorMenu(props) {
	const { editor } = props;
	if (!isSelectionType(editor.state.selection, "cell")) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs(DropdownMenu.Root, { children: [/* @__PURE__ */ jsx(Toolbar.Button, {
		asChild: true,
		children: /* @__PURE__ */ jsx(DropdownMenu.Trigger, {
			asChild: true,
			children: /* @__PURE__ */ jsx(ControlButton, {
				iconName: "Paint",
				"aria-label": "Colour"
			})
		})
	}), /* @__PURE__ */ jsx(DropdownMenu.Content, { children: /* @__PURE__ */ jsx(CellColorDropDownContent, { editor }) })] }), /* @__PURE__ */ jsx(GroupDivider, {})] });
}
function CellColorDropDownContent(props) {
	const { editor } = props;
	const { activeColor } = useEditorState({
		editor,
		selector: (ctx) => ({ activeColor: cellsColor(ctx.editor.state) })
	});
	return /* @__PURE__ */ jsx(FormatRowColor, {
		isCell: true,
		activeColor,
		editor
	});
}
//#endregion
//#region src/extensions/table/components/DeleteMenu.tsx
/**
* Table selection Delete menu item. on Hover, it will show
* a visual guide on which row(s)/column(s)/table will be removed
*/
function DeleteMenu(props) {
	const { editor } = props;
	const { selection } = useEditorState({
		editor,
		selector: (ctx) => ({ selection: ctx.editor.state.selection })
	});
	if (!isSelectionType(selection, "cell")) return null;
	const cellSelection = selection;
	if (!(cellSelection.isRowSelection() || cellSelection.isColSelection() || isTableSelected(editor.state.selection))) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Toolbar.Button, {
		asChild: true,
		children: /* @__PURE__ */ jsx(ControlButton, {
			"aria-label": "Delete",
			iconName: "Trash",
			onClick: () => editor.chain().deleteSelectedTable().focus().run(),
			onMouseEnter: () => editor.commands.predeleteHighlightTable(true),
			onMouseLeave: () => editor.commands.predeleteHighlightTable(false)
		})
	}), /* @__PURE__ */ jsx(GroupDivider, {})] });
}
//#endregion
//#region src/extensions/table/components/FormatMenu.tsx
/**
* Table Menu Dropdown for header row/column & alternating row color
*/
function FormatMenu(props) {
	const { editor } = props;
	if (!isSelectionInsideTable(editor.state.selection)) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs(DropdownMenu.Root, { children: [/* @__PURE__ */ jsx(Toolbar.Button, {
		asChild: true,
		children: /* @__PURE__ */ jsx(DropdownMenu.Trigger, {
			asChild: true,
			children: /* @__PURE__ */ jsx(StyledControlButton, {
				withDownCaret: true,
				iconName: "PaintRoller",
				"aria-label": "Format Table",
				children: "Format"
			})
		})
	}), /* @__PURE__ */ jsx(DropdownMenu.Content, { children: /* @__PURE__ */ jsx(FormatDropDownContent, { editor }) })] }), /* @__PURE__ */ jsx(GroupDivider, {})] });
}
const StyledControlButton = styled(ControlButton)`
  ${ControlButtonText} {
    min-width: 50px;
    display: inline-flex;
    align-items: center;
    color: ${colors.grey500};
    font-weight: 600;
  }
`;
function FormatDropDownContent(props) {
	const { editor } = props;
	const { hasRowHeader, hasColumnHeader } = useEditorState({
		editor,
		selector: (ctx) => ({
			hasRowHeader: hasHeaderRow(ctx.editor.state),
			hasColumnHeader: hasHeaderColumn(ctx.editor.state)
		})
	});
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(DropdownMenu.CheckboxItem, {
			toggleable: true,
			iconName: "HeaderRow",
			"aria-label": "toggle header row",
			checked: hasRowHeader,
			onSelect: (e) => {
				e.preventDefault();
				editor.commands.toggleHeaderRow();
			},
			children: /* @__PURE__ */ jsx(Text, {
				kind: "bodySm",
				color: "grey500",
				children: "Header Row"
			})
		}, "HeaderRow"),
		/* @__PURE__ */ jsx(DropdownMenu.CheckboxItem, {
			toggleable: true,
			iconName: "HeaderColumn",
			"aria-label": "toggle header column",
			checked: hasColumnHeader,
			onSelect: (e) => {
				e.preventDefault();
				editor.commands.toggleHeaderColumn();
			},
			children: /* @__PURE__ */ jsx(Text, {
				kind: "bodySm",
				color: "grey500",
				children: "Header Column"
			})
		}, "HeaderColumn"),
		/* @__PURE__ */ jsx(DropdownMenu.Separator, {}),
		/* @__PURE__ */ jsx(FormatRowAlternateColor, { editor })
	] });
}
function FormatRowAlternateColor(props) {
	const { editor } = props;
	const { alternate, activeColor } = useEditorState({
		editor,
		selector: (ctx) => ({
			alternate: hasAlternateColor(ctx.editor.state),
			activeColor: tableColor(ctx.editor.state)
		})
	});
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(DropdownMenu.CheckboxItem, {
		toggleable: true,
		checked: alternate,
		onSelect: (e) => {
			e.preventDefault();
			editor.commands.toggleTableAlternateColor();
		},
		iconName: "Paint",
		"aria-label": "alternate row colour",
		children: /* @__PURE__ */ jsx(Text, {
			kind: "bodySm",
			color: "grey500",
			children: "Alternating row colour"
		})
	}), alternate && /* @__PURE__ */ jsx(FormatRowColor, {
		activeColor,
		editor
	})] });
}
//#endregion
//#region src/extensions/table/components/MergeSplitMenu.tsx
/**
* Table Menu item for merge/split cell(s)
*/
function MergeSplitMenu(props) {
	const { editor } = props;
	const { canMerge, canSplit, canMergeOrSplit } = useEditorState({
		editor,
		selector: (ctx) => ({
			canMergeOrSplit: ctx.editor.can().mergeOrSplit(),
			canMerge: ctx.editor.can().mergeCells(),
			canSplit: ctx.editor.can().splitCell()
		})
	});
	if (!canMergeOrSplit) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		canMerge && /* @__PURE__ */ jsx(Toolbar.Button, {
			asChild: true,
			children: /* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "Merge cells",
				iconName: "MergeCells",
				onClick: () => editor.chain().mergeCells().focus().run()
			})
		}),
		canSplit && /* @__PURE__ */ jsx(Toolbar.Button, {
			asChild: true,
			children: /* @__PURE__ */ jsx(ControlButton, {
				"aria-label": "Split Cell",
				iconName: "SplitCells",
				onClick: () => editor.chain().splitCell().focus().run()
			})
		}),
		/* @__PURE__ */ jsx(GroupDivider, {})
	] });
}
//#endregion
//#region src/extensions/table/components/TableMenu.tsx
/**
* Table Menu tippy component
*/
function TableMenuComponent(props) {
	const { editor, portalId } = props;
	return /* @__PURE__ */ jsx(FloatingMenuComponent, {
		pluginKey: "tableFloatingMenu",
		editor,
		shouldShow: useCallback(({ state }) => {
			return isSelectionInsideTableGroup(state.selection);
		}, []),
		getBoundingClientRect: useCallback(() => {
			const { state } = editor.view;
			const { selection } = state;
			const tableGroup = findTableGroup(selection);
			const { ranges } = selection;
			const from = Math.min(...ranges.map((range) => range.$from.pos));
			const to = Math.max(...ranges.map((range) => range.$to.pos));
			if (tableGroup) {
				const { table_caption: tableCaptionType } = getTableNodeTypes(state.schema);
				const tableCaption = findChildren(tableGroup.node, (node) => node.type === tableCaptionType)[0];
				const captionOffset = tableCaption && tableCaption.node.attrs.hideText ? tableCaption.node.nodeSize + 2 : 0;
				return posToDOMRect(editor.view, tableGroup.start + captionOffset, tableGroup.pos + tableGroup.node.nodeSize);
			}
			return posToDOMRect(editor.view, from, to);
		}, [editor]),
		portalId,
		isAsync: true,
		mainAxisOffset: 25,
		children: /* @__PURE__ */ jsx(MenuWrapper, { children: /* @__PURE__ */ jsxs(ButtonGroups, {
			id: "editor-table-menu",
			"aria-label": "Table menu",
			onKeyDown: (e) => {
				if (e.key === "Escape") editor.commands.focus();
			},
			"aria-keyshortcuts": "Alt+ArrowDown",
			children: [
				/* @__PURE__ */ jsx(CellColorMenu, { editor }),
				/* @__PURE__ */ jsx(BlockMenu, { editor }),
				/* @__PURE__ */ jsx(FormatMenu, { editor }),
				/* @__PURE__ */ jsx(MergeSplitMenu, { editor }),
				/* @__PURE__ */ jsx(BorderMenu, { editor }),
				/* @__PURE__ */ jsx(DeleteMenu, { editor })
			]
		}) })
	});
}
const MenuWrapper = styled.div`
  display: inline-flex;
  background: transparent;
  border: none;
  outline: none;
  width: 500px;
  justify-content: center;
  align-items: center;
`;
//#endregion
//#region src/extensions/table/extensions/nodes/table.ts
/**
* Table Node extension that extend @tiptap/extension-table
* With the addition of using Cadmus' own NodeView using react
* and also Row(s) & Column(s) selection, deletion and insertion control
*/
const Table$2 = Table.extend({
	selectable: false,
	group: "tableBlock",
	renderHTML({ node, HTMLAttributes }) {
		const firstRow = node.firstChild;
		let tableWidth = this.options.cellMinWidth;
		const colWidths = [];
		if (firstRow) {
			for (let i = 0, col = 0; i < firstRow.childCount; i += 1) {
				const { colspan = 0, colwidth } = firstRow.child(i).attrs;
				for (let j = 0; j < colspan; j += 1, col += 1) {
					const width = (colwidth && colwidth[j]) ?? this.options.cellMinWidth;
					tableWidth += width;
					colWidths.push(width);
				}
			}
			if (tableWidth > 800) tableWidth = 800;
		}
		const colgroups = colWidths.map((width) => ["col", { style: `width: ${width}px;` }]);
		const { style = "" } = HTMLAttributes;
		return [
			"table",
			mergeAttributes$1(this.options.HTMLAttributes, {
				...HTMLAttributes,
				style: `${style};width: ${tableWidth}px;`
			}),
			["colgroup", ...colgroups || []],
			["tbody", ["div", 0]]
		];
	},
	addProseMirrorPlugins() {
		return [
			columnResizing({
				editor: this.editor,
				handleWidth: this.options.handleWidth,
				cellMinWidth: this.options.cellMinWidth,
				lastColumnResizable: this.options.lastColumnResizable
			}),
			tableEditing({ allowTableNodeSelection: this.options.allowTableNodeSelection }),
			TableControlPlugin({ editor: this.editor })
		];
	},
	addKeyboardShortcuts() {
		return {
			"Alt-ArrowDown": () => {
				document.getElementById("editor-table-menu")?.focus();
				return true;
			},
			"Alt-t": () => {
				this.editor.commands.selectTable();
				return true;
			}
		};
	},
	addNodeView() {
		return ReactNodeViewRenderer(TableComponent);
	}
});
//#endregion
//#region src/extensions/table/extensions/nodes/table-caption.ts
/**
* Table caption Node extension which extend Caption Node extension
* Restricted to table_block group instead of block so that it can only appear inside tableGroup
*/
const TableCaption = Node$1.create({
	name: "caption",
	addOptions() {
		return {
			HTMLAttributes: {},
			placeholderText: "Please enter your caption here..."
		};
	},
	content: "paragraph+",
	isolating: true,
	onCreate() {
		const { type, options, editor } = this;
		const { storage } = editor;
		const { placeholderText } = options;
		storage.placeholder?.placeholders?.set(this.name, {
			/**
			* Display the placeholder for caption if it has empty text content
			* and not in focus
			*/
			check: (selection, node, pos) => {
				if (node.type.name !== type.name) return false;
				const nodeStart = pos;
				const nodeEnd = pos + node.nodeSize;
				const { from, to } = selection;
				if (from >= nodeStart && from <= nodeEnd || to <= nodeEnd && to >= nodeStart) return false;
				if (node.textContent === "") return true;
				return false;
			},
			decoration: (node, pos) => {
				const child = node.firstChild;
				if (!child) return null;
				return Decoration.node(pos + 1, pos + 1 + child.nodeSize, {
					class: "empty-node",
					"data-placeholder-text": placeholderText
				});
			}
		});
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"figcaption",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	parseHTML() {
		return [{ tag: "figcaption" }];
	}
}).extend({
	name: "tableCaption",
	tableRole: "table_caption",
	group: "table_block",
	isolating: true,
	addOptions() {
		return {
			...this?.parent?.(),
			placeholderText: "Add table title..."
		};
	},
	addCommands() {
		return {
			toggleTableCaption: () => ({ commands, state }) => {
				const tableGroup = findTableGroup(state.selection);
				if (tableGroup) return commands.toggleShowText(tableGroup.pos, this.type.name);
				return false;
			},
			hideTableCaption: () => ({ commands, state }) => {
				const tableGroup = findTableGroup(state.selection);
				if (tableGroup) return commands.hideText(tableGroup.pos, this.type.name);
				return false;
			}
		};
	},
	parseHTML() {
		return [{
			tag: "figcaption",
			context: "tableGroup/",
			getAttrs(node) {
				if (typeof node === "string") return {};
				const element = node;
				return { hideText: element.style.display === "none" || element.getAttribute("data-cadmus-hidden") === "true" };
			}
		}];
	}
});
//#endregion
//#region src/extensions/table/extensions/nodes/table-cell.ts
const TableCell$1 = TableCell.extend({
	addOptions() {
		return {
			...this.parent?.() ?? {},
			defaultColWidth: 50
		};
	},
	addAttributes() {
		return {
			...this.parent?.() ?? {},
			colwidth: {
				default: [this.options.defaultColWidth],
				parseHTML: (element) => {
					const colwidth = element.getAttribute("colwidth");
					return colwidth ? [parseInt(colwidth, 10)] : [this.options.defaultColWidth];
				}
			}
		};
	}
});
//#endregion
//#region src/extensions/table/extensions/nodes/table-footnote.ts
const TableFootnote = Node$1.create({
	name: "tableFootnote",
	addOptions() {
		return {
			HTMLAttributes: { "data-table-footer": "true" },
			placeholderText: "Add table notes and footer..."
		};
	},
	tableRole: "table_footnote",
	content: "paragraph+",
	isolating: true,
	onCreate() {
		const { type, options, editor } = this;
		const { storage } = editor;
		const { placeholderText } = options;
		storage.placeholder?.placeholders.set(this.name, {
			/**
			* Display the placeholder for table footnote if it has empty text content
			* and not in focus
			*/
			check: (selection, node, pos) => {
				if (node.type.name !== type.name) return false;
				const nodeStart = pos;
				const nodeEnd = pos + node.nodeSize;
				const { from, to } = selection;
				if (from >= nodeStart && from <= nodeEnd || to <= nodeEnd && to >= nodeStart) return false;
				if (node.textContent === "") return true;
				return false;
			},
			decoration: (node, pos) => {
				const child = node.firstChild;
				if (!child) return null;
				return Decoration.node(pos + 1, pos + 1 + child.nodeSize, {
					class: "empty-node",
					"data-placeholder-text": placeholderText
				});
			}
		});
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"div",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	parseHTML() {
		return [{
			tag: "div",
			getAttrs(node) {
				if (typeof node === "string") return false;
				const dom = node;
				if (dom.getAttribute("data-table-footer")) return { hideText: dom.style.display === "none" || dom.getAttribute("data-cadmus-hidden") === "true" };
				return false;
			},
			context: "tableGroup"
		}];
	},
	addCommands() {
		return {
			toggleTableFootnote: () => ({ commands, state }) => {
				const tableGroup = findTableGroup(state.selection);
				if (tableGroup) return commands.toggleShowText(tableGroup.pos, this.type.name);
				return false;
			},
			hideTableFootnote: () => ({ commands, state }) => {
				const tableGroup = findTableGroup(state.selection);
				if (tableGroup) return commands.hideText(tableGroup.pos, this.type.name);
				return false;
			}
		};
	},
	addKeyboardShortcuts() {
		return { Enter: ({ editor }) => {
			const sel = editor.state.selection;
			const tableGroup = findTableGroup(sel);
			if (!tableGroup) return false;
			const endPos = tableGroup.pos + tableGroup.node.nodeSize;
			editor.chain().insertContentAt(endPos, { type: "paragraph" }).run();
			return true;
		} };
	}
});
//#endregion
//#region src/extensions/table/extensions/nodes/table-group.ts
/**
* Wrapper Node for table with its caption and footnote
*/
const TableGroup = Node$1.create({
	name: "tableGroup",
	addOptions() {
		return { HTMLAttributes: { "data-table-group": true } };
	},
	group: "tableBlock",
	tableRole: "table_group",
	content: "tableCaption table tableFootnote",
	defining: true,
	renderHTML({ HTMLAttributes }) {
		return [
			"figure",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		];
	},
	parseHTML() {
		return [{
			tag: "figure",
			getAttrs(node) {
				if (typeof node === "string") return false;
				const dom = node;
				if (dom.getAttribute("data-table-group") === "true" || dom.querySelector(":scope > table")) return {};
				return false;
			}
		}];
	}
});
//#endregion
//#region src/extensions/table/extensions/nodes/table-header.ts
const TableHeader$1 = TableHeader.extend({
	addOptions() {
		return {
			...this.parent?.() ?? {},
			defaultColWidth: 50
		};
	},
	addAttributes() {
		return {
			...this.parent?.() ?? {},
			colwidth: {
				default: [this.options.defaultColWidth],
				parseHTML: (element) => {
					const colwidth = element.getAttribute("colwidth");
					return colwidth ? [parseInt(colwidth, 10)] : [this.options.defaultColWidth];
				}
			}
		};
	}
});
//#endregion
//#region src/extensions/table/extensions/table-background-alternate.ts
/**
* Editor Extension to add alternate table row background capabilities
*/
const TableBackgroundAlternate = Extension.create({
	name: "TableBackgroundAlternate",
	addGlobalAttributes() {
		return [{
			types: ["table"],
			attributes: { alternateBackground: {
				default: false,
				parseHTML: (element) => element.getAttribute("data-table-alternate-background") === "true",
				renderHTML: (attributes) => {
					return { "data-table-alternate-background": attributes.alternateBackground ? "true" : "false" };
				}
			} }
		}];
	},
	addCommands() {
		return {
			toggleTableAlternateColor: (color = defaultTableColor) => ({ state, tr, dispatch }) => {
				const selection = state.selection;
				const table = findTable(selection);
				if (!table) return false;
				const { pos, node } = table;
				const { attrs } = node;
				const currAlternate = attrs.alternateBackground;
				const newAttrs = {
					alternateBackground: !currAlternate,
					backgroundColor: currAlternate ? void 0 : color
				};
				const rect = selectedRect(state);
				const map = TableMap.get(node);
				tr.setNodeMarkup(pos, void 0, {
					...attrs,
					...newAttrs
				}).setSelection(new CellSelection(tr.doc.resolve(map.positionAt(rect.top, rect.left, node) + table.start), tr.doc.resolve(map.positionAt(rect.bottom - 1, rect.right - 1, node) + table.start)));
				dispatch?.(tr);
				return true;
			},
			setTableColor: (color) => ({ state, tr, dispatch }) => {
				const selection = state.selection;
				const table = findTable(selection);
				if (!table) return false;
				const { pos, node } = table;
				const { attrs } = node;
				if (!attrs.alternateBackground) return false;
				const newColor = tableColors.find(({ actual }) => actual === color)?.actual;
				if (!newColor) return false;
				const newAttrs = { backgroundColor: newColor };
				const rect = selectedRect(state);
				const map = TableMap.get(node);
				tr.setNodeMarkup(pos, void 0, {
					...attrs,
					...newAttrs
				}).setSelection(new CellSelection(tr.doc.resolve(map.positionAt(rect.top, rect.left, node) + table.start), tr.doc.resolve(map.positionAt(rect.bottom - 1, rect.right - 1, node) + table.start)));
				dispatch?.(tr);
				return true;
			}
		};
	}
});
//#endregion
//#region src/extensions/table/extensions/table-cell-border.ts
/**
* Editor Extension to add left, right, bottom & top border attribute to
* table cell and table header cell
*/
const TableCellBorder = Extension.create({
	name: "tableCellBorder",
	addOptions() {
		return { sides: [
			"all",
			"bottom",
			"insideHorizontal",
			"top"
		] };
	},
	addGlobalAttributes() {
		function parseBorder(element) {
			return {
				left: element.hasAttribute("data-left-border") ? element.getAttribute("data-left-border") === "true" : true,
				right: element.hasAttribute("data-right-border") ? element.getAttribute("data-right-border") === "true" : true,
				bottom: element.hasAttribute("data-bottom-border") ? element.getAttribute("data-bottom-border") === "true" : true,
				top: element.hasAttribute("data-top-border") ? element.getAttribute("data-top-border") === "true" : true
			};
		}
		function renderBorder(attributes) {
			if (!attributes.border) return {};
			const border = attributes.border;
			return {
				"data-left-border": border.left ? "true" : "false",
				"data-right-border": border.right ? "true" : "false",
				"data-bottom-border": border.bottom ? "true" : "false",
				"data-top-border": border.top ? "true" : "false"
			};
		}
		return [{
			types: ["tableCell", "tableHeader"],
			attributes: { border: {
				default: {
					left: true,
					right: true,
					top: true,
					bottom: true
				},
				parseHTML: (element) => parseBorder(element),
				renderHTML: (attributes) => renderBorder(attributes)
			} }
		}];
	},
	addCommands() {
		return { setTableCellBorder: (side, border) => ({ state, dispatch }) => {
			if (!this.options.sides.includes(side)) return false;
			if (!findTable(state.selection)) return false;
			let { tr } = state;
			const cellsMap = getCellsMap(state.schema, state.selection);
			if (!cellsMap) return false;
			const { cells, height } = cellsMap;
			if (side === "insideHorizontal" && height < 2) return false;
			cells.map((_cell, index) => {
				tr = setCellBorder(cellsMap, index, side, border)(tr);
			});
			dispatch?.(tr);
			return true;
		} };
	}
});
//#endregion
//#region src/extensions/table/table.ts
/**
*
*/
const Table$1 = Extension.create({
	name: "cadmusTable",
	addExtensions() {
		return [
			TableCaption,
			TableCell$1.configure({ defaultColWidth: 50 }),
			TableFootnote,
			TableGroup,
			TableHeader$1.configure({ defaultColWidth: 50 }),
			Table$2.configure({
				resizable: true,
				lastColumnResizable: true,
				handleWidth: 5,
				cellMinWidth: 15,
				allowTableNodeSelection: true
			}),
			TableRow,
			TableBackgroundAlternate,
			TableCellBorder
		];
	},
	addProseMirrorPlugins() {
		return [TableDeleteIndicatorPlugin(), TableEnsureGroupPlugin()];
	},
	addCommands() {
		return {
			insertTableWithCaption: ({ rows = 2, cols = 2, withHeaderRow = false } = {}) => ({ chain, dispatch, state }) => {
				if (findCodeBlockSelection(state.selection) || findTableGroup(state.selection)) return false;
				if (dispatch) return chain().command(({ tr, dispatch, state }) => {
					const node = createTable(state.schema, rows, cols, withHeaderRow);
					const offset = tr.selection.anchor + 1;
					tr.replaceSelectionWith(node).scrollIntoView().setSelection(TextSelection.near(tr.doc.resolve(offset)));
					dispatch?.(tr);
					return true;
				}).command(({ tr }) => {
					const tableGroup = findTableGroup(tr.selection);
					if (tableGroup?.node) {
						const predicate = (node) => node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
						const firstCell = findChildren(tableGroup.node, predicate)[0];
						if (firstCell?.node) {
							tr.setSelection(TextSelection.near(tr.doc.resolve(tableGroup.start + firstCell.pos)));
							dispatch?.(tr);
						}
					}
					return true;
				}).run();
				return true;
			},
			selectRow: (rowIndex) => ({ tr, dispatch }) => {
				dispatch?.(selectRow(rowIndex)(tr));
				return true;
			},
			selectColumn: (columnIndex) => ({ tr, dispatch }) => {
				dispatch?.(selectColumn(columnIndex)(tr));
				return true;
			},
			selectTable: () => ({ tr, dispatch }) => {
				dispatch?.(selectTable(tr));
				return true;
			},
			selectCellContent: () => ({ tr, dispatch }) => {
				if (!findTable(tr.selection)) return false;
				if (tr.selection instanceof CellSelection) return false;
				const cell = findCellClosestToPos(tr.selection.$from);
				if (!cell) return false;
				if (dispatch) tr.setSelection(TextSelection.between(tr.doc.resolve(cell.start), tr.doc.resolve(cell.start + cell.node.nodeSize)));
				return true;
			},
			selectTableCaption: () => ({ tr, commands }) => {
				const tableCaption = findTableCaption(tr.selection);
				if (!tableCaption) return false;
				commands.setTextSelection({
					from: tableCaption.pos,
					to: tableCaption.pos + tableCaption.node.nodeSize
				});
				return true;
			},
			selectTableFootnote: () => ({ tr, commands }) => {
				const tableFootnote = findTableFootnote(tr.selection);
				if (!tableFootnote) return false;
				commands.setTextSelection({
					from: tableFootnote.pos,
					to: tableFootnote.pos + tableFootnote.node.nodeSize
				});
				return true;
			},
			setCellsBackground: (color) => ({ state, dispatch }) => {
				return setCellsBackground(color)(state, dispatch);
			},
			addColumnAt: (columnIndex) => ({ state, tr, dispatch }) => {
				const table = findTable(state.selection);
				if (!table) return false;
				const map = TableMap.get(table.node);
				if (!map) return false;
				dispatch?.(addColumn(tr, {
					tableStart: table.start,
					map,
					table: table.node,
					left: 0,
					right: map.width - 1,
					top: 0,
					bottom: map.height - 1
				}, columnIndex));
				return true;
			},
			addRowAt: (rowIndex) => ({ state, tr, dispatch }) => {
				const table = findTable(state.selection);
				if (!table) return false;
				const map = TableMap.get(table.node);
				if (!map) return false;
				dispatch?.(addRow(tr, {
					tableStart: table.start,
					map,
					table: table.node,
					left: 0,
					right: map.width - 1,
					top: 0,
					bottom: map.height - 1
				}, rowIndex));
				return true;
			},
			deleteSelectedTable: () => ({ chain }) => {
				return chain().first(({ commands }) => [commands.deleteColumn, commands.deleteRow]).command(({ tr, dispatch }) => {
					if (!findTable(tr.selection)) return false;
					if (isTableSelected(tr.selection)) {
						const tableGroup = findTableGroup(tr.selection);
						if (!tableGroup) return false;
						dispatch?.(tr.delete(tableGroup.pos, tableGroup.pos + tableGroup.node.nodeSize));
					}
					return true;
				}).command(({ commands }) => commands.predeleteHighlightTable(false)).run();
			},
			predeleteHighlightTable: (show) => ({ tr, dispatch }) => {
				dispatch?.(tr.setMeta(TableDeleteIndicatorPluginKey, { highlight: show }));
				return true;
			},
			preinsertCol: (colIndex) => ({ tr, dispatch }) => {
				dispatch?.(tr.setMeta(TableControlPluginKey, {
					col: colIndex !== void 0 ? colIndex : null,
					row: null
				}));
				return true;
			},
			preinsertRow: (rowIndex) => ({ tr, dispatch }) => {
				dispatch?.(tr.setMeta(TableControlPluginKey, {
					row: rowIndex !== void 0 ? rowIndex : null,
					col: null
				}));
				return true;
			},
			addTablePasteChip: () => ({ commands }) => commands.addPasteChipAfterPredicate(findTableGroup),
			handleTablePaste: (slice) => ({ state, dispatch }) => {
				if (!isInTable(state)) return false;
				let cells = __pastedCells(slice);
				const sel = state.selection;
				if (sel instanceof CellSelection) {
					if (!cells) cells = {
						width: 1,
						height: 1,
						rows: [Fragment.from(fitSlice(getTableNodeTypes(state.schema).cell, slice))]
					};
					const table = sel.$anchorCell.node(-1), start = sel.$anchorCell.start(-1);
					const rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
					cells = __clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
					__insertCells(state, dispatch, start, rect, cells);
				} else if (cells) {
					const $cell = selectionCell(state);
					if (!$cell) return false;
					const start = $cell.start(-1);
					__insertCells(state, dispatch, start, TableMap.get($cell.node(-1)).findCell($cell.pos - start), cells);
					return true;
				} else return false;
				return true;
			}
		};
	},
	addKeyboardShortcuts() {
		const handleTableDelete = () => this.editor.commands.command(({ state, dispatch, tr }) => {
			const tableGroup = findTableGroup(state.selection);
			if (tableGroup?.node && (isSelectionIncludeTable(state) || isTableSelected(state.selection))) {
				dispatch?.(tr.delete(tableGroup.pos, tableGroup.pos + tableGroup.node.nodeSize));
				return true;
			}
			return false;
		});
		return {
			"Mod-a": () => this.editor.commands.first(({ commands }) => [
				() => commands.selectCellContent(),
				() => commands.selectTableCaption(),
				() => commands.selectTableFootnote()
			]),
			Backspace: handleTableDelete,
			"Mod-Backspace": handleTableDelete,
			"Shift-Backspace": handleTableDelete,
			Delete: handleTableDelete,
			"Mod-Delete": handleTableDelete
		};
	}
});
function fitSlice(nodeType, slice) {
	const node = nodeType.createAndFill();
	return new Transform(node).replace(0, node.content.size, slice).doc;
}
//#endregion
//#region src/extensions/table/styles.ts
const tableStyles = css`
  figure[data-table-group] {
    color: ${(p) => p.theme.text.main};
    box-sizing: border-box;
    position: relative;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 36px;
    margin-bottom: 36px;

    .table-group-wrapper {
      display: flex;
      flex-direction: column;
    }

    figcaption {
      padding: unset;
      max-width: 100%;
      padding: 0px 45px;
    }
  }

  .tableWrapper {
    display: flex;
    justify-content: center;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    border: 10px;
    clear: both;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;

    blockquote {
      min-width: 0;
      padding-left: 0;
      padding-right: 0;
      * {
        padding-left: 9px;
      }
    }

    tbody > div {
      display: contents;
    }

    p,
    li {
      font-size: 14px; /* Table has smaller font size */
    }

    td,
    th {
      padding-top: 8px;
      padding-bottom: 8px;
    }

    ul,
    ol {
      min-width: unset;
      max-width: unset;
      padding-right: unset;
      padding-inline-start: 20px;
    }

    &[data-table-alternate-background="true"] {
      th {
        background-color: var(--background-color);
        filter: contrast(0.9);
      }
      tr:nth-child(even) > td {
        background-color: transparent;
      }
      tr:nth-child(odd) > td {
        background-color: var(--background-color);
      }
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: -1px;
      bottom: -1px;
      width: 4px;
      z-index: 9999;
      background-color: ${colors.indigo500};
    }

    .col-insert-handle {
      position: absolute;
      left: -2px;
      top: 0;
      bottom: 0;
      width: 4px;
      z-index: 9999;
      background-color: ${colors.indigo500};
    }

    .row-insert-handle {
      position: absolute;
      right: 0;
      left: 0;
      top: -2px;
      width: 100%;
      height: 4px;
      z-index: 9999;
      background-color: ${colors.indigo500};
    }

    .selectedCell:not(.cell-predelete) {
      &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: "";
        box-shadow: 0 0 0 1px ${colors.indigo500};
        background: #6355f610;
      }
    }

    .cell-predelete {
      &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: "";
        box-shadow: 0 0 0 1px ${colors.red500};
        background: #d9264408;
      }
    }
  }

  & {
    td:not(.ProseMirror-widget),
    th:not(.ProseMirror-widget) {
      word-break: break-word;
    }
  }

  /** Table cell borders when editable */
  &[contenteditable="true"] {
    td:not(.ProseMirror-widget),
    th:not(.ProseMirror-widget) {
      border-color: #c3cddf;

      &:not([data-left-border="true"]) {
        border-left-color: ${colors.grey50};
      }
      &:not([data-right-border="true"]) {
        border-right-color: ${colors.grey50};
      }
      &:not([data-top-border="true"]) {
        border-top-color: ${colors.grey50};
      }
      &:not([data-bottom-border="true"]) {
        border-bottom-color: ${colors.grey50};
      }

      /** APA thick black borders when either top or bottom border is selected */
      &[data-top-border="true"][data-left-border="false"][data-right-border="false"] {
        border-top: 1.25px solid black;
      }
      &[data-bottom-border="true"][data-left-border="false"][data-right-border="false"] {
        border-bottom: 1.25px solid black;
      }
    }
  }

  /** Table cell borders when readonly */
  &[contenteditable="false"] {
    td:not(.ProseMirror-widget),
    th:not(.ProseMirror-widget) {
      border-color: #c3cddf;

      &:not([data-left-border="true"]) {
        border-left-color: transparent;
      }
      &:not([data-right-border="true"]) {
        border-right-color: transparent;
      }
      &:not([data-top-border="true"]) {
        border-top-color: transparent;
      }
      &:not([data-bottom-border="true"]) {
        border-bottom-color: transparent;
      }

      /** APA thick black borders when either top or bottom border is selected */
      &[data-top-border="true"][data-left-border="false"][data-right-border="false"] {
        border-top: 1.25px solid black;
      }
      &[data-bottom-border="true"][data-left-border="false"][data-right-border="false"] {
        border-bottom: 1.25px solid black;
      }
    }
  }

  td,
  th {
    padding: 8px;
    position: relative;
    border: 1px solid;
    text-align: inherit;
    vertical-align: baseline;

    &[data-cadmus-background-color],
    &[data-cadmus-background-color] {
      background-color: var(--background-color) !important;
    }
  }

  div[data-table-footer="true"] {
    width: 100%;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
    position: relative;
    margin-top: 16px;
    padding: 0px 45px;
    p {
      font-weight: ${editorTypography["systemSm"].fontWeight};
      font-size: ${editorTypography["systemSm"].fontSize};
      line-height: ${editorTypography["systemSm"].lineHeight};
      letter-spacing: ${editorTypography["systemSm"].letterSpacing};
      padding-top: ${editorTypography["systemSm"].paddingTop};
      padding-bottom: ${editorTypography["systemSm"].paddingBottom};
      min-height: calc(
        ${editorTypography["systemSm"].fontSize} *
          ${editorTypography["systemSm"].lineHeight}
      );
    }
  }

  th {
    background-color: ${colors.grey50};
    font-weight: 600;
    p,
    h1,
    h2,
    h3,
    h4 {
      font-weight: inherit;
    }
  }
`;
//#endregion
//#region src/extensions/task-item/task-item.ts
const inputRegex$1 = /^\s*(\[( ?|x|X)]\s)$/;
const TaskItem = Node$1.create({
	name: "taskItem",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "paragraph block*",
	defining: true,
	group: "listItemGroup",
	parseHTML() {
		return [{
			tag: "li[data-type=\"taskItem\"]",
			priority: 51
		}, {
			tag: "li",
			priority: 51,
			getAttrs: (node) => {
				if (typeof node === "string") return false;
				const dom = node;
				if (dom.getAttribute("data-task-created")) return { checked: dom.getAttribute("data-task-completed") };
				return false;
			}
		}];
	},
	addAttributes() {
		return { checked: {
			default: false,
			parseHTML: (element) => element.getAttribute("data-checked") === "true" || !!element.getAttribute("data-task-completed"),
			renderHTML: (attributes) => ({ "data-checked": attributes.checked ? "true" : "false" }),
			keepOnSplit: false
		} };
	},
	renderHTML({ node, HTMLAttributes }) {
		return [
			"li",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { "data-type": "taskItem" }),
			["label", ["input", {
				...node.attrs.checked ? { checked: "true" } : {},
				disabled: "true",
				tabIndex: "-1",
				type: "checkbox"
			}]],
			["div", 0]
		];
	},
	addKeyboardShortcuts() {
		return { Enter: () => this.editor.commands.cadmusSplitListItem("taskItem") };
	},
	addNodeView() {
		return ({ node, HTMLAttributes, getPos, editor }) => {
			const listItem = document.createElement("li");
			const checkboxWrapper = document.createElement("label");
			const checkboxStyler = document.createElement("span");
			const checkbox = document.createElement("input");
			const content = document.createElement("div");
			content.id = Math.random().toString(32).slice(2);
			checkboxWrapper.contentEditable = "false";
			checkbox.type = "checkbox";
			checkbox.setAttribute("aria-labelledby", content.id);
			checkbox.setAttribute("tabindex", "-1");
			if (!editor.isEditable) checkbox.readOnly = true;
			checkbox.addEventListener("change", (event) => {
				if (!editor.isEditable) {
					checkbox.checked = !checkbox.checked;
					return;
				}
				const { checked } = event.target;
				if (typeof getPos === "function" && editor.isEditable) editor.chain().focus(void 0, { scrollIntoView: false }).command(({ tr }) => {
					tr.setNodeMarkup(getPos(), void 0, { checked });
					return true;
				}).run();
			});
			checkbox.addEventListener("keyup", (event) => {
				if (event.key === "Escape") checkbox.blur();
			});
			Object.entries(this.options.HTMLAttributes).forEach(([key, value]) => {
				listItem.setAttribute(key, value);
			});
			listItem.dataset.checked = node.attrs.checked;
			if (node.attrs.checked) {
				checkbox.setAttribute("checked", "checked");
				listItem.setAttribute("data-checked", "true");
			}
			checkboxWrapper.append(checkbox, checkboxStyler);
			listItem.append(checkboxWrapper, content);
			Object.entries(HTMLAttributes).forEach(([key, value]) => {
				listItem.setAttribute(key, value);
			});
			return {
				dom: listItem,
				contentDOM: content,
				update: (updatedNode) => {
					if (updatedNode.type !== this.type) return false;
					listItem.dataset.checked = updatedNode.attrs.checked;
					if (updatedNode.attrs.checked) {
						checkbox.setAttribute("checked", "checked");
						listItem.setAttribute("data-checked", "true");
					} else {
						checkbox.removeAttribute("checked");
						listItem.setAttribute("data-checked", "false");
					}
					return true;
				}
			};
		};
	},
	addProseMirrorPlugins() {
		return [inputRulesPlugin({
			editor: this.editor,
			rules: [
				wrappingInputRule({
					find: inputRegex$1,
					type: this.type,
					getAttributes: (match) => ({ checked: ["x", "X"].includes(match[match.length - 1]) })
				}),
				wrappingInputRule({
					find: /^\s*(\[\])\s$/,
					type: this.type,
					getAttributes: (_match) => ({ checked: false })
				}),
				new InputRule({
					find: inputRegex$1,
					handler: ({ state, range, match }) => {
						const { tr } = state;
						tr.deleteRange(range.from, range.to);
						const listType = getNodeType("taskList", this.editor.schema);
						if (!wrapSelectedItems({
							itemType: this.type,
							listType,
							tr,
							editor: this.editor
						})) {
							const $cursor = tr.doc.resolve(range.from);
							if ($cursor.depth > 2) {
								if (!isListItem($cursor.node($cursor.depth - 1).type.name, this.editor.extensionManager.extensions)) return null;
							} else return null;
						}
						const checked = ["x", "X"].includes(match[match.length - 1]);
						const found = findParentNode((node) => node.type === this.type)(tr.selection);
						if (found) tr.setNodeMarkup(found.pos, void 0, { checked });
					}
				})
			]
		})];
	}
});
//#endregion
//#region src/extensions/telemetry/emitTransactionEvents.ts
function emitTransactionEvents(transaction, opts) {
	const historyMeta = transaction.getMeta(HistoryPluginKey);
	const pasteMeta = transaction.getMeta(PastePluginKey);
	if (pasteMeta || historyMeta) setTimeout(() => {
		if (pasteMeta) opts.onEditorEvent?.({
			type: "paste",
			payload: {
				...pasteMeta,
				origin: pasteMeta.origin === "prosemirror" && !pasteMeta.internal ? "Unknown" : pasteMeta.origin,
				editorId: opts.editorId,
				addedWords: pasteMeta.wordsAdded ?? 0,
				deletedWords: pasteMeta.wordsDeleted ?? 0
			}
		});
		if (historyMeta) opts.onEditorEvent?.({
			type: "history",
			payload: {
				historyType: historyMeta.type,
				addedWords: historyMeta.wordsAdded ?? 0,
				deletedWords: historyMeta.wordsDeleted ?? 0,
				editorId: opts.editorId,
				timestamp: historyMeta.timestamp,
				editorEventId: historyMeta.editorEventId
			}
		});
	});
}
//#endregion
//#region src/extensions/telemetry/processDocWords.ts
/**
* Iterate through editor document, count words and also trigger a suggestion
* request on unique words on the document
*/
function processDocWords(editor, doc, opts) {
	const [words, wordCount] = tokeniseUniqueWords(doc, 0, doc.content.size);
	editor.commands.setWordCount(wordCount);
	if (opts.withCharacterCount || opts.withSummary) {
		const text = editor.getText();
		if (opts.withCharacterCount) editor.storage.telemetry.characterCount = text.length;
		if (opts.withSummary?.length) editor.storage.telemetry.summary = text.slice(0, opts.withSummary.length);
	}
	opts.onSave?.(opts.editorId, editor);
	editor.storage.telemetry.pendingSave = false;
	if (opts.suggestionClient && canSpellCheckWithCadmus(editor)) opts.suggestionClient.requestSuggestions(words);
}
const debouncedProcessDocWords = debounce(processDocWords, 800, { maxWait: 4e3 });
//#endregion
//#region src/extensions/telemetry/word-count-plugin.ts
const WordCountPluginKey = new PluginKey("wordCount");
const WordCountPlugin = (editorId) => new Plugin({
	key: WordCountPluginKey,
	state: {
		init(_, editorState) {
			return {
				editorId,
				selected: selectionWordCount(editorState),
				total: nodeWordCount(editorState.doc)
			};
		},
		apply(tr, state, oldEditorState, newEditorState) {
			const meta = tr.getMeta(WordCountPluginKey);
			if (oldEditorState.selection !== newEditorState.selection) state.selected = selectionWordCount(newEditorState);
			if (meta?.type === "setWordCount" && typeof meta.total === "number") state.total = meta.total;
			return state;
		}
	}
});
//#endregion
//#region src/extensions/telemetry/telemetry.ts
/**
* Collect and emit Telemtric data and events based on transactions in the
* Editor.
*
* ## Document Tokenisation - Word count and Suggestions
*
* On creation and on debounced intervals the latest document state is tokenised
* into Words. These word tokens are used to compute and set the latest Word
* count state, and also transmit them for spelling suggestions via the provided
* `SuggestionClient` (if provided)
*
* The Word count state is maintained in a plugin state and can be accessed
* easily via the `editorWordCount` API function.
*
* The debounced interval is currently hardcoded to 800ms.
*
* ## Save Trigger
*
* On debounced intervals the callback `onSave` is called to signal document
* saving opportunities.
*
* The debounced interval is currently hardcoded to 800ms.
*
* ## Events
*
* Some extensions/plugins set Transaction metadata payloads as event payloads,
* expecting the telemetry extension to pick it up and emit them via the
* provided callbacks.
*
* The `telemetry` plugin itself will do extra work to compute the full event
* payload based on the transaction's document state and emit them.
*
* These events are:
*
* ### Paste Event
*
* Set by the `paste` plugin which processes incoming pastes. The eventual event
* payload formed will contain the changeset of words added and deleted during
* that transaction. This is a heavier operation and is performed
* asynchronously.
*
* The Paste event payload is represented by `EditorPasteEvent`.
*
* ### History Event
*
* Set by the `history` plugin which performs `undo` and `redo` operations. The eventual event
* payload formed will contain the changeset of words added and deleted during
* that transaction. This is a heavier operation and is performed
* asynchronously.
*
* The History event payload is represented by `EditorHistoryEvent`.
*/
const Telemetry = Extension.create({
	name: "telemetry",
	addStorage() {
		return {
			pendingSave: false,
			...this.options.withCharacterCount ? { characterCount: 0 } : {},
			...this.options.withSummary ? { summary: "" } : {}
		};
	},
	/**
	* On each transaction that cause changes in document, debounce word count
	* calculation and suggestion request to the server and also send undo/redo/paste
	* event to the server
	*/
	onTransaction({ transaction, editor }) {
		if (transaction.docChanged) {
			editor.storage.telemetry.pendingSave = true;
			debouncedProcessDocWords(editor, transaction.doc, this.options);
		}
		emitTransactionEvents(transaction, this.options);
	},
	/**
	* Upon creation of the editor instance, initialised word count &
	* suggestion without debouncing it.
	*/
	onCreate() {
		processDocWords(this.editor, this.editor.state.doc, {
			...this.options,
			onSave: void 0
		});
	},
	addCommands() {
		return { setWordCount: (total) => ({ dispatch, tr }) => {
			if (dispatch) tr.setMeta(WordCountPluginKey, {
				type: "setWordCount",
				total
			});
			return true;
		} };
	},
	addProseMirrorPlugins() {
		return [WordCountPlugin(this.options.editorId)];
	}
});
//#endregion
//#region src/extensions/telemetry/editorWordCount.ts
/**
* Read the latest tracked total and selected word count in the `editor`.
*
* @param editor which contains the `word-count` extension.
* @return the object with `total` and `selected` word counts, or `null` if the
*   plugin is not initialised or ready yet.
*/
function editorWordCount(editor) {
	return WordCountPluginKey.getState(editor.state) ?? null;
}
//#endregion
//#region src/extensions/text-color/text-color.ts
const TextColor = Extension.create({
	name: "textColor",
	addOptions() {
		return {
			types: ["textStyle"],
			defaultTextColor: DEFAULT_TEXT_COLOR,
			colors: TEXT_COLORS
		};
	},
	addGlobalAttributes() {
		const colors = this.options.colors.map((c) => tinycolor(c).toHexString());
		const defaultTextColor = tinycolor(this.options.defaultTextColor).toHexString();
		colors.push(defaultTextColor);
		const getColor = (color) => {
			return color && colors.includes(tinycolor(color).toHexString()) ? color : defaultTextColor;
		};
		return [{
			types: this.options.types,
			attributes: { color: {
				default: null,
				renderHTML: (attributes) => {
					if (!attributes.color) return {};
					return { style: `color: ${getColor(attributes.color)}` };
				},
				parseHTML: (element) => getColor(element.style.color)
			} }
		}];
	},
	addCommands() {
		const colors = this.options.colors.map((c) => tinycolor(c).toHexString());
		const defaultTextColor = tinycolor(this.options.defaultTextColor).toHexString();
		return {
			setTextColor: (color) => ({ commands, chain }) => {
				const hexColor = tinycolor(color).toHexString();
				if (colors.includes(hexColor)) return commands.setMark("textStyle", { color: hexColor });
				else if (hexColor === defaultTextColor) return chain().setMark("textStyle", { color: null }).removeEmptyTextStyle().run();
				return false;
			},
			unsetTextColor: () => ({ chain }) => {
				return chain().setMark("textStyle", { color: null }).removeEmptyTextStyle().run();
			}
		};
	}
});
//#endregion
//#region src/extensions/thread/utils.ts
/**
* Get the list of Thread IDs that the editor currently contains.
*/
function listThreads(editorState) {
	const childrenWithThread = findChildren(editorState.doc, (node) => node.marks.some((mark) => mark.type.name === "thread"));
	return [...new Set(childrenWithThread?.flatMap((nodeWithThread) => nodeWithThread.node.marks.filter((mark) => mark.type.name === "thread" && mark.attrs.id).map((mark) => mark.attrs.id)))];
}
/**
* Finds the MarkRanges of a thread `Mark` within a ProseMirror `Node`
* for a specific thread ID.
*
* This utility function is used to support editor actions that require making
* changes to a thread `Mark`, such as deleting a thread, or updating the
* thread's content or attributes.
*
* If found, the function returns a MarkRange array, containing a start and
* end position, as well as the `Mark` itself. A `Mark` is a ProseMirror object
* that represents a formatting `Mark`, such as bold, italic, or a custom
* `Mark` like a thread.
*
* More information about ProseMirror nodes can be found here:
* https://prosemirror.net/docs/ref/#model.Node
*
* @param {PMNode} node - The ProseMirror `Node` to search within.
* @param {string} threadId - The ID of the thread to find.
*
* @returns {MarkRange[]} - The ranges of the thread `Mark`s, or
* an empty array if not found.
*/
function findThreadMarkRanges(node, threadId) {
	const nodeWithThreads = findThreadNodes(node, threadId);
	if (Array.isArray(nodeWithThreads) && nodeWithThreads.length === 0) return [];
	return nodeWithThreads.map((nodeWithThread) => {
		const threadMark = nodeWithThread.node.marks.find((mark) => mark.type.name === "thread" && mark.attrs.id === threadId);
		return {
			from: nodeWithThread.pos,
			to: nodeWithThread.pos + nodeWithThread.node.nodeSize,
			mark: threadMark
		};
	});
}
/**
* Finds all `Node`s with a specific thread mark within a ProseMirror `Node`.
*
* This function searches for all nodes that contain a thread mark with the
* given thread ID. It can be useful for operations that require identifying
* multiple nodes associated with a thread, such as highlighting active
* threads, navigating to threads, or applying decorations to all instances of
* a thread in the editor.
*
* @param {PMNode} node - The ProseMirror `Node` to search within.
* @param {string} threadId - The ID of the thread to find.
* @returns {NodeWithPos[]} - An array of `NodeWithPos` where thread `Mark`s
* are found, or an empty array if none are found.
*/
function findThreadNodes(node, threadId) {
	if (!threadId) return [];
	return findChildren(node, (node) => node.marks.some((mark) => mark.type.name === "thread" && mark.attrs.id === threadId));
}
/**
* Gets the ID of the currently active thread. It helps in managing the state
* of threads and performing actions specific to the active thread.
*
* A user brings a thread into focus by clicking on it in a list of threads
* external to the editor and manually calling the `focusThread` command,
* or by clicking on the highlighted text that contains a thread in the editor.
*
* @param {EditorState} state - The current editor state.
* @returns {string | null} - The ID of the active thread, or null if no thread
* is active.
*/
function currentActiveThreadId(state) {
	return ThreadActiveStatusPluginKey.getState(state)?.activeThreadId ?? null;
}
//#endregion
//#region src/extensions/thread/thread-active-status-plugin.ts
const ThreadActiveStatusPluginKey = new PluginKey("ThreadActiveStatus");
/**
* Create a Plugin tracking the active thread in the editor.
*/
function ThreadActiveStatusPlugin() {
	return new Plugin({
		key: ThreadActiveStatusPluginKey,
		state: {
			init() {
				return { activeThreadId: null };
			},
			apply(tr, prevState) {
				const focusedThreadId = tr.getMeta("activeThreadId");
				if (focusedThreadId === void 0) return prevState;
				return { activeThreadId: focusedThreadId };
			}
		},
		props: {
			/**
			* Adds a decoration to the active thread mark in the editor
			*/
			decorations(editorState) {
				return getDecorationsForState(editorState.doc, this.getState(editorState));
			},
			/**
			* Handle click on a thread SPAN element.
			*/
			handleClick(view, _pos, event) {
				if (!event || !event.target) return;
				const closestThreadId = event.target.closest("[data-thread-id]");
				if (closestThreadId) {
					const dataThreadId = closestThreadId.getAttribute("data-thread-id");
					view.dispatch(view.state.tr.setMeta("activeThreadId", dataThreadId));
				} else view.dispatch(view.state.tr.setMeta("activeThreadId", null));
				return true;
			}
		}
	});
}
function getDecorationsForState(document, threadActiveState) {
	const threadId = threadActiveState?.activeThreadId;
	if (!threadId) return DecorationSet.empty;
	const activeThreadNodes = findThreadNodes(document, threadId);
	if (Array.isArray(activeThreadNodes) && activeThreadNodes.length === 0) return DecorationSet.empty;
	const decorations = activeThreadNodes.map((activeThreadNode) => Decoration.inline(activeThreadNode.pos, activeThreadNode.pos + activeThreadNode.node.nodeSize, { class: "thread-active" }, {
		inclusiveStart: true,
		inclusiveEnd: true
	}));
	return DecorationSet.create(document, decorations);
}
//#endregion
//#region src/extensions/thread/thread-list-plugin.ts
const ThreadListPluginKey = new PluginKey("ThreadList");
/**
* Create a Plugin tracking the list of threads in the editor.
*/
function ThreadListPlugin() {
	return new Plugin({
		key: ThreadListPluginKey,
		state: {
			init(_, state) {
				return listThreads(state);
			},
			apply(tr, currentList, _oldEditorState, newEditorState) {
				if (!tr.docChanged) return currentList;
				return listThreads(newEditorState);
			}
		}
	});
}
//#endregion
//#region src/extensions/thread/thread-paste-plugin.ts
const ThreadPastePluginKey = new PluginKey("threadPaste");
/**
* Plugin to handle paste operations inside thread marks to prevent splitting
*/
const ThreadPastePlugin = () => {
	return new Plugin({
		key: ThreadPastePluginKey,
		props: {
			transformPastedHTML(html) {
				return html.replace(/<\/?thread[^>]*>/g, "");
			},
			handlePaste(view, _event, _slice) {
				const { state } = view;
				const { selection, schema } = state;
				const { $from } = selection;
				const threadMarkType = schema.marks.thread;
				if ($from.marks().find((mark) => mark.type.name === threadMarkType.name)) return true;
				return false;
			}
		}
	});
};
//#endregion
//#region src/extensions/thread/thread.ts
const Thread = Mark.create({
	name: "thread",
	priority: 1e3,
	inclusive: true,
	spanning: true,
	excludes: "thread",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	addAttributes() {
		return {
			id: {
				default: null,
				parseHTML: (element) => element.getAttribute("data-thread-id"),
				renderHTML: (attributes) => attributes.id ? { "data-thread-id": attributes.id } : {}
			},
			resolved: {
				default: "false",
				parseHTML: (element) => element.getAttribute("data-thread-resolved"),
				renderHTML: (attributes) => attributes.resolved ? { "data-thread-resolved": attributes.resolved } : {}
			}
		};
	},
	parseHTML() {
		return [{ tag: "thread" }];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"thread",
			HTMLAttributes,
			""
		];
	},
	addCommands() {
		return {
			insertThread: (threadId) => ({ tr, editor }) => {
				if (!validateThreadInsertion(tr, editor)) return false;
				const threadMark = editor.schema.marks.thread.create({
					id: threadId,
					resolved: "false"
				});
				const sel = tr.selection;
				tr.addMark(sel.from, sel.to, threadMark);
				tr.setMeta("activeThreadId", threadId);
				return true;
			},
			deleteThread: (threadId) => ({ tr }) => {
				const items = findThreadMarkRanges(tr.doc, threadId);
				if (Array.isArray(items) && items.length === 0) return false;
				items.forEach((item) => {
					tr.removeMark(item.from, item.to, item.mark.type);
				});
				return true;
			},
			focusThread: (threadId) => ({ tr }) => {
				if (!threadId) {
					tr.setMeta("activeThreadId", null);
					return false;
				}
				const items = findThreadMarkRanges(tr.doc, threadId);
				if (Array.isArray(items) && items.length === 0) return false;
				const firstThreadMark = items[0];
				if (firstThreadMark) {
					const newSelection = TextSelection.create(tr.doc, firstThreadMark.from);
					tr.setSelection(newSelection);
					tr.setMeta("activeThreadId", firstThreadMark ? threadId : null);
					return true;
				}
				return false;
			},
			resolveThread: (threadId) => ({ tr, editor }) => {
				const items = findThreadMarkRanges(tr.doc, threadId);
				if (Array.isArray(items) && items.length === 0) return false;
				items.forEach((item) => {
					tr.removeMark(item.from, item.to, item.mark.type);
					const threadMark = editor.schema.marks.thread.create({
						id: threadId,
						resolved: "true"
					});
					tr.addMark(item.from, item.to, threadMark);
				});
				tr.setMeta("activeThreadId", null);
				return true;
			},
			unresolveThread: (threadId) => ({ tr, editor }) => {
				const items = findThreadMarkRanges(tr.doc, threadId);
				if (Array.isArray(items) && items.length === 0) return false;
				items.forEach((item) => {
					tr.removeMark(item.from, item.to, item.mark.type);
					const threadMark = editor.schema.marks.thread.create({
						id: threadId,
						resolved: "false"
					});
					tr.addMark(item.from, item.to, threadMark);
				});
				tr.setMeta("activeThreadId", threadId);
				return true;
			},
			deleteAllThreads: () => ({ tr, editor }) => {
				const threadMarkType = editor.schema.marks.thread;
				let hasChanges = false;
				tr.doc.descendants((node, pos) => {
					if (node.marks && node.marks.length > 0) node.marks.forEach((mark) => {
						if (mark.type === threadMarkType) {
							tr.removeMark(pos, pos + node.nodeSize, threadMarkType);
							hasChanges = true;
						}
					});
				});
				tr.setMeta("activeThreadId", null);
				return hasChanges;
			},
			canInsertThread: () => ({ tr, editor }) => {
				return validateThreadInsertion(tr, editor);
			}
		};
	},
	addProseMirrorPlugins() {
		return [
			ThreadActiveStatusPlugin(),
			ThreadListPlugin(),
			ThreadPastePlugin()
		];
	}
});
/**
* Predicate checking if thread insertion is allowed for the current selection.
*
* Checks all requirements:
*
*   - Valid selection (i.e. non-empty and text)
*   - no conflicts, and
*   - no mark splitting
*
*/
function validateThreadInsertion(tr, editor) {
	const sel = tr.selection;
	if (!sel || sel.empty) return false;
	const { from, to } = sel;
	if (hasConflictingThreadMarks(tr, editor, from, to)) return false;
	if (wouldCauseMarkSplitting(tr, from, to)) return false;
	return true;
}
/**
* Helper function to check if a selection would conflict with existing thread marks
*/
function hasConflictingThreadMarks(tr, editor, from, to) {
	const threadMarkType = editor.schema.marks.thread;
	let hasExistingThreadMark = false;
	tr.doc.nodesBetween(from, to, (node) => {
		if (node.marks) node.marks.forEach((mark) => {
			if (mark.type === threadMarkType) hasExistingThreadMark = true;
		});
	});
	const $from = tr.doc.resolve(from);
	const $to = tr.doc.resolve(to);
	const marksAtStart = $from.marks();
	const marksAtEnd = $to.marks();
	for (const mark of marksAtStart) if (mark.type === threadMarkType) {
		hasExistingThreadMark = true;
		break;
	}
	for (const mark of marksAtEnd) if (mark.type === threadMarkType) {
		hasExistingThreadMark = true;
		break;
	}
	return hasExistingThreadMark;
}
/**
* Predicate checking if a selection would cause mark splitting across different
* nodes.
*/
function wouldCauseMarkSplitting(tr, from, to) {
	const nodeAtFrom = tr.doc.resolve(from).parent;
	return !(nodeAtFrom === tr.doc.resolve(to).parent && nodeAtFrom.isTextblock);
}
//#endregion
//#region src/extensions/thread/use-thread-list.ts
/**
* Hook to select the list of threads in the editor state.
*/
function useThreadList(editor) {
	return useEditorState({
		editor,
		selector: (ctx) => ({
			threads: ctx.editor ? ThreadListPluginKey.getState(ctx.editor.state) ?? [] : [],
			activeThreadId: ctx.editor ? ThreadActiveStatusPluginKey.getState(ctx.editor.state)?.activeThreadId ?? null : null
		})
	}) || {
		threads: [],
		activeThreadId: null
	};
}
//#endregion
//#region src/extensions/trailing-node/trailing-node.ts
/**
* Taken from https://www.tiptap.dev/experiments/trailing-node/
*/
function nodeEqualsType({ types, node }) {
	return Array.isArray(types) && types.includes(node.type);
}
const TrailingNode = Extension.create({
	name: "trailingNode",
	addOptions() {
		return {
			node: "paragraph",
			minBlocks: 1
		};
	},
	addProseMirrorPlugins() {
		const plugin = new PluginKey(this.name);
		const disabledNodes = Object.entries(this.editor.schema.nodes).map(([, value]) => value).filter((node) => !(!!node.spec.allowGapCursor || node.spec.code || node.isAtom || !node.isTextblock));
		return [new Plugin({
			key: plugin,
			appendTransaction: (_, __, state) => {
				const { doc, tr, schema } = state;
				const shouldInsertNodeAtEnd = plugin.getState(state);
				const endPosition = doc.content.size;
				const type = schema.nodes[this.options.node];
				if (!shouldInsertNodeAtEnd) return;
				return tr.insert(endPosition, type.create());
			},
			state: {
				init: (_, state) => {
					const lastNode = state.tr.doc.lastChild;
					return lastNode && !nodeEqualsType({
						node: lastNode,
						types: disabledNodes
					}) || state.tr.doc.childCount < this.options.minBlocks;
				},
				apply: (tr, value) => {
					if (!tr.docChanged) return value;
					const lastNode = tr.doc.lastChild;
					return lastNode && !nodeEqualsType({
						node: lastNode,
						types: disabledNodes
					}) || tr.doc.childCount < this.options.minBlocks;
				}
			}
		})];
	}
});
//#endregion
//#region src/extensions/video/video-node-view.ts
var VideoNodeView = class {
	dom;
	contentDOM;
	node;
	editor;
	video;
	menu;
	constructor(node, getPos, HTMLAttributes, editor) {
		this.node = node;
		this.editor = editor;
		const figcaption = document.createElement("figcaption");
		figcaption.style.textAlign = "center";
		const video = document.createElement("video");
		this.video = video;
		const baseStyle = "position: relative; display: block; width: 100%; height: auto; max-height: 60vh; margin-inline: auto;";
		const attrStyle = typeof HTMLAttributes.style === "string" ? HTMLAttributes.style : "";
		video.setAttribute("style", [baseStyle, attrStyle].filter(Boolean).join(" "));
		Object.entries(HTMLAttributes).forEach(([key, value]) => {
			if (value == null || key === "style") return;
			video.setAttribute(key, String(value));
		});
		video.setAttribute("contenteditable", "false");
		video.setAttribute("controls", "true");
		video.setAttribute("controlsList", "nodownload noplaybackrate");
		this.menu = createMediaFloatingMenu("video", editor, getPos);
		const figure = document.createElement("figure");
		figure.setAttribute("data-video", "true");
		figure.append(video, this.menu.dom, figcaption);
		this.dom = figure;
		this.contentDOM = figcaption;
		this.update(node);
	}
	update(node) {
		if (node.type !== this.node.type) return false;
		this.node = node;
		if (node.attrs.src !== this.video.getAttribute("src")) if (node.attrs.src) this.video.setAttribute("src", String(node.attrs.src));
		else this.video.removeAttribute("src");
		if (this.contentDOM) this.contentDOM.style.display = node.attrs.hasCaption ? "" : "none";
		if (this.dom) this.dom.contentEditable = this.editor.isEditable ? "true" : "false";
		this.menu.setCaptionState(!!node.attrs.hasCaption);
		return true;
	}
	ignoreMutation(mutation) {
		if (this.menu.dom.contains(mutation.target)) return true;
		return false;
	}
	stopEvent(event) {
		if (this.menu.dom.contains(event.target)) {
			if (event.type === "focus" || event.type === "blur") return false;
			return true;
		}
		return false;
	}
};
//#endregion
//#region src/extensions/video/video-plugin.ts
const VideoPlugin = (editor) => new Plugin({
	appendTransaction: (_transactions, _oldState, newState) => {
		const sel = findSelectedNodeByType(newState, "video");
		if (!sel) return null;
		const { node, from } = sel;
		if (node.attrs.hasCaption === false) {
			const nodeSelection = NodeSelection.create(newState.doc, from);
			return newState.tr.setSelection(nodeSelection);
		}
		return null;
	},
	props: { handleDOMEvents: {
		paste(view, event) {
			if (!event.clipboardData || !isPastedFile(event)) return false;
			if (event.clipboardData?.getData("text/html")) return false;
			const files = Array.from(event.clipboardData.items).map((dt) => dt.getAsFile()).filter((file) => file !== null);
			if (files.length === 0) return false;
			const { tr } = view.state;
			if (!tr.selection.empty) tr.deleteSelection();
			const pos = tr.selection.from;
			const videos = files.filter((file) => /video/i.test(file.type)).map((file) => [file, ""]);
			if (videos.length === 0) return false;
			insertMedia(editor, videos, "video", pos);
			return true;
		},
		drop(view, event) {
			if (!isDroppedFile(event)) return false;
			if (event.dataTransfer?.getData("text/html")) return false;
			const videos = getDataTransferFiles(event).filter((file) => /video/i.test(file.type)).map((file) => [file, ""]);
			if (videos.length === 0) return false;
			const result = view.posAtCoords({
				left: event.clientX,
				top: event.clientY
			});
			if (result) {
				event.preventDefault();
				insertMedia(editor, videos, "video", result.pos);
				return true;
			}
			return false;
		}
	} }
});
//#endregion
//#region src/extensions/video/video.ts
const Video = Node$1.create({
	name: "video",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block",
	content: "inline*",
	selectable: true,
	draggable: true,
	defining: true,
	allowGapCursor: true,
	addNodeView() {
		return ({ node, getPos, editor, HTMLAttributes }) => new VideoNodeView(node, getPos, HTMLAttributes, editor);
	},
	addAttributes() {
		return {
			src: {
				default: null,
				parseHTML: (element) => element.getAttribute("data-src")
			},
			hasCaption: {
				default: false,
				parseHTML: (element) => {
					return !!element.querySelector(".media-caption");
				}
			}
		};
	},
	parseHTML() {
		return [{ tag: "figure[data-video]" }];
	},
	renderHTML({ node }) {
		const { src, hasCaption } = node.attrs;
		return renderMediaHTML("video", src, hasCaption);
	},
	addKeyboardShortcuts() {
		return { Enter: ({ editor }) => {
			const sel = editor.state.selection;
			const parentVideoNode = findParentNode((node) => {
				return node.type == editor.schema.nodes.video;
			})(sel);
			if (!parentVideoNode) return false;
			const endPos = parentVideoNode.pos + parentVideoNode.node.nodeSize;
			editor.chain().insertContentAt(endPos, { type: "paragraph" }).run();
			return true;
		} };
	},
	addCommands() {
		return {
			setVideo: (options) => ({ tr, dispatch, state }) => {
				const { caption } = options;
				let node;
				if (caption?.length) node = this.type.create(options, state.schema.text(caption));
				else node = this.type.create(options);
				if (options.position !== void 0) {
					if (dispatch) tr.insert(options.position, node);
				} else {
					const { selection } = tr;
					if (dispatch) tr.replaceRangeWith(selection.from, selection.to, node);
				}
				return true;
			},
			setVideoSrc: (options) => ({ tr, dispatch }) => {
				const nodeType = this.type;
				if (tr.doc.nodeAt(options.position)?.type === nodeType) {
					if (dispatch) tr.setNodeAttribute(options.position, "src", options.src);
					return true;
				}
				return false;
			},
			toggleVideoCaption: () => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "video");
				if (!sel) return false;
				const { node, from } = sel;
				const { hasCaption } = node.attrs;
				if (hasCaption === true) return chain().setNodeSelection(from).updateAttributes(this.name, { hasCaption: false }).deleteRange({
					from: from + 1,
					to: from + node.nodeSize
				}).run();
				if (hasCaption === false) return chain().setNodeSelection(from).updateAttributes(this.name, { hasCaption: true }).run();
				return true;
			},
			deleteVideo: () => ({ chain, state }) => {
				const sel = findSelectedNodeByType(state, "video");
				if (sel) {
					const { node, from } = sel;
					return chain().deleteRange({
						from,
						to: from + node.nodeSize
					}).run();
				}
				return false;
			}
		};
	},
	addProseMirrorPlugins() {
		return [new Plugin({ appendTransaction: (_, __, state) => {
			const { doc, tr, schema } = state;
			if (doc.nodeAt(0)?.type.name === "video") {
				const type = schema.nodes["paragraph"];
				return tr.insert(0, type.create());
			}
			return null;
		} }), VideoPlugin(this.editor)];
	}
});
//#endregion
//#region src/extensions/code-block/styles/cadmus-dark-styles.ts
const darkColors = {
	red500: "#ff4d87",
	orange500: "#FF974D",
	blue300: "#86D7FF",
	pink500: "#FF4D87",
	green300: "#A6D279",
	yellow500: "#FFCC3E",
	cyan500: "#61D1D1",
	grey500: "#9DADCA",
	white100: "#FFFFFF",
	white500: "#E8E8F7",
	background: "#0f172e",
	border: "#0f172e",
	preDeleteBackground: "#371932",
	preDeleteBorder: colors.red500,
	preDeleteGutter: "#482d4a",
	selectedBackground: colors.grey200,
	gutterBackground: "#242f4b",
	lineNumber: "#f2f5fc",
	languageDisplay: "#9dadca",
	cursor: "#61d1d1",
	activeLineBackground: "#1b2338",
	activeLineGutterBackground: "#2c3852"
};
/** Dark theme for `CodeBlock` nodes */
const cadmusDarkCodeBlockStyles = css`
  /* basic */
  .cm-s-cadmus-dark {
    color: ${darkColors.white100};
    background-color: ${darkColors.background};
    border: solid 1px ${darkColors.border} !important;
  }

  .cm-s-cadmus-dark.code-block-pre-delete {
    background-color: ${darkColors.preDeleteBackground};
    border: 1px solid ${darkColors.preDeleteBorder} !important;
    .CodeMirror-activeline-background {
      background-color: ${darkColors.preDeleteBackground};
    }
    .CodeMirror-linenumbers {
      background-color: ${darkColors.preDeleteGutter};
    }
    .CodeMirror-activeline-gutter {
      background-color: ${darkColors.preDeleteGutter};
    }
  }

  .cm-s-cadmus-dark .CodeMirror-selected {
    color: ${darkColors.white100} !important;
    background: ${darkColors.selectedBackground} !important;
  }

  /** user select styling */
  .cm-s-cadmus-dark .CodeMirror-focused .CodeMirror-selected,
  .cm-s-cadmus-dark .CodeMirror-line::selection,
  .cm-s-cadmus-dark .CodeMirror-line > span::selection,
  .cm-s-cadmus-dark .CodeMirror-line > span > span::selection,
  .cm-s-cadmus-dark .CodeMirror-line::-moz-selection,
  .cm-s-cadmus-dark .CodeMirror-line > span::-moz-selection,
  .cm-s-cadmus-dark .CodeMirror-line > span > span::-moz-selection {
    background: ${darkColors.selectedBackground};
  }

  .cm-s-cadmus-dark .CodeMirror-gutter,
  .cm-s-cadmus-dark .CodeMirror-gutters {
    border: none;
    background-color: ${darkColors.gutterBackground};
  }
  .cm-s-cadmus-dark .CodeMirror-linenumber,
  .cm-s-cadmus-dark .CodeMirror-linenumbers {
    color: ${darkColors.lineNumber} !important;
    background-color: transparent;
  }
  .cm-s-cadmus-dark .CodeMirror-lines {
    color: ${darkColors.white500} !important;
    background-color: transparent;
  }
  .cm-s-cadmus-dark .CodeMirror-cursor {
    border-left: 2px solid ${darkColors.cursor} !important;
  }

  .cm-s-cadmus-dark .language-display {
    color: ${darkColors.languageDisplay} !important;
  }

  /* addon: edit/machingbrackets.js & addon: edit/matchtags.js */
  .cm-s-cadmus-dark .CodeMirror-matchingbracket,
  .cm-s-cadmus-dark .CodeMirror-matchingtag {
    border-bottom: 2px solid ${darkColors.white500};
    color: ${darkColors.white500} !important;
    background-color: transparent;
  }
  .cm-s-cadmus-dark .CodeMirror-nonmatchingbracket {
    border-bottom: 2px solid ${darkColors.red500};
    color: ${darkColors.red500} !important;
    background-color: transparent;
  }

  /* addon: fold/foldgutter.js */
  .cm-s-cadmus-dark .CodeMirror-foldmarker,
  .cm-s-cadmus-dark .CodeMirror-foldgutter,
  .cm-s-cadmus-dark .CodeMirror-foldgutter-open,
  .cm-s-cadmus-dark .CodeMirror-foldgutter-folded {
    border: none;
    text-shadow: none;
    color: ${darkColors.grey500} !important;
    background-color: transparent;
  }

  /* addon: selection/active-line.js */
  .cm-s-cadmus-dark .CodeMirror-activeline-background {
    background-color: ${darkColors.activeLineBackground};
  }
  .cm-s-cadmus-dark .CodeMirror-activeline-gutter {
    background-color: ${darkColors.activeLineGutterBackground};
  }

  /* basic syntax */
  .cm-s-cadmus-dark span.cm-comment {
    color: ${darkColors.grey500};
  }
  .cm-s-cadmus-dark span.cm-atom {
    color: ${darkColors.pink500};
  }
  .cm-s-cadmus-dark span.cm-number,
  .cm-s-cadmus-dark span.cm-attribute,
  .cm-s-cadmus-dark span.cm-qualifier {
    color: ${darkColors.yellow500};
  }
  .cm-s-cadmus-dark span.cm-keyword,
  .cm-s-cadmus-dark span.cm-operator {
    color: ${darkColors.pink500};
  }
  .cm-s-cadmus-dark span.cm-string,
  .cm-s-cadmus-dark span.cm-quote {
    color: ${darkColors.green300};
  }
  .cm-s-cadmus-dark span.cm-meta {
    color: ${darkColors.pink500};
  }
  .cm-s-cadmus-dark span.cm-variable-2,
  .cm-s-cadmus-dark span.cm-variable-3,
  .cm-s-cadmus-dark span.cm-variable {
    color: ${darkColors.white500};
  }
  .cm-s-cadmus-dark span.cm-tag {
    color: ${darkColors.blue300};
  }
  .cm-s-cadmus-dark span.cm-def {
    color: ${darkColors.cyan500};
  }
  .cm-s-cadmus-dark span.cm-type,
  .cm-s-cadmus-dark span.cm-punctuation {
    color: ${darkColors.white500};
  }
  .cm-s-cadmus-dark span.cm-bracket {
    color: ${darkColors.white500};
  }
  .cm-s-cadmus-dark span.cm-builtin,
  .cm-s-cadmus-dark span.cm-special {
    color: ${darkColors.orange500};
  }
  .cm-s-cadmus-dark span.cm-link {
    color: ${darkColors.pink500};
    border-bottom: solid 1px ${darkColors.pink500};
  }
  .cm-s-cadmus-dark span.cm-error {
    color: ${darkColors.red500};
  }

  .cm-s-cadmus-dark span.cm-header {
    color: ${darkColors.red500};
  }

  .cm-s-cadmus-dark span.cm-em {
    font-style: italic;
  }

  .cm-s-cadmus-dark span.cm-strong {
    font-style: bold;
  }

  .cm-s-cadmus-dark span.cm-property {
    color: ${darkColors.orange500};
  }
`;
//#endregion
//#region src/extensions/code-block/styles/cadmus-light-styles.ts
const lightColors = {
	magenta100: "#B81466",
	red500: "#D92644",
	red300: "#4639DA",
	blue500: "#0066cc",
	blue800: "#0D2F73",
	black100: colors.black100,
	black200: "#0F172E",
	cyan500: "#00807F",
	pink500: "#CC00AA",
	yellow800: "#805500",
	grey500: "#5B6F98",
	background: "#f4f5f880",
	border: "#dee3ed",
	preDeleteBackground: colors.red100,
	preDeleteBorder: colors.red500,
	preDeleteGutter: colors.red200,
	selectedBackground: colors.blue200,
	gutterBackground: "#5973a60f",
	lineNumber: "#5b6f98",
	languageDisplay: "#5b6f98",
	cursor: "#00a3a3",
	activeLineBackground: "#fefefe",
	activeLineGutterBackground: "#f9fafb"
};
/** Light mode for `CodeBlock` nodes */
const cadmusLightCodeBlockStyles = css`
  /* basic */
  .cm-s-cadmus-light {
    color: ${colors.black100};
    background-color: ${lightColors.background};
    border: solid 1px ${lightColors.border} !important;
  }

  .cm-s-cadmus-light.code-block-pre-delete {
    background-color: ${lightColors.preDeleteBackground};
    border: 1px solid ${lightColors.preDeleteBorder} !important;
    .CodeMirror-activeline-background {
      background-color: ${lightColors.preDeleteBackground};
    }
    .CodeMirror-linenumbers {
      background-color: ${lightColors.preDeleteGutter};
    }
    .CodeMirror-activeline-gutter {
      background-color: ${lightColors.preDeleteGutter};
    }
  }

  .cm-s-cadmus-light .CodeMirror-selected {
    color: ${lightColors.black200} !important;
    background: ${lightColors.selectedBackground} !important;
  }

  /** user select styling */
  .cm-s-cadmus-light .CodeMirror-focused .CodeMirror-selected,
  .cm-s-cadmus-light .CodeMirror-line::selection,
  .cm-s-cadmus-light .CodeMirror-line > span::selection,
  .cm-s-cadmus-light .CodeMirror-line > span > span::selection,
  .cm-s-cadmus-light .CodeMirror-line::-moz-selection,
  .cm-s-cadmus-light .CodeMirror-line > span::-moz-selection,
  .cm-s-cadmus-light .CodeMirror-line > span > span::-moz-selection {
    background: ${lightColors.selectedBackground};
  }

  .cm-s-cadmus-light .CodeMirror-gutter,
  .cm-s-cadmus-light .CodeMirror-gutters {
    border: none;
    background-color: ${lightColors.gutterBackground};
  }
  .cm-s-cadmus-light .CodeMirror-linenumber,
  .cm-s-cadmus-light .CodeMirror-linenumbers {
    color: ${lightColors.lineNumber} !important;
    background-color: transparent;
  }
  .cm-s-cadmus-light .CodeMirror-lines {
    color: ${lightColors.black100} !important;
    background-color: transparent;
  }
  .cm-s-cadmus-light .CodeMirror-cursor {
    border-left: 2px solid ${lightColors.cursor} !important;
  }

  .cm-s-cadmus-light .language-display {
    color: ${lightColors.languageDisplay} !important;
  }

  /* addon: edit/machingbrackets.js & addon: edit/matchtags.js */
  .cm-s-cadmus-light .CodeMirror-matchingbracket,
  .cm-s-cadmus-light .CodeMirror-matchingtag {
    border-bottom: 2px solid ${lightColors.grey500};
    color: ${lightColors.grey500} !important;
    background-color: transparent;
  }
  .cm-s-cadmus-light .CodeMirror-nonmatchingbracket {
    border-bottom: 2px solid ${lightColors.red500};
    color: ${lightColors.red500} !important;
    background-color: transparent;
  }

  /* addon: fold/foldgutter.js */
  .cm-s-cadmus-light .CodeMirror-foldmarker,
  .cm-s-cadmus-light .CodeMirror-foldgutter,
  .cm-s-cadmus-light .CodeMirror-foldgutter-open,
  .cm-s-cadmus-light .CodeMirror-foldgutter-folded {
    border: none;
    text-shadow: none;
    color: ${lightColors.grey500} !important;
    background-color: transparent;
  }

  /* addon: selection/active-line.js */
  .cm-s-cadmus-light .CodeMirror-activeline-background {
    background-color: ${lightColors.activeLineBackground};
  }
  .cm-s-cadmus-light .CodeMirror-activeline-gutter {
    background-color: ${lightColors.activeLineGutterBackground};
  }

  /* basic syntaxs */
  .cm-s-cadmus-light span.cm-comment {
    color: ${lightColors.grey500};
  }
  .cm-s-cadmus-light span.cm-atom {
    color: ${lightColors.pink500};
  }
  .cm-s-cadmus-light span.cm-number,
  .cm-s-cadmus-light span.cm-attribute,
  .cm-s-cadmus-light span.cm-qualifier {
    color: ${lightColors.pink500};
  }
  .cm-s-cadmus-light span.cm-keyword,
  .cm-s-cadmus-light span.cm-operator {
    color: ${lightColors.pink500};
  }
  .cm-s-cadmus-light span.cm-string,
  .cm-s-cadmus-light span.cm-quote {
    color: ${lightColors.cyan500};
  }
  .cm-s-cadmus-light span.cm-meta {
    color: ${lightColors.pink500};
  }
  .cm-s-cadmus-light span.cm-variable-2,
  .cm-s-cadmus-light span.cm-variable-3,
  .cm-s-cadmus-light span.cm-variable {
    color: ${lightColors.blue800};
  }
  .cm-s-cadmus-light span.cm-tag {
    color: ${lightColors.blue500};
  }
  .cm-s-cadmus-light span.cm-def {
    color: ${lightColors.blue500};
  }
  .cm-s-cadmus-light span.cm-type,
  .cm-s-cadmus-light span.cm-punctuation {
    color: ${lightColors.black200};
  }
  .cm-s-cadmus-light span.cm-bracket {
    color: ${lightColors.grey500};
  }
  .cm-s-cadmus-light span.cm-builtin,
  .cm-s-cadmus-light span.cm-special {
    color: ${lightColors.magenta100};
  }
  .cm-s-cadmus-light span.cm-link {
    color: ${lightColors.blue800};
    border-bottom: solid 1px ${lightColors.blue800};
  }
  .cm-s-cadmus-light span.cm-error {
    color: ${lightColors.red500};
  }

  .cm-s-cadmus-light span.cm-header {
    color: ${lightColors.red500};
  }

  .cm-s-cadmus-light span.cm-em {
    font-style: italic;
  }

  .cm-s-cadmus-light span.cm-strong {
    font-style: bold;
  }

  .cm-s-cadmus-light span.cm-property {
    color: ${lightColors.yellow800};
  }
`;
//#endregion
//#region src/extensions/code-block/styles/code-block-shared-styles.ts
const config = {
	fontFamily: "ibm-plex-mono, ui-monospace, monospace",
	fontFamilyLanguageCaption: editorTypography.headingOne.fontFamily,
	fontSizeText: "14px",
	fontSizeLineNumber: "14px",
	fontSizeLanguageCaption: "12px",
	fontWeight: "400"
};
const codeBlockSharedStyles = css`
  .CodeMirror {
    border-radius: 3px;
    width: 710px;
    max-width: 90%; /* allow for some margin*/
    height: auto;
    margin: 24px auto;
    line-height: 24px;

    font-family: ${config.fontFamily};
    font-weight: ${config.fontWeight};
    font-size: ${config.fontSizeText};

    user-select: text;
  }

  .CodeMirror .language-display {
    font-size: ${config.fontSizeLanguageCaption} !important;

    position: absolute;
    top: 12px;
    right: 12px;
    line-height: 12px !important;
    font-family: ${config.fontFamilyLanguageCaption} !important;
  }

  .CodeMirror-sizer {
    min-height: 64px !important ;
  }

  .CodeMirror-lines {
    padding: 28px 0px 20px 0px;
  }

  .language-display-off .CodeMirror-lines {
    padding: 20px 0px !important;
  }

  .CodeMirror-line {
    font-size: ${config.fontSizeText} !important ;
    padding: 0 16px !important;
  }

  .CodeMirror-linenumber {
    font-size: ${config.fontSizeLineNumber} !important;
    display: inline-flex;
    justify-content: right;
  }
`;
//#endregion
//#region src/extensions/code-block/styles/index.ts
const codeBlockStyles = css`
  ${css`
  /* BASICS */

  .CodeMirror {
    /* Set height, width, borders, and global font properties here */
    font-family: monospace;
    height: 300px;
    color: black;
    direction: ltr;
  }

  /* PADDING */

  .CodeMirror-lines {
    padding: 4px 0; /* Vertical padding around content */
  }
  .CodeMirror pre.CodeMirror-line,
  .CodeMirror pre.CodeMirror-line-like {
    padding: 0 4px; /* Horizontal padding of content */
  }

  .CodeMirror-scrollbar-filler,
  .CodeMirror-gutter-filler {
    background-color: white; /* The little square between H and V scrollbars */
  }

  /* GUTTER */

  .CodeMirror-gutters {
    border-right: 1px solid #ddd;
    background-color: #f7f7f7;
    white-space: nowrap;
  }
  .CodeMirror-linenumbers {
  }
  .CodeMirror-linenumber {
    padding: 0 4px 0 4px;
    min-width: 20px;
    text-align: right;
    color: #999;
    white-space: nowrap;
  }

  .CodeMirror-guttermarker {
    color: black;
  }
  .CodeMirror-guttermarker-subtle {
    color: #999;
  }

  /* CURSOR */

  .CodeMirror-cursor {
    border-left: 1px solid black;
    border-right: none;
    width: 0;
  }
  /* Shown when moving in bi-directional text */
  .CodeMirror div.CodeMirror-secondarycursor {
    border-left: 1px solid silver;
  }
  .cm-fat-cursor .CodeMirror-cursor {
    width: auto;
    border: 0 !important;
    background: #7e7;
  }
  .cm-fat-cursor div.CodeMirror-cursors {
    z-index: 1;
  }
  .cm-fat-cursor .CodeMirror-line::selection,
  .cm-fat-cursor .CodeMirror-line > span::selection,
  .cm-fat-cursor .CodeMirror-line > span > span::selection {
    background: transparent;
  }
  .cm-fat-cursor .CodeMirror-line::-moz-selection,
  .cm-fat-cursor .CodeMirror-line > span::-moz-selection,
  .cm-fat-cursor .CodeMirror-line > span > span::-moz-selection {
    background: transparent;
  }
  .cm-fat-cursor {
    caret-color: transparent;
  }
  @-moz-keyframes blink {
    0% {
    }
    50% {
      background-color: transparent;
    }
    100% {
    }
  }
  @-webkit-keyframes blink {
    0% {
    }
    50% {
      background-color: transparent;
    }
    100% {
    }
  }
  @keyframes blink {
    0% {
    }
    50% {
      background-color: transparent;
    }
    100% {
    }
  }

  /* Can style cursor different in overwrite (non-insert) mode */
  .CodeMirror-overwrite .CodeMirror-cursor {
  }

  .cm-tab {
    display: inline-block;
    text-decoration: inherit;
  }

  .CodeMirror-rulers {
    position: absolute;
    left: 0;
    right: 0;
    top: -50px;
    bottom: 0;
    overflow: hidden;
  }
  .CodeMirror-ruler {
    border-left: 1px solid #ccc;
    top: 0;
    bottom: 0;
    position: absolute;
  }

  /* DEFAULT THEME */

  .cm-s-default .cm-header {
    color: blue;
  }
  .cm-s-default .cm-quote {
    color: #090;
  }
  .cm-negative {
    color: #d44;
  }
  .cm-positive {
    color: #292;
  }
  .cm-header,
  .cm-strong {
    font-weight: bold;
  }
  .cm-em {
    font-style: italic;
  }
  .cm-link {
    text-decoration: underline;
  }
  .cm-strikethrough {
    text-decoration: line-through;
  }

  .cm-s-default .cm-keyword {
    color: #708;
  }
  .cm-s-default .cm-atom {
    color: #219;
  }
  .cm-s-default .cm-number {
    color: #164;
  }
  .cm-s-default .cm-def {
    color: #00f;
  }
  .cm-s-default .cm-variable,
  .cm-s-default .cm-punctuation,
  .cm-s-default .cm-property,
  .cm-s-default .cm-operator {
  }
  .cm-s-default .cm-variable-2 {
    color: #05a;
  }
  .cm-s-default .cm-variable-3,
  .cm-s-default .cm-type {
    color: #085;
  }
  .cm-s-default .cm-comment {
    color: #a50;
  }
  .cm-s-default .cm-string {
    color: #a11;
  }
  .cm-s-default .cm-string-2 {
    color: #f50;
  }
  .cm-s-default .cm-meta {
    color: #555;
  }
  .cm-s-default .cm-qualifier {
    color: #555;
  }
  .cm-s-default .cm-builtin {
    color: #30a;
  }
  .cm-s-default .cm-bracket {
    color: #997;
  }
  .cm-s-default .cm-tag {
    color: #170;
  }
  .cm-s-default .cm-attribute {
    color: #00c;
  }
  .cm-s-default .cm-hr {
    color: #999;
  }
  .cm-s-default .cm-link {
    color: #00c;
  }

  .cm-s-default .cm-error {
    color: #f00;
  }
  .cm-invalidchar {
    color: #f00;
  }

  .CodeMirror-composing {
    border-bottom: 2px solid;
  }

  /* Default styles for common addons */

  div.CodeMirror span.CodeMirror-matchingbracket {
    color: #0b0;
  }
  div.CodeMirror span.CodeMirror-nonmatchingbracket {
    color: #a22;
  }
  .CodeMirror-matchingtag {
    background: rgba(255, 150, 0, 0.3);
  }
  .CodeMirror-activeline-background {
    background: #e8f2ff;
  }

  /* STOP */

  /* The rest of this file contains styles related to the mechanics of
   the editor. You probably shouldn't touch them. */

  .CodeMirror {
    position: relative;
    overflow: hidden;
    background: white;
  }

  .CodeMirror-scroll {
    overflow: scroll !important; /* Things will break if this is overridden */
    /* 50px is the magic margin used to hide the element's real scrollbars */
    /* See overflow: hidden in .CodeMirror */
    margin-bottom: -50px;
    margin-right: -50px;
    padding-bottom: 50px;
    height: 100%;
    outline: none; /* Prevent dragging from highlighting the element */
    position: relative;
    z-index: 0;
  }
  .CodeMirror-sizer {
    position: relative;
    border-right: 50px solid transparent;
  }

  /* The fake, visible scrollbars. Used to force redraw during scrolling
   before actual scrolling happens, thus preventing shaking and
   flickering artifacts. */
  .CodeMirror-vscrollbar,
  .CodeMirror-hscrollbar,
  .CodeMirror-scrollbar-filler,
  .CodeMirror-gutter-filler {
    position: absolute;
    z-index: 6;
    display: none;
    outline: none;
  }
  .CodeMirror-vscrollbar {
    right: 0;
    top: 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .CodeMirror-hscrollbar {
    bottom: 0;
    left: 0;
    overflow-y: hidden;
    overflow-x: scroll;
  }
  .CodeMirror-scrollbar-filler {
    right: 0;
    bottom: 0;
  }
  .CodeMirror-gutter-filler {
    left: 0;
    bottom: 0;
  }

  .CodeMirror-gutters {
    position: absolute;
    left: 0;
    top: 0;
    min-height: 100%;
    z-index: 3;
  }
  .CodeMirror-gutter {
    white-space: normal;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    margin-bottom: -50px;
  }
  .CodeMirror-gutter-wrapper {
    position: absolute;
    z-index: 4;
    background: none !important;
    border: none !important;
  }
  .CodeMirror-gutter-background {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 4;
  }
  .CodeMirror-gutter-elt {
    position: absolute;
    cursor: default;
    z-index: 4;
  }
  .CodeMirror-gutter-wrapper ::selection {
    background-color: transparent;
  }
  .CodeMirror-gutter-wrapper ::-moz-selection {
    background-color: transparent;
  }

  .CodeMirror-lines {
    cursor: text;
    min-height: 1px; /* prevents collapsing before first draw */
  }
  .CodeMirror pre.CodeMirror-line,
  .CodeMirror pre.CodeMirror-line-like {
    /* Reset some styles that the rest of the page might have set */
    -moz-border-radius: 0;
    -webkit-border-radius: 0;
    border-radius: 0;
    border-width: 0;
    background: transparent;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    white-space: pre;
    word-wrap: normal;
    line-height: inherit;
    color: inherit;
    z-index: 2;
    position: relative;
    overflow: visible;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-variant-ligatures: contextual;
    font-variant-ligatures: contextual;
  }
  .CodeMirror-wrap pre.CodeMirror-line,
  .CodeMirror-wrap pre.CodeMirror-line-like {
    word-wrap: break-word;
    white-space: pre-wrap;
    word-break: normal;
  }

  .CodeMirror-linebackground {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
  }

  .CodeMirror-linewidget {
    position: relative;
    z-index: 2;
    padding: 0.1px; /* Force widget margins to stay inside of the container */
  }

  .CodeMirror-widget {
  }

  .CodeMirror-rtl pre {
    direction: rtl;
  }

  .CodeMirror-code {
    outline: none;
  }

  /* Force content-box sizing for the elements where we expect it */
  .CodeMirror-scroll,
  .CodeMirror-sizer,
  .CodeMirror-gutter,
  .CodeMirror-gutters,
  .CodeMirror-linenumber {
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }

  .CodeMirror-measure {
    position: absolute;
    width: 100%;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }

  .CodeMirror-cursor {
    position: absolute;
    pointer-events: none;
  }
  .CodeMirror-measure pre {
    position: static;
  }

  div.CodeMirror-cursors {
    visibility: hidden;
    position: relative;
    z-index: 3;
  }
  div.CodeMirror-dragcursors {
    visibility: visible;
  }

  .CodeMirror-focused div.CodeMirror-cursors {
    visibility: visible;
  }

  .CodeMirror-selected {
    background: #d9d9d9;
  }
  .CodeMirror-focused .CodeMirror-selected {
    background: #d7d4f0;
  }
  .CodeMirror-crosshair {
    cursor: crosshair;
  }

  .cm-searching {
    background-color: #ffa;
    background-color: rgba(255, 255, 0, 0.4);
  }

  /* Used to force a border model for a node */
  .cm-force-border {
    padding-right: 0.1px;
  }

  @media print {
    /* Hide the cursor when printing */
    .CodeMirror div.CodeMirror-cursors {
      visibility: hidden;
    }
  }

  .CodeMirror.CodeMirror-Readonly div.CodeMirror-cursors {
    visibility: hidden;
  }

  /* See issue #2901 */
  .cm-tab-wrap-hack:after {
    content: "";
  }

  /* Help users use markselection to safely style text background */
  span.CodeMirror-selectedtext {
    background: none;
  }
`}
  ${codeBlockSharedStyles}
  ${cadmusDarkCodeBlockStyles}
  ${cadmusLightCodeBlockStyles}
`;
//#endregion
//#region src/extensions/hidden-characters/styles.ts
/**
* Glyph styling for the Hidden Characters marks, injected into the editor's
* global `.ProseMirror` stylesheet (see CadmusEditorWrapper).
*
* Two styles are used for hidden characters:
* - Width-bearing chars (space, nbsp, tab): inline decorations on the real
*   character (so text selection stays continuous), glyph overlaid via
*   `::after` from the `--hc-glyph` property.
* - Chars with no box to style (zero-width, soft hyphen, pilcrow, line break):
*   inserted `.cdm-hidden-char-widget` chips.
*/
const hiddenCharactersStyles = css`
  .cdm-hidden-char-inline {
    position: relative;
  }

  .cdm-hidden-char-inline::after {
    content: var(--hc-glyph);
    position: absolute;
    top: 54%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1;
    font-weight: 600;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }

  .cdm-hidden-char-space::after {
    color: ${HIDDEN_CHAR_STYLES.space.fg};
    font-size: 0.5em;
  }

  .cdm-hidden-char-nbsp::after {
    color: ${HIDDEN_CHAR_STYLES.nbsp.fg};
    font-size: 0.45em;
  }

  .cdm-hidden-char-tab::after {
    color: ${HIDDEN_CHAR_STYLES.tab.fg};
    font-size: 0.7em;
  }

  .cdm-hidden-char-widget {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7em;
    line-height: 1;
    border-radius: 2px;
    padding: 4px;
    margin: 0 1px;
    vertical-align: baseline;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }

  .cdm-hidden-char-zero-width {
    color: ${HIDDEN_CHAR_STYLES["zero-width"].fg};
    background: ${HIDDEN_CHAR_STYLES["zero-width"].bg};
  }

  .cdm-hidden-char-soft-hyphen {
    color: ${HIDDEN_CHAR_STYLES["soft-hyphen"].fg};
    background: ${HIDDEN_CHAR_STYLES["soft-hyphen"].bg};
  }

  .cdm-hidden-char-pilcrow {
    color: ${HIDDEN_CHAR_STYLES.pilcrow.fg};
    background: ${HIDDEN_CHAR_STYLES.pilcrow.bg};
  }

  .cdm-hidden-char-break {
    color: ${HIDDEN_CHAR_STYLES.break.fg};
    background: ${HIDDEN_CHAR_STYLES.break.bg};
  }
`;
//#endregion
//#region src/extensions/selection/styles.ts
const selectionStyles = css`
  .selection-highlight {
    background: #f0f9ff;
    border-bottom: 2px solid #bae6fd;
    transition:
      background 0.2s ease,
      border 0.2s ease;
  }
`;
//#endregion
//#region src/extensions/thread/styles.ts
const threadStyles = css`
  @keyframes pendingPulse {
    0%,
    100% {
      background: #fff7e0;
      border-bottom-color: #f2ebd4;
    }
  }

  thread {
    background: #fff7e0;
    border-bottom: 2px solid #f2ebd4;
    transition:
      background 0.2s ease,
      border 0.2s ease;

    &:hover:not([data-thread-resolved="true"]):not(
        [data-thread-pending="true"]
      ) {
      background: #ffeecc;
      border-bottom: 2px solid #e6d9b8;
    }

    &.thread-active:not([data-thread-resolved="true"]):not(
        [data-thread-pending="true"]
      ) {
      background: #ffe697;
      border-bottom: 2px solid #d3bb70;
    }

    & span.thread-active {
      background: #ffe4ad;
      padding: 2px 0;
      border-bottom: 2px solid #f0d295;
    }

    /* Pending thread styles - animated amber pulse */
    &[data-thread-pending="true"] {
      animation: pendingPulse 0.4s ease-in-out infinite;

      &:hover {
        animation-play-state: paused;
        background: #ffeecc;
        border-bottom: 2px solid #e6d9b8;
      }

      &.thread-active {
        animation-play-state: paused;
        background: #ffe697;
        border-bottom: 2px solid #d3bb70;
      }

      /* Element highlighted as thread selected at Marking-Feedback page */
      & span.thread-active {
        background: #ffe4ad;
        border-bottom: 2px solid #f0d295;
      }
    }

    /* Resolved thread styles - pastel green with precedence */
    &[data-thread-resolved="true"] {
      background: #e8f5e8;
      border-bottom: 2px solid #c8e6c8;

      &:hover {
        background: #d4edd4;
        border-bottom: 2px solid #b2d4b2;
      }

      &.thread-active {
        background: #c1e4c1;
        border-bottom: 2px solid #9cc89c;
      }

      /* Element highlighted as thread selected at Marking-Feedback page */
      & span.thread-active {
        background: #c1e4c1;
      }
    }
  }
`;
//#endregion
//#region src/react/CadmusEditorWrapper.tsx
const blockIndentStyles = () => Array.from(Array(9).keys()).map((indent) => css`
      & > *[data-indent="${indent}"] {
        padding-left: ${45 + indent * 27}px;
      }

      & > *[data-indent-special="hanging"] {
        &[data-indent="${indent}"] {
          padding-left: ${45 + (indent + 1) * 27}px;
        }
      }
    `);
const indentation = css`
  ${blockIndentStyles}
  tab-size: 27px;
  & > *[data-indent-special="hanging"] {
    text-indent: -27px;
    padding-left: calc(45px + 27px);
  }
  & > *[data-indent-special="firstLine"] {
    text-indent: 27px;
  }
  & > *[data-indent-special="normal"] {
    text-indent: 0px;
  }
`;
const blocks = (fullWidth) => css`
  & > .ProseMirror-gapcursor {
    max-width: ${fullWidth ? "100%" : "800px"};
    min-width: 320px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    padding-left: 45px;
    padding-right: 45px;
    box-sizing: border-box;
    display: inline-block;
  }
  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > blockquote,
  & > p,
  & > ul,
  & > ol,
  & > hr,
  & > pre {
    padding-right: 45px;
    padding-left: 45px;
    color: ${(p) => p.theme.text.main};
    box-sizing: border-box;
    max-width: ${fullWidth ? "100%" : "min(800px, 100%)"};
    margin-left: auto;
    margin-right: auto;
    position: relative;
    margin-top: 0;
    margin-bottom: 0;
  }

  a,
  a:any-link {
    color: ${(p) => p.theme.text.accent};
  }

  .selected-link {
    color: ${(p) => p.theme.text.accent};
    text-decoration: underline;
  }

  .outer-placeholder {
    white-space: nowrap;
    color: ${(p) => p.theme.text.shade1};
  }

  .inner-placeholder {
    position: absolute;
    left: 0;
    white-space: pre-wrap;
    width: 100%;
    text-indent: initial;
    max-height: 270px;
    overflow: hidden;
    padding: 0 45px;
    box-sizing: border-box;
  }

  p {
    font-weight: ${editorTypography["bodyMd"].fontWeight};
    font-size: ${editorTypography["bodyMd"].fontSize};
    line-height: ${editorTypography["bodyMd"].lineHeight};
    letter-spacing: ${editorTypography["bodyMd"].letterSpacing};
    padding-top: ${editorTypography["bodyMd"].paddingTop};
    padding-bottom: ${editorTypography["bodyMd"].paddingBottom};
    min-height: calc(
      ${editorTypography["bodyMd"].fontSize} *
        ${editorTypography["bodyMd"].lineHeight}
    );
    font-family: ${editorTypography["bodyMd"].fontFamily};
    margin-block-start: 0;
    margin-block-end: 0;
  }

  h1 {
    color: ${(p) => p.theme.text.heading};
    font-weight: ${editorTypography.headingOne.fontWeight};
    font-size: ${editorTypography.headingOne.fontSize};
    line-height: ${editorTypography.headingOne.lineHeight};
    letter-spacing: ${editorTypography.headingOne.letterSpacing};
    padding-top: ${editorTypography.headingOne.paddingTop};
    padding-bottom: ${editorTypography.headingOne.paddingBottom};
    font-family: ${editorTypography.headingOne.fontFamily};
    min-height: calc(
      ${editorTypography.headingOne.fontSize} *
        ${editorTypography.headingOne.lineHeight}
    );
  }

  h2 {
    color: ${(p) => p.theme.text.heading};
    font-weight: ${editorTypography.headingTwo.fontWeight};
    font-size: ${editorTypography.headingTwo.fontSize};
    line-height: ${editorTypography.headingTwo.lineHeight};
    letter-spacing: ${editorTypography.headingTwo.letterSpacing};
    padding-top: ${editorTypography.headingTwo.paddingTop};
    padding-bottom: ${editorTypography.headingTwo.paddingBottom};
    font-family: ${editorTypography.headingTwo.fontFamily};
    min-height: calc(
      ${editorTypography.headingTwo.fontSize} *
        ${editorTypography.headingTwo.lineHeight}
    );
  }

  h3 {
    color: ${(p) => p.theme.text.heading};
    font-weight: ${editorTypography.headingThree.fontWeight};
    font-size: ${editorTypography.headingThree.fontSize};
    line-height: ${editorTypography.headingThree.lineHeight};
    letter-spacing: ${editorTypography.headingThree.letterSpacing};
    padding-top: ${editorTypography.headingThree.paddingTop};
    padding-bottom: ${editorTypography.headingThree.paddingBottom};
    font-family: ${editorTypography.headingThree.fontFamily};
    min-height: calc(
      ${editorTypography.headingThree.fontSize} *
        ${editorTypography.headingThree.lineHeight}
    );
  }

  h4 {
    color: ${(p) => p.theme.text.heading};
    font-weight: ${editorTypography.headingFour.fontWeight};
    font-size: ${editorTypography.headingFour.fontSize};
    line-height: ${editorTypography.headingFour.lineHeight};
    letter-spacing: ${editorTypography.headingFour.letterSpacing};
    padding-top: ${editorTypography.headingFour.paddingTop};
    padding-bottom: ${editorTypography.headingFour.paddingBottom};
    font-family: ${editorTypography.headingFour.fontFamily};
    min-height: calc(
      ${editorTypography.headingFour.fontSize} *
        ${editorTypography.headingFour.lineHeight}
    );
  }

  blockquote {
    max-width: 800px;
    min-width: 320px;
    padding-top: 18px;
    padding-bottom: 18px;
    padding-left: 45px;
    padding-right: 45px;
    box-sizing: border-box;
    margin: 0;
    margin-left: auto;
    margin-right: auto;
    font-family: ${editorTypography.blockquote.fontFamily};
    display: block;
    position: relative;
    & > * {
      margin: 0;
      padding: 0;
      padding-left: 36px;
      border-left: 1px solid ${(p) => p.theme.text.shade1};
      color: ${(p) => p.theme.text.shade1};
    }
  }

  pre {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  hr {
    border: 0;
    height: 1px;
    margin-top: 18px;
    margin-bottom: 18px;
    background-color: ${(p) => p.theme.divider};
  }

  li {
    font-weight: ${editorTypography["bodyMd"].fontWeight};
    font-size: ${editorTypography["bodyMd"].fontSize};
    line-height: ${editorTypography["bodyMd"].lineHeight};
    letter-spacing: ${editorTypography["bodyMd"].letterSpacing};
    padding-top: ${editorTypography["bodyMd"].paddingTop};
    padding-bottom: ${editorTypography["bodyMd"].paddingBottom};
    font-family: ${editorTypography.bodyMd.fontFamily};
    list-style-image: none;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    padding-inline-start: 40px;
  }

  ul[data-type="taskList"] {
    padding-inline-start: 18px;
  }

  /* First level OLs and ULs are padded */
  & > ol,
  & > ul {
    padding-inline-start: 81px;
  }
  & > ul[data-type="taskList"] {
    padding-inline-start: 63px;
  }

  ol {
    list-style-type: decimal;
    /* Editor layout styles */
    max-width: 800px;
    min-width: 320px;
    padding-right: 45px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    display: block;

    /* UnorderedList styles */
    margin-top: 0;
    margin-bottom: 0;
  }

  ol ol {
    list-style-type: lower-alpha;
  }
  ol ol ol {
    list-style-type: lower-roman;
  }
  ol ol ol ol {
    list-style-type: decimal;
  }
  ol ol ol ol ol {
    list-style-type: lower-alpha;
  }
  ol ol ol ol ol ol {
    list-style-type: lower-roman;
  }
  ol ol ol ol ol ol ol {
    list-style-type: decimal;
  }
  ol ol ol ol ol ol ol ol {
    list-style-type: lower-alpha;
  }

  ul {
    list-style-type: disc;
    /* Editor layout styles */
    max-width: min(800px, 100%);
    padding-right: 45px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    display: block;
    /* UnorderedList styles */
    margin-top: 0;
    margin-bottom: 0;
  }

  ul[data-type="taskList"] {
    list-style: none;

    & > li[data-checked="true"] {
      & > div > p:first-child {
        text-decoration: line-through;
      }
    }

    & > li {
      display: flex;
      @media print {
        display: list-item;
        margin-inline-start: 16px;
        list-style-position: outside;
        padding-left: 0.6ch;
        & > label {
          display: none;
        }
        list-style-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHlsZT0ic3Ryb2tlLXdpZHRoOiAxcHg7IHN0cm9rZTogYmxhY2s7Ij4KICA8ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJpbmhlcml0IiBmaWxsLW9wYWNpdHk9Ii43MiIgcng9IjIiIC8+CiAgICA8cmVjdCB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHg9IjEiIHk9IjEiIGZpbGw9IiNGRkYiIHJ4PSIxIiAvPgogIDwvZz4KPC9zdmc+Cg==");
        &[data-checked="true"] {
          list-style-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSIjMDBGIiBmaWxsLW9wYWNpdHk9Ii41NCIgb3BhY2l0eT0iLjU0IiByeD0iMiIgLz4KICAgIDxyZWN0IHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgeD0iMSIgeT0iMSIgZmlsbD0iIzAwRiIgcng9IjEiIC8+CiAgICA8cG9seWdvbiBmaWxsPSIjRkZGIiBwb2ludHM9IjYuNTM1IDkuMDY1IDQuNDggNy4zNCAzIDguODA4IDYuNTM1IDEyIDEzIDUuNDY4IDExLjUyIDQiIC8+CiAgPC9nPgo8L3N2Zz4K");
        }
      }
      margin-top: 9px;

      & > label {
        flex: 0 0 auto;
        margin-right: 0.5rem;
        align-self: baseline;
      }
      & > div {
        max-width: min(800px, 100%);
        &:not(ul[data-type="task-list"], li, label, input) {
          margin: 0;
        }
      }
    }
  }

  ul ul {
    list-style-type: circle;
  }
  ul ul ul {
    list-style-type: square;
  }
  ul ul ul ul {
    list-style-type: disc;
  }
  ul ul ul ul ul {
    list-style-type: circle;
  }
  ul ul ul ul ul ul {
    list-style-type: square;
  }
  ul ul ul ul ul ul ul {
    list-style-type: disc;
  }
  ul ul ul ul ul ul ul ul {
    list-style-type: circle;
  }
`;
const mediaStyles = css`
  figure {
    display: block;
    margin: 1em auto;
    padding: 0;
    position: relative;
    max-width: 800px;

    figcaption {
      border: 0;
      display: block;
      font-size: 14px;
      line-height: 24px;
      width: 100%;
      max-width: 800px;
      margin: 1em auto 0;
      padding: 0 45px;
      box-sizing: border-box;
      /* for absolute positioning of ::before placeholder */
      position: relative;
      outline: none;
      background: none;
      resize: none;
      user-select: text;

      &.no-caption {
        margin: 0;
        padding: 0;
        font-size: 0;
        /* Resize handles are difficult to hit without this*/
        line-height: 0;
      }
    }

    img:not(.ProseMirror-separator) {
      display: block;
      box-sizing: border-box;
      min-width: 160px;
      width: 100%;
      min-height: 63px;
      object-fit: contain;
      margin-left: auto;
      margin-right: auto;
      cursor: pointer;

      &[data-image-uploading="true"] {
        opacity: 0.36;
      }
    }

    span[data-loading="true"] {
      ${css`
  display: block;
  width: 18px;
  height: 18px;
  border-right: 2px solid ${(p) => p.theme.text.shade1};
  border-top: 2px solid ${(p) => p.theme.background.action3};
  border-bottom: 2px solid ${(p) => p.theme.background.action3};
  border-left: 2px solid ${(p) => p.theme.background.action3};
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 9px);
  left: calc(50% - 9px);
  transform: translate(-50%, -50%);
  animation: ${keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`} 1s linear infinite;
`}
    }

    &.ProseMirror-selectednode {
      img {
        outline: 1.5px solid ${(p) => p.theme.text.accent};
        outline-offset: 3px;
      }
      outline: none;
    }
  }

  figure[data-loading="true"] {
    img {
      opacity: 0.36;
    }
  }

  :not(.ProseMirror-focused) > figure.ProseMirror-selectednode > img {
    outline: 3px solid ${(p) => p.theme.background.action3};
    outline-offset: 2px;
  }

  figure[data-empty-node] {
    figcaption::before {
      content: "Add a caption...";
      color: ${(p) => p.theme.text.shade1};
      /* place the text behind text cursor */
      z-index: -1;
    }
  }

  figure:not([data-table-group]) {
    page-break-inside: avoid;
  }

  @media print {
    /* 230mm = A4 page (297mm) minus top + bottom margins (2 × 0.5in ≈ 25mm each) */
    figure img:not(.ProseMirror-separator) {
      max-height: 230mm;
      object-fit: contain;
    }
  }

  figure {
    &[data-loading],
    &[data-video],
    &[data-audio],
    &[data-image-width="fitToText"],
    &[data-image-width="original"] {
      padding: 0px 45px;
    }

    &[data-video],
    &[data-audio] {
      position: relative;

      &[contenteditable="true"]:hover > .media-floating-menu,
      &[contenteditable="true"].ProseMirror-selectednode > .media-floating-menu,
      &[contenteditable="true"]:focus-within > .media-floating-menu {
        display: flex;
      }
    }
  }

  .media-floating-menu {
    position: absolute;
    top: 4px;
    right: 49px;
    display: none;
    align-items: center;
    gap: 2px;
    z-index: 10;
    background: white;
    box-shadow:
      0 0 1px 0 rgba(71, 92, 133, 0.54),
      0 2px 9px -2px rgba(71, 92, 133, 0.15),
      0 12px 12px -3px rgba(71, 92, 133, 0.06);
    border-radius: 6px;
    padding: 2px;

    @media print {
      display: none !important;
    }
  }

  .media-floating-menu-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 4px;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: ${(p) => p.theme.text.shade1};
    cursor: pointer;
    outline: 0;

    &:hover {
      background: ${(p) => p.theme.colors.grey50};
    }

    &:active {
      background: ${(p) => p.theme.colors.grey100};
    }

    &:focus-visible {
      ${(p) => p.theme.focus};
      outline: 0;
    }

    svg {
      display: block;
    }
  }

  figure .media-src-caption {
    display: none;
    width: 100%;
    text-decoration: none;
    text-align: center;
    color: inherit;
    position: relative;
    margin-top: 4px;
    color: ${(p) => p.theme.text.shade2};
    word-break: break-all;

    @media print {
      display: block;
    }
  }

  .img-wrapper {
    position: relative;
    display: block;
    width: 710px; /** 800px - 45px * 2 horizontal padding */
    max-width: 100%;

    &[data-image-width="full"] {
      width: 800px;
      object-fit: cover;
    }

    &[data-image-width="fitToText"] {
      object-fit: contain;
    }

    &[data-image-width="original"] {
      object-fit: contain;
    }

    &[data-image-width="custom"] {
      object-fit: cover;
    }

    &[data-image-align="left"] {
      margin: 0px auto 0px 0px;
    }

    &[data-image-align="right"] {
      margin: 0px 0px 0px auto;
    }

    &[data-image-align="center"] {
      margin: 0px auto;
    }
  }

  .resize-point {
    width: 9px;
    height: 9px;
    background: white;
    border: 1.5px solid ${(p) => p.theme.text.accent};
    box-sizing: border-box;
    border-radius: 2px;
    position: absolute;
  }

  .resize-point--ne {
    left: -7px;
    top: -7px;
    cursor: nwse-resize; /*resize-point cursor*/
  }

  .resize-point--nw {
    right: -7px;
    top: -7px;
    cursor: nesw-resize;
  }

  .resize-point--sw {
    left: -7px;
    bottom: -7px;
    cursor: nesw-resize;
    background: white;
  }

  .resize-point--se {
    right: -7px;
    bottom: -7px;
    cursor: nwse-resize;
  }
`;
const widgetStyles = css`
  .ProseMirror-widget.image-uploader-error {
    width: 100%;
    padding: 45px;
    box-sizing: border-box;
    max-width: 710px;
    min-height: 99px;
    margin: 1em auto;
    text-align: center;
    background: ${(p) => p.theme.background.action1};

    & > p {
      margin: 18px 0;
    }

    & > img {
      width: 100%;
      max-width: 540px;
    }
  }

  .cui-LinkButton {
    /* Apply editorTypography styles based on inline inheritance or bodySm default */
    font-size: ${editorTypography["bodySm"].fontSize};
    letter-spacing: ${editorTypography["bodySm"].letterSpacing};
    font-weight: initial;
    line-height: ${editorTypography["bodySm"].lineHeight};
    font-family: ${editorTypography.bodySm.fontFamily};

    text-align: left;
    background: transparent;
    text-decoration: none;
    border: none;
    padding: 0;
    outline: 0;
    margin-left: 0;
    margin-right: 0;
    position: relative;
    cursor: pointer;
  }

  .cui-LinkButton > span {
    display: inline;

    color: ${(p) => p.theme.text.accent};
    fill: ${(p) => p.theme.text.accent};
    background-image:
      linear-gradient(
        to right,
        ${(p) => p.theme.text.accent} 0%,
        ${(p) => p.theme.text.accent} 100%
      ),
      linear-gradient(
        to right,
        ${(p) => p.theme.text.shade2} 0%,
        ${(p) => p.theme.text.shade2} 50%,
        transparent 50%,
        transparent 100%
      );

    background-size:
      0% 1px,
      2px 1px;
    background-repeat: no-repeat, repeat-x;
    background-position: bottom left;

    transform: translateZ(0);
    will-change: background;
    transition: background 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  /* On hover, animate the underline of the LinkButtonText */
  .cui-LinkButton:hover > span {
    background-size:
      100% 1px,
      2px 1px;
  }
  .cui-LinkButton:active > span,
  .cui-LinkButton:focus > span {
    background-size:
      100% 2px,
      2px 1px;
  }
`;
const suggestionStyles = css`
  .suggestion {
    text-decoration: solid underline red;
    &:hover {
      background: pink;
    }
  }
`;
const blink = keyframes`
  to {
    visibility: hidden;
  }
`;
const CadmusEditorWrapper = styled.div`
  /* Grow to occupy full height */
  flex: 1;

  .ProseMirror {
    /* Reset numberrings counter */
    counter-reset: blank-counter footnote-node;
    --table-background-color: ${(p) => p.theme.colors.blue200};
    position: relative;
    font-variant-ligatures: none;
    font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
    outline: none;
    white-space: pre-wrap;
    word-break: break-word;
    min-width: 320px;
    font-family: ${fontFamilySans};

    &:focus {
      outline: none;
    }

    ${codeBlockStyles}

    ${codeStyles}

    ${indentation}

    /* Pass the prop inside the blocks */
    ${({ fullWidth }) => blocks(fullWidth)}

    ${tableStyles}

    ${mediaStyles}

    ${mathStyles}

    ${widgetStyles}

    ${suggestionStyles}

    ${hiddenCharactersStyles}

    ${threadStyles}

    ${selectionStyles}

    &:not([data-suggestable="false"]) {
      ${suggestionStyles}
    }

    .empty-node {
      &::before {
        content: attr(data-placeholder-text);
        display: inline-block;
        pointer-events: none;
        color: ${(p) => p.theme.text.shade1};
      }
    }

    [data-emoji-text] {
      img.emoji {
        height: 1em;
        width: 1em;
        margin: 0 0.05em 0 0.1em;
        vertical-align: -0.1em;
      }
    }
    /* Style individual blank underlines */
    [data-cadmus-blank] {
      user-select: none;
      color: ${(p) => p.theme.colors.pink800};
      padding: 2px 16px 1px 8px;
      border-radius: 2px;
      background: ${(p) => p.theme.colors.npink200};
      display: inline-block;
      margin: 1.5px 5px;
      counter-increment: blank-counter;
      &:before {
        content: counter(blank-counter) ". ";
      }
    }

    footnote {
      background: #fcf6fc;
      padding: 1px 4px 3px;
      vertical-align: super;
      font-size: 80%;
      counter-increment: footnote-node;

      &:before {
        content: counter(footnote-node);
      }

      &:hover {
        background: ${(p) => p.theme.colors.lilac300};
      }
    }
    /**
     * When the footnote editor is active, don't show the default outline
     * around the footnote superscript.
     */
    footnote.ProseMirror-selectednode.footnote-active {
      outline: none; /* Remove default outline */
    }
    footnote.footnote-active {
      background: #ffe59e;
    }

    .footnote-content {
      display: none;
    }

    [data-cadmus-pasted] {
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      vertical-align: middle;
      gap: 3px;
      max-width: 100%;
      padding-left: 9px;
      padding-right: 2px;
      margin: 0 2px;
      box-sizing: border-box;
      border-radius: 12px;
      line-height: 24px;
      text-indent: 0;

      font-size: ${editorTypography["bodySm"].fontSize};
      letter-spacing: ${editorTypography["bodySm"].letterSpacing};
      font-family: ${editorTypography.bodySm.fontFamily};
      white-space: initial;
      word-break: break-all;

      color: ${(p) => p.theme.text.shade1};
      background: ${(p) => p.theme.background.action2};

      .icon-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: none;
        background: transparent;

        cursor: pointer;

        &:hover {
          background: ${(p) => p.theme.background.action3};
        }

        span {
          color: ${(p) => p.theme.text.shade1};
          fill: ${(p) => p.theme.text.shade1};
        }
      }
    }
    &[contenteditable="false"] {
      [data-cadmus-pasted] {
        display: none;
      }
      figure[data-empty-node="true"] {
        figcaption {
          display: none;
        }
      }
      footnote {
        pointer-events: none;
      }
    }
  }

  img.ProseMirror-separator {
    display: inline !important;
    border: none !important;
    margin: 0 !important;
  }

  .ProseMirror-hideselection *::selection {
    background: transparent;
  }

  .ProseMirror-hideselection *::-moz-selection {
    background: transparent;
  }

  .ProseMirror-hideselection {
    caret-color: transparent;
  }

  .ProseMirror-selectednode {
    outline: 2px solid #b3d7fe;
  }

  .ProseMirror-gapcursor {
    display: none;
    pointer-events: none;
    position: absolute;
    margin: 0;
  }

  .ProseMirror-gapcursor:after {
    content: "";
    display: block;
    position: absolute;
    top: -2px;
    width: 20px;
    border-top: 1px solid black;
    animation: ${blink} 1.1s steps(2, start) infinite;
  }

  .ProseMirror-focused .ProseMirror-gapcursor {
    display: block;
  }

  &[data-page-mode="true"]::after {
    content: "";
    display: block;
    margin-top: 108px;
    border-top: 1px solid transparent;
    width: 100%;
  }

  &[data-page-mode="true"]::before {
    content: "";
    display: block;
    margin-bottom: 63px;
    border-bottom: 1px solid transparent;
    width: 100%;
  }

  li::marker {
    font-variant-numeric: normal;
  }

  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }

  .ProseMirror-collab-caret {
    position: relative;
    margin-left: -1px;
    margin-right: -1px;
    border: 1px solid var(--caret-color);
    word-break: normal;
    pointer-events: none;
    height: 100%;
  }

  /* This renders the username above the caret. The bottom-left corner is left
   * square (0) so the pill visually connects to the caret bar below it, like a
   * speech-bubble tail. */
  .ProseMirror-collab-caret > div {
    position: absolute;
    top: -1.05em;
    left: -1px;
    font-size: 12px;
    font-family: "Open Sauce Two", sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    user-select: none;
    color: white;
    white-space: nowrap;

    padding: 3px 8px;
    border-radius: 4px 4px 4px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: var(--caret-color);
    color: white;
  }
`;
//#endregion
//#region src/extensions/code-block-server/makeCodeBlockDomSpec.ts
/**
* Creates a ProseMirror `DOMOutputSpec` representation of the given plain text code.
*
* The `text` is tokensied using CodeMirror's `nodejs` `runMode` function, and
* the tokens are annotated and collected as a `DOMOutputSpec` tree.
*
* See: https://prosemirror.net/docs/ref/#model.DOMOutputSpec
* See: https://codemirror.net/demo/runmode.html
*
* Example output DOM structure:
*
*     <div.CodeMirror>
*       <div.language-display />
*       <div.CodeMirror-Sizer>
*         <div>
*           <div.CodeMirror-lines>
*             <div.CodeMirror-code> ...codeDOM</div>
*           </div>
*         </div>
*       </div>
*       <div.CodeMirror-gutters />
*     </div>
*
*
* @param text plain text code to tokenise
* @param langauge known CodeBlock language which affects tokenisation.
* @param theme CodeBlock dark or light theme for CSS classes
*/
function makeCodeBlockDomSpec(text, language, theme = "cadmus-light", showLineNumbers = true, showLanguage = true) {
	const gutterDiv = [
		"div",
		{
			class: "CodeMirror-gutters",
			style: "height: 122px; left: 0px"
		},
		["div", {
			class: "CodeMirror-gutter CodeMirror-linenumbers",
			style: `width: ${showLineNumbers ? "29px" : "0px"}`
		}]
	];
	const tokenisedText = tokeniseToDomSpec(text, language, showLineNumbers);
	const codeMirrorSizer = [
		"div",
		{
			class: "CodeMirror-sizer",
			style: codeMirrorSizerStyleTag
		},
		[
			"div",
			{ style: `position: relative; top: 0px; margin-left: ${showLineNumbers ? "0px" : "-29px"}; margin-right: -50px; margin-bottom: -50px; padding-bottom:50px` },
			[
				"div",
				{
					class: "CodeMirror-lines",
					role: "presentation"
				},
				[
					"div",
					{
						class: "CodeMirror-code",
						role: "presentation"
					},
					...tokenisedText
				]
			]
		]
	];
	return [
		"div",
		mergeAttributes({
			class: showLanguage ? `CodeMirror cm-s-${theme} CodeMirror-wrap` : `CodeMirror cm-s-${theme} language-display-off CodeMirror-wrap`,
			translate: "no",
			draggable: "false",
			contentditable: "false"
		}),
		[
			"div",
			{
				class: "language-display",
				style: `visibility: ${showLanguage ? "visible" : "hidden"}`
			},
			getLanguageDisplay(language)
		],
		codeMirrorSizer,
		gutterDiv
	];
}
/** Uses `runMode` to tokenize the `text` according to the given `lang` and returns
* an array of `DOMOutputSpec` nodes to match the tokenisation, so that each
* element in the array acts as a line. The output serves as the content of the
* `div.CodeMirror-code` element.
*/
const tokeniseToDomSpec = (text, lang, showLineNumbers = true) => {
	let lineCounter = 1;
	const allLines = [];
	let currentLine = [];
	const tokenCallback = (token, tokenClass) => {
		if (token == "\n") {
			if (currentLine.length == 0) currentLine.push([
				"span",
				{ class: "cm-text" },
				"\n"
			]);
			allLines.push(getDomSpecForLine(currentLine, lineCounter, showLineNumbers));
			lineCounter++;
			currentLine = [];
		} else currentLine.push([
			"span",
			{ class: `cm-${tokenClass}` },
			token
		]);
	};
	if (typeof CodeMirror?.runMode === "function") {
		CodeMirror?.runMode?.(text, getLanguageMode(lang), tokenCallback);
		if (currentLine.length == 0) currentLine.push([
			"span",
			{ class: "cm-text" },
			"\n"
		]);
		allLines.push(getDomSpecForLine(currentLine, lineCounter, showLineNumbers));
	}
	return allLines;
};
/**
* Makes a styled `DOMOutputSpec` from a given array of tokenized DOMOutputSpecs
* that represents a single line of code, associated with a given line number.
*/
function getDomSpecForLine(line, lineNumber, showLineNumbers = true) {
	return [
		"div",
		{ style: "position: relative" },
		["div", { class: "CodeMirror-linebackground" }],
		["div", {
			class: "CodeMirror-gutter-background",
			style: "left: -29px; width: 29px;"
		}],
		[
			"div",
			{
				class: "CodeMirror-gutter-wrapper",
				style: `left: -29px; visibility: ${showLineNumbers ? "visible" : "hidden"}`,
				"aria-hidden": "true"
			},
			[
				"div",
				{
					class: "CodeMirror-linenumber",
					style: `left: 0px; width: 9px;`
				},
				`${lineNumber}`
			]
		],
		[
			"pre",
			{
				class: "CodeMirror-line",
				role: "presentation",
				style: "padding: 0 16px; margin: 0;"
			},
			[
				"span",
				{ role: "presentation" },
				...line
			]
		]
	];
}
const codeMirrorSizerStyleTag = "margin-left: 29px; margin-bottom: 0px; border-right-width: 50px; min-height: 72px; padding-right: 0px; padding-bottom: 0px";
//#endregion
export { SlimDocument as $, ListItem as A, isValidURL as At, FootnoteStatic as B, Subscript$1 as C, CodeBlockDeleteIndicatorPluginKey as Ct, MathFigure as D, parseMarkdownLanguage as Dt, MathServerExtension as E, getLanguageMode as Et, Hyperlink as F, Audio as Ft, currentActiveFootnoteId as G, Footnote as H, getValidURL as I, insertMedia as It, EmptyMediaNode as J, listFootnotes as K, openLink as L, uploadMediaToServer as Lt, ImageMenuComponent as M, CODEBLOCK_MARKDOWN_INPUT_REGEX as Mt, Image$1 as N, MARKDOWN_CODEBLOCK_REGEX as Nt, InlineMathBase as O, getText as Ot, HyperlinkMenuComponent as P, buildRegex as Pt, SingleBlockDocument as Q, Highlight$1 as R, ALLOWED_MIME_TYPES as Rt, enableCadmusSpellCheck as S, CodeBlockDeleteIndicatorPlugin as St, OrderedList as T, getLanguageDisplay as Tt, FootnoteListPluginKey as U, htmlToDOMOutputSpec as V, FootnoteActiveStatusPluginKey as W, NodePasteRule as X, Emoji as Y, Document as Z, Superscript$1 as _, Paste as _t, useThreadList as a, FloatingMenuComponent as at, canSpellCheckWithCadmus as b, CodeBlockPastePlugin as bt, ThreadActiveStatusPluginKey as c, fontFamilySans as ct, TextColor as d, List as dt, sendableWordCountChange as et, editorWordCount as f, Blockquote as ft, TableMenuComponent as g, listExistingBlanks as gt, Table$1 as h, Blank as ht, TrailingNode as i, FloatingMenuExtension as it, Indentation as j, BASE_URL_REGEX as jt, BlockMathBase as k, textWordCount as kt, currentActiveThreadId as l, Code$1 as lt, TaskItem as m, BlockBackground as mt, CadmusEditorWrapper as n, HistoryPluginKey as nt, Thread as o, findTableGroup as ot, Telemetry as p, BlockTextVisibility as pt, TaskList as q, Video as r, Collab as rt, ThreadListPluginKey as s, editorTypography as st, makeCodeBlockDomSpec as t, History as tt, listThreads as u, BulletList as ut, SuggestionMenuComponent as v, PastePluginKey as vt, PasteChip as w, findCodeBlockSelection as wt, disableSpellCheck as x, CodeBlockPastePluginKey as xt, Suggestion as y, copyEventHandler as yt, useFootnoteList as z, MediaUploader as zt };

//# sourceMappingURL=makeCodeBlockDomSpec-CtiYDMcB.mjs.map